function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $37559147baa8b97c$var$toArray(objectOrArray) {
    objectOrArray = objectOrArray || [];
    return Array.isArray(objectOrArray) ? objectOrArray : [
        objectOrArray
    ];
}
function $37559147baa8b97c$var$log(msg) {
    return `[Vaadin.Router] ${msg}`;
}
function $37559147baa8b97c$var$logValue(value) {
    if (typeof value !== "object") return String(value);
    const stringType = Object.prototype.toString.call(value).match(/ (.*)\]$/)[1];
    if (stringType === "Object" || stringType === "Array") return `${stringType} ${JSON.stringify(value)}`;
    else return stringType;
}
const $37559147baa8b97c$var$MODULE = "module";
const $37559147baa8b97c$var$NOMODULE = "nomodule";
const $37559147baa8b97c$var$bundleKeys = [
    $37559147baa8b97c$var$MODULE,
    $37559147baa8b97c$var$NOMODULE
];
function $37559147baa8b97c$var$ensureBundle(src) {
    if (!src.match(/.+\.[m]?js$/)) throw new Error($37559147baa8b97c$var$log(`Unsupported type for bundle "${src}": .js or .mjs expected.`));
}
function $37559147baa8b97c$var$ensureRoute(route) {
    if (!route || !$37559147baa8b97c$var$isString(route.path)) throw new Error($37559147baa8b97c$var$log(`Expected route config to be an object with a "path" string property, or an array of such objects`));
    const bundle = route.bundle;
    const stringKeys = [
        "component",
        "redirect",
        "bundle"
    ];
    if (!$37559147baa8b97c$var$isFunction(route.action) && !Array.isArray(route.children) && !$37559147baa8b97c$var$isFunction(route.children) && !$37559147baa8b97c$var$isObject(bundle) && !stringKeys.some((key)=>$37559147baa8b97c$var$isString(route[key]))) throw new Error($37559147baa8b97c$var$log(`Expected route config "${route.path}" to include either "${stringKeys.join('", "')}" ` + `or "action" function but none found.`));
    if (bundle) {
        if ($37559147baa8b97c$var$isString(bundle)) $37559147baa8b97c$var$ensureBundle(bundle);
        else if (!$37559147baa8b97c$var$bundleKeys.some((key)=>key in bundle)) throw new Error($37559147baa8b97c$var$log('Expected route bundle to include either "' + $37559147baa8b97c$var$NOMODULE + '" or "' + $37559147baa8b97c$var$MODULE + '" keys, or both'));
        else $37559147baa8b97c$var$bundleKeys.forEach((key)=>key in bundle && $37559147baa8b97c$var$ensureBundle(bundle[key]));
    }
    if (route.redirect) [
        "bundle",
        "component"
    ].forEach((overriddenProp)=>{
        if (overriddenProp in route) console.warn($37559147baa8b97c$var$log(`Route config "${route.path}" has both "redirect" and "${overriddenProp}" properties, ` + `and "redirect" will always override the latter. Did you mean to only use "${overriddenProp}"?`));
    });
}
function $37559147baa8b97c$var$ensureRoutes(routes) {
    $37559147baa8b97c$var$toArray(routes).forEach((route)=>$37559147baa8b97c$var$ensureRoute(route));
}
function $37559147baa8b97c$var$loadScript(src, key) {
    let script = document.head.querySelector('script[src="' + src + '"][async]');
    if (!script) {
        script = document.createElement("script");
        script.setAttribute("src", src);
        if (key === $37559147baa8b97c$var$MODULE) script.setAttribute("type", $37559147baa8b97c$var$MODULE);
        else if (key === $37559147baa8b97c$var$NOMODULE) script.setAttribute($37559147baa8b97c$var$NOMODULE, "");
        script.async = true;
    }
    return new Promise((resolve, reject)=>{
        script.onreadystatechange = script.onload = (e)=>{
            script.__dynamicImportLoaded = true;
            resolve(e);
        };
        script.onerror = (e)=>{
            if (script.parentNode) script.parentNode.removeChild(script);
            reject(e);
        };
        if (script.parentNode === null) document.head.appendChild(script);
        else if (script.__dynamicImportLoaded) resolve();
    });
}
function $37559147baa8b97c$var$loadBundle(bundle) {
    if ($37559147baa8b97c$var$isString(bundle)) return $37559147baa8b97c$var$loadScript(bundle);
    else return Promise.race($37559147baa8b97c$var$bundleKeys.filter((key)=>key in bundle).map((key)=>$37559147baa8b97c$var$loadScript(bundle[key], key)));
}
function $37559147baa8b97c$var$fireRouterEvent(type, detail) {
    return !window.dispatchEvent(new CustomEvent(`vaadin-router-${type}`, {
        cancelable: type === "go",
        detail: detail
    }));
}
function $37559147baa8b97c$var$isObject(o) {
    // guard against null passing the typeof check
    return typeof o === "object" && !!o;
}
function $37559147baa8b97c$var$isFunction(f) {
    return typeof f === "function";
}
function $37559147baa8b97c$var$isString(s) {
    return typeof s === "string";
}
function $37559147baa8b97c$var$getNotFoundError(context) {
    const error = new Error($37559147baa8b97c$var$log(`Page not found (${context.pathname})`));
    error.context = context;
    error.code = 404;
    return error;
}
const $37559147baa8b97c$var$notFoundResult = new class NotFoundResult {
}();
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ function $37559147baa8b97c$var$getAnchorOrigin(anchor) {
    // IE11: on HTTP and HTTPS the default port is not included into
    // window.location.origin, so won't include it here either.
    const port = anchor.port;
    const protocol = anchor.protocol;
    const defaultHttp = protocol === "http:" && port === "80";
    const defaultHttps = protocol === "https:" && port === "443";
    const host = defaultHttp || defaultHttps ? anchor.hostname // does not include the port number (e.g. www.example.org)
     : anchor.host; // does include the port number (e.g. www.example.org:80)
    return `${protocol}//${host}`;
}
// The list of checks is not complete:
//  - SVG support is missing
//  - the 'rel' attribute is not considered
function $37559147baa8b97c$var$vaadinRouterGlobalClickHandler(event) {
    // ignore the click if the default action is prevented
    if (event.defaultPrevented) return;
    // ignore the click if not with the primary mouse button
    if (event.button !== 0) return;
    // ignore the click if a modifier key is pressed
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) return;
    // find the <a> element that the click is at (or within)
    let anchor = event.target;
    const path = event.composedPath ? event.composedPath() : event.path || [];
    // FIXME(web-padawan): `Symbol.iterator` used by webcomponentsjs is broken for arrays
    // example to check: `for...of` loop here throws the "Not yet implemented" error
    for(let i = 0; i < path.length; i++){
        const target = path[i];
        if (target.nodeName && target.nodeName.toLowerCase() === "a") {
            anchor = target;
            break;
        }
    }
    while(anchor && anchor.nodeName.toLowerCase() !== "a")anchor = anchor.parentNode;
    // ignore the click if not at an <a> element
    if (!anchor || anchor.nodeName.toLowerCase() !== "a") return;
    // ignore the click if the <a> element has a non-default target
    if (anchor.target && anchor.target.toLowerCase() !== "_self") return;
    // ignore the click if the <a> element has the 'download' attribute
    if (anchor.hasAttribute("download")) return;
    // ignore the click if the <a> element has the 'router-ignore' attribute
    if (anchor.hasAttribute("router-ignore")) return;
    // ignore the click if the target URL is a fragment on the current page
    if (anchor.pathname === window.location.pathname && anchor.hash !== "") return;
    // ignore the click if the target is external to the app
    // In IE11 HTMLAnchorElement does not have the `origin` property
    const origin = anchor.origin || $37559147baa8b97c$var$getAnchorOrigin(anchor);
    if (origin !== window.location.origin) return;
    // if none of the above, convert the click into a navigation event
    const { pathname: pathname, search: search, hash: hash } = anchor;
    if ($37559147baa8b97c$var$fireRouterEvent("go", {
        pathname: pathname,
        search: search,
        hash: hash
    })) {
        event.preventDefault();
        // for a click event, the scroll is reset to the top position.
        if (event && event.type === "click") window.scrollTo(0, 0);
    }
}
/**
 * A navigation trigger for Vaadin Router that translated clicks on `<a>` links
 * into Vaadin Router navigation events.
 *
 * Only regular clicks on in-app links are translated (primary mouse button, no
 * modifier keys, the target href is within the app's URL space).
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $37559147baa8b97c$var$CLICK = {
    activate () {
        window.document.addEventListener("click", $37559147baa8b97c$var$vaadinRouterGlobalClickHandler);
    },
    inactivate () {
        window.document.removeEventListener("click", $37559147baa8b97c$var$vaadinRouterGlobalClickHandler);
    }
};
// PopStateEvent constructor shim
const $37559147baa8b97c$var$isIE = /Trident/.test(navigator.userAgent);
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ if ($37559147baa8b97c$var$isIE && !$37559147baa8b97c$var$isFunction(window.PopStateEvent)) {
    window.PopStateEvent = function(inType, params) {
        params = params || {};
        var e = document.createEvent("Event");
        e.initEvent(inType, Boolean(params.bubbles), Boolean(params.cancelable));
        e.state = params.state || null;
        return e;
    };
    window.PopStateEvent.prototype = window.Event.prototype;
}
function $37559147baa8b97c$var$vaadinRouterGlobalPopstateHandler(event) {
    if (event.state === "vaadin-router-ignore") return;
    const { pathname: pathname, search: search, hash: hash } = window.location;
    $37559147baa8b97c$var$fireRouterEvent("go", {
        pathname: pathname,
        search: search,
        hash: hash
    });
}
/**
 * A navigation trigger for Vaadin Router that translates popstate events into
 * Vaadin Router navigation events.
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $37559147baa8b97c$var$POPSTATE = {
    activate () {
        window.addEventListener("popstate", $37559147baa8b97c$var$vaadinRouterGlobalPopstateHandler);
    },
    inactivate () {
        window.removeEventListener("popstate", $37559147baa8b97c$var$vaadinRouterGlobalPopstateHandler);
    }
};
/**
 * Expose `pathToRegexp`.
 */ var $37559147baa8b97c$var$pathToRegexp_1 = $37559147baa8b97c$var$pathToRegexp$1;
var $37559147baa8b97c$var$parse_1 = $37559147baa8b97c$var$parse;
var $37559147baa8b97c$var$compile_1 = $37559147baa8b97c$var$compile;
var $37559147baa8b97c$var$tokensToFunction_1 = $37559147baa8b97c$var$tokensToFunction;
var $37559147baa8b97c$var$tokensToRegExp_1 = $37559147baa8b97c$var$tokensToRegExp;
/**
 * Default configs.
 */ var $37559147baa8b97c$var$DEFAULT_DELIMITER = "/";
var $37559147baa8b97c$var$DEFAULT_DELIMITERS = "./";
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $37559147baa8b97c$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
    // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
    "(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $37559147baa8b97c$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || $37559147baa8b97c$var$DEFAULT_DELIMITER;
    var delimiters = options && options.delimiters || $37559147baa8b97c$var$DEFAULT_DELIMITERS;
    var pathEscaped = false;
    var res;
    while((res = $37559147baa8b97c$var$PATH_REGEXP.exec(str)) !== null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        var prev = "";
        var next = str[index];
        var name = res[2];
        var capture = res[3];
        var group = res[4];
        var modifier = res[5];
        if (!pathEscaped && path.length) {
            var k = path.length - 1;
            if (delimiters.indexOf(path[k]) > -1) {
                prev = path[k];
                path = path.slice(0, k);
            }
        }
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
            pathEscaped = false;
        }
        var partial = prev !== "" && next !== undefined && next !== prev;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = prev || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            pattern: pattern ? $37559147baa8b97c$var$escapeGroup(pattern) : "[^" + $37559147baa8b97c$var$escapeString(delimiter) + "]+?"
        });
    }
    // Push any remaining characters.
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $37559147baa8b97c$var$compile(str, options) {
    return $37559147baa8b97c$var$tokensToFunction($37559147baa8b97c$var$parse(str, options));
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $37559147baa8b97c$var$tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$");
    return function(data, options) {
        var path = "";
        var encode = options && options.encode || encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                segment = encode(String(value), token);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) {
                // Prepend partial segment prefixes.
                if (token.partial) path += token.prefix;
                continue;
            }
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? "an array" : "a string"));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $37559147baa8b97c$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $37559147baa8b97c$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $37559147baa8b97c$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */ function $37559147baa8b97c$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
    });
    return path;
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $37559147baa8b97c$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($37559147baa8b97c$var$pathToRegexp$1(path[i], keys, options).source);
    return new RegExp("(?:" + parts.join("|") + ")", $37559147baa8b97c$var$flags(options));
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $37559147baa8b97c$var$stringToRegexp(path, keys, options) {
    return $37559147baa8b97c$var$tokensToRegExp($37559147baa8b97c$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $37559147baa8b97c$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    var strict = options.strict;
    var start = options.start !== false;
    var end = options.end !== false;
    var delimiter = $37559147baa8b97c$var$escapeString(options.delimiter || $37559147baa8b97c$var$DEFAULT_DELIMITER);
    var delimiters = options.delimiters || $37559147baa8b97c$var$DEFAULT_DELIMITERS;
    var endsWith = [].concat(options.endsWith || []).map($37559147baa8b97c$var$escapeString).concat("$").join("|");
    var route = start ? "^" : "";
    var isEndDelimited = tokens.length === 0;
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") {
            route += $37559147baa8b97c$var$escapeString(token);
            isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
        } else {
            var capture = token.repeat ? "(?:" + token.pattern + ")(?:" + $37559147baa8b97c$var$escapeString(token.delimiter) + "(?:" + token.pattern + "))*" : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (token.partial) route += $37559147baa8b97c$var$escapeString(token.prefix) + "(" + capture + ")?";
                else route += "(?:" + $37559147baa8b97c$var$escapeString(token.prefix) + "(" + capture + "))?";
            } else route += $37559147baa8b97c$var$escapeString(token.prefix) + "(" + capture + ")";
        }
    }
    if (end) {
        if (!strict) route += "(?:" + delimiter + ")?";
        route += endsWith === "$" ? "$" : "(?=" + endsWith + ")";
    } else {
        if (!strict) route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        if (!isEndDelimited) route += "(?=" + delimiter + "|" + endsWith + ")";
    }
    return new RegExp(route, $37559147baa8b97c$var$flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $37559147baa8b97c$var$pathToRegexp$1(path, keys, options) {
    if (path instanceof RegExp) return $37559147baa8b97c$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $37559147baa8b97c$var$arrayToRegexp(/** @type {!Array} */ path, keys, options);
    return $37559147baa8b97c$var$stringToRegexp(/** @type {string} */ path, keys, options);
}
$37559147baa8b97c$var$pathToRegexp_1.parse = $37559147baa8b97c$var$parse_1;
$37559147baa8b97c$var$pathToRegexp_1.compile = $37559147baa8b97c$var$compile_1;
$37559147baa8b97c$var$pathToRegexp_1.tokensToFunction = $37559147baa8b97c$var$tokensToFunction_1;
$37559147baa8b97c$var$pathToRegexp_1.tokensToRegExp = $37559147baa8b97c$var$tokensToRegExp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { hasOwnProperty: $37559147baa8b97c$var$hasOwnProperty } = Object.prototype;
const $37559147baa8b97c$var$cache$1 = new Map();
// see https://github.com/pillarjs/path-to-regexp/issues/148
$37559147baa8b97c$var$cache$1.set("|false", {
    keys: [],
    pattern: /(?:)/
});
function $37559147baa8b97c$var$decodeParam(val) {
    try {
        return decodeURIComponent(val);
    } catch (err) {
        return val;
    }
}
function $37559147baa8b97c$var$matchPath(routepath, path, exact, parentKeys, parentParams) {
    exact = !!exact;
    const cacheKey = `${routepath}|${exact}`;
    let regexp = $37559147baa8b97c$var$cache$1.get(cacheKey);
    if (!regexp) {
        const keys = [];
        regexp = {
            keys: keys,
            pattern: $37559147baa8b97c$var$pathToRegexp_1(routepath, keys, {
                end: exact,
                strict: routepath === ""
            })
        };
        $37559147baa8b97c$var$cache$1.set(cacheKey, regexp);
    }
    const m = regexp.pattern.exec(path);
    if (!m) return null;
    const params = Object.assign({}, parentParams);
    for(let i = 1; i < m.length; i++){
        const key = regexp.keys[i - 1];
        const prop = key.name;
        const value = m[i];
        if (value !== undefined || !$37559147baa8b97c$var$hasOwnProperty.call(params, prop)) {
            if (key.repeat) params[prop] = value ? value.split(key.delimiter).map($37559147baa8b97c$var$decodeParam) : [];
            else params[prop] = value ? $37559147baa8b97c$var$decodeParam(value) : value;
        }
    }
    return {
        path: m[0],
        keys: (parentKeys || []).concat(regexp.keys),
        params: params
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ /**
 * Traverses the routes tree and matches its nodes to the given pathname from
 * the root down to the leaves. Each match consumes a part of the pathname and
 * the matching process continues for as long as there is a matching child
 * route for the remaining part of the pathname.
 *
 * The returned value is a lazily evaluated iterator.
 *
 * The leading "/" in a route path matters only for the root of the routes
 * tree (or if all parent routes are ""). In all other cases a leading "/" in
 * a child route path has no significance.
 *
 * The trailing "/" in a _route path_ matters only for the leaves of the
 * routes tree. A leaf route with a trailing "/" matches only a pathname that
 * also has a trailing "/".
 *
 * The trailing "/" in a route path does not affect matching of child routes
 * in any way.
 *
 * The trailing "/" in a _pathname_ generally does not matter (except for
 * the case of leaf nodes described above).
 *
 * The "" and "/" routes have special treatment:
 *  1. as a single route
 *     the "" and "/" routes match only the "" and "/" pathnames respectively
 *  2. as a parent in the routes tree
 *     the "" route matches any pathname without consuming any part of it
 *     the "/" route matches any absolute pathname consuming its leading "/"
 *  3. as a leaf in the routes tree
 *     the "" and "/" routes match only if the entire pathname is consumed by
 *         the parent routes chain. In this case "" and "/" are equivalent.
 *  4. several directly nested "" or "/" routes
 *     - directly nested "" or "/" routes are 'squashed' (i.e. nesting two
 *       "/" routes does not require a double "/" in the pathname to match)
 *     - if there are only "" in the parent routes chain, no part of the
 *       pathname is consumed, and the leading "/" in the child routes' paths
 *       remains significant
 *
 * Side effect:
 *   - the routes tree { path: '' } matches only the '' pathname
 *   - the routes tree { path: '', children: [ { path: '' } ] } matches any
 *     pathname (for the tree root)
 *
 * Prefix matching can be enabled also by `children: true`.
 */ function $37559147baa8b97c$var$matchRoute(route, pathname, ignoreLeadingSlash, parentKeys, parentParams) {
    let match;
    let childMatches;
    let childIndex = 0;
    let routepath = route.path || "";
    if (routepath.charAt(0) === "/") {
        if (ignoreLeadingSlash) routepath = routepath.substr(1);
        ignoreLeadingSlash = true;
    }
    return {
        next (routeToSkip) {
            if (route === routeToSkip) return {
                done: true
            };
            const children = route.__children = route.__children || route.children;
            if (!match) {
                match = $37559147baa8b97c$var$matchPath(routepath, pathname, !children, parentKeys, parentParams);
                if (match) return {
                    done: false,
                    value: {
                        route: route,
                        keys: match.keys,
                        params: match.params,
                        path: match.path
                    }
                };
            }
            if (match && children) while(childIndex < children.length){
                if (!childMatches) {
                    const childRoute = children[childIndex];
                    childRoute.parent = route;
                    let matchedLength = match.path.length;
                    if (matchedLength > 0 && pathname.charAt(matchedLength) === "/") matchedLength += 1;
                    childMatches = $37559147baa8b97c$var$matchRoute(childRoute, pathname.substr(matchedLength), ignoreLeadingSlash, match.keys, match.params);
                }
                const childMatch = childMatches.next(routeToSkip);
                if (!childMatch.done) return {
                    done: false,
                    value: childMatch.value
                };
                childMatches = null;
                childIndex++;
            }
            return {
                done: true
            };
        }
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $37559147baa8b97c$var$resolveRoute(context) {
    if ($37559147baa8b97c$var$isFunction(context.route.action)) return context.route.action(context);
    return undefined;
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $37559147baa8b97c$var$isChildRoute(parentRoute, childRoute) {
    let route = childRoute;
    while(route){
        route = route.parent;
        if (route === parentRoute) return true;
    }
    return false;
}
function $37559147baa8b97c$var$generateErrorMessage(currentContext) {
    let errorMessage = `Path '${currentContext.pathname}' is not properly resolved due to an error.`;
    const routePath = (currentContext.route || {}).path;
    if (routePath) errorMessage += ` Resolution had failed on route: '${routePath}'`;
    return errorMessage;
}
function $37559147baa8b97c$var$updateChainForRoute(context, match) {
    const { route: route, path: path } = match;
    if (route && !route.__synthetic) {
        const item = {
            path: path,
            route: route
        };
        if (!context.chain) context.chain = [];
        else // Discard old items
        if (route.parent) {
            let i = context.chain.length;
            while(i-- && context.chain[i].route && context.chain[i].route !== route.parent)context.chain.pop();
        }
        context.chain.push(item);
    }
}
/**
 */ class $37559147baa8b97c$export$8b4c839865b08288 {
    constructor(routes, options = {}){
        if (Object(routes) !== routes) throw new TypeError("Invalid routes");
        this.baseUrl = options.baseUrl || "";
        this.errorHandler = options.errorHandler;
        this.resolveRoute = options.resolveRoute || $37559147baa8b97c$var$resolveRoute;
        this.context = Object.assign({
            resolver: this
        }, options.context);
        this.root = Array.isArray(routes) ? {
            path: "",
            __children: routes,
            parent: null,
            __synthetic: true
        } : routes;
        this.root.parent = null;
    }
    /**
   * Returns the current list of routes (as a shallow copy). Adding / removing
   * routes to / from the returned array does not affect the routing config,
   * but modifying the route objects does.
   *
   * @return {!Array<!Router.Route>}
   */ getRoutes() {
        return [
            ...this.root.__children
        ];
    }
    /**
   * Sets the routing config (replacing the existing one).
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   */ setRoutes(routes) {
        $37559147baa8b97c$var$ensureRoutes(routes);
        const newRoutes = [
            ...$37559147baa8b97c$var$toArray(routes)
        ];
        this.root.__children = newRoutes;
    }
    /**
   * Appends one or several routes to the routing config and returns the
   * effective routing config after the operation.
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   * @return {!Array<!Router.Route>}
   * @protected
   */ addRoutes(routes) {
        $37559147baa8b97c$var$ensureRoutes(routes);
        this.root.__children.push(...$37559147baa8b97c$var$toArray(routes));
        return this.getRoutes();
    }
    /**
   * Removes all existing routes from the routing config.
   */ removeRoutes() {
        this.setRoutes([]);
    }
    /**
   * Asynchronously resolves the given pathname, i.e. finds all routes matching
   * the pathname and tries resolving them one after another in the order they
   * are listed in the routes config until the first non-null result.
   *
   * Returns a promise that is fulfilled with the return value of an object that consists of the first
   * route handler result that returns something other than `null` or `undefined` and context used to get this result.
   *
   * If no route handlers return a non-null result, or if no route matches the
   * given pathname the returned promise is rejected with a 'page not found'
   * `Error`.
   *
   * @param {!string|!{pathname: !string}} pathnameOrContext the pathname to
   *    resolve or a context object with a `pathname` property and other
   *    properties to pass to the route resolver functions.
   * @return {!Promise<any>}
   */ resolve(pathnameOrContext) {
        const context = Object.assign({}, this.context, $37559147baa8b97c$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext);
        const match = $37559147baa8b97c$var$matchRoute(this.root, this.__normalizePathname(context.pathname), this.baseUrl);
        const resolve = this.resolveRoute;
        let matches = null;
        let nextMatches = null;
        let currentContext = context;
        function next(resume, parent = matches.value.route, prevResult) {
            const routeToSkip = prevResult === null && matches.value.route;
            matches = nextMatches || match.next(routeToSkip);
            nextMatches = null;
            if (!resume) {
                if (matches.done || !$37559147baa8b97c$var$isChildRoute(parent, matches.value.route)) {
                    nextMatches = matches;
                    return Promise.resolve($37559147baa8b97c$var$notFoundResult);
                }
            }
            if (matches.done) return Promise.reject($37559147baa8b97c$var$getNotFoundError(context));
            currentContext = Object.assign(currentContext ? {
                chain: currentContext.chain ? currentContext.chain.slice(0) : []
            } : {}, context, matches.value);
            $37559147baa8b97c$var$updateChainForRoute(currentContext, matches.value);
            return Promise.resolve(resolve(currentContext)).then((resolution)=>{
                if (resolution !== null && resolution !== undefined && resolution !== $37559147baa8b97c$var$notFoundResult) {
                    currentContext.result = resolution.result || resolution;
                    return currentContext;
                }
                return next(resume, parent, resolution);
            });
        }
        context.next = next;
        return Promise.resolve().then(()=>next(true, this.root)).catch((error)=>{
            const errorMessage = $37559147baa8b97c$var$generateErrorMessage(currentContext);
            if (!error) error = new Error(errorMessage);
            else console.warn(errorMessage);
            error.context = error.context || currentContext;
            // DOMException has its own code which is read-only
            if (!(error instanceof DOMException)) error.code = error.code || 500;
            if (this.errorHandler) {
                currentContext.result = this.errorHandler(error);
                return currentContext;
            }
            throw error;
        });
    }
    /**
   * URL constructor polyfill hook. Creates and returns an URL instance.
   */ static __createUrl(url, base) {
        return new URL(url, base);
    }
    /**
   * If the baseUrl property is set, transforms the baseUrl and returns the full
   * actual `base` string for using in the `new URL(path, base);` and for
   * prepernding the paths with. The returned base ends with a trailing slash.
   *
   * Otherwise, returns empty string.
   */ get __effectiveBaseUrl() {
        return this.baseUrl ? this.constructor.__createUrl(this.baseUrl, document.baseURI || document.URL).href.replace(/[^\/]*$/, "") : "";
    }
    /**
   * If the baseUrl is set, matches the pathname with the router’s baseUrl,
   * and returns the local pathname with the baseUrl stripped out.
   *
   * If the pathname does not match the baseUrl, returns undefined.
   *
   * If the `baseUrl` is not set, returns the unmodified pathname argument.
   */ __normalizePathname(pathname) {
        if (!this.baseUrl) // No base URL, no need to transform the pathname.
        return pathname;
        const base = this.__effectiveBaseUrl;
        const normalizedUrl = this.constructor.__createUrl(pathname, base).href;
        if (normalizedUrl.slice(0, base.length) === base) return normalizedUrl.slice(base.length);
    }
}
$37559147baa8b97c$export$8b4c839865b08288.pathToRegexp = $37559147baa8b97c$var$pathToRegexp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { pathToRegexp: $37559147baa8b97c$var$pathToRegexp } = $37559147baa8b97c$export$8b4c839865b08288;
const $37559147baa8b97c$var$cache = new Map();
function $37559147baa8b97c$var$cacheRoutes(routesByName, route, routes) {
    const name = route.name || route.component;
    if (name) {
        if (routesByName.has(name)) routesByName.get(name).push(route);
        else routesByName.set(name, [
            route
        ]);
    }
    if (Array.isArray(routes)) for(let i = 0; i < routes.length; i++){
        const childRoute = routes[i];
        childRoute.parent = route;
        $37559147baa8b97c$var$cacheRoutes(routesByName, childRoute, childRoute.__children || childRoute.children);
    }
}
function $37559147baa8b97c$var$getRouteByName(routesByName, routeName) {
    const routes = routesByName.get(routeName);
    if (routes && routes.length > 1) throw new Error(`Duplicate route with name "${routeName}".` + ` Try seting unique 'name' route properties.`);
    return routes && routes[0];
}
function $37559147baa8b97c$var$getRoutePath(route) {
    let path = route.path;
    path = Array.isArray(path) ? path[0] : path;
    return path !== undefined ? path : "";
}
function $37559147baa8b97c$var$generateUrls(router, options = {}) {
    if (!(router instanceof $37559147baa8b97c$export$8b4c839865b08288)) throw new TypeError("An instance of Resolver is expected");
    const routesByName = new Map();
    return (routeName, params)=>{
        let route = $37559147baa8b97c$var$getRouteByName(routesByName, routeName);
        if (!route) {
            routesByName.clear(); // clear cache
            $37559147baa8b97c$var$cacheRoutes(routesByName, router.root, router.root.__children);
            route = $37559147baa8b97c$var$getRouteByName(routesByName, routeName);
            if (!route) throw new Error(`Route "${routeName}" not found`);
        }
        let regexp = $37559147baa8b97c$var$cache.get(route.fullPath);
        if (!regexp) {
            let fullPath = $37559147baa8b97c$var$getRoutePath(route);
            let rt = route.parent;
            while(rt){
                const path = $37559147baa8b97c$var$getRoutePath(rt);
                if (path) fullPath = path.replace(/\/$/, "") + "/" + fullPath.replace(/^\//, "");
                rt = rt.parent;
            }
            const tokens = $37559147baa8b97c$var$pathToRegexp.parse(fullPath);
            const toPath = $37559147baa8b97c$var$pathToRegexp.tokensToFunction(tokens);
            const keys = Object.create(null);
            for(let i = 0; i < tokens.length; i++)if (!$37559147baa8b97c$var$isString(tokens[i])) keys[tokens[i].name] = true;
            regexp = {
                toPath: toPath,
                keys: keys
            };
            $37559147baa8b97c$var$cache.set(fullPath, regexp);
            route.fullPath = fullPath;
        }
        let url = regexp.toPath(params, options) || "/";
        if (options.stringifyQueryParams && params) {
            const queryParams = {};
            const keys = Object.keys(params);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                if (!regexp.keys[key]) queryParams[key] = params[key];
            }
            const query = options.stringifyQueryParams(queryParams);
            if (query) url += query.charAt(0) === "?" ? query : `?${query}`;
        }
        return url;
    };
}
/**
 * @typedef NavigationTrigger
 * @type {object}
 * @property {function()} activate
 * @property {function()} inactivate
 */ /** @type {Array<NavigationTrigger>} */ let $37559147baa8b97c$var$triggers = [];
function $37559147baa8b97c$var$setNavigationTriggers(newTriggers) {
    $37559147baa8b97c$var$triggers.forEach((trigger)=>trigger.inactivate());
    newTriggers.forEach((trigger)=>trigger.activate());
    $37559147baa8b97c$var$triggers = newTriggers;
}
const $37559147baa8b97c$var$willAnimate = (elem)=>{
    const name = getComputedStyle(elem).getPropertyValue("animation-name");
    return name && name !== "none";
};
const $37559147baa8b97c$var$waitForAnimation = (elem, cb)=>{
    const listener = ()=>{
        elem.removeEventListener("animationend", listener);
        cb();
    };
    elem.addEventListener("animationend", listener);
};
function $37559147baa8b97c$var$animate(elem, className) {
    elem.classList.add(className);
    return new Promise((resolve)=>{
        if ($37559147baa8b97c$var$willAnimate(elem)) {
            const rect = elem.getBoundingClientRect();
            const size = `height: ${rect.bottom - rect.top}px; width: ${rect.right - rect.left}px`;
            elem.setAttribute("style", `position: absolute; ${size}`);
            $37559147baa8b97c$var$waitForAnimation(elem, ()=>{
                elem.classList.remove(className);
                elem.removeAttribute("style");
                resolve();
            });
        } else {
            elem.classList.remove(className);
            resolve();
        }
    });
}
const $37559147baa8b97c$var$MAX_REDIRECT_COUNT = 256;
function $37559147baa8b97c$var$isResultNotEmpty(result) {
    return result !== null && result !== undefined;
}
function $37559147baa8b97c$var$copyContextWithoutNext(context) {
    const copy = Object.assign({}, context);
    delete copy.next;
    return copy;
}
function $37559147baa8b97c$var$createLocation({ pathname: pathname = "", search: search = "", hash: hash = "", chain: chain = [], params: params = {}, redirectFrom: redirectFrom, resolver: resolver }, route) {
    const routes = chain.map((item)=>item.route);
    return {
        baseUrl: resolver && resolver.baseUrl || "",
        pathname: pathname,
        search: search,
        hash: hash,
        routes: routes,
        route: route || routes.length && routes[routes.length - 1] || null,
        params: params,
        redirectFrom: redirectFrom,
        getUrl: (userParams = {})=>$37559147baa8b97c$var$getPathnameForRouter($37559147baa8b97c$export$55185c17a0fcbe46.pathToRegexp.compile($37559147baa8b97c$var$getMatchedPath(routes))(Object.assign({}, params, userParams)), resolver)
    };
}
function $37559147baa8b97c$var$createRedirect(context, pathname) {
    const params = Object.assign({}, context.params);
    return {
        redirect: {
            pathname: pathname,
            from: context.pathname,
            params: params
        }
    };
}
function $37559147baa8b97c$var$renderElement(context, element) {
    element.location = $37559147baa8b97c$var$createLocation(context);
    const index = context.chain.map((item)=>item.route).indexOf(context.route);
    context.chain[index].element = element;
    return element;
}
function $37559147baa8b97c$var$runCallbackIfPossible(callback, args, thisArg) {
    if ($37559147baa8b97c$var$isFunction(callback)) return callback.apply(thisArg, args);
}
function $37559147baa8b97c$var$amend(amendmentFunction, args, element) {
    return (amendmentResult)=>{
        if (amendmentResult && (amendmentResult.cancel || amendmentResult.redirect)) return amendmentResult;
        if (element) return $37559147baa8b97c$var$runCallbackIfPossible(element[amendmentFunction], args, element);
    };
}
function $37559147baa8b97c$var$processNewChildren(newChildren, route) {
    if (!Array.isArray(newChildren) && !$37559147baa8b97c$var$isObject(newChildren)) throw new Error($37559147baa8b97c$var$log(`Incorrect "children" value for the route ${route.path}: expected array or object, but got ${newChildren}`));
    route.__children = [];
    const childRoutes = $37559147baa8b97c$var$toArray(newChildren);
    for(let i = 0; i < childRoutes.length; i++){
        $37559147baa8b97c$var$ensureRoute(childRoutes[i]);
        route.__children.push(childRoutes[i]);
    }
}
function $37559147baa8b97c$var$removeDomNodes(nodes) {
    if (nodes && nodes.length) {
        const parent = nodes[0].parentNode;
        for(let i = 0; i < nodes.length; i++)parent.removeChild(nodes[i]);
    }
}
function $37559147baa8b97c$var$getPathnameForRouter(pathname, router) {
    const base = router.__effectiveBaseUrl;
    return base ? router.constructor.__createUrl(pathname.replace(/^\//, ""), base).pathname : pathname;
}
function $37559147baa8b97c$var$getMatchedPath(chain) {
    return chain.map((item)=>item.path).reduce((a, b)=>{
        if (b.length) return a.replace(/\/$/, "") + "/" + b.replace(/^\//, "");
        return a;
    }, "");
}
/**
 * A simple client-side router for single-page applications. It uses
 * express-style middleware and has a first-class support for Web Components and
 * lazy-loading. Works great in Polymer and non-Polymer apps.
 *
 * Use `new Router(outlet, options)` to create a new Router instance.
 *
 * * The `outlet` parameter is a reference to the DOM node to render
 *   the content into.
 *
 * * The `options` parameter is an optional object with options. The following
 *   keys are supported:
 *   * `baseUrl` — the initial value for [
 *     the `baseUrl` property
 *   ](#/classes/Router#property-baseUrl)
 *
 * The Router instance is automatically subscribed to navigation events
 * on `window`.
 *
 * See [Live Examples](#/classes/Router/demos/demo/index.html) for the detailed usage demo and code snippets.
 *
 * See also detailed API docs for the following methods, for the advanced usage:
 *
 * * [setOutlet](#/classes/Router#method-setOutlet) – should be used to configure the outlet.
 * * [setTriggers](#/classes/Router#method-setTriggers) – should be used to configure the navigation events.
 * * [setRoutes](#/classes/Router#method-setRoutes) – should be used to configure the routes.
 *
 * Only `setRoutes` has to be called manually, others are automatically invoked when creating a new instance.
 *
 * @extends Resolver
 * @demo demo/index.html
 * @summary JavaScript class that renders different DOM content depending on
 *    a given path. It can re-render when triggered or automatically on
 *    'popstate' and / or 'click' events.
 */ class $37559147baa8b97c$export$55185c17a0fcbe46 extends $37559147baa8b97c$export$8b4c839865b08288 {
    /**
   * Creates a new Router instance with a given outlet, and
   * automatically subscribes it to navigation events on the `window`.
   * Using a constructor argument or a setter for outlet is equivalent:
   *
   * ```
   * const router = new Router();
   * router.setOutlet(outlet);
   * ```
   * @param {?Node=} outlet
   * @param {?RouterOptions=} options
   */ constructor(outlet, options){
        const baseElement = document.head.querySelector("base");
        const baseHref = baseElement && baseElement.getAttribute("href");
        super([], Object.assign({
            // Default options
            baseUrl: baseHref && $37559147baa8b97c$export$8b4c839865b08288.__createUrl(baseHref, document.URL).pathname.replace(/[^\/]*$/, "")
        }, options));
        this.resolveRoute = (context)=>this.__resolveRoute(context);
        const triggers = $37559147baa8b97c$export$55185c17a0fcbe46.NavigationTrigger;
        $37559147baa8b97c$export$55185c17a0fcbe46.setTriggers.apply($37559147baa8b97c$export$55185c17a0fcbe46, Object.keys(triggers).map((key)=>triggers[key]));
        /**
     * The base URL for all routes in the router instance. By default,
     * if the base element exists in the `<head>`, vaadin-router
     * takes the `<base href>` attribute value, resolves against current `document.URL`
     * and gets the `pathname` from the result.
     *
     * @public
     * @type {string}
     */ this.baseUrl;
        /**
     * A promise that is settled after the current render cycle completes. If
     * there is no render cycle in progress the promise is immediately settled
     * with the last render cycle result.
     *
     * @public
     * @type {!Promise<!RouterLocation>}
     */ this.ready;
        this.ready = Promise.resolve(outlet);
        /**
     * Contains read-only information about the current router location:
     * pathname, active routes, parameters. See the
     * [Location type declaration](#/classes/RouterLocation)
     * for more details.
     *
     * @public
     * @type {!RouterLocation}
     */ this.location;
        this.location = $37559147baa8b97c$var$createLocation({
            resolver: this
        });
        this.__lastStartedRenderId = 0;
        this.__navigationEventHandler = this.__onNavigationEvent.bind(this);
        this.setOutlet(outlet);
        this.subscribe();
        // Using WeakMap instead of WeakSet because WeakSet is not supported by IE11
        this.__createdByRouter = new WeakMap();
        this.__addedByRouter = new WeakMap();
    }
    __resolveRoute(context) {
        const route = context.route;
        let callbacks = Promise.resolve();
        if ($37559147baa8b97c$var$isFunction(route.children)) callbacks = callbacks.then(()=>route.children($37559147baa8b97c$var$copyContextWithoutNext(context))).then((children)=>{
            // The route.children() callback might have re-written the
            // route.children property instead of returning a value
            if (!$37559147baa8b97c$var$isResultNotEmpty(children) && !$37559147baa8b97c$var$isFunction(route.children)) children = route.children;
            $37559147baa8b97c$var$processNewChildren(children, route);
        });
        const commands = {
            redirect: (path)=>$37559147baa8b97c$var$createRedirect(context, path),
            component: (component)=>{
                const element = document.createElement(component);
                this.__createdByRouter.set(element, true);
                return element;
            }
        };
        return callbacks.then(()=>{
            if (this.__isLatestRender(context)) return $37559147baa8b97c$var$runCallbackIfPossible(route.action, [
                context,
                commands
            ], route);
        }).then((result)=>{
            if ($37559147baa8b97c$var$isResultNotEmpty(result)) {
                // Actions like `() => import('my-view.js')` are not expected to
                // end the resolution, despite the result is not empty. Checking
                // the result with a whitelist of values that end the resolution.
                if (result instanceof HTMLElement || result.redirect || result === $37559147baa8b97c$var$notFoundResult) return result;
            }
            if ($37559147baa8b97c$var$isString(route.redirect)) return commands.redirect(route.redirect);
            if (route.bundle) return $37559147baa8b97c$var$loadBundle(route.bundle).then(()=>{}, ()=>{
                throw new Error($37559147baa8b97c$var$log(`Bundle not found: ${route.bundle}. Check if the file name is correct`));
            });
        }).then((result)=>{
            if ($37559147baa8b97c$var$isResultNotEmpty(result)) return result;
            if ($37559147baa8b97c$var$isString(route.component)) return commands.component(route.component);
        });
    }
    /**
   * Sets the router outlet (the DOM node where the content for the current
   * route is inserted). Any content pre-existing in the router outlet is
   * removed at the end of each render pass.
   *
   * NOTE: this method is automatically invoked first time when creating a new Router instance.
   *
   * @param {?Node} outlet the DOM node where the content for the current route
   *     is inserted.
   */ setOutlet(outlet) {
        if (outlet) this.__ensureOutlet(outlet);
        this.__outlet = outlet;
    }
    /**
   * Returns the current router outlet. The initial value is `undefined`.
   *
   * @return {?Node} the current router outlet (or `undefined`)
   */ getOutlet() {
        return this.__outlet;
    }
    /**
   * Sets the routing config (replacing the existing one) and triggers a
   * navigation event so that the router outlet is refreshed according to the
   * current `window.location` and the new routing config.
   *
   * Each route object may have the following properties, listed here in the processing order:
   * * `path` – the route path (relative to the parent route if any) in the
   * [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   *
   * * `children` – an array of nested routes or a function that provides this
   * array at the render time. The function can be synchronous or asynchronous:
   * in the latter case the render is delayed until the returned promise is
   * resolved. The `children` function is executed every time when this route is
   * being rendered. This allows for dynamic route structures (e.g. backend-defined),
   * but it might have a performance impact as well. In order to avoid calling
   * the function on subsequent renders, you can override the `children` property
   * of the route object and save the calculated array there
   * (via `context.route.children = [ route1, route2, ...];`).
   * Parent routes are fully resolved before resolving the children. Children
   * 'path' values are relative to the parent ones.
   *
   * * `action` – the action that is executed before the route is resolved.
   * The value for this property should be a function, accepting `context`
   * and `commands` parameters described below. If present, this function is
   * always invoked first, disregarding of the other properties' presence.
   * The action can return a result directly or within a `Promise`, which
   * resolves to the result. If the action result is an `HTMLElement` instance,
   * a `commands.component(name)` result, a `commands.redirect(path)` result,
   * or a `context.next()` result, the current route resolution is finished,
   * and other route config properties are ignored.
   * See also **Route Actions** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `redirect` – other route's path to redirect to. Passes all route parameters to the redirect target.
   * The target route should also be defined.
   * See also **Redirects** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `bundle` – string containing the path to `.js` or `.mjs` bundle to load before resolving the route,
   * or the object with "module" and "nomodule" keys referring to different bundles.
   * Each bundle is only loaded once. If "module" and "nomodule" are set, only one bundle is loaded,
   * depending on whether the browser supports ES modules or not.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * Any error, e.g. 404 while loading bundle will cause route resolution to throw.
   * See also **Code Splitting** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `component` – the tag name of the Web Component to resolve the route to.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * If route contains the `component` property (or an action that return a component)
   * and its child route also contains the `component` property, child route's component
   * will be rendered as a light dom child of a parent component.
   *
   * * `name` – the string name of the route to use in the
   * [`router.urlForName(name, params)`](#/classes/Router#method-urlForName)
   * navigation helper method.
   *
   * For any route function (`action`, `children`) defined, the corresponding `route` object is available inside the callback
   * through the `this` reference. If you need to access it, make sure you define the callback as a non-arrow function
   * because arrow functions do not have their own `this` reference.
   *
   * `context` object that is passed to `action` function holds the following properties:
   * * `context.pathname` – string with the pathname being resolved
   *
   * * `context.search` – search query string
   *
   * * `context.hash` – hash string
   *
   * * `context.params` – object with route parameters
   *
   * * `context.route` – object that holds the route that is currently being rendered.
   *
   * * `context.next()` – function for asynchronously getting the next route
   * contents from the resolution chain (if any)
   *
   * `commands` object that is passed to `action` function has
   * the following methods:
   *
   * * `commands.redirect(path)` – function that creates a redirect data
   * for the path specified.
   *
   * * `commands.component(component)` – function that creates a new HTMLElement
   * with current context. Note: the component created by this function is reused if visiting the same path twice in row.
   *
   *
   * @param {!Array<!Route>|!Route} routes a single route or an array of those
   * @param {?boolean} skipRender configure the router but skip rendering the
   *     route corresponding to the current `window.location` values
   *
   * @return {!Promise<!Node>}
   */ setRoutes(routes, skipRender = false) {
        this.__previousContext = undefined;
        this.__urlForName = undefined;
        super.setRoutes(routes);
        if (!skipRender) this.__onNavigationEvent();
        return this.ready;
    }
    /**
   * Asynchronously resolves the given pathname and renders the resolved route
   * component into the router outlet. If no router outlet is set at the time of
   * calling this method, or at the time when the route resolution is completed,
   * a `TypeError` is thrown.
   *
   * Returns a promise that is fulfilled with the router outlet DOM Node after
   * the route component is created and inserted into the router outlet, or
   * rejected if no route matches the given path.
   *
   * If another render pass is started before the previous one is completed, the
   * result of the previous render pass is ignored.
   *
   * @param {!string|!{pathname: !string, search: ?string, hash: ?string}} pathnameOrContext
   *    the pathname to render or a context object with a `pathname` property,
   *    optional `search` and `hash` properties, and other properties
   *    to pass to the resolver.
   * @param {boolean=} shouldUpdateHistory
   *    update browser history with the rendered location
   * @return {!Promise<!Node>}
   */ render(pathnameOrContext, shouldUpdateHistory) {
        const renderId = ++this.__lastStartedRenderId;
        const context = Object.assign({
            search: "",
            hash: ""
        }, $37559147baa8b97c$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext, {
            __renderId: renderId
        });
        // Find the first route that resolves to a non-empty result
        this.ready = this.resolve(context)// Process the result of this.resolve() and handle all special commands:
        // (redirect / prevent / component). If the result is a 'component',
        // then go deeper and build the entire chain of nested components matching
        // the pathname. Also call all 'on before' callbacks along the way.
        .then((context)=>this.__fullyResolveChain(context)).then((context)=>{
            if (this.__isLatestRender(context)) {
                const previousContext = this.__previousContext;
                // Check if the render was prevented and make an early return in that case
                if (context === previousContext) {
                    // Replace the history with the previous context
                    // to make sure the URL stays the same.
                    this.__updateBrowserHistory(previousContext, true);
                    return this.location;
                }
                this.location = $37559147baa8b97c$var$createLocation(context);
                if (shouldUpdateHistory) // Replace only if first render redirects, so that we don’t leave
                // the redirecting record in the history
                this.__updateBrowserHistory(context, renderId === 1);
                $37559147baa8b97c$var$fireRouterEvent("location-changed", {
                    router: this,
                    location: this.location
                });
                // Skip detaching/re-attaching there are no render changes
                if (context.__skipAttach) {
                    this.__copyUnchangedElements(context, previousContext);
                    this.__previousContext = context;
                    return this.location;
                }
                this.__addAppearingContent(context, previousContext);
                const animationDone = this.__animateIfNeeded(context);
                this.__runOnAfterEnterCallbacks(context);
                this.__runOnAfterLeaveCallbacks(context, previousContext);
                return animationDone.then(()=>{
                    if (this.__isLatestRender(context)) {
                        // If there is another render pass started after this one,
                        // the 'disappearing content' would be removed when the other
                        // render pass calls `this.__addAppearingContent()`
                        this.__removeDisappearingContent();
                        this.__previousContext = context;
                        return this.location;
                    }
                });
            }
        }).catch((error)=>{
            if (renderId === this.__lastStartedRenderId) {
                if (shouldUpdateHistory) this.__updateBrowserHistory(context);
                $37559147baa8b97c$var$removeDomNodes(this.__outlet && this.__outlet.children);
                this.location = $37559147baa8b97c$var$createLocation(Object.assign(context, {
                    resolver: this
                }));
                $37559147baa8b97c$var$fireRouterEvent("error", Object.assign({
                    router: this,
                    error: error
                }, context));
                throw error;
            }
        });
        return this.ready;
    }
    // `topOfTheChainContextBeforeRedirects` is a context coming from Resolver.resolve().
    // It would contain a 'redirect' route or the first 'component' route that
    // matched the pathname. There might be more child 'component' routes to be
    // resolved and added into the chain. This method would find and add them.
    // `contextBeforeRedirects` is the context containing such a child component
    // route. It's only necessary when this method is called recursively (otherwise
    // it's the same as the 'top of the chain' context).
    //
    // Apart from building the chain of child components, this method would also
    // handle 'redirect' routes, call 'onBefore' callbacks and handle 'prevent'
    // and 'redirect' callback results.
    __fullyResolveChain(topOfTheChainContextBeforeRedirects, contextBeforeRedirects = topOfTheChainContextBeforeRedirects) {
        return this.__findComponentContextAfterAllRedirects(contextBeforeRedirects)// `contextAfterRedirects` is always a context with an `HTMLElement` result
        // In other cases the promise gets rejected and .then() is not called
        .then((contextAfterRedirects)=>{
            const redirectsHappened = contextAfterRedirects !== contextBeforeRedirects;
            const topOfTheChainContextAfterRedirects = redirectsHappened ? contextAfterRedirects : topOfTheChainContextBeforeRedirects;
            const matchedPath = $37559147baa8b97c$var$getPathnameForRouter($37559147baa8b97c$var$getMatchedPath(contextAfterRedirects.chain), contextAfterRedirects.resolver);
            const isFound = matchedPath === contextAfterRedirects.pathname;
            // Recursive method to try matching more child and sibling routes
            const findNextContextIfAny = (context, parent = context.route, prevResult)=>{
                return context.next(undefined, parent, prevResult).then((nextContext)=>{
                    if (nextContext === null || nextContext === $37559147baa8b97c$var$notFoundResult) {
                        // Next context is not found in children, ...
                        if (isFound) // ...but original context is already fully matching - use it
                        return context;
                        else if (parent.parent !== null) // ...and there is no full match yet - step up to check siblings
                        return findNextContextIfAny(context, parent.parent, nextContext);
                        else return nextContext;
                    }
                    return nextContext;
                });
            };
            return findNextContextIfAny(contextAfterRedirects).then((nextContext)=>{
                if (nextContext === null || nextContext === $37559147baa8b97c$var$notFoundResult) throw $37559147baa8b97c$var$getNotFoundError(topOfTheChainContextAfterRedirects);
                return nextContext && nextContext !== $37559147baa8b97c$var$notFoundResult && nextContext !== contextAfterRedirects ? this.__fullyResolveChain(topOfTheChainContextAfterRedirects, nextContext) : this.__amendWithOnBeforeCallbacks(contextAfterRedirects);
            });
        });
    }
    __findComponentContextAfterAllRedirects(context) {
        const result = context.result;
        if (result instanceof HTMLElement) {
            $37559147baa8b97c$var$renderElement(context, result);
            return Promise.resolve(context);
        } else if (result.redirect) return this.__redirect(result.redirect, context.__redirectCount, context.__renderId).then((context)=>this.__findComponentContextAfterAllRedirects(context));
        else if (result instanceof Error) return Promise.reject(result);
        else return Promise.reject(new Error($37559147baa8b97c$var$log(`Invalid route resolution result for path "${context.pathname}". ` + `Expected redirect object or HTML element, but got: "${$37559147baa8b97c$var$logValue(result)}". ` + `Double check the action return value for the route.`)));
    }
    __amendWithOnBeforeCallbacks(contextWithFullChain) {
        return this.__runOnBeforeCallbacks(contextWithFullChain).then((amendedContext)=>{
            if (amendedContext === this.__previousContext || amendedContext === contextWithFullChain) return amendedContext;
            return this.__fullyResolveChain(amendedContext);
        });
    }
    __runOnBeforeCallbacks(newContext) {
        const previousContext = this.__previousContext || {};
        const previousChain = previousContext.chain || [];
        const newChain = newContext.chain;
        let callbacks = Promise.resolve();
        const prevent = ()=>({
                cancel: true
            });
        const redirect = (pathname)=>$37559147baa8b97c$var$createRedirect(newContext, pathname);
        newContext.__divergedChainIndex = 0;
        newContext.__skipAttach = false;
        if (previousChain.length) {
            for(let i = 0; i < Math.min(previousChain.length, newChain.length); i = ++newContext.__divergedChainIndex){
                if (previousChain[i].route !== newChain[i].route || previousChain[i].path !== newChain[i].path && previousChain[i].element !== newChain[i].element || !this.__isReusableElement(previousChain[i].element, newChain[i].element)) break;
            }
            // Skip re-attaching and notifications if element and chain do not change
            newContext.__skipAttach = // Same route chain
            newChain.length === previousChain.length && newContext.__divergedChainIndex == newChain.length && // Same element
            this.__isReusableElement(newContext.result, previousContext.result);
            if (newContext.__skipAttach) {
                // execute onBeforeLeave for changed segment element when skipping attach
                for(let i = newChain.length - 1; i >= 0; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                    prevent: prevent
                }, previousChain[i]);
                // execute onBeforeEnter for changed segment element when skipping attach
                for(let i = 0; i < newChain.length; i++){
                    callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                        prevent: prevent,
                        redirect: redirect
                    }, newChain[i]);
                    previousChain[i].element.location = $37559147baa8b97c$var$createLocation(newContext, previousChain[i].route);
                }
            } else // execute onBeforeLeave when NOT skipping attach
            for(let i = previousChain.length - 1; i >= newContext.__divergedChainIndex; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                prevent: prevent
            }, previousChain[i]);
        }
        // execute onBeforeEnter when NOT skipping attach
        if (!newContext.__skipAttach) for(let i = 0; i < newChain.length; i++){
            if (i < newContext.__divergedChainIndex) {
                if (i < previousChain.length && previousChain[i].element) previousChain[i].element.location = $37559147baa8b97c$var$createLocation(newContext, previousChain[i].route);
            } else {
                callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                    prevent: prevent,
                    redirect: redirect
                }, newChain[i]);
                if (newChain[i].element) newChain[i].element.location = $37559147baa8b97c$var$createLocation(newContext, newChain[i].route);
            }
        }
        return callbacks.then((amendmentResult)=>{
            if (amendmentResult) {
                if (amendmentResult.cancel) {
                    this.__previousContext.__renderId = newContext.__renderId;
                    return this.__previousContext;
                }
                if (amendmentResult.redirect) return this.__redirect(amendmentResult.redirect, newContext.__redirectCount, newContext.__renderId);
            }
            return newContext;
        });
    }
    __runOnBeforeLeaveCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $37559147baa8b97c$var$createLocation(newContext);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const afterLeaveFunction = $37559147baa8b97c$var$amend("onBeforeLeave", [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return afterLeaveFunction(result);
            }
        }).then((result)=>{
            if (!(result || {}).redirect) return result;
        });
    }
    __runOnBeforeEnterCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $37559147baa8b97c$var$createLocation(newContext, chainElement.route);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const beforeEnterFunction = $37559147baa8b97c$var$amend("onBeforeEnter", [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return beforeEnterFunction(result);
            }
        });
    }
    __isReusableElement(element, otherElement) {
        if (element && otherElement) return this.__createdByRouter.get(element) && this.__createdByRouter.get(otherElement) ? element.localName === otherElement.localName : element === otherElement;
        return false;
    }
    __isLatestRender(context) {
        return context.__renderId === this.__lastStartedRenderId;
    }
    __redirect(redirectData, counter, renderId) {
        if (counter > $37559147baa8b97c$var$MAX_REDIRECT_COUNT) throw new Error($37559147baa8b97c$var$log(`Too many redirects when rendering ${redirectData.from}`));
        return this.resolve({
            pathname: this.urlForPath(redirectData.pathname, redirectData.params),
            redirectFrom: redirectData.from,
            __redirectCount: (counter || 0) + 1,
            __renderId: renderId
        });
    }
    __ensureOutlet(outlet = this.__outlet) {
        if (!(outlet instanceof Node)) throw new TypeError($37559147baa8b97c$var$log(`Expected router outlet to be a valid DOM Node (but got ${outlet})`));
    }
    __updateBrowserHistory({ pathname: pathname, search: search = "", hash: hash = "" }, replace) {
        if (window.location.pathname !== pathname || window.location.search !== search || window.location.hash !== hash) {
            const changeState = replace ? "replaceState" : "pushState";
            window.history[changeState](null, document.title, pathname + search + hash);
            window.dispatchEvent(new PopStateEvent("popstate", {
                state: "vaadin-router-ignore"
            }));
        }
    }
    __copyUnchangedElements(context, previousContext) {
        // Find the deepest common parent between the last and the new component
        // chains. Update references for the unchanged elements in the new chain
        let deepestCommonParent = this.__outlet;
        for(let i = 0; i < context.__divergedChainIndex; i++){
            const unchangedElement = previousContext && previousContext.chain[i].element;
            if (unchangedElement) {
                if (unchangedElement.parentNode === deepestCommonParent) {
                    context.chain[i].element = unchangedElement;
                    deepestCommonParent = unchangedElement;
                } else break;
            }
        }
        return deepestCommonParent;
    }
    __addAppearingContent(context, previousContext) {
        this.__ensureOutlet();
        // If the previous 'entering' animation has not completed yet,
        // stop it and remove that content from the DOM before adding new one.
        this.__removeAppearingContent();
        // Copy reusable elements from the previousContext to current
        const deepestCommonParent = this.__copyUnchangedElements(context, previousContext);
        // Keep two lists of DOM elements:
        //  - those that should be removed once the transition animation is over
        //  - and those that should remain
        this.__appearingContent = [];
        this.__disappearingContent = Array.from(deepestCommonParent.children).filter(// Only remove layout content that was added by router
        (e)=>this.__addedByRouter.get(e) && // Do not remove the result element to avoid flickering
            e !== context.result);
        // Add new elements (starting after the deepest common parent) to the DOM.
        // That way only the components that are actually different between the two
        // locations are added to the DOM (and those that are common remain in the
        // DOM without first removing and then adding them again).
        let parentElement = deepestCommonParent;
        for(let i = context.__divergedChainIndex; i < context.chain.length; i++){
            const elementToAdd = context.chain[i].element;
            if (elementToAdd) {
                parentElement.appendChild(elementToAdd);
                this.__addedByRouter.set(elementToAdd, true);
                if (parentElement === deepestCommonParent) this.__appearingContent.push(elementToAdd);
                parentElement = elementToAdd;
            }
        }
    }
    __removeDisappearingContent() {
        if (this.__disappearingContent) $37559147baa8b97c$var$removeDomNodes(this.__disappearingContent);
        this.__disappearingContent = null;
        this.__appearingContent = null;
    }
    __removeAppearingContent() {
        if (this.__disappearingContent && this.__appearingContent) {
            $37559147baa8b97c$var$removeDomNodes(this.__appearingContent);
            this.__disappearingContent = null;
            this.__appearingContent = null;
        }
    }
    __runOnAfterLeaveCallbacks(currentContext, targetContext) {
        if (!targetContext) return;
        // REVERSE iteration: from Z to A
        for(let i = targetContext.chain.length - 1; i >= currentContext.__divergedChainIndex; i--){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = targetContext.chain[i].element;
            if (!currentComponent) continue;
            try {
                const location = $37559147baa8b97c$var$createLocation(currentContext);
                $37559147baa8b97c$var$runCallbackIfPossible(currentComponent.onAfterLeave, [
                    location,
                    {},
                    targetContext.resolver
                ], currentComponent);
            } finally{
                if (this.__disappearingContent.indexOf(currentComponent) > -1) $37559147baa8b97c$var$removeDomNodes(currentComponent.children);
            }
        }
    }
    __runOnAfterEnterCallbacks(currentContext) {
        // forward iteration: from A to Z
        for(let i = currentContext.__divergedChainIndex; i < currentContext.chain.length; i++){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = currentContext.chain[i].element || {};
            const location = $37559147baa8b97c$var$createLocation(currentContext, currentContext.chain[i].route);
            $37559147baa8b97c$var$runCallbackIfPossible(currentComponent.onAfterEnter, [
                location,
                {},
                currentContext.resolver
            ], currentComponent);
        }
    }
    __animateIfNeeded(context) {
        const from = (this.__disappearingContent || [])[0];
        const to = (this.__appearingContent || [])[0];
        const promises = [];
        const chain = context.chain;
        let config;
        for(let i = chain.length; i > 0; i--)if (chain[i - 1].route.animate) {
            config = chain[i - 1].route.animate;
            break;
        }
        if (from && to && config) {
            const leave = $37559147baa8b97c$var$isObject(config) && config.leave || "leaving";
            const enter = $37559147baa8b97c$var$isObject(config) && config.enter || "entering";
            promises.push($37559147baa8b97c$var$animate(from, leave));
            promises.push($37559147baa8b97c$var$animate(to, enter));
        }
        return Promise.all(promises).then(()=>context);
    }
    /**
   * Subscribes this instance to navigation events on the `window`.
   *
   * NOTE: beware of resource leaks. For as long as a router instance is
   * subscribed to navigation events, it won't be garbage collected.
   */ subscribe() {
        window.addEventListener("vaadin-router-go", this.__navigationEventHandler);
    }
    /**
   * Removes the subscription to navigation events created in the `subscribe()`
   * method.
   */ unsubscribe() {
        window.removeEventListener("vaadin-router-go", this.__navigationEventHandler);
    }
    __onNavigationEvent(event) {
        const { pathname: pathname, search: search, hash: hash } = event ? event.detail : window.location;
        if ($37559147baa8b97c$var$isString(this.__normalizePathname(pathname))) {
            if (event && event.preventDefault) event.preventDefault();
            this.render({
                pathname: pathname,
                search: search,
                hash: hash
            }, true);
        }
    }
    /**
   * Configures what triggers Router navigation events:
   *  - `POPSTATE`: popstate events on the current `window`
   *  - `CLICK`: click events on `<a>` links leading to the current page
   *
   * This method is invoked with the pre-configured values when creating a new Router instance.
   * By default, both `POPSTATE` and `CLICK` are enabled. This setup is expected to cover most of the use cases.
   *
   * See the `router-config.js` for the default navigation triggers config. Based on it, you can
   * create the own one and only import the triggers you need, instead of pulling in all the code,
   * e.g. if you want to handle `click` differently.
   *
   * See also **Navigation Triggers** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * @param {...NavigationTrigger} triggers
   */ static setTriggers(...triggers) {
        $37559147baa8b97c$var$setNavigationTriggers(triggers);
    }
    /**
   * Generates a URL for the route with the given name, optionally performing
   * substitution of parameters.
   *
   * The route is searched in all the Router instances subscribed to
   * navigation events.
   *
   * **Note:** For child route names, only array children are considered.
   * It is not possible to generate URLs using a name for routes set with
   * a children function.
   *
   * @function urlForName
   * @param {!string} name the route name or the route’s `component` name.
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForName(name, params) {
        if (!this.__urlForName) this.__urlForName = $37559147baa8b97c$var$generateUrls(this);
        return $37559147baa8b97c$var$getPathnameForRouter(this.__urlForName(name, params), this);
    }
    /**
   * Generates a URL for the given route path, optionally performing
   * substitution of parameters.
   *
   * @param {!string} path string route path declared in [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForPath(path, params) {
        return $37559147baa8b97c$var$getPathnameForRouter($37559147baa8b97c$export$55185c17a0fcbe46.pathToRegexp.compile(path)(params), this);
    }
    /**
   * Triggers navigation to a new path. Returns a boolean without waiting until
   * the navigation is complete. Returns `true` if at least one `Router`
   * has handled the navigation (was subscribed and had `baseUrl` matching
   * the `path` argument), otherwise returns `false`.
   *
   * @param {!string|!{pathname: !string, search: (string|undefined), hash: (string|undefined)}} path
   *   a new in-app path string, or an URL-like object with `pathname`
   *   string property, and optional `search` and `hash` string properties.
   * @return {boolean}
   */ static go(path) {
        const { pathname: pathname, search: search, hash: hash } = $37559147baa8b97c$var$isString(path) ? this.__createUrl(path, "http://a") // some base to omit origin
         : path;
        return $37559147baa8b97c$var$fireRouterEvent("go", {
            pathname: pathname,
            search: search,
            hash: hash
        });
    }
}
const $37559147baa8b97c$var$DEV_MODE_CODE_REGEXP = /\/\*[\*!]\s+vaadin-dev-mode:start([\s\S]*)vaadin-dev-mode:end\s+\*\*\//i;
const $37559147baa8b97c$var$FlowClients = window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients;
function $37559147baa8b97c$var$isMinified() {
    function test() {
        /** vaadin-dev-mode:start
    return false;
    vaadin-dev-mode:end **/ return true;
    }
    return $37559147baa8b97c$var$uncommentAndRun(test);
}
function $37559147baa8b97c$var$isDevelopmentMode() {
    try {
        if ($37559147baa8b97c$var$isForcedDevelopmentMode()) return true;
        if (!$37559147baa8b97c$var$isLocalhost()) return false;
        if ($37559147baa8b97c$var$FlowClients) return !$37559147baa8b97c$var$isFlowProductionMode();
        return !$37559147baa8b97c$var$isMinified();
    } catch (e) {
        // Some error in this code, assume production so no further actions will be taken
        return false;
    }
}
function $37559147baa8b97c$var$isForcedDevelopmentMode() {
    return localStorage.getItem("vaadin.developmentmode.force");
}
function $37559147baa8b97c$var$isLocalhost() {
    return [
        "localhost",
        "127.0.0.1"
    ].indexOf(window.location.hostname) >= 0;
}
function $37559147baa8b97c$var$isFlowProductionMode() {
    if ($37559147baa8b97c$var$FlowClients) {
        const productionModeApps = Object.keys($37559147baa8b97c$var$FlowClients).map((key)=>$37559147baa8b97c$var$FlowClients[key]).filter((client)=>client.productionMode);
        if (productionModeApps.length > 0) return true;
    }
    return false;
}
function $37559147baa8b97c$var$uncommentAndRun(callback, args) {
    if (typeof callback !== "function") return;
    const match = $37559147baa8b97c$var$DEV_MODE_CODE_REGEXP.exec(callback.toString());
    if (match) try {
        // requires CSP: script-src 'unsafe-eval'
        callback = new Function(match[1]);
    } catch (e) {
        // eat the exception
        console.log("vaadin-development-mode-detector: uncommentAndRun() failed", e);
    }
    return callback(args);
}
// A guard against polymer-modulizer removing the window.Vaadin
// initialization above.
window["Vaadin"] = window["Vaadin"] || {};
/**
 * Inspects the source code of the given `callback` function for
 * specially-marked _commented_ code. If such commented code is found in the
 * callback source, uncomments and runs that code instead of the callback
 * itself. Otherwise runs the callback as is.
 *
 * The optional arguments are passed into the callback / uncommented code,
 * the result is returned.
 *
 * See the `isMinified()` function source code in this file for an example.
 *
 */ const $37559147baa8b97c$var$runIfDevelopmentMode = function(callback, args) {
    if (window.Vaadin.developmentMode) return $37559147baa8b97c$var$uncommentAndRun(callback, args);
};
if (window.Vaadin.developmentMode === undefined) window.Vaadin.developmentMode = $37559147baa8b97c$var$isDevelopmentMode();
/* This file is autogenerated from src/vaadin-usage-statistics.tpl.html */ function $37559147baa8b97c$var$maybeGatherAndSendStats() {
/** vaadin-dev-mode:start
  (function () {
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var getPolymerVersion = function getPolymerVersion() {
  return window.Polymer && window.Polymer.version;
};

var StatisticsGatherer = function () {
  function StatisticsGatherer(logger) {
    classCallCheck(this, StatisticsGatherer);

    this.now = new Date().getTime();
    this.logger = logger;
  }

  createClass(StatisticsGatherer, [{
    key: 'frameworkVersionDetectors',
    value: function frameworkVersionDetectors() {
      return {
        'Flow': function Flow() {
          if (window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients) {
            var flowVersions = Object.keys(window.Vaadin.Flow.clients).map(function (key) {
              return window.Vaadin.Flow.clients[key];
            }).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().flow;
            });
            if (flowVersions.length > 0) {
              return flowVersions[0];
            }
          }
        },
        'Vaadin Framework': function VaadinFramework() {
          if (window.vaadin && window.vaadin.clients) {
            var frameworkVersions = Object.values(window.vaadin.clients).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().vaadinVersion;
            });
            if (frameworkVersions.length > 0) {
              return frameworkVersions[0];
            }
          }
        },
        'AngularJs': function AngularJs() {
          if (window.angular && window.angular.version && window.angular.version) {
            return window.angular.version.full;
          }
        },
        'Angular': function Angular() {
          if (window.ng) {
            var tags = document.querySelectorAll("[ng-version]");
            if (tags.length > 0) {
              return tags[0].getAttribute("ng-version");
            }
            return "Unknown";
          }
        },
        'Backbone.js': function BackboneJs() {
          if (window.Backbone) {
            return window.Backbone.VERSION;
          }
        },
        'React': function React() {
          var reactSelector = '[data-reactroot], [data-reactid]';
          if (!!document.querySelector(reactSelector)) {
            // React does not publish the version by default
            return "unknown";
          }
        },
        'Ember': function Ember() {
          if (window.Em && window.Em.VERSION) {
            return window.Em.VERSION;
          } else if (window.Ember && window.Ember.VERSION) {
            return window.Ember.VERSION;
          }
        },
        'jQuery': function (_jQuery) {
          function jQuery() {
            return _jQuery.apply(this, arguments);
          }

          jQuery.toString = function () {
            return _jQuery.toString();
          };

          return jQuery;
        }(function () {
          if (typeof jQuery === 'function' && jQuery.prototype.jquery !== undefined) {
            return jQuery.prototype.jquery;
          }
        }),
        'Polymer': function Polymer() {
          var version = getPolymerVersion();
          if (version) {
            return version;
          }
        },
        'LitElement': function LitElement() {
          var version = window.litElementVersions && window.litElementVersions[0];
          if (version) {
            return version;
          }
        },
        'LitHtml': function LitHtml() {
          var version = window.litHtmlVersions && window.litHtmlVersions[0];
          if (version) {
            return version;
          }
        },
        'Vue.js': function VueJs() {
          if (window.Vue) {
            return window.Vue.version;
          }
        }
      };
    }
  }, {
    key: 'getUsedVaadinElements',
    value: function getUsedVaadinElements(elements) {
      var version = getPolymerVersion();
      var elementClasses = void 0;
      // NOTE: In case you edit the code here, YOU MUST UPDATE any statistics reporting code in Flow.
      // Check all locations calling the method getEntries() in
      // https://github.com/vaadin/flow/blob/master/flow-server/src/main/java/com/vaadin/flow/internal/UsageStatistics.java#L106
      // Currently it is only used by BootstrapHandler.
      if (version && version.indexOf('2') === 0) {
        // Polymer 2: components classes are stored in window.Vaadin
        elementClasses = Object.keys(window.Vaadin).map(function (c) {
          return window.Vaadin[c];
        }).filter(function (c) {
          return c.is;
        });
      } else {
        // Polymer 3: components classes are stored in window.Vaadin.registrations
        elementClasses = window.Vaadin.registrations || [];
      }
      elementClasses.forEach(function (klass) {
        var version = klass.version ? klass.version : "0.0.0";
        elements[klass.is] = { version: version };
      });
    }
  }, {
    key: 'getUsedVaadinThemes',
    value: function getUsedVaadinThemes(themes) {
      ['Lumo', 'Material'].forEach(function (themeName) {
        var theme;
        var version = getPolymerVersion();
        if (version && version.indexOf('2') === 0) {
          // Polymer 2: themes are stored in window.Vaadin
          theme = window.Vaadin[themeName];
        } else {
          // Polymer 3: themes are stored in custom element registry
          theme = customElements.get('vaadin-' + themeName.toLowerCase() + '-styles');
        }
        if (theme && theme.version) {
          themes[themeName] = { version: theme.version };
        }
      });
    }
  }, {
    key: 'getFrameworks',
    value: function getFrameworks(frameworks) {
      var detectors = this.frameworkVersionDetectors();
      Object.keys(detectors).forEach(function (framework) {
        var detector = detectors[framework];
        try {
          var version = detector();
          if (version) {
            frameworks[framework] = { version: version };
          }
        } catch (e) {}
      });
    }
  }, {
    key: 'gather',
    value: function gather(storage) {
      var storedStats = storage.read();
      var gatheredStats = {};
      var types = ["elements", "frameworks", "themes"];

      types.forEach(function (type) {
        gatheredStats[type] = {};
        if (!storedStats[type]) {
          storedStats[type] = {};
        }
      });

      var previousStats = JSON.stringify(storedStats);

      this.getUsedVaadinElements(gatheredStats.elements);
      this.getFrameworks(gatheredStats.frameworks);
      this.getUsedVaadinThemes(gatheredStats.themes);

      var now = this.now;
      types.forEach(function (type) {
        var keys = Object.keys(gatheredStats[type]);
        keys.forEach(function (key) {
          if (!storedStats[type][key] || _typeof(storedStats[type][key]) != _typeof({})) {
            storedStats[type][key] = { firstUsed: now };
          }
          // Discards any previously logged version number
          storedStats[type][key].version = gatheredStats[type][key].version;
          storedStats[type][key].lastUsed = now;
        });
      });

      var newStats = JSON.stringify(storedStats);
      storage.write(newStats);
      if (newStats != previousStats && Object.keys(storedStats).length > 0) {
        this.logger.debug("New stats: " + newStats);
      }
    }
  }]);
  return StatisticsGatherer;
}();

var StatisticsStorage = function () {
  function StatisticsStorage(key) {
    classCallCheck(this, StatisticsStorage);

    this.key = key;
  }

  createClass(StatisticsStorage, [{
    key: 'read',
    value: function read() {
      var localStorageStatsString = localStorage.getItem(this.key);
      try {
        return JSON.parse(localStorageStatsString ? localStorageStatsString : '{}');
      } catch (e) {
        return {};
      }
    }
  }, {
    key: 'write',
    value: function write(data) {
      localStorage.setItem(this.key, data);
    }
  }, {
    key: 'clear',
    value: function clear() {
      localStorage.removeItem(this.key);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      var storedStats = this.read();
      var empty = true;
      Object.keys(storedStats).forEach(function (key) {
        if (Object.keys(storedStats[key]).length > 0) {
          empty = false;
        }
      });

      return empty;
    }
  }]);
  return StatisticsStorage;
}();

var StatisticsSender = function () {
  function StatisticsSender(url, logger) {
    classCallCheck(this, StatisticsSender);

    this.url = url;
    this.logger = logger;
  }

  createClass(StatisticsSender, [{
    key: 'send',
    value: function send(data, errorHandler) {
      var logger = this.logger;

      if (navigator.onLine === false) {
        logger.debug("Offline, can't send");
        errorHandler();
        return;
      }
      logger.debug("Sending data to " + this.url);

      var req = new XMLHttpRequest();
      req.withCredentials = true;
      req.addEventListener("load", function () {
        // Stats sent, nothing more to do
        logger.debug("Response: " + req.responseText);
      });
      req.addEventListener("error", function () {
        logger.debug("Send failed");
        errorHandler();
      });
      req.addEventListener("abort", function () {
        logger.debug("Send aborted");
        errorHandler();
      });
      req.open("POST", this.url);
      req.setRequestHeader("Content-Type", "application/json");
      req.send(data);
    }
  }]);
  return StatisticsSender;
}();

var StatisticsLogger = function () {
  function StatisticsLogger(id) {
    classCallCheck(this, StatisticsLogger);

    this.id = id;
  }

  createClass(StatisticsLogger, [{
    key: '_isDebug',
    value: function _isDebug() {
      return localStorage.getItem("vaadin." + this.id + ".debug");
    }
  }, {
    key: 'debug',
    value: function debug(msg) {
      if (this._isDebug()) {
        console.info(this.id + ": " + msg);
      }
    }
  }]);
  return StatisticsLogger;
}();

var UsageStatistics = function () {
  function UsageStatistics() {
    classCallCheck(this, UsageStatistics);

    this.now = new Date();
    this.timeNow = this.now.getTime();
    this.gatherDelay = 10; // Delay between loading this file and gathering stats
    this.initialDelay = 24 * 60 * 60;

    this.logger = new StatisticsLogger("statistics");
    this.storage = new StatisticsStorage("vaadin.statistics.basket");
    this.gatherer = new StatisticsGatherer(this.logger);
    this.sender = new StatisticsSender("https://tools.vaadin.com/usage-stats/submit", this.logger);
  }

  createClass(UsageStatistics, [{
    key: 'maybeGatherAndSend',
    value: function maybeGatherAndSend() {
      var _this = this;

      if (localStorage.getItem(UsageStatistics.optOutKey)) {
        return;
      }
      this.gatherer.gather(this.storage);
      setTimeout(function () {
        _this.maybeSend();
      }, this.gatherDelay * 1000);
    }
  }, {
    key: 'lottery',
    value: function lottery() {
      return true;
    }
  }, {
    key: 'currentMonth',
    value: function currentMonth() {
      return this.now.getYear() * 12 + this.now.getMonth();
    }
  }, {
    key: 'maybeSend',
    value: function maybeSend() {
      var firstUse = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      var monthProcessed = Number(localStorage.getItem(UsageStatistics.monthProcessedKey));

      if (!firstUse) {
        // Use a grace period to avoid interfering with tests, incognito mode etc
        firstUse = this.timeNow;
        localStorage.setItem(UsageStatistics.firstUseKey, firstUse);
      }

      if (this.timeNow < firstUse + this.initialDelay * 1000) {
        this.logger.debug("No statistics will be sent until the initial delay of " + this.initialDelay + "s has passed");
        return;
      }
      if (this.currentMonth() <= monthProcessed) {
        this.logger.debug("This month has already been processed");
        return;
      }
      localStorage.setItem(UsageStatistics.monthProcessedKey, this.currentMonth());
      // Use random sampling
      if (this.lottery()) {
        this.logger.debug("Congratulations, we have a winner!");
      } else {
        this.logger.debug("Sorry, no stats from you this time");
        return;
      }

      this.send();
    }
  }, {
    key: 'send',
    value: function send() {
      // Ensure we have the latest data
      this.gatherer.gather(this.storage);

      // Read, send and clean up
      var data = this.storage.read();
      data["firstUse"] = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      data["usageStatisticsVersion"] = UsageStatistics.version;
      var info = 'This request contains usage statistics gathered from the application running in development mode. \n\nStatistics gathering is automatically disabled and excluded from production builds.\n\nFor details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.\n\n\n\n';
      var self = this;
      this.sender.send(info + JSON.stringify(data), function () {
        // Revert the 'month processed' flag
        localStorage.setItem(UsageStatistics.monthProcessedKey, self.currentMonth() - 1);
      });
    }
  }], [{
    key: 'version',
    get: function get$1() {
      return '2.1.2';
    }
  }, {
    key: 'firstUseKey',
    get: function get$1() {
      return 'vaadin.statistics.firstuse';
    }
  }, {
    key: 'monthProcessedKey',
    get: function get$1() {
      return 'vaadin.statistics.monthProcessed';
    }
  }, {
    key: 'optOutKey',
    get: function get$1() {
      return 'vaadin.statistics.optout';
    }
  }]);
  return UsageStatistics;
}();

try {
  window.Vaadin = window.Vaadin || {};
  window.Vaadin.usageStatsChecker = window.Vaadin.usageStatsChecker || new UsageStatistics();
  window.Vaadin.usageStatsChecker.maybeGatherAndSend();
} catch (e) {
  // Intentionally ignored as this is not a problem in the app being developed
}

}());

  vaadin-dev-mode:end **/ }
const $37559147baa8b97c$var$usageStatistics = function() {
    if (typeof $37559147baa8b97c$var$runIfDevelopmentMode === "function") return $37559147baa8b97c$var$runIfDevelopmentMode($37559147baa8b97c$var$maybeGatherAndSendStats);
};
window.Vaadin = window.Vaadin || {};
window.Vaadin.registrations = window.Vaadin.registrations || [];
window.Vaadin.registrations.push({
    is: "@vaadin/router",
    version: "1.7.4"
});
$37559147baa8b97c$var$usageStatistics();
$37559147baa8b97c$export$55185c17a0fcbe46.NavigationTrigger = {
    POPSTATE: $37559147baa8b97c$var$POPSTATE,
    CLICK: $37559147baa8b97c$var$CLICK
};


class $e5b0870a079870e6$export$54a961b2d8e954c3 {
}
function $e5b0870a079870e6$export$54041a06ff8d6008(router, routeTree) {
    router.setRoutes(routeTree);
    return router;
}
function $e5b0870a079870e6$export$baddd0131ee8c05b(element) {
    return new (0, $37559147baa8b97c$export$55185c17a0fcbe46)(element);
}
function $e5b0870a079870e6$export$91ec06c66ef21811(element, routeTree, RouterClass = (0, $37559147baa8b97c$export$55185c17a0fcbe46), location = window.location) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const router = new RouterClass(element);
    $e5b0870a079870e6$export$54041a06ff8d6008(router, routeTree);
    const prefix = undefined ?? "";
    const { search: search, pathname: pathname } = location;
    const route = pathname.replace(prefix, "");
    if (route === "/") // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    RouterClass.go(`${prefix}/default/en/new-session${search}`);
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $9d41c80c94e7185d$var$extendStatics = function(d, b) {
    $9d41c80c94e7185d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $9d41c80c94e7185d$var$extendStatics(d, b);
};
function $9d41c80c94e7185d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $9d41c80c94e7185d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9d41c80c94e7185d$export$18ce0697a983be9b = function() {
    $9d41c80c94e7185d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d41c80c94e7185d$export$18ce0697a983be9b.apply(this, arguments);
};
function $9d41c80c94e7185d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9d41c80c94e7185d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9d41c80c94e7185d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9d41c80c94e7185d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $9d41c80c94e7185d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $9d41c80c94e7185d$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $9d41c80c94e7185d$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $9d41c80c94e7185d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9d41c80c94e7185d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9d41c80c94e7185d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $9d41c80c94e7185d$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $9d41c80c94e7185d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $9d41c80c94e7185d$export$45d3717a4c69092e(o, m, p);
}
function $9d41c80c94e7185d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9d41c80c94e7185d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9d41c80c94e7185d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9d41c80c94e7185d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9d41c80c94e7185d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9d41c80c94e7185d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $9d41c80c94e7185d$export$10c90e4f7922046c(v) {
    return this instanceof $9d41c80c94e7185d$export$10c90e4f7922046c ? (this.v = v, this) : new $9d41c80c94e7185d$export$10c90e4f7922046c(v);
}
function $9d41c80c94e7185d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9d41c80c94e7185d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9d41c80c94e7185d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9d41c80c94e7185d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $9d41c80c94e7185d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9d41c80c94e7185d$export$19a8beecd37a4c45 === "function" ? $9d41c80c94e7185d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9d41c80c94e7185d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $9d41c80c94e7185d$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $9d41c80c94e7185d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9d41c80c94e7185d$export$45d3717a4c69092e(result, mod, k);
    }
    $9d41c80c94e7185d$var$__setModuleDefault(result, mod);
    return result;
}
function $9d41c80c94e7185d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9d41c80c94e7185d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9d41c80c94e7185d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $9d41c80c94e7185d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $9d41c80c94e7185d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $9d41c80c94e7185d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $9d41c80c94e7185d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $9d41c80c94e7185d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $9d41c80c94e7185d$export$2e2bcd8739ae039 = {
    __extends: $9d41c80c94e7185d$export$a8ba968b8961cb8a,
    __assign: $9d41c80c94e7185d$export$18ce0697a983be9b,
    __rest: $9d41c80c94e7185d$export$3c9a16f847548506,
    __decorate: $9d41c80c94e7185d$export$29e00dfd3077644b,
    __param: $9d41c80c94e7185d$export$d5ad3fd78186038f,
    __metadata: $9d41c80c94e7185d$export$f1db080c865becb9,
    __awaiter: $9d41c80c94e7185d$export$1050f835b63b671e,
    __generator: $9d41c80c94e7185d$export$67ebef60e6f28a6,
    __createBinding: $9d41c80c94e7185d$export$45d3717a4c69092e,
    __exportStar: $9d41c80c94e7185d$export$f33643c0debef087,
    __values: $9d41c80c94e7185d$export$19a8beecd37a4c45,
    __read: $9d41c80c94e7185d$export$8d051b38c9118094,
    __spread: $9d41c80c94e7185d$export$afc72e2116322959,
    __spreadArrays: $9d41c80c94e7185d$export$6388937ca91ccae8,
    __spreadArray: $9d41c80c94e7185d$export$1216008129fb82ed,
    __await: $9d41c80c94e7185d$export$10c90e4f7922046c,
    __asyncGenerator: $9d41c80c94e7185d$export$e427f37a30a4de9b,
    __asyncDelegator: $9d41c80c94e7185d$export$bbd80228419bb833,
    __asyncValues: $9d41c80c94e7185d$export$e3b29a3d6162315f,
    __makeTemplateObject: $9d41c80c94e7185d$export$4fb47efe1390b86f,
    __importStar: $9d41c80c94e7185d$export$c21735bcef00d192,
    __importDefault: $9d41c80c94e7185d$export$da59b14a69baef04,
    __classPrivateFieldGet: $9d41c80c94e7185d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $9d41c80c94e7185d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $9d41c80c94e7185d$export$81fdc39f203e4e04,
    __addDisposableResource: $9d41c80c94e7185d$export$88ac25d8e944e405,
    __disposeResources: $9d41c80c94e7185d$export$8f076105dc360e92
};


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2123215298adf759$var$t = window, $2123215298adf759$export$b4d10f6001c083c2 = $2123215298adf759$var$t.ShadowRoot && (void 0 === $2123215298adf759$var$t.ShadyCSS || $2123215298adf759$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $2123215298adf759$var$s = Symbol(), $2123215298adf759$var$n = new WeakMap;
class $2123215298adf759$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $2123215298adf759$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($2123215298adf759$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $2123215298adf759$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $2123215298adf759$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $2123215298adf759$export$8d80f9cac07cdb3 = (t)=>new $2123215298adf759$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $2123215298adf759$var$s), $2123215298adf759$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $2123215298adf759$export$505d1e8739bad805(n, t, $2123215298adf759$var$s);
}, $2123215298adf759$export$2ca4a66ec4cecb90 = (s, n)=>{
    $2123215298adf759$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $2123215298adf759$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $2123215298adf759$export$ee69dfd951e24778 = $2123215298adf759$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $2123215298adf759$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $376a1641c3ee24aa$var$s;
const $376a1641c3ee24aa$var$e = window, $376a1641c3ee24aa$var$r = $376a1641c3ee24aa$var$e.trustedTypes, $376a1641c3ee24aa$var$h = $376a1641c3ee24aa$var$r ? $376a1641c3ee24aa$var$r.emptyScript : "", $376a1641c3ee24aa$var$o = $376a1641c3ee24aa$var$e.reactiveElementPolyfillSupport, $376a1641c3ee24aa$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $376a1641c3ee24aa$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $376a1641c3ee24aa$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $376a1641c3ee24aa$var$l = {
    attribute: !0,
    type: String,
    converter: $376a1641c3ee24aa$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $376a1641c3ee24aa$export$53a6892c50694894
}, $376a1641c3ee24aa$var$d = "finalized";
class $376a1641c3ee24aa$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $376a1641c3ee24aa$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $376a1641c3ee24aa$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($376a1641c3ee24aa$var$d)) return !1;
        this[$376a1641c3ee24aa$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $2123215298adf759$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $2123215298adf759$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $2123215298adf759$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $376a1641c3ee24aa$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $376a1641c3ee24aa$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $376a1641c3ee24aa$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $376a1641c3ee24aa$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$376a1641c3ee24aa$export$c7c07a37856565d[$376a1641c3ee24aa$var$d] = !0, $376a1641c3ee24aa$export$c7c07a37856565d.elementProperties = new Map, $376a1641c3ee24aa$export$c7c07a37856565d.elementStyles = [], $376a1641c3ee24aa$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $376a1641c3ee24aa$var$o || $376a1641c3ee24aa$var$o({
    ReactiveElement: $376a1641c3ee24aa$export$c7c07a37856565d
}), (null !== ($376a1641c3ee24aa$var$s = $376a1641c3ee24aa$var$e.reactiveElementVersions) && void 0 !== $376a1641c3ee24aa$var$s ? $376a1641c3ee24aa$var$s : $376a1641c3ee24aa$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $5bb961e9df347661$var$t;
const $5bb961e9df347661$var$i = window, $5bb961e9df347661$var$s = $5bb961e9df347661$var$i.trustedTypes, $5bb961e9df347661$var$e = $5bb961e9df347661$var$s ? $5bb961e9df347661$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $5bb961e9df347661$var$o = "$lit$", $5bb961e9df347661$var$n = `lit$${(Math.random() + "").slice(9)}$`, $5bb961e9df347661$var$l = "?" + $5bb961e9df347661$var$n, $5bb961e9df347661$var$h = `<${$5bb961e9df347661$var$l}>`, $5bb961e9df347661$var$r = document, $5bb961e9df347661$var$u = ()=>$5bb961e9df347661$var$r.createComment(""), $5bb961e9df347661$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $5bb961e9df347661$var$c = Array.isArray, $5bb961e9df347661$var$v = (t)=>$5bb961e9df347661$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $5bb961e9df347661$var$a = "[ 	\n\f\r]", $5bb961e9df347661$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $5bb961e9df347661$var$_ = /-->/g, $5bb961e9df347661$var$m = />/g, $5bb961e9df347661$var$p = RegExp(`>|${$5bb961e9df347661$var$a}(?:([^\\s"'>=/]+)(${$5bb961e9df347661$var$a}*=${$5bb961e9df347661$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $5bb961e9df347661$var$g = /'/g, $5bb961e9df347661$var$$ = /"/g, $5bb961e9df347661$var$y = /^(?:script|style|textarea|title)$/i, $5bb961e9df347661$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $5bb961e9df347661$export$c0bb0b647f701bb5 = $5bb961e9df347661$var$w(1), $5bb961e9df347661$export$7ed1367e7fa1ad68 = $5bb961e9df347661$var$w(2), $5bb961e9df347661$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $5bb961e9df347661$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $5bb961e9df347661$var$E = new WeakMap, $5bb961e9df347661$var$C = $5bb961e9df347661$var$r.createTreeWalker($5bb961e9df347661$var$r, 129, null, !1);
function $5bb961e9df347661$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $5bb961e9df347661$var$e ? $5bb961e9df347661$var$e.createHTML(i) : i;
}
const $5bb961e9df347661$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $5bb961e9df347661$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $5bb961e9df347661$var$f ? "!--" === c[1] ? u = $5bb961e9df347661$var$_ : void 0 !== c[1] ? u = $5bb961e9df347661$var$m : void 0 !== c[2] ? ($5bb961e9df347661$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $5bb961e9df347661$var$p) : void 0 !== c[3] && (u = $5bb961e9df347661$var$p) : u === $5bb961e9df347661$var$p ? ">" === c[0] ? (u = null != l ? l : $5bb961e9df347661$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $5bb961e9df347661$var$p : '"' === c[3] ? $5bb961e9df347661$var$$ : $5bb961e9df347661$var$g) : u === $5bb961e9df347661$var$$ || u === $5bb961e9df347661$var$g ? u = $5bb961e9df347661$var$p : u === $5bb961e9df347661$var$_ || u === $5bb961e9df347661$var$m ? u = $5bb961e9df347661$var$f : (u = $5bb961e9df347661$var$p, l = void 0);
        const w = u === $5bb961e9df347661$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $5bb961e9df347661$var$f ? s + $5bb961e9df347661$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $5bb961e9df347661$var$o + s.slice(v) + $5bb961e9df347661$var$n + w) : s + $5bb961e9df347661$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $5bb961e9df347661$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $5bb961e9df347661$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $5bb961e9df347661$var$V(t, i);
        if (this.el = $5bb961e9df347661$var$N.createElement(a, e), $5bb961e9df347661$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $5bb961e9df347661$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($5bb961e9df347661$var$o) || i.startsWith($5bb961e9df347661$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $5bb961e9df347661$var$o).split($5bb961e9df347661$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $5bb961e9df347661$var$H : "?" === i[1] ? $5bb961e9df347661$var$L : "@" === i[1] ? $5bb961e9df347661$var$z : $5bb961e9df347661$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($5bb961e9df347661$var$y.test(h.tagName)) {
                    const t = h.textContent.split($5bb961e9df347661$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $5bb961e9df347661$var$s ? $5bb961e9df347661$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $5bb961e9df347661$var$u()), $5bb961e9df347661$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $5bb961e9df347661$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $5bb961e9df347661$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($5bb961e9df347661$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $5bb961e9df347661$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $5bb961e9df347661$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $5bb961e9df347661$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $5bb961e9df347661$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $5bb961e9df347661$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $5bb961e9df347661$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $5bb961e9df347661$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $5bb961e9df347661$var$r).importNode(s, !0);
        $5bb961e9df347661$var$C.currentNode = o;
        let n = $5bb961e9df347661$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $5bb961e9df347661$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $5bb961e9df347661$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $5bb961e9df347661$var$C.nextNode(), l++);
        }
        return $5bb961e9df347661$var$C.currentNode = $5bb961e9df347661$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $5bb961e9df347661$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $5bb961e9df347661$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $5bb961e9df347661$var$S(this, t, i), $5bb961e9df347661$var$d(t) ? t === $5bb961e9df347661$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $5bb961e9df347661$export$45b790e32b2810ee && this._$AR(), this._$AH = $5bb961e9df347661$export$45b790e32b2810ee) : t !== this._$AH && t !== $5bb961e9df347661$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $5bb961e9df347661$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $5bb961e9df347661$export$45b790e32b2810ee && $5bb961e9df347661$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($5bb961e9df347661$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $5bb961e9df347661$var$N.createElement($5bb961e9df347661$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $5bb961e9df347661$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $5bb961e9df347661$var$E.get(t.strings);
        return void 0 === i && $5bb961e9df347661$var$E.set(t.strings, i = new $5bb961e9df347661$var$N(t)), i;
    }
    T(t) {
        $5bb961e9df347661$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $5bb961e9df347661$var$R(this.k($5bb961e9df347661$var$u()), this.k($5bb961e9df347661$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $5bb961e9df347661$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $5bb961e9df347661$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $5bb961e9df347661$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $5bb961e9df347661$var$S(this, t, i, 0), n = !$5bb961e9df347661$var$d(t) || t !== this._$AH && t !== $5bb961e9df347661$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $5bb961e9df347661$var$S(this, e[s + l], i, l), h === $5bb961e9df347661$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$5bb961e9df347661$var$d(h) || h !== this._$AH[l]), h === $5bb961e9df347661$export$45b790e32b2810ee ? t = $5bb961e9df347661$export$45b790e32b2810ee : t !== $5bb961e9df347661$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $5bb961e9df347661$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $5bb961e9df347661$var$H extends $5bb961e9df347661$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $5bb961e9df347661$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $5bb961e9df347661$var$I = $5bb961e9df347661$var$s ? $5bb961e9df347661$var$s.emptyScript : "";
class $5bb961e9df347661$var$L extends $5bb961e9df347661$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $5bb961e9df347661$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $5bb961e9df347661$var$I) : this.element.removeAttribute(this.name);
    }
}
class $5bb961e9df347661$var$z extends $5bb961e9df347661$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $5bb961e9df347661$var$S(this, t, i, 0)) && void 0 !== s ? s : $5bb961e9df347661$export$45b790e32b2810ee) === $5bb961e9df347661$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $5bb961e9df347661$export$45b790e32b2810ee && e !== $5bb961e9df347661$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $5bb961e9df347661$export$45b790e32b2810ee && (e === $5bb961e9df347661$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $5bb961e9df347661$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $5bb961e9df347661$var$S(this, t);
    }
}
const $5bb961e9df347661$export$8613d1ca9052b22e = {
    O: $5bb961e9df347661$var$o,
    P: $5bb961e9df347661$var$n,
    A: $5bb961e9df347661$var$l,
    C: 1,
    M: $5bb961e9df347661$var$V,
    L: $5bb961e9df347661$var$M,
    R: $5bb961e9df347661$var$v,
    D: $5bb961e9df347661$var$S,
    I: $5bb961e9df347661$var$R,
    V: $5bb961e9df347661$var$k,
    H: $5bb961e9df347661$var$L,
    N: $5bb961e9df347661$var$z,
    U: $5bb961e9df347661$var$H,
    F: $5bb961e9df347661$var$Z
}, $5bb961e9df347661$var$B = $5bb961e9df347661$var$i.litHtmlPolyfillSupport;
null == $5bb961e9df347661$var$B || $5bb961e9df347661$var$B($5bb961e9df347661$var$N, $5bb961e9df347661$var$R), (null !== ($5bb961e9df347661$var$t = $5bb961e9df347661$var$i.litHtmlVersions) && void 0 !== $5bb961e9df347661$var$t ? $5bb961e9df347661$var$t : $5bb961e9df347661$var$i.litHtmlVersions = []).push("2.8.0");
const $5bb961e9df347661$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $5bb961e9df347661$var$R(i.insertBefore($5bb961e9df347661$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $2919ec35aa0c9943$var$l, $2919ec35aa0c9943$var$o;
const $2919ec35aa0c9943$export$8bf27daf9e8907c9 = (0, $376a1641c3ee24aa$export$c7c07a37856565d);
class $2919ec35aa0c9943$export$3f2f9f5909897157 extends (0, $376a1641c3ee24aa$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $5bb961e9df347661$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $5bb961e9df347661$export$9c068ae9cc5db4e8;
    }
}
$2919ec35aa0c9943$export$3f2f9f5909897157.finalized = !0, $2919ec35aa0c9943$export$3f2f9f5909897157._$litElement$ = !0, null === ($2919ec35aa0c9943$var$l = globalThis.litElementHydrateSupport) || void 0 === $2919ec35aa0c9943$var$l || $2919ec35aa0c9943$var$l.call(globalThis, {
    LitElement: $2919ec35aa0c9943$export$3f2f9f5909897157
});
const $2919ec35aa0c9943$var$n = globalThis.litElementPolyfillSupport;
null == $2919ec35aa0c9943$var$n || $2919ec35aa0c9943$var$n({
    LitElement: $2919ec35aa0c9943$export$3f2f9f5909897157
});
const $2919ec35aa0c9943$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($2919ec35aa0c9943$var$o = globalThis.litElementVersions) && void 0 !== $2919ec35aa0c9943$var$o ? $2919ec35aa0c9943$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $35bfe564118c7d14$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e24e784c98936ac9$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $47e412eef43c2fd3$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $47e412eef43c2fd3$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $47e412eef43c2fd3$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $47e412eef43c2fd3$var$e(n, t, o) : $47e412eef43c2fd3$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $508a6eefcf14fe64$export$ca000e230c0caa3e(t) {
    return (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e9c1c90793c75917$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $e9c1c90793c75917$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $e9c1c90793c75917$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $fa239cb691055a5e$export$b2b799818fbabcf3(e) {
    return (0, $e9c1c90793c75917$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $95c2f37d0a859407$export$2fa187e846a241c4(i, n) {
    return (0, $e9c1c90793c75917$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8660d4204a87fd9f$export$dcd0d083aa86c355(e) {
    return (0, $e9c1c90793c75917$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $4b8f3dc9653ac5ea$export$163dfc35cc43f240(e) {
    return (0, $e9c1c90793c75917$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $eca0be5f509d50f1$var$n;
const $eca0be5f509d50f1$var$e = null != (null === ($eca0be5f509d50f1$var$n = window.HTMLSlotElement) || void 0 === $eca0be5f509d50f1$var$n ? void 0 : $eca0be5f509d50f1$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $eca0be5f509d50f1$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $e9c1c90793c75917$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $eca0be5f509d50f1$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f821582fea9fe512$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $eca0be5f509d50f1$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $e9c1c90793c75917$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * Tag that allows expressions to be used in localized non-HTML template
 * strings.
 *
 * Example: msg(str`Hello ${this.user}!`);
 *
 * The Lit html tag can also be used for this purpose, but HTML will need to be
 * escaped, and there is a small overhead for HTML parsing.
 *
 * Untagged template strings with expressions aren't supported by lit-localize
 * because they don't allow for values to be captured at runtime.
 */ const $c6b9444fa6a10929$var$_str = (strings, ...values)=>({
        strTag: true,
        strings: strings,
        values: values
    });
const $c6b9444fa6a10929$export$42d51816ce590c93 = $c6b9444fa6a10929$var$_str;
const $c6b9444fa6a10929$export$d837b01947f59adf = (val)=>typeof val !== "string" && "strTag" in val;
const $c6b9444fa6a10929$export$54d1368c2e63ae35 = (strings, values, valueOrder)=>{
    let concat = strings[0];
    for(let i = 1; i < strings.length; i++){
        concat += values[valueOrder ? valueOrder[i - 1] : i - 1];
        concat += strings[i];
    }
    return concat;
};


const $b28552b036af2307$export$627842c9718b61c7 = (template)=>(0, $c6b9444fa6a10929$export$d837b01947f59adf)(template) ? (0, $c6b9444fa6a10929$export$54d1368c2e63ae35)(template.strings, template.values) : template;


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * Name of the event dispatched to `window` whenever a locale change starts,
 * finishes successfully, or fails. Only relevant to runtime mode.
 *
 * The `detail` of this event is an object with a `status` string that can be:
 * "loading", "ready", or "error", along with the relevant locale code, and
 * error message if applicable.
 *
 * You can listen for this event to know when your application should be
 * re-rendered following a locale change. See also the Localized mixin, which
 * automatically re-renders LitElement classes using this event.
 */ const $5cde22bd23a08a82$export$22ecc5ec4a7dfb64 = "lit-localize-status";



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
class $732d7d1e81b3d279$var$LocalizeController {
    constructor(host){
        this.__litLocalizeEventHandler = (event)=>{
            if (event.detail.status === "ready") this.host.requestUpdate();
        };
        this.host = host;
    }
    hostConnected() {
        window.addEventListener((0, $5cde22bd23a08a82$export$22ecc5ec4a7dfb64), this.__litLocalizeEventHandler);
    }
    hostDisconnected() {
        window.removeEventListener((0, $5cde22bd23a08a82$export$22ecc5ec4a7dfb64), this.__litLocalizeEventHandler);
    }
}
/**
 * Re-render the given LitElement whenever a new active locale has loaded.
 *
 * See also {@link localized} for the same functionality as a decorator.
 *
 * When using lit-localize in transform mode, calls to this function are
 * replaced with undefined.
 *
 * Usage:
 *
 *   import {LitElement, html} from 'lit';
 *   import {msg, updateWhenLocaleChanges} from '@lit/localize';
 *
 *   class MyElement extends LitElement {
 *     constructor() {
 *       super();
 *       updateWhenLocaleChanges(this);
 *     }
 *
 *     render() {
 *       return html`<b>${msg('Hello World')}</b>`;
 *     }
 *   }
 */ const $732d7d1e81b3d279$var$_updateWhenLocaleChanges = (host)=>host.addController(new $732d7d1e81b3d279$var$LocalizeController(host));
const $732d7d1e81b3d279$export$19147fd8eb2795e4 = $732d7d1e81b3d279$var$_updateWhenLocaleChanges;


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
/**
 * Class decorator to enable re-rendering the given LitElement whenever a new
 * active locale has loaded.
 *
 * See also {@link updateWhenLocaleChanges} for the same functionality without
 * the use of decorators.
 *
 * When using lit-localize in transform mode, applications of this decorator are
 * removed.
 *
 * Usage:
 *
 *   import {LitElement, html} from 'lit';
 *   import {customElement} from 'lit/decorators.js';
 *   import {msg, localized} from '@lit/localize';
 *
 *   @localized()
 *   @customElement('my-element')
 *   class MyElement extends LitElement {
 *     render() {
 *       return html`<b>${msg('Hello World')}</b>`;
 *     }
 *   }
 */ const $d6bc8835316fae7d$var$_localized = ()=>(classOrDescriptor)=>typeof classOrDescriptor === "function" ? $d6bc8835316fae7d$var$legacyLocalized(classOrDescriptor) : $d6bc8835316fae7d$var$standardLocalized(classOrDescriptor);
const $d6bc8835316fae7d$export$85ef745e96563a4b = $d6bc8835316fae7d$var$_localized;
const $d6bc8835316fae7d$var$standardLocalized = ({ kind: kind, elements: elements })=>{
    return {
        kind: kind,
        elements: elements,
        finisher (clazz) {
            clazz.addInitializer((0, $732d7d1e81b3d279$export$19147fd8eb2795e4));
        }
    };
};
const $d6bc8835316fae7d$var$legacyLocalized = (clazz)=>{
    clazz.addInitializer((0, $732d7d1e81b3d279$export$19147fd8eb2795e4));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return clazz;
};


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $475180388b79fbb4$export$85f6557964517f1a {
    constructor(){
        this.settled = false;
        this.promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    resolve(value) {
        this.settled = true;
        this._resolve(value);
    }
    reject(error) {
        this.settled = true;
        this._reject(error);
    }
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */ // This module is derived from the file:
// https://github.com/tjwebb/fnv-plus/blob/1e2ce68a07cb7dd4c3c85364f3d8d96c95919474/index.js#L309
//
// Changes:
// - Only the _hash64_1a_fast function is included.
// - Removed loop unrolling.
// - Converted to TypeScript ES module.
// - var -> let/const
//
// TODO(aomarks) Upstream improvements to https://github.com/tjwebb/fnv-plus/.
const $6d1c9a0c187a9e31$var$hl = [];
for(let i = 0; i < 256; i++)$6d1c9a0c187a9e31$var$hl[i] = (i >> 4 & 15).toString(16) + (i & 15).toString(16);
function $6d1c9a0c187a9e31$export$318d539d57e27224(str) {
    let t0 = 0, v0 = 0x2325, t1 = 0, v1 = 0x8422, t2 = 0, v2 = 0x9ce4, t3 = 0, v3 = 0xcbf2;
    for(let i = 0; i < str.length; i++){
        v0 ^= str.charCodeAt(i);
        t0 = v0 * 435;
        t1 = v1 * 435;
        t2 = v2 * 435;
        t3 = v3 * 435;
        t2 += v0 << 8;
        t3 += v1 << 8;
        t1 += t0 >>> 16;
        v0 = t0 & 65535;
        t2 += t1 >>> 16;
        v1 = t1 & 65535;
        v3 = t3 + (t2 >>> 16) & 65535;
        v2 = t2 & 65535;
    }
    return $6d1c9a0c187a9e31$var$hl[v3 >> 8] + $6d1c9a0c187a9e31$var$hl[v3 & 255] + $6d1c9a0c187a9e31$var$hl[v2 >> 8] + $6d1c9a0c187a9e31$var$hl[v2 & 255] + $6d1c9a0c187a9e31$var$hl[v1 >> 8] + $6d1c9a0c187a9e31$var$hl[v1 & 255] + $6d1c9a0c187a9e31$var$hl[v0 >> 8] + $6d1c9a0c187a9e31$var$hl[v0 & 255];
}


const $ce25f4117de1869e$export$bab7f2b996bc5244 = "\x1e";
/**
 * Id prefix on html-tagged templates to distinguish e.g. `<b>x</b>` from
 * html`<b>x</b>`.
 */ const $ce25f4117de1869e$var$HTML_PREFIX = "h";
/**
 * Id prefix on plain string templates to distinguish e.g. `<b>x</b>` from
 * html`<b>x</b>`.
 */ const $ce25f4117de1869e$var$STRING_PREFIX = "s";
function $ce25f4117de1869e$export$bb8801913caa27b4(strings, isHtmlTagged) {
    return (isHtmlTagged ? $ce25f4117de1869e$var$HTML_PREFIX : $ce25f4117de1869e$var$STRING_PREFIX) + (0, $6d1c9a0c187a9e31$export$318d539d57e27224)(typeof strings === "string" ? strings : strings.join($ce25f4117de1869e$export$bab7f2b996bc5244));
}


const $c6ac4392245be6bf$var$expressionOrders = new WeakMap();
const $c6ac4392245be6bf$var$hashCache = new Map();
function $c6ac4392245be6bf$export$9a3f0ce3906e68f(templates, template, options) {
    var _a;
    if (templates) {
        const id = (_a = options === null || options === void 0 ? void 0 : options.id) !== null && _a !== void 0 ? _a : $c6ac4392245be6bf$var$generateId(template);
        const localized = templates[id];
        if (localized) {
            if (typeof localized === "string") // E.g. "Hello World!"
            return localized;
            else if ("strTag" in localized) // E.g. str`Hello ${name}!`
            //
            // Localized templates have ${number} in place of real template
            // expressions. They can't have real template values, because the
            // variable scope would be wrong. The number tells us the index of the
            // source value to substitute in its place, because expressions can be
            // moved to a different position during translation.
            return (0, $c6b9444fa6a10929$export$54d1368c2e63ae35)(localized.strings, // Cast `template` because its type wasn't automatically narrowed (but
            // we know it must be the same type as `localized`).
            template.values, localized.values);
            else {
                // E.g. html`Hello <b>${name}</b>!`
                //
                // We have to keep our own mapping of expression ordering because we do
                // an in-place update of `values`, and otherwise we'd lose ordering for
                // subsequent renders.
                let order = $c6ac4392245be6bf$var$expressionOrders.get(localized);
                if (order === undefined) {
                    order = localized.values;
                    $c6ac4392245be6bf$var$expressionOrders.set(localized, order);
                }
                return {
                    ...localized,
                    values: order.map((i)=>template.values[i])
                };
            }
        }
    }
    return (0, $b28552b036af2307$export$627842c9718b61c7)(template);
}
function $c6ac4392245be6bf$var$generateId(template) {
    const strings = typeof template === "string" ? template : template.strings;
    let id = $c6ac4392245be6bf$var$hashCache.get(strings);
    if (id === undefined) {
        id = (0, $ce25f4117de1869e$export$bb8801913caa27b4)(strings, typeof template !== "string" && !("strTag" in template));
        $c6ac4392245be6bf$var$hashCache.set(strings, id);
    }
    return id;
}


/**
 * Dispatch a "lit-localize-status" event to `window` with the given detail.
 */ function $6f72fc66e4601be7$var$dispatchStatusEvent(detail) {
    window.dispatchEvent(new CustomEvent((0, $5cde22bd23a08a82$export$22ecc5ec4a7dfb64), {
        detail: detail
    }));
}
let $6f72fc66e4601be7$var$activeLocale = "";
let $6f72fc66e4601be7$var$loadingLocale;
let $6f72fc66e4601be7$var$sourceLocale;
let $6f72fc66e4601be7$var$validLocales;
let $6f72fc66e4601be7$var$loadLocale;
let $6f72fc66e4601be7$var$templates;
let $6f72fc66e4601be7$var$loading = new (0, $475180388b79fbb4$export$85f6557964517f1a)();
// The loading promise must be initially resolved, because that's what we should
// return if the user immediately calls setLocale(sourceLocale).
$6f72fc66e4601be7$var$loading.resolve();
let $6f72fc66e4601be7$var$requestId = 0;
const $6f72fc66e4601be7$export$2f3903bcf09d572a = (config)=>{
    (0, $76ac3e1a759bb142$export$293be9dc57421d1c)((template, options)=>(0, $c6ac4392245be6bf$export$9a3f0ce3906e68f)($6f72fc66e4601be7$var$templates, template, options));
    $6f72fc66e4601be7$var$activeLocale = $6f72fc66e4601be7$var$sourceLocale = config.sourceLocale;
    $6f72fc66e4601be7$var$validLocales = new Set(config.targetLocales);
    $6f72fc66e4601be7$var$validLocales.add(config.sourceLocale);
    $6f72fc66e4601be7$var$loadLocale = config.loadLocale;
    return {
        getLocale: $6f72fc66e4601be7$var$getLocale,
        setLocale: $6f72fc66e4601be7$var$setLocale
    };
};
/**
 * Return the active locale code.
 */ const $6f72fc66e4601be7$var$getLocale = ()=>{
    return $6f72fc66e4601be7$var$activeLocale;
};
/**
 * Set the active locale code, and begin loading templates for that locale using
 * the `loadLocale` function that was passed to `configureLocalization`. Returns
 * a promise that resolves when the next locale is ready to be rendered.
 *
 * Note that if a second call to `setLocale` is made while the first requested
 * locale is still loading, then the second call takes precedence, and the
 * promise returned from the first call will resolve when second locale is
 * ready. If you need to know whether a particular locale was loaded, check
 * `getLocale` after the promise resolves.
 *
 * Throws if the given locale is not contained by the configured `sourceLocale`
 * or `targetLocales`.
 */ const $6f72fc66e4601be7$var$setLocale = (newLocale)=>{
    if (newLocale === ($6f72fc66e4601be7$var$loadingLocale !== null && $6f72fc66e4601be7$var$loadingLocale !== void 0 ? $6f72fc66e4601be7$var$loadingLocale : $6f72fc66e4601be7$var$activeLocale)) return $6f72fc66e4601be7$var$loading.promise;
    if (!$6f72fc66e4601be7$var$validLocales || !$6f72fc66e4601be7$var$loadLocale) throw new Error("Internal error");
    if (!$6f72fc66e4601be7$var$validLocales.has(newLocale)) throw new Error("Invalid locale code");
    $6f72fc66e4601be7$var$requestId++;
    const thisRequestId = $6f72fc66e4601be7$var$requestId;
    $6f72fc66e4601be7$var$loadingLocale = newLocale;
    if ($6f72fc66e4601be7$var$loading.settled) $6f72fc66e4601be7$var$loading = new (0, $475180388b79fbb4$export$85f6557964517f1a)();
    $6f72fc66e4601be7$var$dispatchStatusEvent({
        status: "loading",
        loadingLocale: newLocale
    });
    const localePromise = newLocale === $6f72fc66e4601be7$var$sourceLocale ? // queue it on a microtask so that switching locales is consistently
    // asynchronous.
    Promise.resolve({
        templates: undefined
    }) : $6f72fc66e4601be7$var$loadLocale(newLocale);
    localePromise.then((mod)=>{
        if ($6f72fc66e4601be7$var$requestId === thisRequestId) {
            $6f72fc66e4601be7$var$activeLocale = newLocale;
            $6f72fc66e4601be7$var$loadingLocale = undefined;
            $6f72fc66e4601be7$var$templates = mod.templates;
            $6f72fc66e4601be7$var$dispatchStatusEvent({
                status: "ready",
                readyLocale: newLocale
            });
            $6f72fc66e4601be7$var$loading.resolve();
        }
    // Else another locale was requested in the meantime. Don't resolve or
    // reject, because the newer load call is going to use the same promise.
    // Note the user can call getLocale() after the promise resolves if they
    // need to check if the locale is still the one they expected to load.
    }, (err)=>{
        if ($6f72fc66e4601be7$var$requestId === thisRequestId) {
            $6f72fc66e4601be7$var$dispatchStatusEvent({
                status: "error",
                errorLocale: newLocale,
                errorMessage: err.toString()
            });
            $6f72fc66e4601be7$var$loading.reject(err);
        }
    });
    return $6f72fc66e4601be7$var$loading.promise;
};


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

const $6143f1e9660bc9d4$export$96b14ce1c501d224 = (config)=>{
    (0, $76ac3e1a759bb142$export$293be9dc57421d1c)((0, $b28552b036af2307$export$627842c9718b61c7));
    const sourceLocale = config.sourceLocale;
    return {
        getLocale: ()=>sourceLocale
    };
};


let $76ac3e1a759bb142$export$d8bbfaecd0f57bdf = (0, $b28552b036af2307$export$627842c9718b61c7);
let $76ac3e1a759bb142$var$installed = false;
function $76ac3e1a759bb142$export$293be9dc57421d1c(impl) {
    if ($76ac3e1a759bb142$var$installed) throw new Error("lit-localize can only be configured once");
    $76ac3e1a759bb142$export$d8bbfaecd0f57bdf = impl;
    $76ac3e1a759bb142$var$installed = true;
}



var $d6ddaea74a7cb02c$exports = {};

















var $d6ddaea74a7cb02c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $d6ddaea74a7cb02c$export$73eb20912bbbece9 = [
    "small",
    "medium",
    "large"
];
let $d6ddaea74a7cb02c$export$65261e4f18f687bc = class WhCardElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.flat = false;
        this.size = "medium";
    }
    getHeading() {
        if (this.heading === undefined) return "";
        return this.heading.trim() === "" ? "" : (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<h2>${this.heading}</h2>`;
    }
    get supportedSize() {
        if (!$d6ddaea74a7cb02c$export$73eb20912bbbece9.includes(this.size)) {
            // eslint-disable-next-line no-console
            console.warn(`${this.size} is not a supported option. Use one of ${$d6ddaea74a7cb02c$export$73eb20912bbbece9.join(", ")} instead`);
            return "medium";
        }
        return this.size;
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <section ?flat=${this.flat} size=${this.supportedSize}>
        ${this.getHeading()}
        <article>
          <slot></slot>
        </article>
      </section>
    `;
    }
};
/* Stryker disable next-line StringLiteral */ $d6ddaea74a7cb02c$export$65261e4f18f687bc.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --wh-color-surface-primary: #f5f5f0;
      --wh-color-separator: #3232641a;
      --wh-dimension-radius-s: 2px;
      --wh-dimension-radius-m: 8px;
      --wh-dimension-radius-l: 32px;
      --wh-dimension-separator-s: 1px;
      --wh-dimension-spacer-xs: 16px;
      --wh-dimension-spacer-s: 24px;
      --wh-shadow-elevation1-blur: 14px;
      --wh-shadow-elevation1-color: #0408081a;
      --wh-shadow-elevation1-offsetX: 0;
      --wh-shadow-elevation1-offsetY: 5px;
      --wh-shadow-elevation1-spread: 0;
      --wh-shadow-elevation1: var(--wh-shadow-elevation1-offsetX)
        var(--wh-shadow-elevation1-offsetY) var(--wh-shadow-elevation1-blur)
        var(--wh-shadow-elevation1-spread) var(--wh-shadow-elevation1-color);
      --wh-stroke-style-standard: solid;
      --wh-typography-h2-fontFamily: "Source Sans Pro", helvetica, arial;
      --wh-typography-h2-fontSize: 32px;
    }

    section {
      background-color: var(--wh-color-surface-primary, hotpink);
      border-radius: var(--wh-dimension-radius-m);
      box-shadow: var(--wh-shadow-elevation1);
      color: var(--wh-theme-colors-on-surface, hotpink);
      font-family: var(--wh-typography-h2-fontFamily, San-Serif);
      overflow: hidden;
    }

    section[flat] {
      box-shadow: none;
    }

    section[size="small"] {
      border-radius: var(--wh-dimension-radius-s);
    }

    section[size="medium"] {
      border-radius: var(--wh-dimension-radius-m);
    }

    section[size="large"] {
      border-radius: var(--wh-dimension-radius-l);
    }

    h2 {
      border-bottom: var(--wh-dimension-separator-s)
        var(--wh-stroke-style-standard) var(--wh-color-separator, hotpink);
      font-size: var(--wh-typography-h2-fontSize);
      margin: 0;
    }

    :is(article, h2) {
      padding: var(--wh-dimension-spacer-s) var(--wh-dimension-spacer-xs);
    }

    section[size="large"] :is(article, h2) {
      padding: var(--wh-dimension-spacer-s);
    }
  `;
$d6ddaea74a7cb02c$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $d6ddaea74a7cb02c$export$65261e4f18f687bc.prototype, "heading", void 0);
$d6ddaea74a7cb02c$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d6ddaea74a7cb02c$export$65261e4f18f687bc.prototype, "flat", void 0);
$d6ddaea74a7cb02c$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $d6ddaea74a7cb02c$export$65261e4f18f687bc.prototype, "size", void 0);
$d6ddaea74a7cb02c$export$65261e4f18f687bc = $d6ddaea74a7cb02c$var$__decorate([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("wh-card")
], $d6ddaea74a7cb02c$export$65261e4f18f687bc);






let $11e41786a8a7e641$export$a845a8e02c7be389 = class WebKioskHomeLinkElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<a class="home-link" href=${this.link}>
      <img
        src="assets/shared/home-logo.svg"
        alt=${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Walgreens Logo", {
            id: "walgreens-logo"
        })}
      />
      ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Home", {
            id: "home-link",
            desc: "Click to return back to the main page of the application"
        })}
    </a>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-link-color: #284b9b;

      display: flex;
    }

    .home-link {
      color: var(--web-kiosk-link-color, hotpink);
    }

    .home-link img {
      margin-right: 8px;
    }

    a {
      display: inline-flex;
      align-items: center;
      text-decoration: none;
      font-size: 33px;
      font-weight: 700;
      line-height: 40px;
      color: var(--web-kiosk-link-color, hotpink);
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.link = "home";
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $11e41786a8a7e641$export$a845a8e02c7be389.prototype, "link", void 0);
$11e41786a8a7e641$export$a845a8e02c7be389 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-home-link")
], $11e41786a8a7e641$export$a845a8e02c7be389);


/* eslint-disable sonarjs/no-duplicate-string */ 


var $02d11728b58142c5$exports = {};
$02d11728b58142c5$exports = JSON.parse('{"en":{"default":{"newSession":{"cards":[{"label":"Blue Shield of California","key":"bsc","image":"assets/payors/blue-shield-of-california.png"},{"label":"Braven","key":"braven","image":"assets/payors/braven.png"},{"label":"Buckeye Health Plan","key":"buckeye","image":"assets/payors/buckeye-health-plan.png"},{"label":"Clover Health","key":"clover","image":"assets/payors/clover-health.png"},{"label":"Horizon","key":"horizon","image":"assets/payors/horizon-blue.png"}],"defaultStoreButtonText":"My Health Insurance Provider Is Not Shown","heading":"Select Your Health Insurance Provider","instructionMessage":"To begin, select your health insurance provider from the options above. If your health insurance provider is not shown, tap the button on the right to continue.","instructionTitle":"Welcome to Walgreens Health Corner"},"feedback":{"title":"Leave Feedback","heading":"Your feedback is important","description":"To help us improve future Health Corner visits, please let us know what you thought of your experience today. Your response will only be used to help us and your health plan understand how we can make your next visit better.","surveyHeading":"Complete the survey on your device","surveyQrCodeLink":"assets/feedback/surveyQrCode.png","surveyQrCodeLinkAlt":"survey QR code","phoneHeading":"iPhone & Newer Android","phoneDescription":"Simply point your camera at the QR code on the right to automatically launch the survey.","oldPhoneHeading":"Older Android","oldPhoneDescription":"Download a QR code reader app from the Play Store. Scan the code with the QR code app."},"home":{"title":"Home","heading":"Welcome to healthcare without the hold music.","cards":[{"title":"About Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Meet your Health Advisors and find more information about Walgreens Health Corner’s operation hours."},{"title":"Services Offered","link":"services","icon":"assets/home/store.svg","description":"Convenient access to personalized care and support for your health, based on your health plan eligibility."}],"descriptionBold":"Walgreens Health Corner","description":"is an easy, new way to take care of your health to-dos. Members of select health insurance providers get specialized services with no co-pays and no appointments."},"about":{"title":"About Walgreens Health Corner","heading":"About Walgreens Health Corner","description":"Check out our hours and meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.","cards":[{"heading":"Information and hours","description":"Get updated hours so you can get updated answers to your health questions.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Information and hours","heading":"You’ve got questions. We’ve got answers.","description":"Not sure how to navigate over-the-counter medicine or prescriptions? Want advice on how to stay active? Need help using a new health device? Our Health Advisors are here to help answer these questions, and more.","advisorsDescription":"Our Health Advisors are a friendly, clinically trained team here to help you navigate your health needs. They will get to know you with each visit and interaction, providing personalized ongoing care. From assistance finding health information, to tips on nutrition and staying active, they are here for you.","legalText":"Walgreens Health Corner services are not intended for use in urgent and emergent care. The information provided is not a substitute for medical advice from your physician. If you are in need of immediate medical attention, contact your physician or go to the nearest emergency room. Consult your physician for diagnosis and treatment of your medical condition."},"privacy":{"title":"Privacy Policy and Terms & Conditions","headerHeading":"Health and privacy. We protect both.","headerDescription":"You trust us with your health and wellness needs, and we take that responsibility seriously. That includes making sure your data is safe and secure, and that you have control. The Privacy Policy covers the type of data we collect and how we use it, as well as your rights as a consumer. Please don’t hesitate to contact us with any questions.","headerCards":[{"title":"Build Trust","img":"assets/privacy/trust.svg","description":"We care for your wellbeing and your needs."},{"title":"Protect Privacy","img":"assets/privacy/privacy.svg","description":"We don’t sell your pharmacy information."},{"title":"Enhance Experience","img":"assets/privacy/experience.svg","description":"We use data to personalize your offers and deals."}],"contentPrivacyIcon":"assets/privacy/onlineSecurityPrivacyIcon.svg","contentPrivacyIconAlt":"Online Privacy and Security Privacy Icon","contentPrivacySidebarText":"Online Privacy & Security Policy","contentPrivacyBody":"<h3>Walgreens Health Corner Online Privacy & Security Policy</h3>\\n<p>This Privacy Policy lets you know how we collect, use, share, and protect information about you. By interacting with the Walgreens Health Corner kiosk, you consent to the practices described in this Privacy Policy. Any changes in our Privacy Policy will appear on this page so that you are aware of the data we collect and how we use it.</p>\\n<p>Walgreens Health Corner use and disclosure of your information will be subject to the requirements of the Health Insurance Portability and Accountability Act (commonly known as \\"HIPAA\\"). In some circumstances, the Walgreens Notice of Privacy Practices will apply in addition to this policy, and in others, your health plan\'s Notice of Privacy Practices will apply in addition to this policy. If you have questions about which policy applies to your information, please do not hesitate to contact us at 877-645-4128.</p>\\n\\n<h4>Our Privacy Program</h4>\\n<p>At Walgreens Health Corner, we are committed to maintaining our customers\' privacy. We take great care to safeguard the information that we collect to maintain our customers\' privacy. We have provided this Privacy Policy to you to describe information collection and use practices at Walgreens Health Corner. This Privacy Policy describes the choices you can make about the way your information is collected and used.</p>\\n\\n<h4>Information We Collect</h4>\\n<p>We want you to understand how the information you provide to us is collected and used. When you interact with Walgreens Health Corner or use our services, we collect certain information about you and the services you use. An example of using our \\"services\\" would be when you use our mobile application. We may collect and store information from you in the following situations:</p>\\n\\n<h4>Information you provide to us directly, including when you:</h4>\\n<ul>\\n    <li>Make a transaction with us on our website or mobile application;</li>\\n    <li>Create an account on our mobile application;</li>\\n    <li>Correspond directly with us, such as through our mobile application, customer service, or dispute resolution mechanisms; or</li>\\n    <li>Import content from connected devices or services, or post user-generated content, to our mobile application.</li>\\n</ul>\\n\\n<h4>Information we collect when you use our services, including:</h4>\\n<ul>\\n    <li>\\n        <h5>Device Information</h5>\\n        <ul>\\n            <li>We may collect device-specific information when you use our mobile application or services. This includes information such as Internet Protocol (IP) address, hardware model, operating system, unique device identifiers, mobile network information, location data such as zip code, the path you take through our mobile application, and other information about your session on our mobile application. We may also associate the information we collect from your different devices, which helps us provide consistent services across your devices</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Log Information</h5>\\n        <ul>\\n            <li>This includes details of how you used our mobile application including clicks and page information such as the address (or URL) of the website or mobile application you came from before visiting our mobile application, which pages you visit on our mobile application, which browser you used to view our mobile application, and any search terms entered.</li>\\n            <li>Other information from your interaction with our mobile application, services, and content, including device and connection information, statistics on page views, and other standard weblog information.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Precise Location Information</h5>\\n        <ul>\\n            <li>When you use our mobile application or services on your mobile phone or device and enable location services on your mobile phone or device browser, we may collect information about your physical location through satellite, cell phone tower, WiFi signal, beacons, Bluetooth and near field communication protocols (\\"precise location information\\"). If you use our mobile application, your device may share precise location information when you enable location services for our mobile application.</li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>How We Use Your Information:</h4>\\n<p>Our primary purpose in collecting information is to provide you with a safe, smooth, efficient, and customized experience. We may use your information in a variety of ways, including for the following purposes:</p>\\n<h5>Product and Service Fulfillment</h5>\\n<ul>\\n    <li>We use your information to communicate with you, respond to your inquiries, fulfill your requests and improve your experience.</li>\\n    <li>We use your Precise Location Information to provide location-based services. For example, to locate nearby Walgreens in your area.</li>\\n</ul>\\n<h5>Internal Operations</h5>\\n<ul>\\n    <li>We use your information to improve the effectiveness of our services, conduct research and analysis, or to perform other business activities as needed and as permitted by HIPAA.</li>\\n</ul>\\n<h5>Prevention of Fraud and other Harm</h5>\\n<ul>\\n    <li>We use your information to detect, prevent or investigate potential security breaches, fraudulent transactions and monitor against theft.</li>\\n</ul>\\n<h5>Legal Compliance and As Necessary or Appropriate Under Applicable Law</h5>\\n<ul>\\n    <li>We may use your information as necessary or appropriate under applicable law, to comply with legal process, to respond to such requests from public and government authorities (including law enforcement), to enforce our terms and conditions, including investigations of potential violations, to detect, prevent or otherwise address fraud, security or technical issues, to protect our rights, privacy, safety or property, and to allow us to pursue available remedies to limit the damages that we may sustain. In matters involving claims of personal or public safety or in litigation where the data is pertinent, we may use your information without your consent or court process where permitted by HIPAA.</li>\\n</ul>\\n\\n<h4>How We Share Your Information:</h4>\\n<p>We do not sell, rent, or loan your personally identifiable information to any third parties. We will share your information with companies, organizations and individuals outside of Walgreens Health Corner as described in this Privacy Policy and as permitted by HIPAA:</p>\\n<ul>\\n    <li>\\n        <h5>Internally</h5>\\n        <ul>\\n            <li>We may share your information with our parent company or affiliates, including but not limited to, Walgreens Boots Alliance Inc., Boots Retail USA Inc., Walgreens Specialty Pharmacy Holdings, LLC, and Walgreens Specialty Pharmacy, LLC DBA Alliance Rx Walgreens Prime.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>When We Work with Third Parties</h5>\\n        <ul>\\n            <li>We may share your information with affiliated and unaffiliated companies that perform tasks on our behalf related to our business. Such tasks include analyzing mobile application usage data, customer service, electronic mail service, and social and other media services.</li>\\n            <li>We may work with other companies who operate their own websites or mobile applications, to allow them to offer Walgreens Health Corner customers the ability to connect the Walgreens Health Corner services with other companies\' mobile applications and devices. These services give you more options for ways to use Walgreens Health Corner services from websites or apps that are not owned or operated by Walgreens Health Corner.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>When Sharing is Required by Law or Helps Us Protect Our Interests</h5>\\n        <ul>\\n            <li>We will disclose your information as necessary or appropriate under applicable law, to comply with legal process, to respond to such requests from public and government authorities, to enforce our terms and conditions, including investigations of potential violations, to detect, prevent or otherwise address fraud, security or technical issues, to protect our rights, privacy, safety or property, and to allow us to pursue available remedies to limit the damages that we may sustain. In matters involving claims of personal or public safety or in litigation where the data is pertinent, we may use or disclose personal information without your consent or court process.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>When We Work on Business Transactions</h5>\\n        <ul>\\n            <li>As we continue to develop our business, we might sell or buy stores or assets, or engage in mergers, acquisitions or sale of company assets. Customer information, including your information, may be disclosed in connection with the evaluation of and entry into such transactions, or in the course of providing transition of services to another entity as permitted by law. In such transactions, customer information generally is one of the transferred business assets. Additionally, in the event that Walgreens Health Corner or substantially all of its assets are acquired, customer information, including your information, will likely be one of the transferred assets as is permissible under law.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>De-identified or Aggregate information with Third Parties</h5>\\n        <ul>\\n            <li>We may share de-identified or aggregate information with third parties for lawful purposes.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>With Your Consent</h5>\\n        <ul>\\n            <li>At your direction or request, or when you otherwise consent, we may share your information.</li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>Your Choices</h4>\\n<p>By interacting with Walgreens Health Corner as described herein, you consent to the practices described in this Privacy Policy. However, we want you to know that you do have certain choices with regard to how your information is collected and used.</p>\\n<ul>\\n    <li>\\n        <h5>Email and Mobile Communications</h5>\\n        <ul>\\n            <li>You may choose to stop receiving email and mobile communications by changing your preferences online. If you have an online account, log in to your account on our mobile application and go to the Settings tab on your Profile page. If you do not have an online account, you may click Unsubscribe from the bottom of Walgreens Health Corner emails. To request unsubscribing by phone, contact 877-645-4128.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Mobile Application</h5>\\n        <ul>\\n            <li>\\n                <h6>Push Notifications</h6>\\n                <ul>\\n                    <li>You can opt out from further allowing Walgreens to send you push notifications in the mobile application by adjusting the permissions in your mobile device or from the Walgreens app.</li>\\n                </ul>\\n            </li>\\n            <li>\\n                <h6>Precise Location Information</h6>\\n                <ul>\\n                    <li>\\n                        You can opt out from further allowing Walgreens to access Precise Location\\n                        <br><br>\\n                        Information by adjusting the permissions in your mobile device.\\n                    </li>\\n                </ul>\\n            </li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>Accessing and Updating Your Personally Identifiable Information</h4>\\n<ul>\\n    <li>If you have a Walgreens Health Corner account, you can log in and update your information. You can also review and update the information you have given us by contacting us at 877-645-4128. Our customer care staff will update your information.</li>\\n    <li>\\n        <h5>Links to Third-Party Websites</h5>\\n        <ul>\\n            <li>Our services may contain links to, or otherwise make available, third-party services, websites and mobile applications that are operated and controlled by third parties. We do not take responsibility for the content or the privacy practices employed by other websites. Unless otherwise stated, any Information you provide to any such third-party website will be collected by that party and not by Walgreens Health Corner, and will be subject to that party\'s privacy policy (if any), rather than this Privacy Policy. In such a situation, we will have no control over, and shall not be responsible for, that party\'s use of the Information you provide to them.</li>\\n        </ul>\\n    </li>\\n</ul>\\n    \\n<h4>How We Protect Your Information</h4>\\n<ul>\\n    <li>\\n        <h5>Security Measures</h5>\\n        <ul>\\n            <li>Walgreens Health recognizes the importance of maintaining the security of your information. When you visit our mobile application we use reasonable security measures, including administrative, technical, and physical safeguards.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Email Security</h5>\\n        <ul>\\n            <li>\\"Phishing\\" is a common email scam where your email address is used to contact you and ask for personally identifiable or sensitive information. Always be cautious when opening links or attachments from unsolicited third parties. Also know that Walgreens Health Corner will not send you emails asking for your credit card number or social security number, or requesting you reply with personally identifiable information. If you are ever asked for this information, you can be confident it is not from Walgreens Health Corner.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Children\'s Personal Information</h5>\\n        <ul>\\n            <li>We recognize the importance of protecting children\'s online privacy. Our mobile application and services are intended for a general audience and are not directed to children. We do not knowingly collect personal information online from children under the age of 13.</li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>How To Contact Us:</h4>\\n<p>If you have questions about our Privacy Policy, contact us by:</p>\\n<blockquote>\\n    <strong>Phone:</strong> (877) 924-4472<br>\\n    <strong>E-mail:</strong> privacy.office@walgreens.com<br>\\n    <strong>Regular mail:</strong><br>\\n    Walgreen Co. Privacy Office<br>\\n    Attn: Privacy Officer<br>\\n    200 Wilmot Rd, MS 9000<br>\\n    Deerfield, IL 60015\\n</blockquote>\\n<p>To request this Privacy Policy in an alternative accessible format, call our Customer Care Center at 877-645-4128.</p>\\n<p><strong>Effective Date:</strong> October 25, 2021</p>","contentTermsIcon":"assets/privacy/termsAndConditionsIcon.svg","contentTermsIconAlt":"Terms and Conditions Icon","contentTermsSidebarText":"Terms and Conditions","contentTermsBody":"<h3>Terms and Conditions of Use</h3>\\n<p>Welcome to Walgreens! Please take a few minutes to read these important terms and conditions (\\"Terms\\").</p>\\n\\n<h4>I. Introduction</h4>\\n<p>These Terms govern your use of the online services provided by Walgreen Co. and its affiliates (\\"Walgreens,\\" \\"us,\\" or \\"we\\"), including websites, mobile applications, photo services, Auto- Reorder & Save, Rx reminders, in-store wifi, Walgreens Content (as defined in Section 2), and other services (\\"Services\\"). The Services are intended for use by users that reside in the U.S. and are 18 or older (or 13 or older, with the consent and involvement of a parent or guardian). If you are not the intended audience or you object to these Terms, you may not use our Services. These Terms act as a binding agreement between you and us, and by accessing any Services in any way, you agree to be bound by all of them, including, but not limited to, resolving disputes via binding arbitration, conducting this transaction electronically, disclaiming warranties, damage and remedy exclusions and limitations, and a choice of Illinois law.</p>\\n<p>From time to time we may update the Services and these Terms, and such changes shall be applied prospectively. Your use of the Services after we post any changes to these Terms constitutes your agreement to those changes. You agree to review these Terms periodically to ensure that you are familiar with the most recent version. We will notify you of any material updates to the Terms. We may, in our sole discretion, and at any time, discontinue the Services or any part thereof, with or without notice, or may prevent your use of the Services with or without notice to you. You agree that you do not have any rights in the Services and that we will have no liability to you if the Services are discontinued or your ability to access the Services (including any content you may have posted) is terminated.</p>\\n\\n<h4>II. Information We Display</h4>\\n<p>We own or license all content contained within the Services, including without limitation, text, images, icons, data, software, trademarks, trade dress, and User Content (as defined in Section 3) (collectively, \\"Walgreens Content\\"), and you may access and use it solely for your own personal, non-commercial shopping and information purposes. Walgreens Content may be protected by domestic and international copyright, patent, trademark, and other rights, and all rights, titles, and interests are reserved by the respective owners. Copying, publishing, broadcasting, modifying, distributing or transmitting any Walgreens Content in any way without our prior written consent is strictly prohibited.</p>\\n<p>While we work hard to provide a superior customer experience, we cannot guarantee that all Walgreens Content we display is correct, complete, or current, including product pricing, images, information, and availability.</p>\\n<p>We may display or allow users to create User Content, or link to or from third party sites and material. We do not monitor, verify, or otherwise endorse User Content or third party sites or material, and hereby disclaim all liability with respect thereto. Your use of any third party site is subject to the terms of use and privacy policies made applicable thereto by such third party. Any health-related information is provided to enhance your experience, but is not intended to constitute medical advice or diagnose, treat, cure, or prevent any medical condition. If you have questions about your health or treatment, please contact your pharmacist or other medical professional.</p>\\n\\n<h4>III. Your Actions</h4>\\n<p>To ensure a positive experience for all users, you agree that you will not: (i) use or exploit the Services for any purpose that is illegal, tortuous, libelous, defamatory, false, misleading, harassing, abusive, obscene, vulgar, pornographic, intrusive on another\'s privacy, harmful to the interests of us or our users, or inappropriate with respect to race, gender, sexuality, ethnicity, or another intrinsic characteristic; (ii) upload, post, reproduce, distribute, transmit, transfer, or otherwise use or exploit in any way information, software, or other material protected by any intellectual property, publicity, or privacy right (including our trademarks and trade dress) without first obtaining the permission of the owner of such rights; (iii) collect or store personal data about other users; (iv) reproduce, distribute, duplicate, copy, sell, resell, decompile, modify, reverse engineer, disassemble, assign, create derivative works of, impersonate, or otherwise exploit any part of the Services (including any software we make available) for any purpose unless expressly approved by us in writing; (v) upload, post, email, or otherwise transmit any advertising or promotional materials or any other form of solicitation or unauthorized communication; (vi) undertake or facilitate any effort to interrupt, modify, limit, interfere with, commercially exploit, or negatively impact the functionality of any Services, nor will you use or exploit the Services in any way other than as expressly permitted by these Terms; (vii) remove, alter, obscure, or otherwise render unintelligible any proprietary notices; and (viii) deploy or utilize any automated method of collecting content from our site, such as robots, crawlers, and scraping mechanisms (Sections (i) through (viii) collectively, \\"Prohibited Use\\"). To protect the interests of us and our users, we may monitor, modify, terminate, and disclose to third parties (including law enforcement) your use of the Services (including User Content) at any time.</p>\\n<p>You may be able to create or submit designs, photos, product reviews, written posts, and other content (\\"User Content\\"). You agree that: (i) you will not display or furnish any User Content that contains personal information about or the likeness of any individual, violates the privacy/publicity of any other individual or entity, or anything that you are under a contractual obligation to keep private or confidential; (ii) you will not impersonate any person or organization (including us), or misrepresent an affiliation with another person or organization; and (iii) you will not post or upload any User Content that constitutes a Prohibited Use. Notwithstanding the foregoing, these Terms in no way limit your rights under the Consumer Review Fairness Act of 2016 (H.R. 5111).</p>\\n<p>By displaying, publishing, or otherwise posting any User Content on or through the Services, or by affirmatively agreeing to our online request to use your User Content (electronically or otherwise), you hereby grant us a perpetual, non-exclusive, sub-licensable (through multiple tiers), worldwide, fully-paid, royalty free license to use such User Content (including without limitation, to modify, publicly perform, publicly display, reproduce, create derivative works of, and distribute such User Content for any purpose, whether it contains a personal likeness or otherwise) in any and all media now known or hereinafter developed, without the requirement to make payment to any party or seek any third party permission or make any authorship attribution. You continue to retain all ownership rights in your User Content, and you continue to have the right to use your User Content in any way you choose, subject to these Terms and the license described herein, though for purposes of this Section, you waive all \\"moral rights\\" in the same. You represent and warrant that (i) you own the User Content submitted, displayed, published, provided, or posted by you on the Services, or otherwise have the right to grant the license set forth herein, and (ii) your displaying, publishing, providing, or posting of any User Content you submit, and our use thereof in accordance with these Terms, does not and will not violate applicable law or any privacy, publicity, copyright, trademark, patent, contract or any other rights of any person or entity. Notwithstanding the foregoing, you further understand and agree that you have no ownership rights to any account you may have with us, or other access to the Services or features therein. We may cancel and terminate any account or User Content at any time without notice. We assume no liability for any information removed from our Services, and reserve the right to permanently restrict access to the Services or a user account.</p>\\n<p>If the Services require you to create an account or provide personal information, you agree to submit accurate, complete information, and to update it as appropriate. You are solely responsible for the activities and security of your account, and you must notify us if you suspect any unauthorized use. We are not liable for any loss you incur as a result of someone else using your password or account, either with or without your knowledge, and are not responsible for any delay in shutting down your account after you have reported a breach of security to us.</p>\\n\\n<h4>IV. Service-Specific Terms</h4>\\n<p>The Services we provide may be subject to additional policies, such as a return policy, gift card policy, myWalgreens Terms and Conditions, or other terms. You can learn more about those specific services and policies at https://www.walgreens.com/help.</p>\\n<p>If you make any purchases, you represent that you and we (including our service providers) are authorized to use the information you provide (including payment method information) to carry out the transaction. YOU REPRESENT AND WARRANT THAT YOU HAVE THE LEGAL RIGHT TO USE ANY CREDIT CARD(S) UTILIZED IN CONNECTION WITH ANY TRANSACTION. Our acknowledgement of an order means that your order request has been received, but not that your order has been accepted or shipped or that the price or availability of an item has been confirmed. We reserve the right to change the price of an item up until the time of shipment. Title and risk of loss transfer to you upon our delivery of the order to the carrier. Notwithstanding anything to the contrary, we reserve the right to cancel or limit any orders for any reason. Prices, promotions, offers, and product availability are all subject to change without notice.</p>\\n<p>If you participate in myWalgreens program, that participation is governed by the myWalgreens Terms and Conditions.</p>\\n<p>If you choose to upload images and create products for purchase through our photo services, you agree that you are solely responsible for such User Content, and that you will notify us of any content you see that constitutes Prohibited Use. To facilitate use of the photo services, we may offer a reasonable amount of temporary storage space to active users, as we may determine from time to time in our sole discretion.</p>\\n<p>If you create an automatically recurring order through our Auto-Reorder & Save program, the additional terms of this paragraph apply. Your initial order will be delivered using the shipping method you select, and all auto-reorders will be delivered via free standard shipping. Your initial order will cost the amount displayed at checkout, and all auto-reorders will be charged either the sale price in effect at the time or the then-current Auto-Reorder & Save discount, whichever is lower. Your orders will continue to ship until you cancel or change your auto-reorder. Your payment method will continue to be charged until you cancel or change it. Your initial order price is not guaranteed for auto-reorders. If the price advertised for any of your items changes, this price change will also apply to your items scheduled for Auto-Reorder. You will not be notified of price changes before your auto-reorder items are processed and shipped. myWalgreens Cash rewards may be earned on any order, subject to the myWalgreens Terms and Conditions, but cannot be redeemed on any auto-reorder. To view and manage your auto- reorders, sign into Your Account and click \\"Auto-Reorder Manager.\\" You may cancel or skip an auto-reorder at any time prior to the deadline displayed in the Auto-Reorder Manager. For additional information, visit us at https://www.walgreens.com/autoreorder or go to https://www.walgreens.com/contactus or contact us at 1-877-250-5823</p>\\n<p>If you choose to access in-store wifi services we may provide, you agree that you are responsible for all activities occurring on your device.</p>\\n<p>If you download one of our mobile applications, these Terms constitute an end-user license agreement, and you agree to act in accordance with the end-user license agreements and policies made applicable by your wireless carrier and operating system software provider (including as listed within their respective app stores). You agree you are solely responsible for any costs incurred with accessing one of our mobile applications. You may be required to send and receive, at your cost, electronic communications related to the Services offered via our mobile applications, including without limitation, administrative messages, service announcements, diagnostic data reports, and updates. If you do not have an unlimited wireless mobile data plan, you may incur additional charges from your wireless service provider in connection with your use of these Services. You are solely responsible for obtaining any additional subscription or connectivity services or equipment necessary to access these Services, including but not limited to payment of all third party fees associated therewith, including fees for information sent to or through these Services. We may, at our discretion, automatically download updates to our mobile applications to your device from time to time. You agree to accept these updates, and to pay for any costs associated with receiving them. Our mobile applications may not work with all devices or all mobile carriers.</p>\\n<p>If you download and use one of our mobile applications available through the Apple platform: You, the end-user of these Services, acknowledge that this agreement is entered into by and between Walgreens and its subsidiaries and affiliates, and you, and not with Apple, Inc., and Apple, Inc. is not responsible for the Services. Notwithstanding the foregoing, you acknowledge that Apple, Inc. and its subsidiaries are third-party beneficiaries of this agreement and that Apple, Inc. has the right (and is deemed to have accepted the right) to enforce this agreement. You acknowledge that Apple, Inc. has no obligation whatsoever to maintain or support the Services. You acknowledge that you have reviewed and agree to the App Store Terms and Conditions (located online at https://www.apple.com/legal/itunes/us/terms.html#APPS), including the Usage Rules set forth therein. This agreement incorporates by reference the Licensed Application End User License Agreement (the \\"LAEULA\\") published by Apple, Inc. (located online at https://www.apple.com/legal/macapps/dev/stdeula/). For purposes of this Agreement, our mobile application-based Services are considered the \\"Licensed Application\\" as defined in the LAEULA and Walgreens is considered the \\"Application Provider\\" as defined in the LAEULA. If any of the Terms herein conflict with the terms of the LAEULA, these Terms shall control. In the event of any failure of the Services to conform to any applicable warranty set forth herein, you acknowledge that to the maximum extent permitted by applicable law, Apple, Inc. will have no other warranty obligation whatsoever with respect to the Services, and any other claims, losses, liabilities, damages, costs or expenses attributable to any failure to conform to any warranty. You further acknowledge and agree that in no event will Apple, Inc. be responsible for any claims relating to the Services (including, without limitation, a third party claim that the Services infringe that third party\'s intellectual property rights) or your use or possession of the Services, including but not limited to: (i) product liability claims; (ii) any claim that the Services fail to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection or similar legislation.</p>\\n\\n<h4>V. Privacy</h4>\\n<p>While providing the Services, you may provide, and we may automatically collect, information about you and your use of the Services, including without limitation, your real-time location, MAC address, and IP address. Our collection and use of such information is governed by our Online Privacy and Security Policy available at https://www.walgreens.com/privacy and Notice of Privacy Practices available at https://www.walgreens.com/noticeofprivacy</p>\\n\\n<h4>VI. Disclaimers, Limitation of Liability, and Indemnification</h4>\\n<p>We provide the Services (including, without limitation, all Walgreens Content, User Content, and other content whatsoever) as a service to you. THESE SERVICES ARE PROVIDED ON AN \\"AS IS\\" AND \\"AS AVAILABLE\\" BASIS WITHOUT WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY, AND TO THE EXTENT PERMISSIBLE BY APPLICABLE LAW, WE EXPRESSLY DISCLAIM ANY AND ALL SUCH WARRANTIES. THIS DISCLAIMER INCLUDES, BUT IS NOT LIMITED TO, ANY AND ALL REPRESENTATIONS OR WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, PERFORMANCE, RELIABILITY, SECURITY, AVAILABILITY, ACCURACY, QUALITY, APPROPRIATENESS, COMPLETENESS, NON-INFRINGEMENT, OR THAT THE SERVICES ARE ERROR OR DEFECT-FREE. BEFORE USING ANY PRODUCT, YOU SHOULD CONFIRM ANY INFORMATION OF IMPORTANCE TO YOU ON THE PRODUCT PACKAGING. WE ARE NOT RESPONSIBLE FOR, AND HEREBY DISCLAIM ANY LIABILITY WITH RESPECT TO, ALL USER CONTENT, ANY USER, AND ANY THIRD PARTY. YOU ASSUME RESPONSIBILITY FOR THE ACCURACY, APPROPRIATENESS AND LEGALITY OF ANY INFORMATION YOU SUPPLY US. YOU AGREE THAT YOU USE THESE SERVICES AT YOUR SOLE RISK.</p>\\n<p>THESE SERVICES ARE MADE AVAILABLE TO USERS IN THE U.S., AND WE MAKE NO WARRANTY OR REPRESENTATION THAT ANY OF THE SERVICES ARE APPROPRIATE FOR USE IN OTHER LOCATIONS. NO PART OF THE SERVICES SHOULD BE CONSTRUED AS AN OFFER OR SOLICITATION BY OR TO ANYONE TO WHOM SUCH AN OFFER OR SOLICITATION CANNOT LEGALLY BE MADE.</p>\\n<p>AS PARTIAL CONSIDERATION FOR YOUR ACCESS TO OUR SERVICES (INCLUDING WALGREENS CONTENT), YOU AGREE THAT WE ARE NOT LIABLE TO YOU IN ANY MANNER WHATSOEVER FOR DECISIONS YOU MAY MAKE OR YOUR ACTIONS OR NON-ACTIONS IN RELIANCE THEREUPON. YOU ALSO AGREE THAT OUR AGGREGATE LIABILITY ARISING FROM OR RELATED TO YOUR USE OF AND ACCESS TO THE SERVICES, REGARDLESS OF THE FORM OF ACTION OR CLAIM (FOR EXAMPLE, CONTRACT, WARRANTY, TORT, NEGLIGENCE, STRICT LIABILITY, PROFESSIONAL MALPRACTICE, FRAUD, INFRINGEMENT OR OTHER BASES FOR CLAIMS) IS LIMITED TO THE PURCHASE PRICE OF ANY ITEMS YOU PURCHASED FROM US IN THE APPLICABLE TRANSACTION, IF ANY. WE SHALL NOT IN ANY CASE BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES (\\"DAMAGES\\"), NOR SHALL WE BE RESPONSIBLE FOR ANY DAMAGES WHATSOEVER THAT RESULT FROM MISTAKES, OMISSIONS, INTERRUPTIONS, DELETION OF FILES, ERRORS, DEFECTS, DELAYS IN OPERATION OR TRANSMISSION, OR ANY FAILURE OF PERFORMANCE, WHETHER OR NOT CAUSED BY EVENTS BEYOND OUR REASONABLE CONTROL, INCLUDING BUT NOT LIMITED TO ACTS OF GOD, COMMUNICATIONS LINE FAILURE, THEFT, DESTRUCTION, OR UNAUTHORIZED ACCESS TO OUR SITES, RECORDS, PROGRAMS, SERVICES, OR CONTENT, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IF YOU ARE DISSATISFIED WITH THESE TERMS OR OUR SERVICES (INCLUDING WALGREENS CONTENT), YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE SERVICES.</p>\\n<p>SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR INCIDENTAL CONSEQUENTIAL, OR OTHER DAMAGES; AS A RESULT, THE ABOVE LIMITATIONS OR EXCLUSIONS MAY NOT BE APPLICABLE TO YOU, AND THE FOREGOING PARAGRAPH SHALL NOT APPLY TO A RESIDENT OF NEW JERSEY TO THE EXTENT DAMAGES TO SUCH NEW JERSEY RESIDENT ARE THE RESULT OF OUR NEGLIGENT, FRAUDULENT OR RECKLESS ACT(S) OR INTENTIONAL MISCONDUCT.</p>\\n<p>YOU AGREE TO INDEMNIFY, DEFEND AND HOLD HARMLESS WALGREENS, INCLUDING ITS OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES, LICENSORS, SUPPLIERS, INFORMATION PROVIDERS AND AGENTS, FROM AND AGAINST ALL LOSSES, EXPENSES, DAMAGES, FEES, FINES, AND COSTS, INCLUDING WITHOUT LIMITATION, REASONABLE ATTORNEYS\' FEES, RESULTING FROM OR RELATING TO YOUR USE OF THE SERVICES OR VIOLATIONS OF THESE TERMS.</p>\\n\\n<h4>VII. Dispute Resolution</h4>\\n<p>If a dispute ever arises between us, please contact us at walgreens.com/contactus. If we cannot resolve the matter informally, you and we each agree that any and all disputes or claims that have arisen or may arise between you and us shall be resolved exclusively through final and binding arbitration, rather than in court, except that you may assert claims in small claims court, if your claims qualify (\\"Agreement to Arbitrate\\"). The Federal Arbitration Act governs the interpretation and enforcement of this Agreement to Arbitrate, which shall be conducted by the American Arbitration Association (\\"AAA\\") under its rules and procedures, including the AAA\'s Supplementary Procedures for Consumer-Related Disputes (as applicable), as modified by these Terms. A form for initiating arbitration proceedings is available on the AAA\'s website. The arbitration shall be held in the county in which you reside. If the value of the relief sought is $10,000 or less, you or we may elect to have the arbitration conducted by telephone or based solely on written submissions, which election shall be binding on you and us subject to the arbitrator\'s discretion to require an in-person hearing, if the circumstances warrant. Attendance at an in-person hearing may be made by telephone by you and/or us, unless the arbitrator requires otherwise.</p>\\n<p>The arbitrator will decide the substance of all claims in accordance with the laws of the State of Illinois, including recognized principles of equity, and will honor all claims of privilege recognized by law. The arbitrator shall not be bound by rulings in prior arbitrations involving different Walgreens users, but is bound by rulings in prior arbitrations involving the same Walgreens user to the extent required by applicable law. The arbitrator\'s award shall be final and binding, and judgment on the award rendered by the arbitrator may be entered in any court having jurisdiction thereof.</p>\\n<p>You and we agree that each of us may bring claims against the other only on an individual basis and not as a plaintiff or class member in any purported class or representative action or proceeding. Unless you and we agree otherwise, the arbitrator may not consolidate or join more than one person\'s or party\'s claims and may not otherwise preside over any form of a consolidated, representative, or class proceeding. The arbitrator may award relief (including monetary, injunctive, and declaratory relief) only in favor of the individual party seeking relief and only to the extent necessary to provide relief necessitated by that party\'s individual claim(s). Any relief awarded shall not affect our other users.</p>\\n<p>You can choose to reject the Agreement to Arbitrate by mailing us a signed opt-out notice (\\"Opt- Out Notice\\") within 30 days after the date you first access the Services or accept any subsequently published version of these Terms. The Opt-Out Notice must include a statement that you do not agree to this Agreement to Arbitrate, your name, address, phone number, and any email address(es) used to log in to any applicable account(s) to which the opt-out applies. You must mail the Opt-Out Notice to Walgreens, Attn: Litigation and Regulatory Law Department, 104 Wilmot Road, MS 1431, Deerfield, IL 60015. This procedure is the only way you can opt out of the Agreement to Arbitrate. If you opt out of the Agreement to Arbitrate, all other parts of these Terms, including all other provisions of this Section, will continue to apply. Opting out of this Agreement to Arbitrate has no effect on any previous, other, or future arbitration agreements that you may have with us.</p>\\n<p>To the extent permitted by applicable law, any claims arising in connection with the use of these Services or these Terms must be filed within one (1) year of the date of the event giving rise to such action.</p>\\n\\n<h4>VIII. Digital Millennium Copyright Act</h4>\\n<p>If you believe any Walgreens Content infringes on your copyright, please go to https://www.walgreens.com/topic/help/digital_millenium_copyright_act.jsp for instructions on how to notify us.</p>\\n\\n<h4>IX. Additional Terms</h4>\\n<p>These Terms, including all other terms and policies referenced herein, constitute the entire agreement between you and us with respect to the Service, and shall be construed in accordance with the laws of the State of Illinois, without respect to its conflict of laws rules. In the event of any inconsistencies between these Terms and the policies referenced therein, these Terms shall control. Our failure to exercise or enforce any terms herein shall not constitute a waiver, and if we fail to act with respect to your breach or anyone else\'s breach on any occasion, we are not waiving our right to act with respect to future or similar breaches. If you breach any provision of these Terms, you may no longer use the Services. If these Terms or your permission to use the Services is terminated by us for any reason, the agreement formed by your acceptance of these Terms will nevertheless continue to apply and be binding upon you in respect of your prior use of the Services and anything relating to or arising from such use. If you are dissatisfied with the Services or with these Terms, your sole and exclusive remedy is to discontinue using the Services. These Terms, including any or all rights and obligations hereunder, may be freely assigned or transferred by us, but not by you. Section headings are included for convenience only, and shall not affect the interpretation of any Terms. You agree that any electronic notices we send you shall satisfy any requirement that such notices be made in writing. If any part of this these Terms is ruled to be unlawful, void, or for any reason unenforceable, then such part shall be deemed severable from these Terms, and shall be eliminated or limited to the minimum extent necessary. The remainder of these Terms, including any revised portion, shall remain and be in full force and effect.</p>\\n<p>Our automated touch-tone prescription refill system is licensed under the following United States Patents: 5,128,984; 5,561,707; 5,684,863; 5,815,551; 5,828,734; 5,898,762; 5,917,893; 5,974,120; and others.</p>\\n<p>Copyright 2021, Walgreen Co. All rights reserved.</p>"},"services":{"title":"Services Offered","cards":[{"title":"Health Questions","icon":"assets/services/help_icon.svg","subTitle":"Get assistance and answers to your questions","highlightedText":"Making better wellness choices for your health can be confusing at times. Spend one-on-one time with a Health Advisor and get answers to some of the questions you have.","additionalText":"From advice on over-the-counter medications and supplements to nutrition, ask a Health Advisor who has the clinical background to help you find answers to your questions.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Health Plan."},{"title":"Health Monitoring Devices","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Get help setting up health monitoring devices","highlightedText":"Health monitoring devices can show you day-to-day changes in your health by monitoring things like your blood pressure, activity, sleep, and more.","additionalText":"Learn how to set up and use wearable or in-home health devices that can help you better understand your health.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Health Plan."},{"title":"Flu Vaccine","icon":"assets/services/syringe_icon.svg","subTitle":"Get a flu vaccine","highlightedText":"Seasonal flu vaccines can help you reduce the risk of getting certain strains of influenza virus.","additionalText":"The vaccine can reduce flu illnesses, doctors\' visits, and missed work and school due to flu, as well as prevent flu-related hospitalizations and deaths. <br /><br /> Talk to a Health Advisor or pharmacist to get your flu vaccine.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Health Plan."}],"appointment":{"title":"Schedule an appointment","phoneNumber":"Call: 877-645-4128"}},"scheduleAppointments":{"infoHeader":"Care is now closer than you think","infoDescription":"At Walgreens Health Corner you now have an easy place to get your health to-do’s done. Bring us your health questions, concerns, or even schedule appointments for immunizations, or health checks. Walgreens Health Corner is here to help you. Schedule an appointment today.","detailsHeader":"Here are just some of the ways Walgreens Health Corner can help you.","details":[{"title":"Health questions","icon":"assets/scheduleAppointments/help.svg","description":"<p>Get assistance and answers to your questions.</p><p>Making better wellness choices for your health can be confusing at times. Spend one-on-one time with a Health Advisor and get answers to some of the questions you have.</p>"},{"title":"Health Monitoring Devices","icon":"assets/scheduleAppointments/immunization.svg","description":"<p>Get help setting up health monitoring devices.</p><p>Health monitoring devices can show you day-to-day changes in your health by monitoring things like your blood pressure, activity, sleep, and more.</p>"},{"title":"Flu Vaccine","icon":"assets/scheduleAppointments/band.svg","description":"<p>Get a flu vaccine*.</p><p>Seasonal flu vaccines can help you reduce the risk of getting certain strains of influenza virus. Talk to a Health Advisor or pharmacist to get your flu vaccine.</p><p></p><p>*Vaccines subject to availability. State-, age-, and health-related restrictions may apply</p>"}]},"inactivityModal":{"title":"Your session is about to expire","description":"Tap “Stay” to continue exploring the services Health Corner has to offer.","closeBtnText":"Close","timeoutMessageStart":"This session will time out in","timeoutMessageFinish":"seconds if you do not respond.","stayBtnText":"Stay","leaveBtnText":"Leave"},"virtualCare":{"title":"Virtual Care","leftHeader":"Experience Virtual Care","leftParagraph":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.","middleHeader":"Try our Virtual Care","phoneImg":"assets/virtual-care/find-a-provider.png","phoneImgAlt":"Search for providers and your closest Walgreens Health Corner location to support your health needs. Schedule appointments with select providers straight from the app.","rightHeader":"Scan the code to experience Walgreen’s Virtual Care.","newPhoneHeader":"iPhone & Newer Android","newPhoneParagraph":"Simply point your camera at the QR code on the right to automatically launch the survey.","oldPhoneHeader":"Older Android","oldPhoneParagraph":"Download a QR code reader app from the Play Store. Scan the code with the QR code app.","speechBubble":"Scan me!","qrCode":"assets/virtual-care/surveyQrCode.png","qrCodeAlt":"QR code to access our Virtual Care service"},"video":{"title":"Video","mediaUrl":"assets/video/kiosk_video.mp4","mediaPosterImg":"assets/video/videoPoster.png","pointerImg":"assets/video/pointer.svg","pointerAlt":"Learn More","learnMore":"Tap to learn more about Walgreens Health Corner"},"footer":{"leaveFeedback":"Leave Feedback","privacyPolicy":"Privacy Policy and Terms","termsAndConditions":"Conditions","nextLanguage":"Espa\xf1ol","endSession":"End Session"},"endSessionPrompt":{"modalTitle":"Are you done?","confirmText":"Yes","denyText":"No"}},"bsc":{"home":{"title":"Home","heading":"Welcome to healthcare without the hold music.","cards":[{"title":"About Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Meet your Health Advisors and find more information about Walgreens Health Corner’s operation hours."},{"title":"Services Offered","link":"services","icon":"assets/home/store.svg","description":"Convenient access to personalized care and support for your health, based on your health plan eligibility."},{"title":"Connected Devices","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitor and track your health with smart devices that measure  your progress over time."}],"descriptionBold":"Walgreens Health Corner","description":"is an easy, new way to take care of your health to-dos. Members of select health insurance providers get specialized services with no co-pays and no appointments."},"about":{"title":"About Walgreens Health Corner","heading":"About Walgreens Health Corner","description":"Check out our hours and meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.","cards":[{"heading":"Information and hours","description":"Get updated hours so you can get updated answers to your health questions.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Information and hours","heading":"You’ve got questions. We’ve got answers.","description":"Not sure how to navigate over-the-counter medicine or prescriptions? Want advice on how to stay active? Need help using a new health device? Our Health Advisors are here to help answer these questions, and more.","hoursTitle":"Health Corner Hours","advisorsDescription":"Our Health Advisors are a friendly, clinically trained team here to help you navigate your health needs. They will get to know you with each visit and interaction, providing personalized ongoing care. From assistance finding health information, to tips on nutrition and staying active, they are here for you.","learnMore":"If you’d like to learn more enter <br />https://www.walgreens.com/findcare/partner/blueshieldca-health-corner<br /> into your mobile phone or personal device.","legalText":"Walgreens Health Corner services are not intended for use in urgent and emergent care. The information provided is not a substitute for medical advice from your physician. If you are in need of immediate medical attention, contact your physician or go to the nearest emergency room. Consult your physician for diagnosis and treatment of your medical condition."},"connectedDevices":{"title":"Smart Health Devices","heading":"Monitor Your Health with Smart Devices","description":"Simplify how you track your progress or identify important changes in your health with devices that sync data via an app in your smart phone or tablet.","devices":[{"title":"Omron 10 Series Blood Pressure Monitor","id":"omron-10-series-blood-pressure-monitor","name":"Omron 10 Series Blood Pressure Monitor","body":"Comfortable and easy to read","img":"assets/connectedDevices/devices/omron-bp-monitor-large.png","thumbnail":"assets/connectedDevices/devices/omron-bp-monitor.png","attributes":[{"title":"Advanced accuracy technology","body":"Minimizes the impact your breathing and movements will have on your blood pressure reading results, helping to reduce measurement inconsistencies and errors.","icon":"assets/devices/device-health-dashboard.svg"},{"title":"Customizable intervals and users","body":"Automatically take 3 consecutive readings at intervals you can customize. See your last reading next to your current for immediate comparison. Accommodates two users.","icon":"assets/devices/device-clock.svg"},{"title":"Easy to Read & Comfortable","body":"Backlit LCD display features high-contrast, black backlit screen with extra-large numbers for easy-to-read results.","icon":"assets/devices/device-optical.svg"}]},{"title":"KardiaMobile Personal EKG Monitor","id":"kardiamobile-personal-ekg-monitor","name":"KardiaMobile Personal EKG Monitor","body":"Check in on your heart from home","img":"assets/connectedDevices/devices/kardiamobile-ekg-monitor-large.png","thumbnail":"assets/connectedDevices/devices/kardiamobile-ekg-monitor.png","attributes":[{"title":"Real-time detection","body":"Detect the 3 most common heart arrhythmias: Atrial Fibrillation, Bradycardia and Tachycardia and gain peace of mind by knowing instantly if your heart rhythm is normal.","icon":"assets/devices/device-heart-blood-pressure.svg"},{"title":"Easy to use","body":"Simply place your fingers on the sensors—no wires, patches, or gels.","icon":"assets/devices/device-bluetooth.svg"},{"title":"Store or share in seconds","body":"Store your EKGs on your phone or email to your doctor with the press of a button.","icon":"assets/devices/device-share.svg"}]},{"title":"OneTouch Verio Reflect Glucose Meter","id":"onetouch-verio-reflect-glucose-meter","name":"OneTouch Verio Reflect Glucose Meter","body":"Personalized insight to help manage your diabetes","img":"assets/connectedDevices/devices/onetouch-glucose-meter-large.png","thumbnail":"assets/connectedDevices/devices/onetouch-glucose-meter.png","disclaimer":"ATTENTION MEDICARE PATIENTS: Available for online purchase only. Walgreens.com is NOT an accredited Medicare supplier. If you purchase any medical equipment or supplies from the Home Health Care Solutions section of our website and submit a claim to Medicare for those items, Medicare will not pay. You are personally and fully responsible for payment of any medical equipment or supplies you purchase from this website.)","attributes":[{"title":"Learn better diabetes management","body":"In-app personalized insight, guidance and encouragement to help patients manage their diabetes.","icon":"assets/devices/device-blood-glucose.svg"},{"title":"Read and react in real-time","body":"ColorSure Dynamic Range Indicator shows when results are low, high, or in range so you can take action.","icon":"assets/devices/device-graph.svg"},{"title":"Reliable test strips","body":"Uses OneTouch Verio test strips with 9 years of proven accuracy at very low and very high blood glucose levels.","icon":"assets/devices/device-blood.svg"}]},{"title":"iChoice Pulse Oximeter","id":"ichoice-pulse-oximeter","name":"iChoice Pulse Oximeter","body":"Relaxation driven by your heart rate","img":"assets/connectedDevices/devices/ichoice-pulse-oximeter-large.png","thumbnail":"assets/connectedDevices/devices/ichoice-pulse-oximeter.png","attributes":[{"title":"Get readings in real-time","body":"Measures Oxygen level, Heart Rate and Calm/Stress level. The fingertip sensor transmits vital readings in real-time to the free iChoice Relax app.","icon":"assets/devices/device-heart-blood-pressure.svg"},{"title":"Improve with coaching techniques","body":"Follow breathing pacers driven by your heart rate to reduce anxiety and stress. Learn to breathe at your Personal Best Relaxation Breathing Rate.","icon":"assets/devices/device-trophy.svg"},{"title":"Sleep better","body":"Use in-app relaxing videos and sounds to help you fall asleep.","icon":"assets/devices/device-night.svg"}]}]},"services":{"title":"Services Offered","heading":"A new way to care for your health","description":"Meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.  Plus, Blue Shield of California members can access additional services here in the Health Corner.","cards":[{"title":"Health Questions","icon":"assets/services/help_icon.svg","subTitle":"Get assistance and answers to your questions","highlightedText":"Making better wellness choices for your health can be confusing at times. Spend one-on-one time with a Health Advisor and get answers to some of the questions you have.","additionalText":"From advice on over-the-counter medications and supplements to nutrition, ask a Health Advisor who has the clinical background to help you find answers to your questions.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Blue Shield of California Health Plan."},{"title":"Health Monitoring Devices","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Get help setting up health monitoring devices","highlightedText":"Health monitoring devices can show you day-to-day changes in your health by monitoring things like your blood pressure, activity, sleep, and more.","additionalText":"Learn how to set up and use wearable or in-home health devices that can help you better understand your health.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Blue Shield of California Health Plan."},{"title":"Flu Vaccine","icon":"assets/services/syringe_icon.svg","subTitle":"Get a flu vaccine","highlightedText":"Seasonal flu vaccines can help you reduce the risk of getting certain strains of influenza virus.","additionalText":"The vaccine can reduce flu illnesses, doctors\' visits, and missed work and school due to flu, as well as prevent flu-related hospitalizations and deaths. <br /><br /> Talk to a Health Advisor or pharmacist to get your flu vaccine.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Blue Shield of California Health Plan."},{"title":"Blood Pressure Screening","icon":"assets/services/bp_icon.svg","availability":"BSC members only","subTitle":"Blue Shield of California members get a blood pressure screening","highlightedText":"Monitoring your blood pressure is important to reduce the risk of heart attack and stroke.","additionalText":"High blood pressure often does not present with any symptoms and often develops slowly over time; therefore, it is important to have your blood pressure checked regularly.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Blue Shield of California Health Plan."},{"title":"BMI Assessment","icon":"assets/services/bmi_icon.svg","availability":"BSC members only","subTitle":"Blue Shield of California members get a BMI assessment","highlightedText":"Body mass index (BMI) is used to estimate body fat and if a person is at a healthy weight.","additionalText":"Higher body fat can be related to an increased risk of some diseases. BMI is a calculation based on height and weight.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Blue Shield of California Health Plan."},{"title":"A1C Test","icon":"assets/services/drop_icon.svg","availability":"BSC members only","subTitle":"Blue Shield of California members get an A1C test","highlightedText":"The A1C test—also known as the hemoglobin A1C or HbA1c test—is a simple blood test that measures your average blood sugar levels over the past 2-3 months.","additionalText":"It’s one of the commonly used tests to diagnose pre-diabetes and diabetes and is also the main test to help you and your health care team manage your diabetes.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Blue Shield of California Health Plan."},{"title":"Mammography Care Coordination","icon":"assets/services/selfcare_icon.svg","availability":"BSC members only","subTitle":"Blue Shield of California members get mammography care coordination","highlightedText":"A breast cancer screening is an important test for early detection of breast cancer before there are signs or symptoms of the disease.","additionalText":"Although they cannot prevent breast cancer, screening tests (such as yearly mammograms) are given routinely to find breast cancer early, when it is easier to treat.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Blue Shield of California Health Plan."},{"title":"At-Home Colorectal Cancer Screening","icon":"assets/services/home_icon.svg","availability":"BSC members only","subTitle":"Blue Shield of California members get an at-home colorectal cancer screening test kit","highlightedText":"A screening test can be done in the comfort of your home and is used to look for colorectal abnormalities when a person doesn’t have symptoms.","additionalText":"You should begin screening for colorectal cancer soon after turning 50, then continue getting screened at regular intervals.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Blue Shield of California Health Plan."}],"appointment":{"title":"Schedule an appointment","phoneNumber":"Call: 877-645-4128"}},"scheduleAppointments":{"infoHeader":"Care is now closer than you think","infoDescription":"At Walgreens Health Corner you now have an easy place to get your health to-do’s done. Bring us your health questions, concerns, or even schedule appointments for immunizations, or health checks. Walgreens Health Corner is here to help you. Schedule an appointment today.","detailsHeader":"Here are just some of the ways Walgreens Health Corner can help you.","details":[{"title":"Health questions","icon":"assets/scheduleAppointments/help.svg","description":"<p>Get assistance and answers to your questions.</p><p>Making better wellness choices for your health can be confusing at times. Spend one-on-one time with a Health Advisor and get answers to some of the questions you have.</p>"},{"title":"Health Monitoring Devices","icon":"assets/scheduleAppointments/immunization.svg","description":"<p>Get help setting up health monitoring devices.</p><p>Health monitoring devices can show you day-to-day changes in your health by monitoring things like your blood pressure, activity, sleep, and more.</p>"},{"title":"Flu Vaccine","icon":"assets/scheduleAppointments/band.svg","description":"<p>Get a flu vaccine*.</p><p>Seasonal flu vaccines can help you reduce the risk of getting certain strains of influenza virus. Talk to a Health Advisor or pharmacist to get your flu vaccine.</p><p></p><p>*Vaccines subject to availability. State-, age-, and health-related restrictions may apply</p>"}],"appointment":{"text":"Schedule an appointment","number":"Call: 877-645-4128"}}},"clover":{"home":{"title":"Home","heading":"Welcome to healthcare without the hold music.","cards":[{"title":"About Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Meet your Health Advisors and find more information about Walgreens Health Corner’s operation hours."},{"title":"Services Offered","link":"services","icon":"assets/home/store.svg","description":"Convenient access to personalized care and support for your health, based on your health plan eligibility."},{"title":"Connected Devices","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitor and track your health with smart devices that measure  your progress over time."}],"descriptionBold":"Walgreens Health Corner","description":"is an easy, new way to take care of your health to-dos.  Members of select health insurance providers get specialized services with no co-pays and no appointments."},"feedback":{"title":"Leave Feedback","heading":"Your feedback is important","description":"To help us improve future Health Corner visits, please let us know what you thought of your experience today. Your response will only be used to help us and your health plan understand how we can make your next visit better.","surveyHeading":"Complete the survey on your device","surveyQrCodeLink":"assets/feedback/surveyQrCodeNJ.png","surveyQrCodeLinkAlt":"survey QR code","phoneHeading":"iPhone & Newer Android","phoneDescription":"Simply point your camera at the QR code on the right to automatically launch the survey.","oldPhoneHeading":"Older Android","oldPhoneDescription":"Download a QR code reader app from the Play Store. Scan the code with the QR code app."},"about":{"title":"About Walgreens Health Corner","heading":"About Walgreens Health Corner","description":"Check out our hours and meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.","cards":[{"heading":"Information and hours","description":"Get updated hours so you can get updated answers to your health questions.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Information and hours","heading":"You’ve got questions. We’ve got answers.","description":"Not sure how to navigate over-the-counter medicine or prescriptions? Want advice on how to stay active? Need help using a new health device? Our Health Advisors are here to help answer these questions, and more.","hoursTitle":"Health Corner Hours","advisorsDescription":"Our Health Advisors are a friendly, clinically trained team here to help you navigate your health needs. They will get to know you with each visit and interaction, providing personalized ongoing care. From assistance finding health information, to tips on nutrition and staying active, they are here for you.","learnMore":"If you’d like to learn more enter <br />https://www.walgreenshealth.com/clover-health/home<br /> into your mobile phone or personal device.","legalText":"Walgreens Health Corner services are not intended for use in urgent and emergent care. The information provided is not a substitute for medical advice from your physician. If you are in need of immediate medical attention, contact your physician or go to the nearest emergency room. Consult your physician for diagnosis and treatment of your medical condition."},"connectedDevices":{"title":"Smart Health Devices","heading":"Monitor Your Health with Smart Devices","description":"Connected devices use bluetooth technology to monitor, alert and sync data via an app in your smart phone or tablet.","devices":[{"title":"Withings Activity Tracker","id":"withings-activity-tracker","name":"Withings Activity Tracker","body":"Classic style. Advanced tracking.","img":"assets/connectedDevices/devices/activity-tracker-large.png","thumbnail":"assets/connectedDevices/devices/activity-tracker.png","attributes":[{"title":"Seamless Tracking","body":"Automatically tracks walk, run, swim and easily detects 30+ activities. Offers workout mode and connected GPS. Visualizes your trends and data on your smartphone.","icon":"assets/devices/device-walking.svg"},{"title":"Durable","body":"Up to 18 months battery life and water resistant to 50m.","icon":"assets/devices/device-calendar.svg"},{"title":"Sleep Tracking","body":"Delivers a Sleep Score, light & deep sleep stages, plus silent alarm & Smart Wake-Up.","icon":"assets/devices/device-sleep-tracking.svg"}]},{"title":"Withings Sleep Mat","id":"withings-sleep-mat","name":"Withings Sleep Mat","body":"Better nights for better days","img":"assets/connectedDevices/devices/sleep-mat-large.png","thumbnail":"assets/connectedDevices/devices/sleep-mat.png","attributes":[{"title":"Nothing to Wear","body":"Easy one-time setup under the mattress, compatible with most mattresses. Wake up to immediate in-app results you can easily share as a PDF of data in the app with your doctor.","icon":"assets/devices/checkbox.svg"},{"title":"Advanced Sleep Tracking","body":"Get an in-depth analysis of your night with sleep cycles, continuous heart rate & snore detection. Know how restorative your sleep was with the Sleep Score.","icon":"assets/devices/sleep-tracking.svg"},{"title":"Home Automation","body":"Control lights, temperature, and other smart home-enabled devices just by getting into and out of bed.","icon":"assets/devices/home.svg"}]},{"title":"Withings Scale","id":"withings-scale","name":"Withings Scale","body":"Health goals. Tailored to you.","img":"assets/connectedDevices/devices/withings-scale-large.png","thumbnail":"assets/connectedDevices/devices/withings-scale.png","attributes":[{"title":"Instant Weight Insight","body":"Track progress and stay motivated during each weigh-in with weight trend and BMI screens.","icon":"assets/devices/graph.svg"},{"title":"Automatic Synchronization","body":"Data from every weigh-in appears in the Health Mate app automatically via Wi-Fi.","icon":"assets/devices/bluetooth.svg"},{"title":"Multi-user Friendly","body":"Recognizes up to 8 users with independent sync.","icon":"assets/devices/multi-user.svg"}]},{"title":"Withings Blood Pressure Cuff","id":"withings-blood-pressure-cuff","name":"Withings Blood Pressure Cuff","body":"Easy to use. Easy to read.","img":"assets/connectedDevices/devices/withings-blood-pressure-cuff-large.png","thumbnail":"assets/connectedDevices/devices/withings-blood-pressure-cuff.png","attributes":[{"title":"Medical accuracy and accessibility","body":"Clinically validated monitoring your blood pressure with accurate results you can trust. Level up your medical check- up by sharing a health journal with your healthcare professionals.","icon":"assets/devices/graph.svg"},{"title":"Easy to read","body":"Even before you open the app, Instant color-coded feedback on the LED screen shows you where you stand at a glance.","icon":"assets/devices/glasses.svg"},{"title":"Easy to use","body":"With only one button to press and automatic Wi-Fi sync to the free Health Mate app, our devices are the simplest way to accurately measure and monitor blood pressure over time.","icon":"assets/devices/bluetooth.svg"}]}]},"services":{"title":"Services Offered","heading":"A new way to care for your health","description":"Meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.  Plus, Clover members can access additional services here in the Health Corner.","cards":[{"title":"Health Questions","icon":"assets/services/help_icon.svg","subTitle":"Get assistance and answers to your questions","highlightedText":"Making better wellness choices for your health can be confusing at times. Spend one-on-one time with a Health Advisor and get answers to some of the questions you have.","additionalText":"From advice on over-the-counter medications and supplements to nutrition, ask a Health Advisor who has the clinical background to help you find answers to your questions.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"Health Monitoring Devices","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Get help setting up health monitoring devices","highlightedText":"Health monitoring devices can show you day-to-day changes in your health by monitoring things like your blood pressure, activity, sleep, and more.","additionalText":"Learn how to set up and use wearable or in-home health devices that can help you better understand your health.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"Flu Vaccine","icon":"assets/services/syringe_icon.svg","subTitle":"Get a flu vaccine","highlightedText":"Seasonal flu vaccines can help you reduce the risk of getting certain strains of influenza virus.","additionalText":"The vaccine can reduce flu illnesses, doctors\' visits, and missed work and school due to flu, as well as prevent flu-related hospitalizations and deaths. <br /><br /> Talk to a Health Advisor or pharmacist to get your flu vaccine.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"Health Risk Assessment","icon":"assets/services/test_results_icon.svg","availability":"Clover members only","subTitle":"Clover members get a health risk assessment","highlightedText":"We want to help you be as healthy as you can be with health care support that is specifically tailored to you.","additionalText":"A Health Advisor will walk you through a questionnaire that evaluates lifestyle factors and health risks covering topics such as nutrition, fitness, stress, sleep, and mental health.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"Blood Pressure Screening","icon":"assets/services/bp_icon.svg","availability":"Clover members only","subTitle":"Clover members get a blood pressure screening","highlightedText":"Monitoring your blood pressure is important to reduce the risk of heart attack and stroke.","additionalText":"High blood pressure often does not present with any symptoms and often develops slowly over time; therefore, it is important to have your blood pressure checked regularly.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"BMI Assessment","icon":"assets/services/bmi_icon.svg","availability":"Clover members only","subTitle":"Clover members get a BMI assessment","highlightedText":"Body mass index (BMI) is used to estimate body fat and if a person is at a healthy weight.","additionalText":"Higher body fat can be related to an increased risk of some diseases. BMI is a calculation based on height and weight.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"A1C Test","icon":"assets/services/drop_icon.svg","availability":"Clover members only","subTitle":"Clover members get an A1C test","highlightedText":"The A1C test—also known as the hemoglobin A1C or HbA1c test—is a simple blood test that measures your average blood sugar levels over the past 2-3 months.","additionalText":"It’s one of the commonly used tests to diagnose pre-diabetes and diabetes and is also the main test to help you and your health care team manage your diabetes.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"Medication Education Info","icon":"assets/services/medication_info_icon.svg","availability":"Clover members only","subTitle":"Clover Health members can get educational information about their medications","highlightedText":"Taking medications as prescribed is important for controlling chronic conditions, treating temporary conditions, and overall long-term health and well-being.","additionalText":"Get general educational information about the prescriptions you are taking for your health condition.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"At-Home Colorectal Cancer Screening","icon":"assets/services/home_icon.svg","availability":"Clover members only","subTitle":"Clover members get an at-home colorectal cancer screening test kit","highlightedText":"A screening test can be done in the comfort of your home and is used to look for colorectal abnormalities when a person doesn’t have symptoms.","additionalText":"You should begin screening for colorectal cancer soon after turning 50, then continue getting screened at regular intervals.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."},{"title":"Diabetic Kidney Disease Screening","icon":"assets/services/microscope_icon.svg","availability":"Clover members only","subTitle":"Clover Health members can get a Diabetic Kidney Disease Screening","highlightedText":"A screening test can be done in the comfort of your home with simple urine collection that can detect the presence of proteins","additionalText":"Diabetic kidney screening is recommended for adults diagnosed with diabetes. The beginning and timing of your screenings may vary based on your progress and type of diabetes you\'ve been diagnosed with.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Clover Health Plan."}],"appointment":{"title":"Schedule an appointment","phoneNumber":"Call: 877-645-4128"}}},"buckeye":{"home":{"title":"Home","heading":"Welcome to healthcare without the hold music.","cards":[{"title":"About Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Meet your Health Advisors and find more information about Walgreens Health Corner’s operation hours."},{"title":"Services Offered","link":"services","icon":"assets/home/store.svg","description":"Convenient access to personalized care and support for your health, based on your health plan eligibility."},{"title":"Connected Devices","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitor and track your health with smart devices that measure  your progress over time."}],"descriptionBold":"Walgreens Health Corner","description":"is an easy, new way to take care of your health to-dos. Members of select health insurance providers get specialized services with no co-pays and no appointments."},"about":{"title":"About Walgreens Health Corner","heading":"About Walgreens Health Corner","description":"Check out our hours and meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.","cards":[{"heading":"Information and hours","description":"Get updated hours so you can get updated answers to your health questions.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Information and hours","heading":"You’ve got questions. We’ve got answers.","description":"Not sure how to navigate over-the-counter medicine or prescriptions? Want advice on how to stay active? Need help using a new health device? Our Health Advisors are here to help answer these questions, and more.","hoursTitle":"Health Corner Hours","advisorsDescription":"Our Health Advisors are a friendly, clinically trained team here to help you navigate your health needs. They will get to know you with each visit and interaction, providing personalized ongoing care. From assistance finding health information, to tips on nutrition and staying active, they are here for you.","learnMore":"If you’d like to learn more enter <br />https://www.walgreenshealth.com/buckeyehealthplan/home<br /> into your mobile phone or personal device.","legalText":"Walgreens Health Corner services are not intended for use in urgent and emergent care. The information provided is not a substitute for medical advice from your physician. If you are in need of immediate medical attention, contact your physician or go to the nearest emergency room. Consult your physician for diagnosis and treatment of your medical condition."},"connectedDevices":{"title":"Smart Health Devices","heading":"Monitor Your Health with Smart Devices","description":"Simplify how you track your progress or identify important changes in your health with devices that sync data via an app in your smart phone or tablet.","devices":[{"title":"Omron 10 Series Blood Pressure Monitor","id":"omron-10-series-blood-pressure-monitor","name":"Omron 10 Series Blood Pressure Monitor","body":"Comfortable and easy to read","img":"assets/connectedDevices/devices/omron-bp-monitor-large.png","thumbnail":"assets/connectedDevices/devices/omron-bp-monitor.png","attributes":[{"title":"Advanced accuracy technology","body":"Minimizes the impact your breathing and movements will have on your blood pressure reading results, helping to reduce measurement inconsistencies and errors.","icon":"assets/devices/device-health-dashboard.svg"},{"title":"Customizable intervals and users","body":"Automatically take 3 consecutive readings at intervals you can customize. See your last reading next to your current for immediate comparison. Accommodates two users.","icon":"assets/devices/device-clock.svg"},{"title":"Easy to Read & Comfortable","body":"Backlit LCD display features high-contrast, black backlit screen with extra-large numbers for easy-to-read results.","icon":"assets/devices/device-optical.svg"}]},{"title":"KardiaMobile Personal EKG Monitor","id":"kardiamobile-personal-ekg-monitor","name":"KardiaMobile Personal EKG Monitor","body":"Check in on your heart from home","img":"assets/connectedDevices/devices/kardiamobile-ekg-monitor-large.png","thumbnail":"assets/connectedDevices/devices/kardiamobile-ekg-monitor.png","attributes":[{"title":"Real-time detection","body":"Detect the 3 most common heart arrhythmias: Atrial Fibrillation, Bradycardia and Tachycardia and gain peace of mind by knowing instantly if your heart rhythm is normal.","icon":"assets/devices/device-heart-blood-pressure.svg"},{"title":"Easy to use","body":"Simply place your fingers on the sensors—no wires, patches, or gels.","icon":"assets/devices/device-bluetooth.svg"},{"title":"Store or share in seconds","body":"Store your EKGs on your phone or email to your doctor with the press of a button.","icon":"assets/devices/device-share.svg"}]},{"title":"OneTouch Verio Reflect Glucose Meter","id":"onetouch-verio-reflect-glucose-meter","name":"OneTouch Verio Reflect Glucose Meter","body":"Personalized insight to help manage your diabetes","img":"assets/connectedDevices/devices/onetouch-glucose-meter-large.png","thumbnail":"assets/connectedDevices/devices/onetouch-glucose-meter.png","disclaimer":"ATTENTION MEDICARE PATIENTS: Available for online purchase only. Walgreens.com is NOT an accredited Medicare supplier. If you purchase any medical equipment or supplies from the Home Health Care Solutions section of our website and submit a claim to Medicare for those items, Medicare will not pay. You are personally and fully responsible for payment of any medical equipment or supplies you purchase from this website.)","attributes":[{"title":"Learn better diabetes management","body":"In-app personalized insight, guidance and encouragement to help patients manage their diabetes.","icon":"assets/devices/device-blood-glucose.svg"},{"title":"Read and react in real-time","body":"ColorSure Dynamic Range Indicator shows when results are low, high, or in range so you can take action.","icon":"assets/devices/device-graph.svg"},{"title":"Reliable test strips","body":"Uses OneTouch Verio test strips with 9 years of proven accuracy at very low and very high blood glucose levels.","icon":"assets/devices/device-blood.svg"}]},{"title":"iChoice Pulse Oximeter","id":"ichoice-pulse-oximeter","name":"iChoice Pulse Oximeter","body":"Relaxation driven by your heart rate","img":"assets/connectedDevices/devices/ichoice-pulse-oximeter-large.png","thumbnail":"assets/connectedDevices/devices/ichoice-pulse-oximeter.png","attributes":[{"title":"Get readings in real-time","body":"Measures Oxygen level, Heart Rate and Calm/Stress level. The fingertip sensor transmits vital readings in real-time to the free iChoice Relax app.","icon":"assets/devices/device-heart-blood-pressure.svg"},{"title":"Improve with coaching techniques","body":"Follow breathing pacers driven by your heart rate to reduce anxiety and stress. Learn to breathe at your Personal Best Relaxation Breathing Rate.","icon":"assets/devices/device-trophy.svg"},{"title":"Sleep better","body":"Use in-app relaxing videos and sounds to help you fall asleep.","icon":"assets/devices/device-night.svg"}]}]},"services":{"title":"Services Offered","heading":"A new way to care for your health","description":"Meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy. Plus, Buckeye Health Plan members can access additional services.","cards":[{"title":"Health Questions","icon":"assets/services/help_icon.svg","subTitle":"Get assistance and answers to your questions","highlightedText":"Making better wellness choices for your health can be confusing at times. Spend one-on-one time with a Health Advisor and get answers to some of the questions you have.","additionalText":"From advice on over-the-counter medications and supplements to nutrition, ask a Health Advisor who has the clinical background to help you find answers to your questions.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan."},{"title":"Health Monitoring Devices","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Get help setting up health monitoring devices","highlightedText":"Health monitoring devices can show you day-to-day changes in your health by monitoring things like your blood pressure, activity, sleep, and more.","additionalText":"Learn how to set up and use wearable or in-home health devices that can help you better understand your health.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan."},{"title":"Flu Vaccine","icon":"assets/services/syringe_icon.svg","subTitle":"Get a flu vaccine","highlightedText":"Seasonal flu vaccines can help you reduce the risk of getting certain strains of influenza virus.","additionalText":"The vaccine can reduce flu illnesses, doctors\' visits, and missed work and school due to flu, as well as prevent flu-related hospitalizations and deaths. <br /><br /> Talk to a Health Advisor or pharmacist to get your flu vaccine.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan."},{"title":"Health Assessment","icon":"assets/services/test_results_icon.svg","availability":"Buckeye Health Plan members only","subTitle":"Buckeye Health Plan members get a health assessment","highlightedText":"We want to help you be as healthy as you can be with health care support that is specifically tailored to you.","additionalText":"A Health Advisor will walk you through a questionnaire that evaluates lifestyle factors and health risks covering topics such as nutrition, fitness, stress, sleep, and mental health.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Blood Pressure Screening","icon":"assets/services/bp_icon.svg","availability":"Buckeye Health Plan members only","subTitle":"Buckeye Health Plan members get a blood pressure screening","highlightedText":"Monitoring your blood pressure is important to reduce the risk of heart attack and stroke.","additionalText":"High blood pressure often does not present with any symptoms and often develops slowly over time; therefore, it is important to have your blood pressure checked regularly.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"BMI Assessment","icon":"assets/services/bmi_icon.svg","availability":"Buckeye Health Plan members only","subTitle":"Buckeye Health Plan members get a BMI assessment","highlightedText":"Body mass index (BMI) is used to estimate body fat and if a person is at a healthy weight.","additionalText":"Higher body fat can be related to an increased risk of some diseases. BMI is a calculation based on height and weight.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"A1C Test","icon":"assets/services/drop_icon.svg","availability":"Buckeye Health Plan members only","subTitle":"Buckeye Health Plan members get an A1C test","highlightedText":"The A1C test—also known as the hemoglobin A1C or HbA1c test—is a simple blood test that measures your average blood sugar levels over the past 2-3 months.","additionalText":"It’s one of the commonly used tests to diagnose pre-diabetes and diabetes and is also the main test to help you and your health care team manage your diabetes.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Mammography Care Coordination","icon":"assets/services/selfcare_icon.svg","availability":"Buckeye Health Plan members only","subTitle":"Buckeye Health Plan members get mammography care coordination","highlightedText":"A breast cancer screening is an important test for early detection of breast cancer before there are signs or symptoms of the disease.","additionalText":"Although they cannot prevent breast cancer, screening tests (such as yearly mammograms) are given routinely to find breast cancer early, when it is easier to treat.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"At-Home Colorectal Cancer Screening","icon":"assets/services/home_icon.svg","availability":"Buckeye Health Plan members only","subTitle":"Buckeye Health Plan members get an at-home colorectal cancer screening test kit","highlightedText":"A screening test can be done in the comfort of your home and is used to look for colorectal abnormalities when a person doesn’t have symptoms.","additionalText":"You should begin screening for colorectal cancer soon after turning 50, then continue getting screened at regular intervals.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Diabetic Kidney Disease Screening","icon":"assets/services/microscope_icon.svg","availability":"Buckeye Health Plan members only","subTitle":"Buckeye Health Plan Members can get a Diabetic Kidney Disease Screening","highlightedText":"A screening test can be done in the comfort of your home with simple urine collection that can detect the presence of proteins.","additionalText":"Diabetic kidney screening is recommended for adults diagnosed with diabetes. The beginning and timing of your screenings may vary based on your progress and type of diabetes you\'ve been diagnosed with.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility varies based on Buckeye Health Plan.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"}],"appointment":{"title":"Schedule an appointment","phoneNumber":"Call: 877-645-4128"}}},"horizon":{"home":{"title":"Home","heading":"Welcome to healthcare without the hold music.","cards":[{"title":"About Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Meet your Health Advisors and find more information about Walgreens Health Corner’s operation hours."},{"title":"Services Offered","link":"services","icon":"assets/home/store.svg","description":"Convenient access to personalized care and support for your health, based on your health plan eligibility."},{"title":"Connected Devices","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitor and track your health with smart devices that measure  your progress over time."}],"descriptionBold":"Walgreens Health Corner","description":"is an easy, new way to take care of your health to-dos. Members of select health insurance providers get specialized services with no co-pays and no appointments."},"feedback":{"title":"Leave Feedback","heading":"Your feedback is important","description":"To help us improve future Health Corner visits, please let us know what you thought of your experience today. Your response will only be used to help us and your health plan understand how we can make your next visit better.","surveyHeading":"Complete the survey on your device","surveyQrCodeLink":"assets/feedback/surveyQrCodeNJ.png","surveyQrCodeLinkAlt":"survey QR code","phoneHeading":"iPhone & Newer Android","phoneDescription":"Simply point your camera at the QR code on the right to automatically launch the survey.","oldPhoneHeading":"Older Android","oldPhoneDescription":"Download a QR code reader app from the Play Store. Scan the code with the QR code app."},"about":{"title":"About Walgreens Health Corner","heading":"About Walgreens Health Corner","description":"Check out our hours and meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.","cards":[{"heading":"Information and hours","description":"Get updated hours so you can get updated answers to your health questions.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Information and hours","heading":"You’ve got questions. We’ve got answers.","description":"Not sure how to navigate over-the-counter medicine or prescriptions? Want advice on how to stay active? Need help using a new health device? Our Health Advisors are here to help answer these questions, and more.","hoursTitle":"Health Corner Hours","advisorsDescription":"Our Health Advisors are a friendly, clinically trained team here to help you navigate your health needs. They will get to know you with each visit and interaction, providing personalized ongoing care. From assistance finding health information, to tips on nutrition and staying active, they are here for you.","legalText":"Walgreens Health Corner services are not intended for use in urgent and emergent care. The information provided is not a substitute for medical advice from your physician. If you are in need of immediate medical attention, contact your physician or go to the nearest emergency room. Consult your physician for diagnosis and treatment of your medical condition."},"connectedDevices":{"title":"Smart Health Devices","heading":"Monitor Your Health with Smart Devices","description":"Connected devices use bluetooth technology to monitor, alert and sync data via an app in your smart phone or tablet.","devices":[{"title":"Withings Activity Tracker","id":"withings-activity-tracker","name":"Withings Activity Tracker","body":"Classic style. Advanced tracking.","img":"assets/connectedDevices/devices/activity-tracker-large.png","thumbnail":"assets/connectedDevices/devices/activity-tracker.png","attributes":[{"title":"Seamless Tracking","body":"Automatically tracks walk, run, swim and easily detects 30+ activities. Offers workout mode and connected GPS. Visualizes your trends and data on your smartphone.","icon":"assets/devices/device-walking.svg"},{"title":"Durable","body":"Up to 18 months battery life and water resistant to 50m.","icon":"assets/devices/device-calendar.svg"},{"title":"Sleep Tracking","body":"Delivers a Sleep Score, light & deep sleep stages, plus silent alarm & Smart Wake-Up.","icon":"assets/devices/device-sleep-tracking.svg"}]},{"title":"Withings Sleep Mat","id":"withings-sleep-mat","name":"Withings Sleep Mat","body":"Better nights for better days","img":"assets/connectedDevices/devices/sleep-mat-large.png","thumbnail":"assets/connectedDevices/devices/sleep-mat.png","attributes":[{"title":"Nothing to Wear","body":"Easy one-time setup under the mattress, compatible with most mattresses. Wake up to immediate in-app results you can easily share as a PDF of data in the app with your doctor.","icon":"assets/devices/checkbox.svg"},{"title":"Advanced Sleep Tracking","body":"Get an in-depth analysis of your night with sleep cycles, continuous heart rate & snore detection. Know how restorative your sleep was with the Sleep Score.","icon":"assets/devices/sleep-tracking.svg"},{"title":"Home Automation","body":"Control lights, temperature, and other smart home-enabled devices just by getting into and out of bed.","icon":"assets/devices/home.svg"}]},{"title":"Withings Scale","id":"withings-scale","name":"Withings Scale","body":"Health goals. Tailored to you.","img":"assets/connectedDevices/devices/withings-scale-large.png","thumbnail":"assets/connectedDevices/devices/withings-scale.png","attributes":[{"title":"Instant Weight Insight","body":"Track progress and stay motivated during each weigh-in with weight trend and BMI screens.","icon":"assets/devices/graph.svg"},{"title":"Automatic Synchronization","body":"Data from every weigh-in appears in the Health Mate app automatically via Wi-Fi.","icon":"assets/devices/bluetooth.svg"},{"title":"Multi-user Friendly","body":"Recognizes up to 8 users with independent sync.","icon":"assets/devices/multi-user.svg"}]},{"title":"Withings Blood Pressure Cuff","id":"withings-blood-pressure-cuff","name":"Withings Blood Pressure Cuff","body":"Easy to use. Easy to read.","img":"assets/connectedDevices/devices/withings-blood-pressure-cuff-large.png","thumbnail":"assets/connectedDevices/devices/withings-blood-pressure-cuff.png","attributes":[{"title":"Medical accuracy and accessibility","body":"Clinically validated monitoring your blood pressure with accurate results you can trust. Level up your medical check- up by sharing a health journal with your healthcare professionals.","icon":"assets/devices/graph.svg"},{"title":"Easy to read","body":"Even before you open the app, Instant color-coded feedback on the LED screen shows you where you stand at a glance.","icon":"assets/devices/glasses.svg"},{"title":"Easy to use","body":"With only one button to press and automatic Wi-Fi sync to the free Health Mate app, our devices are the simplest way to accurately measure and monitor blood pressure over time.","icon":"assets/devices/bluetooth.svg"}]}]},"services":{"title":"Services Offered","heading":"A new way to care for your health","description":"Meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.  Plus, Horizon members can access additional services here in the Health Corner.","cards":[{"title":"Health Questions","icon":"assets/services/help_icon.svg","subTitle":"Get assistance and answers to your questions","highlightedText":"Making better wellness choices for your health can be confusing at times. Spend one-on-one time with a Health Advisor and get answers to some of the questions you have.","additionalText":"From advice on over-the-counter medications and supplements to nutrition, ask a Health Advisor who has the clinical background to help you find answers to your questions.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Horizon Health Plan."},{"title":"Health Monitoring Devices","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Get help setting up health monitoring devices","highlightedText":"Health monitoring devices can show you day-to-day changes in your health by monitoring things like your blood pressure, activity, sleep, and more.","additionalText":"Learn how to set up and use wearable or in-home health devices that can help you better understand your health.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Horizon Health Plan."},{"title":"Flu Vaccine","icon":"assets/services/syringe_icon.svg","subTitle":"Get a flu vaccine","highlightedText":"Seasonal flu vaccines can help you reduce the risk of getting certain strains of influenza virus.","additionalText":"The vaccine can reduce flu illnesses, doctors\' visits, and missed work and school due to flu, as well as prevent flu-related hospitalizations and deaths. <br /><br /> Talk to a Health Advisor or pharmacist to get your flu vaccine.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Horizon Health Plan."},{"title":"Blood Pressure Screening","icon":"assets/services/bp_icon.svg","availability":"Horizon members only","subTitle":"Horizon members get a blood pressure screening","highlightedText":"Monitoring your blood pressure is important to reduce the risk of heart attack and stroke.","additionalText":"High blood pressure often does not present with any symptoms and often develops slowly over time; therefore, it is important to have your blood pressure checked regularly.","headerColor":"#ffffff","headerBackgroundColor":"#1F3D7D","headerLogo":"assets/services/horizon-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Horizon Health Plan."},{"title":"A1C Test","icon":"assets/services/drop_icon.svg","availability":"Horizon members only","subTitle":"Horizon members get an A1C test","highlightedText":"The A1C test—also known as the hemoglobin A1C or HbA1c test—is a simple blood test that measures your average blood sugar levels over the past 2-3 months.","additionalText":"It’s one of the commonly used tests to diagnose pre-diabetes and diabetes and is also the main test to help you and your health care team manage your diabetes.","headerColor":"#ffffff","headerBackgroundColor":"#1F3D7D","headerLogo":"assets/services/horizon-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Horizon Health Plan."},{"title":"Colorectal Cancer Screening","icon":"assets/services/home_icon.svg","availability":"Horizon members only","subTitle":"Horizon members get an at-home colorectal cancer screening test kit","highlightedText":"A screening test can be done in the comfort of your home and is used to look for colorectal abnormalities when a person doesn’t have symptoms.","additionalText":"You should begin screening for colorectal cancer soon after turning 50, then continue getting screened at regular intervals.","headerColor":"#ffffff","headerBackgroundColor":"#1F3D7D","headerLogo":"assets/services/horizon-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Horizon Health Plan."},{"title":"Care for Adults 66+","icon":"assets/services/person_with_heart_icon.svg","availability":"Horizon members only","subTitle":"Helping Horizon members 66 years and older get the care they need","highlightedText":"Getting the care you need in this phase of life can help you maintain or improve your quality of life so you can do more of what matters to you","additionalText":"Our Walgreens Health Corner team will work with you to provide: \\n-Medication Review\\n- Pain Assessment\\n- Falls Assessment\\n-Physical Activity Assessment\\n","headerColor":"#ffffff","headerBackgroundColor":"#1F3D7D","headerLogo":"assets/services/horizon-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Horizon Health Plan."}],"appointment":{"title":"Schedule an appointment","phoneNumber":"Call: 877-645-4128"}}},"braven":{"home":{"title":"Home","heading":"Welcome to healthcare without the hold music.","cards":[{"title":"About Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Meet your Health Advisors and find more information about Walgreens Health Corner’s operation hours."},{"title":"Services Offered","link":"services","icon":"assets/home/store.svg","description":"Convenient access to personalized care and support for your health, based on your health plan eligibility."},{"title":"Connected Devices","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitor and track your health with smart devices that measure  your progress over time."}],"descriptionBold":"Walgreens Health Corner","description":"is an easy, new way to take care of your health to-dos. Members of select health insurance providers get specialized services with no co-pays and no appointments."},"feedback":{"title":"Leave Feedback","heading":"Your feedback is important","description":"To help us improve future Health Corner visits, please let us know what you thought of your experience today. Your response will only be used to help us and your health plan understand how we can make your next visit better.","surveyHeading":"Complete the survey on your device","surveyQrCodeLink":"assets/feedback/surveyQrCodeNJ.png","surveyQrCodeLinkAlt":"survey QR code","phoneHeading":"iPhone & Newer Android","phoneDescription":"Simply point your camera at the QR code on the right to automatically launch the survey.","oldPhoneHeading":"Older Android","oldPhoneDescription":"Download a QR code reader app from the Play Store. Scan the code with the QR code app."},"about":{"title":"About Walgreens Health Corner","heading":"About Walgreens Health Corner","description":"Check out our hours and meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.","cards":[{"heading":"Information and hours","description":"Get updated hours so you can get updated answers to your health questions.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Information and hours","heading":"You’ve got questions. We’ve got answers.","description":"Not sure how to navigate over-the-counter medicine or prescriptions? Want advice on how to stay active? Need help using a new health device? Our Health Advisors are here to help answer these questions, and more.","hoursTitle":"Health Corner Hours","advisorsDescription":"Our Health Advisors are a friendly, clinically trained team here to help you navigate your health needs. They will get to know you with each visit and interaction, providing personalized ongoing care. From assistance finding health information, to tips on nutrition and staying active, they are here for you.","legalText":"Walgreens Health Corner services are not intended for use in urgent and emergent care. The information provided is not a substitute for medical advice from your physician. If you are in need of immediate medical attention, contact your physician or go to the nearest emergency room. Consult your physician for diagnosis and treatment of your medical condition."},"connectedDevices":{"title":"Smart Health Devices","heading":"Monitor Your Health with Smart Devices","description":"Connected devices use bluetooth technology to monitor, alert and sync data via an app in your smart phone or tablet.","devices":[{"title":"Withings Activity Tracker","id":"withings-activity-tracker","name":"Withings Activity Tracker","body":"Classic style. Advanced tracking.","img":"assets/connectedDevices/devices/activity-tracker-large.png","thumbnail":"assets/connectedDevices/devices/activity-tracker.png","attributes":[{"title":"Seamless Tracking","body":"Automatically tracks walk, run, swim and easily detects 30+ activities. Offers workout mode and connected GPS. Visualizes your trends and data on your smartphone.","icon":"assets/devices/device-walking.svg"},{"title":"Durable","body":"Up to 18 months battery life and water resistant to 50m.","icon":"assets/devices/device-calendar.svg"},{"title":"Sleep Tracking","body":"Delivers a Sleep Score, light & deep sleep stages, plus silent alarm & Smart Wake-Up.","icon":"assets/devices/device-sleep-tracking.svg"}]},{"title":"Withings Sleep Mat","id":"withings-sleep-mat","name":"Withings Sleep Mat","body":"Better nights for better days","img":"assets/connectedDevices/devices/sleep-mat-large.png","thumbnail":"assets/connectedDevices/devices/sleep-mat.png","attributes":[{"title":"Nothing to Wear","body":"Easy one-time setup under the mattress, compatible with most mattresses. Wake up to immediate in-app results you can easily share as a PDF of data in the app with your doctor.","icon":"assets/devices/checkbox.svg"},{"title":"Advanced Sleep Tracking","body":"Get an in-depth analysis of your night with sleep cycles, continuous heart rate & snore detection. Know how restorative your sleep was with the Sleep Score.","icon":"assets/devices/sleep-tracking.svg"},{"title":"Home Automation","body":"Control lights, temperature, and other smart home-enabled devices just by getting into and out of bed.","icon":"assets/devices/home.svg"}]},{"title":"Withings Scale","id":"withings-scale","name":"Withings Scale","body":"Health goals. Tailored to you.","img":"assets/connectedDevices/devices/withings-scale-large.png","thumbnail":"assets/connectedDevices/devices/withings-scale.png","attributes":[{"title":"Instant Weight Insight","body":"Track progress and stay motivated during each weigh-in with weight trend and BMI screens.","icon":"assets/devices/graph.svg"},{"title":"Automatic Synchronization","body":"Data from every weigh-in appears in the Health Mate app automatically via Wi-Fi.","icon":"assets/devices/bluetooth.svg"},{"title":"Multi-user Friendly","body":"Recognizes up to 8 users with independent sync.","icon":"assets/devices/multi-user.svg"}]},{"title":"Withings Blood Pressure Cuff","id":"withings-blood-pressure-cuff","name":"Withings Blood Pressure Cuff","body":"Easy to use. Easy to read.","img":"assets/connectedDevices/devices/withings-blood-pressure-cuff-large.png","thumbnail":"assets/connectedDevices/devices/withings-blood-pressure-cuff.png","attributes":[{"title":"Medical accuracy and accessibility","body":"Clinically validated monitoring your blood pressure with accurate results you can trust. Level up your medical check- up by sharing a health journal with your healthcare professionals.","icon":"assets/devices/graph.svg"},{"title":"Easy to read","body":"Even before you open the app, Instant color-coded feedback on the LED screen shows you where you stand at a glance.","icon":"assets/devices/glasses.svg"},{"title":"Easy to use","body":"With only one button to press and automatic Wi-Fi sync to the free Health Mate app, our devices are the simplest way to accurately measure and monitor blood pressure over time.","icon":"assets/devices/bluetooth.svg"}]}]},"services":{"title":"Services Offered","heading":"A new way to care for your health","description":"Meet our friendly Health Advisors who can help answer questions and guide you to select tests and services available here or in the pharmacy.  Plus, Braven members can access additional services here in the Health Corner.","cards":[{"title":"Health Questions","icon":"assets/services/help_icon.svg","subTitle":"Get assistance and answers to your questions","highlightedText":"Making better wellness choices for your health can be confusing at times. Spend one-on-one time with a Health Advisor and get answers to some of the questions you have.","additionalText":"From advice on over-the-counter medications and supplements to nutrition, ask a Health Advisor who has the clinical background to help you find answers to your questions.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Braven Health Plan."},{"title":"Health Monitoring Devices","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Get help setting up health monitoring devices","highlightedText":"Health monitoring devices can show you day-to-day changes in your health by monitoring things like your blood pressure, activity, sleep, and more.","additionalText":"Learn how to set up and use wearable or in-home health devices that can help you better understand your health.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Braven Health Plan."},{"title":"Flu Vaccine","icon":"assets/services/syringe_icon.svg","subTitle":"Get a flu vaccine","highlightedText":"Seasonal flu vaccines can help you reduce the risk of getting certain strains of influenza virus.","additionalText":"The vaccine can reduce flu illnesses, doctors\' visits, and missed work and school due to flu, as well as prevent flu-related hospitalizations and deaths. <br /><br /> Talk to a Health Advisor or pharmacist to get your flu vaccine.","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Braven Health Plan."},{"title":"Blood Pressure Screening","icon":"assets/services/bp_icon.svg","availability":"Braven members only","subTitle":"Braven members get a blood pressure screening","highlightedText":"Monitoring your blood pressure is important to reduce the risk of heart attack and stroke.","additionalText":"High blood pressure often does not present with any symptoms and often develops slowly over time; therefore, it is important to have your blood pressure checked regularly.","headerColor":"#284B9B","headerBackgroundColor":"#FFFFFF","headerLogo":"assets/services/braven-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Braven Health Plan."},{"title":"A1C Test","icon":"assets/services/drop_icon.svg","availability":"Braven members only","subTitle":"Braven members get an A1C test","highlightedText":"The A1C test—also known as the hemoglobin A1C or HbA1c test—is a simple blood test that measures your average blood sugar levels over the past 2-3 months.","additionalText":"It’s one of the commonly used tests to diagnose pre-diabetes and diabetes and is also the main test to help you and your health care team manage your diabetes.","headerColor":"#284B9B","headerBackgroundColor":"#FFFFFF","headerLogo":"assets/services/braven-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Braven Health Plan."},{"title":"Colorectal Cancer Screening","icon":"assets/services/home_icon.svg","availability":"Braven members only","subTitle":"Braven members get an at-home colorectal cancer screening test kit","highlightedText":"A screening test can be done in the comfort of your home and is used to look for colorectal abnormalities when a person doesn’t have symptoms.","additionalText":"You should begin screening for colorectal cancer soon after turning 50, then continue getting screened at regular intervals.","headerColor":"#284B9B","headerBackgroundColor":"#FFFFFF","headerLogo":"assets/services/braven-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Braven Health Plan."},{"title":"Care for Adults 66+","icon":"assets/services/person_with_heart_icon.svg","availability":"Braven members only","subTitle":"Helping Braven members 66 years and older get the care they need.","highlightedText":"Getting the care you need in this phase of life can help you maintain or improve your quality of life so you can do more of what matters to you.","additionalText":"Our Walgreens Health Corner team will work with you to provide: \\n-Falls Assessment \\n-Physical Activity Assessment","headerColor":"#284B9B","headerBackgroundColor":"#FFFFFF","headerLogo":"assets/services/braven-logo.png","legalDisclaimer":"*See a Health Advisor to determine which services you are eligible for. Costs and eligibility vary based on Braven Health Plan."}],"appointment":{"title":"Schedule an appointment","phoneNumber":"Call: 877-645-4128"}}}},"es-419":{"default":{"newSession":{"cards":[{"label":"Blue Shield of California","key":"bsc","image":"assets/payors/blue-shield-of-california.png"},{"label":"Braven","key":"braven","image":"assets/payors/braven.png"},{"label":"Buckeye Health Plan","key":"buckeye","image":"assets/payors/buckeye-health-plan.png"},{"label":"Clover Health","key":"clover","image":"assets/payors/clover-health.png"},{"label":"Horizon","key":"horizon","image":"assets/payors/horizon-blue.png"}],"defaultStoreButtonText":"Mi Proveedor de Seguro M\xe9dico No Est\xe1 Disponible","heading":"Seleccione Su Proveedor de Seguros","instructionMessage":"Para comenzar, seleccione su proveedor de seguro de salud de las opciones disponibles. Si no se muestra su proveedor de seguro de salud, toque el bot\xf3n a la derecha para continuar.","instructionTitle":"Bienvenido a Walgreens Health Corner"},"feedback":{"title":"Deja tus Comentarios","heading":"Tu opini\xf3n es importante","description":"Para ayudarnos a mejorar futuras visitas a Health Corner, por favor, h\xe1ganos saber lo que piensa de su experiencia de hoy. Su respuesta solo se utilizar\xe1 para ayudarnos a nosotros y a su plan de salud a comprender c\xf3mo podemos mejorar su pr\xf3xima visita.","surveyHeading":"Completa la encuesta en su dispositivo","surveyQrCodeLink":"assets/feedback/surveyQrCode.png","surveyQrCodeLinkAlt":"c\xf3digo QR de la encuesta","phoneHeading":"iPhone & Nuevo Android","phoneDescription":"Simplemente apunte su c\xe1mara al c\xf3digo QR a la derecha para iniciar autom\xe1ticamente la encuesta.","oldPhoneHeading":"Android m\xe1s antiguo","oldPhoneDescription":"Descargue una aplicaci\xf3n de lector de c\xf3digos QR desde Play Store. Escanee el c\xf3digo con la aplicaci\xf3n de c\xf3digo QR."},"home":{"title":"Inicio","heading":"Bienvenido a tus cuidados de salud sin la m\xfasica de espera.","cards":[{"title":"Sobre Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Conoce a tus Asesores de Salud y m\xe1s informaci\xf3n sobre el horario de Walgreens Health Corner"},{"title":"Servicios que ofrecemos","link":"services","icon":"assets/home/store.svg","description":"Acceso conveniente a asistencia y ayuda personalizadas para tu salud, basadas en la elegibilidad de tu plan de salud."}],"descriptionBold":"Walgreens Health Corner","description":"es una sencilla, nueva forma de hacerte cargo de tus tareas de salud. Los miembros de selectos proveedores de seguros m\xe9dicos obtienen servicios especializados sin pagos duplicados ni citas."},"about":{"title":"Acerca de Walgreens Health Corner","heading":"Sobre Walgreens Health Corner","description":"Consulte nuestros horarios y conozca a nuestros amigables asesores de salud que pueden ayudarlo a responder preguntas y guiarlo para seleccionar pruebas y servicios disponibles aqu\xed o en la farmacia.","cards":[{"heading":"Informaci\xf3n y horarios","description":"Obtenga horarios actualizados para que pueda obtener respuestas actualizadas a sus preguntas de salud.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Informaci\xf3n y horarios de operaci\xf3n","heading":"Tienes preguntas. Tenemos respuestas.","description":"\xbfNo est\xe1s seguro(a) de c\xf3mo navegar por los medicamentos de venta libre o receta m\xe9dica? \xbfQuieres consejos sobre c\xf3mo mantenerte activo? \xbfNecesitas ayuda para usar un nuevo dispositivo de salud? Nuestros Aesores de salud est\xe1n aqu\xed para ayudarte a responder estas preguntas y m\xe1s.","advisorsDescription":"Nuestros asesores de salud son un equipo amigable y cl\xednicamente capacitado que est\xe1 aqu\xed para ayudarte a navegar tus necesidades de salud. Ellos te conocer\xe1n en cada visita e interacci\xf3n, brind\xe1ndote atenci\xf3n personalizada y continua. Desde ayuda para encontrar informaci\xf3n de salud hasta consejos sobre nutrici\xf3n y como mantenerte activo(a), est\xe1n aqu\xed para ayudarte.","legalText":"Los servicios de Walgreens Health Corner no est\xe1n dise\xf1ados para usarse en casos de atenci\xf3n o como servicios m\xe9dicos de emergencia. La informaci\xf3n proporcionada no sustituye el consejo cl\xednico de tu m\xe9dico. Si necesitas atenci\xf3n m\xe9dica inmediata, comun\xedcate con tu m\xe9dico o ve a la sala de emergencias m\xe1s cercana. Consulta a tu m\xe9dico para el diagn\xf3stico y tratamiento de tu condici\xf3n m\xe9dica o enfermedad."},"privacy":{"title":"Pol\xedtica de Privacidad y T\xe9minos y Condiciones","headerHeading":"Salud y privacidad. Nosotros protejemos ambas.","headerDescription":"T\xfa nos conf\xedas tus necesidades de salud y bienestar y nosotros nos tomamos esa responsabilidad en serio. Esto incluye asegurarnos de que tus datos est\xe9n seguros y protegidos, y de que t\xfa tengas el control. La Pol\xedtica de privacidad cubre el tipo de datos que recopilamos y c\xf3mo los usamos, as\xed como tu derecho como consumidor. Por favor, no dudes en ponerte en contacto con nosotros con cualquier pregunta.","headerCards":[{"title":"Generamos Confianza","img":"assets/privacy/trust.svg","description":"Nos preocupamos por tu bienestar y tus nececidades."},{"title":"Protegemos la Privacidad","img":"assets/privacy/privacy.svg","description":"No vendemos tu informaci\xf3n farmac\xe9utica."},{"title":"Mejoramos la Experiencia","img":"assets/privacy/experience.svg","description":"Usamos tus datos para personalizar tus ofertas y descuentos."}],"contentPrivacyIcon":"assets/privacy/onlineSecurityPrivacyIcon.svg","contentPrivacyIconAlt":"Pol\xedtica de Privacidad y Seguridad en L\xednea","contentPrivacySidebarText":"Pol\xedtica de Privacidad y Seguridad en L\xednea","contentPrivacyBody":"<h3>Pol\xedtica de Seguridad y Privacidad en L\xednea de Walgreens Health Corner</h3>\\n<p>Esta Pol\xedtica de Privacidad te permite saber c\xf3mo recopilamos, usamos, compartimos y protegemos tu informaci\xf3n. Al interactuar con el quiosco de Walgreens Health Corner, aceptas las pr\xe1cticas descritas en esta Pol\xedtica de Privacidad. Cualquier cambio en nuestra Pol\xedtica de Privacidad aparecer\xe1 en esta p\xe1gina para que est\xe9s al tanto de los datos que recopilamos y c\xf3mo los usamos.</p>\\n<p>El uso de tu informaci\xf3n por parte de Walgreens Health Corner estar\xe1 sujeto a los requisitos de la Ley de Portabilidad y Responsabilidad del Seguro M\xe9dico (com\xfanmente conocida como \\"HIPAA\\"). En algunas circunstancias, se aplicar\xe1 el Aviso de Pr\xe1cticas de Privacidad de Walgreens adem\xe1s de esta pol\xedtica y, en otras, se aplicar\xe1 el Aviso de Pr\xe1cticas de Privacidad de tu plan de salud adem\xe1s de esta pol\xedtica. Si tienes preguntas sobre qu\xe9 pol\xedtica se aplica a la informaci\xf3n que has enviado, no dudes y cont\xe1ctanos al 877-645-4128.</p>\\n\\n<h4>Nuestro Programa de Privacidad</h4>\\n<p>En Walgreens Health Corner, estamos comprometidos a mantener la privacidad de nuestros clientes. Nos preocupamos mucho por salvaguardar la informaci\xf3n que recopilamos para mantener la privacidad de nuestros clientes. Te proporcionamos esta Pol\xedtica de Privacidad para describir la recopilaci\xf3n de informaci\xf3n y las pr\xe1cticas de uso en Walgreens Health Corner. Esta Pol\xedtica de Privacidad describe las elecciones que puedes hacer sobre la forma en que se recopila y utiliza tu informaci\xf3n.</p>\\n\\n<h4>Informaci\xf3n Que Recopilamos</h4>\\n<p>Queremos que comprendas c\xf3mo se recopila y se utiliza lainformaci\xf3nque nos proporcionas. Cuando interact\xfaas con Walgreens Health Corner o utilizas nuestros servicios, recopilamos cierta informaci\xf3n sobre ti y los servicios que utilizas. Un ejemplo del uso de nuestros \\"servicios\\" ser\xeda cuando utilizas nuestra aplicaci\xf3n m\xf3vil. Podemos recopilar y almacenar informaci\xf3n sobre ti en las siguientes situaciones:</p>\\n\\n<h4>Informaci\xf3n que nos proporcionas directamente, incluyendo cuando:</h4>\\n<ul>\\n    <li>Realizas una transacci\xf3n con nosotros en nuestro sitio web o aplicaci\xf3n m\xf3vil;</li>\\n    <li>Creas una cuenta en nuestra aplicaci\xf3n m\xf3vil;</li>\\n    <li>Mantienes correspondencia directa con nosotros, por ejemplo, a trav\xe9s de nuestra aplicaci\xf3n m\xf3vil, servicio al cliente o mecanismos de resoluci\xf3n de disputas; o</li>\\n    <li>Importas contenido desde dispositivos o servicios conectados, o publicas contenido generado por el usuario en nuestra aplicaci\xf3n m\xf3vil.</li>\\n</ul>\\n\\n<h4>Informaci\xf3n que recopilamos cuando utilizas nuestros servicios, que incluye:</h4>\\n<ul>\\n    <li>\\n        <h5>Informaci\xf3n del Dispositivo</h5>\\n        <ul>\\n            <li>Podemos recopilar informaci\xf3n espec\xedfica del dispositivo cuando utilizas nuestras aplicaciones o servicios m\xf3viles. Esto incluye informaci\xf3n como la direcci\xf3n del Protocolo de Internet (IP), el modelo de hardware, el sistema operativo, los identificadores \xfanicos del dispositivo, la informaci\xf3n de la red m\xf3vil, los datos de ubicaci\xf3n, como el c\xf3digo postal, la ruta que tomas a trav\xe9s de nuestra aplicaci\xf3n m\xf3vil y otra informaci\xf3n sobre tu sesi\xf3n en nuestra aplicaci\xf3n m\xf3vil. Tambi\xe9n podemos asociar la informaci\xf3n que recopilamos de tus diferentes dispositivos, lo que nos ayuda a brindar servicios consistentes en todos tus dispositivos</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Informaci\xf3n de Registro</h5>\\n        <ul>\\n            <li>Esto incluye detalles de c\xf3mo usaste nuestra aplicaci\xf3n m\xf3vil, incluidos los clics y la informaci\xf3n de la p\xe1gina, como la direcci\xf3n (o URL) del sitio web o la aplicaci\xf3n m\xf3vil en la que estabas antes de visitar nuestro sitio web o aplicaci\xf3n m\xf3vil, qu\xe9 p\xe1ginas visitas en nuestra aplicaci\xf3n m\xf3vil, qu\xe9 navegador se utiliz\xf3 para ver nuestra aplicaci\xf3n m\xf3vil, y cualquier t\xe9rmino de b\xfasqueda ingresado.</li>\\n            <li>Otra informaci\xf3n de tu interacci\xf3n con nuestra aplicaci\xf3n m\xf3vil, servicios y contenido, incluida la informaci\xf3n del dispositivo y la conexi\xf3n, estad\xedsticas sobre visitas a la p\xe1gina y otra informaci\xf3n est\xe1ndar del weblog.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Informaci\xf3n de Ubicaci\xf3n Precisa</h5>\\n        <ul>\\n            <li>Cuando utilizas nuestra aplicaci\xf3n o servicios m\xf3viles en tu tel\xe9fono m\xf3vil o dispositivo y habilitas los servicios de ubicaci\xf3n en tu tel\xe9fono m\xf3vil o navegador de dispositivo, podemos recopilar informaci\xf3n sobre tu ubicaci\xf3n f\xedsica a trav\xe9s de sat\xe9lites, torres de telefon\xeda celular, se\xf1al WiFi, balizas, Bluetooth y protocolos de comunicaci\xf3n de campo cercano ( \\"informaci\xf3n de ubicaci\xf3n precisa\\"). Si usas nuestra aplicaci\xf3n m\xf3vil, tu dispositivo puede compartir informaci\xf3n de ubicaci\xf3n precisa cuando habilitas los servicios de ubicaci\xf3n para nuestra aplicaci\xf3n m\xf3vil.</li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>C\xf3mo Usamos Tu Informaci\xf3n:</h4>\\n<p>Nuestro objetivo principal al recopilar informaci\xf3n es brindarte una experiencia segura, fluida, eficiente y personalizada. Podemos usar tu informaci\xf3n de varias maneras, incluso para los siguientes prop\xf3sitos:</p>\\n\\n<h4>Cumplimiento de Productos y Servicios</h4>\\n<ul>\\n    <li>Utilizamos tu informaci\xf3n de contacto para comunicarnos contigo, para responder a tus consultas, cumplir con tus solicitudes y mejorar tu experiencia.</li>\\n    <li>Utilizamos tu Informaci\xf3n de Ubicaci\xf3n Precisa para proporcionar servicios basados en la ubicaci\xf3n. Por ejemplo, para localizar Walgreens cerca de tu \xe1rea.</li>\\n</ul>\\n\\n<h4>Operaciones Internas</h4>\\n<ul>\\n    <li>Utilizamos tu informaci\xf3n para mejorar la efectividad de nuestros servicios, realizar investigaciones y an\xe1lisis, o para realizar otras actividades comerciales seg\xfan sea necesario y seg\xfan sea permitido por HIPAA.</li>\\n</ul>\\n\\n<h4>Prevenci\xf3n de Fraude y otros Da\xf1os</h4>\\n<ul>\\n    <li>Utilizamos tu informaci\xf3n para detectar, prevenir o investigar posibles brechas de seguridad, transacciones fraudulentas y monitorear contra robos.</li>\\n</ul>\\n\\n<h4>Cumplimiento Legal y seg\xfan sea Necesario o Apropiado Bajo la Ley Aplicable</h4>\\n<ul>\\n    <li>Podemos usar tu informaci\xf3n seg\xfan sea necesario o apropiado seg\xfan la ley aplicable, para cumplir con el proceso legal, para responder a dichas solicitudes de las autoridades p\xfablicas y gubernamentales (incluidas las fuerzas del orden), para hacer cumplir nuestros t\xe9rminos y condiciones, incluidas las investigaciones de posibles violaciones, para detectar , prevenir o abordar problemas de fraude, seguridad o t\xe9cnicos, para proteger nuestros derechos, privacidad, seguridad o propiedad, y permitirnos buscar los recursos disponibles para limitar los da\xf1os que podamos sufrir. En asuntos que involucren reclamos de seguridad personal o p\xfablica o en litigios donde los datos sean pertinentes, podemos usar informaci\xf3n personal sin tu consentimiento o proceso judicial seg\xfan lo permita HIPAA.</li>\\n</ul>\\n\\n<h4>C\xf3mo Compartimos Tu Informaci\xf3n:</h4>\\n<p>No vendemos, alquilamos ni prestamos su informaci\xf3n de identificaci\xf3n personal a terceros. Compartiremos tu informaci\xf3n con empresas, organizaciones e individuos fuera de Walgreens Health Corner como se describe en esta Pol\xedtica de Privacidad y seg\xfan lo permitido por HIPAA:</p>\\n<ul>\\n    <li>\\n        <h5>Internamente</h5>\\n        <ul>\\n            <li>Podemos compartir tu informaci\xf3n con nuestra empresa matriz o afiliados, incluidos, entre otros, Walgreens Boots Alliance Inc., Boots Retail USA Inc., Walgreens Specialty Pharmacy Holdings, LLC y Walgreens Specialty Pharmacy, LLC DBA Alliance Rx Walgreens Prime.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Cuando Trabajamos Con Terceros</h5>\\n        <ul>\\n            <li>Podemos compartir tu informaci\xf3n con empresas afiliadas y no afiliadas que realizan tareas en nuestro nombre relacionadas con nuestro negocio. Dichas tareas incluyen el an\xe1lisis de los datos de uso de la aplicaci\xf3n m\xf3vil, el servicio al cliente, el servicio de correo electr\xf3nico y los servicios sociales y de otros medios.</li>\\n            <li>Podemos trabajar con otras empresas que operan sus propios sitios web o aplicaciones m\xf3viles, para permitirles ofrecer a los clientes de Walgreens Health Corner la capacidad de conectarse a los servicios de Walgreens Health Corner con aplicaciones m\xf3viles y dispositivos de otras compa\xf1\xedas. Estos servicios te brindan m\xe1s opciones para usar los servicios de Walgreens Health Corner desde sitios web o aplicaciones que Walgreens Health Corner no posee ni opera.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Cuando la Ley Exige Compartir o Cuando Nos Ayuda a Proteger Nuestros Intereses</h5>\\n        <ul>\\n            <li>Divulgaremos tu informaci\xf3n seg\xfan sea necesario o apropiado seg\xfan la ley aplicable, para cumplir con el proceso legal, para responder a dichas solicitudes de las autoridades p\xfablicas y gubernamentales, para hacer cumplir nuestros t\xe9rminos y condiciones, incluidas las investigaciones de posibles violaciones, para detectar, prevenir o abordar de otra manera fraude, problemas de seguridad o t\xe9cnicos, para proteger nuestros derechos, privacidad, seguridad o propiedad, y para permitirnos buscar los recursos disponibles para limitar los da\xf1os que podamos sufrir. En asuntos que involucren reclamos de seguridad personal o p\xfablica o en litigios donde los datos sean pertinentes, podemos usar o divulgar informaci\xf3n personal sin tu consentimiento o proceso judicial.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Cuando Trabajamos En Transacciones Comerciales</h5>\\n        <ul>\\n            <li>A medida que continuamos desarrollando nuestro negocio, podemos vender o comprar tiendas o activos, o participar en fusiones, adquisiciones o ventas de activos de la empresa. La informaci\xf3n de los clientes, incluida tu informaci\xf3n personal, puede divulgarse en relaci\xf3n con la evaluaci\xf3n o entrada en tales transacciones, o en el curso de la prestaci\xf3n de servicios de transici\xf3n a otra entidad seg\xfan lo permita la ley. En tales transacciones, la informaci\xf3n del cliente generalmente es uno de los activos comerciales transferidos. Adem\xe1s, en caso de que Walgreens Health Corner o pr\xe1cticamente todos sus activos sean adquiridos, la informaci\xf3n del cliente, incluida tu informaci\xf3n probablemente ser\xe1 uno de los activos transferidos seg\xfan lo permita la ley.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Informaci\xf3n No Identificable o Agregada con Terceros</h5>\\n        <ul>\\n            <li>Podemos compartir informaci\xf3n no identificable o agregada con terceros para fines legales.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Con Tu Consentimiento</h5>\\n        <ul>\\n            <li>Bajo tu direcci\xf3n o solicitud, o cuando lo consientas, podemos compartir tu informaci\xf3n.</li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>Tus Opciones</h4>\\n<p>Al interactuar con Walgreens Health Corner como se describe aqu\xed, das tu consentimiento a las pr\xe1cticas descritas en esta Pol\xedtica de Privacidad. Sin embargo, queremos que sepas que tienes ciertas opciones con respecto a c\xf3mo se recopila y utiliza tu informaci\xf3n.</p>\\n<ul>\\n    <li>\\n        <h5>Correo Electr\xf3nico y Comunicaciones M\xf3viles</h5>\\n        <ul>\\n            <li>Puedes optar por dejar de recibir correos electr\xf3nicos y comunicaciones de marketing m\xf3vil cambiando tus preferencias en l\xednea. Si tienes una cuenta en l\xednea, inicia sesi\xf3n en tu cuenta en nuestra aplicaci\xf3n m\xf3vil e ingresa en la pesta\xf1a de Configuraci\xf3n en tu p\xe1gina de Perfil. Si no tienes una cuenta en l\xednea, puedes hacer clic en Unsuscribe en la parte inferior de los correos electr\xf3nicos de Walgreens Health Corner. Para solicitar la cancelaci\xf3n de suscripci\xf3n por tel\xe9fono, comun\xedcate al 877-645-4128.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Aplicaci\xf3n M\xf3vil</h5>\\n        <ul>\\n            <li>\\n                <h6>Notificaciones Autom\xe1ticas</h6>\\n                <ul>\\n                    <li>Puedes optar por no permitir que Walgreens te env\xede notificaciones autom\xe1ticas ajustando los permisos en tu dispositivo m\xf3vil o desde la aplicaci\xf3n m\xf3vil de Walgreens.</li>\\n                </ul>\\n            </li>\\n            <li>\\n                <h6>Informaci\xf3n de Ubicaci\xf3n Precisa</h6>\\n                <ul>\\n                    <li>Puedes optar por no permitir que Walgreens acceda a la Informaci\xf3n de Ubicaci\xf3n Precisa ajustando los permisos en tu dispositivo m\xf3vil.</li>\\n                </ul>\\n            </li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>Acceso y Actualizaci\xf3n de tu Informaci\xf3n de Identificaci\xf3n Personal</h4>\\n<ul>\\n    <li>Si tienes una cuenta de Walgreens Health Corner, puedes iniciar sesi\xf3n y actualizar tu informaci\xf3n. Puedes revisar y actualizar la informaci\xf3n que nos has proporcionado contact\xe1ndonos al 877-645-4128. Nuestro personal de atenci\xf3n al cliente actualizar\xe1 tu informaci\xf3n.</li>\\n    <li>\\n        <h5>Enlaces a Sitios Web de Terceros</h5>\\n        <ul>\\n            <li>Nuestros servicios pueden contener enlaces a, o poner a disposici\xf3n, servicios de terceros, sitios web y aplicaciones m\xf3viles de terceros que son operados y controlados por terceros. No nos hacemos responsables del contenido o las pr\xe1cticas de privacidad empleadas por otros sitios web. A menos que se indique lo contrario, cualquier informaci\xf3n que proporciones a cualquier sitio web de terceros ser\xe1 recopilada por esa parte y no por Walgreens Health Corner, y estar\xe1 sujeta a la pol\xedtica de privacidad de esa parte (si corresponde), en lugar de esta Pol\xedtica de Privacidad. En tal situaci\xf3n, no tendremos control sobre el uso que esa parte haga de la Informaci\xf3n que les proporciones, y no seremos responsables del mismo.</li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>C\xf3mo Protegemos Tu Informaci\xf3n</h4>\\n<ul>\\n    <li>\\n        <h5>Medidas de Seguridad</h5>\\n        <ul>\\n            <li>Walgreens Health reconoce la importancia de mantener la seguridad de tu informaci\xf3n. Cuando visitas nuestra aplicaci\xf3n m\xf3vil, utilizamos medidas de seguridad razonables, incluidas salvaguardias administrativas, t\xe9cnicas y f\xedsicas.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Seguridad del Correo Electr\xf3nico</h5>\\n        <ul>\\n            <li>El \\"phishing\\" es una estafa com\xfan por correo electr\xf3nico en la que se utiliza tu direcci\xf3n de correo electr\xf3nico para contactarte y solicitarte informaci\xf3n confidencial o de identificaci\xf3n personal. Siempre ten cuidado al abrir enlaces o archivos adjuntos de terceros no solicitados. Tambi\xe9n debes saber que Walgreens Health Corner no te enviar\xe1 correos electr\xf3nicos solicitando tu n\xfamero de tarjeta de cr\xe9dito, n\xfamero de seguro social u otra informaci\xf3n de identificaci\xf3n personal. Si alguna vez te piden esta informaci\xf3n, puedes estar seguro de que no es de Walgreens Health Corner.</li>\\n        </ul>\\n    </li>\\n    <li>\\n        <h5>Informaci\xf3n Personal de los Ni\xf1os</h5>\\n        <ul>\\n            <li>Reconocemos la importancia de proteger la privacidad en l\xednea de los ni\xf1os. Nuestra aplicaci\xf3n y servicios m\xf3viles est\xe1n destinados a una audiencia general y no est\xe1n dirigidos a ni\xf1os. No recopilamos a sabiendas informaci\xf3n personal en l\xednea de ni\xf1os menores de 13 a\xf1os.</li>\\n        </ul>\\n    </li>\\n</ul>\\n\\n<h4>C\xf3mo Contactarnos:</h4>\\n<p>Si tienes preguntas sobre nuestra Pol\xedtica de Privacidad, cont\xe1ctanos a trav\xe9s de:</p>\\n<blockquote>\\n    <strong>Tel\xe9fono:</strong> (877) 924-4472\\n    <br>\\n    <strong>Correo electr\xf3nico:</strong> privacy.office@walgreens.com\\n    <br>\\n    <strong>Correo postal</strong>:<br>\\n    Walgreen Co. Privacy Office<br>\\n    Attn: Privacy Officer<br>\\n    200 Wilmot Rd, MS 9000<br>\\n    Deerfield, IL 60015\\n</blockquote>\\n<p>Para solicitar esta Pol\xedtica de Privacidad en un formato accesible alternativo, llama a nuestro Centro de Atenci\xf3n al Cliente al 877-645-4128.</p>\\n<p>Fecha Efectiva: 25 de octubre de 2021</p>","contentTermsIcon":"assets/privacy/termsAndConditionsIcon.svg","contentTermsIconAlt":"T\xe9rminos y Condiciones","contentTermsSidebarText":"T\xe9rminos y Condiciones","contentTermsBody":"<h3>T\xe9rminos y Condiciones de Uso</h3>\\n<p>\xa1Bienvenido/a a Walgreens! Toma unos minutos para leer estos importantes t\xe9rminos y condiciones (\\"T\xe9rminos\\").</p>\\n\\n<h4>I. Introducci\xf3n</h4>\\n<p>Estos T\xe9rminos rigen el uso de los servicios en l\xednea proporcionados por Walgreen Co. y sus afiliados (\\"Walgreens\\" o \\"nosotros\\"), incluidos sitios web, aplicaciones m\xf3viles, servicios fotogr\xe1ficos, Auto-Reorder & Save, recordatorios de recetas, wifi en la tienda, Contenido de Walgreens (como se define en la Secci\xf3n 2) y otros servicios (\\"Servicios\\"). Los Servicios est\xe1n destinados a usuarios que residen en los EE. UU. y tienen 18 a\xf1os o m\xe1s (o 13 a\xf1os o m\xe1s, con el consentimiento y la participaci\xf3n de un padre o tutor). Si t\xfa no eres el p\xfablico objetivo o te opones a estos T\xe9rminos, no podr\xe1s utilizar nuestros Servicios. Estos T\xe9rminos act\xfaan como un acuerdo vinculante entre t\xfa y nosotros, y al acceder a cualquier Servicio de cualquier manera, t\xfa aceptas estar sujeto a todos ellos, incluidos, entre otros, la resoluci\xf3n de disputas mediante arbitraje vinculante, la realizaci\xf3n de esta transacci\xf3n electr\xf3nicamente, la renuncia a garant\xedas, exclusiones y limitaciones de da\xf1os y remedios, y una elecci\xf3n de la ley de Illinois.</p>\\n<p>De vez en cuando podemos actualizar los Servicios y estos T\xe9rminos, y dichos cambios se aplicar\xe1n de forma prospectiva. Tu uso de los Servicios despu\xe9s de que publiquemos cualquier cambio en estos T\xe9rminos constituye tu aceptaci\xf3n de dichos cambios. T\xfa aceptas revisar estos T\xe9rminos peri\xf3dicamente para asegurarte de estar familiarizado con la versi\xf3n m\xe1s reciente. Te notificaremos cualquier actualizaci\xf3n importante de los T\xe9rminos. Podemos, a nuestro exclusivo criterio y en cualquier momento, suspender los Servicios o cualquier parte de los mismos, con o sin previo aviso, o podemos impedir tu uso de los Servicios con o sin previo aviso. T\xfa aceptas que no tienes ning\xfan derecho sobre los Servicios y que no seremos responsables ante ti si se interrumpen los Servicios o se cancela tu capacidad para acceder a los Servicios (incluido cualquier contenido que hayas publicado).</p>\\n\\n<h4>II. Informaci\xf3n que Mostramos</h4>\\n<p>Somos propietarios o licenciamos todo el contenido en los Servicios, incluidos, entre otros, texto, im\xe1genes, \xedconos, datos, software, marcas comerciales, imagen comercial y Contenido de Usuario (como se define en la Secci\xf3n 3) (colectivamente, \\"Contenido de Walgreens\\"), y puedes acceder a \xe9l y utilizarlo \xfanicamente para sus fines personales y no comerciales de informaci\xf3n y compras. El Contenido de Walgreens puede estar protegido por derechos de autor, patentes, marcas comerciales y otros derechos nacionales e internacionales, y todos los derechos, t\xedtulos e intereses est\xe1n reservados por sus respectivos propietarios. Est\xe1 estrictamente prohibido copiar, publicar, difundir, modificar, distribuir o transmitir cualquier Contenido de Walgreens de cualquier forma sin nuestro consentimiento previo por escrito.</p>\\n<p>Si bien trabajamos arduamente para brindar una experiencia superior al cliente, no podemos garantizar que todo el Contenido de Walgreens que mostramos sea correcto, completo o actual, incluidos los precios de los productos, las im\xe1genes, la informaci\xf3n y la disponibilidad.</p>\\n<p>Podemos mostrar o permitir a los usuarios crear Contenido de Usuario, o vincular hacia o desde sitios y materiales de terceros. No supervisamos, verificamos ni respaldamos de ninguna otra manera el Contenido del Usuario ni los sitios o materiales de terceros, y por la presente renunciamos a toda responsabilidad con respecto a los mismos. Tu uso de cualquier sitio de terceros est\xe1 sujeto a los t\xe9rminos de uso y las pol\xedticas de privacidad aplicables al mismo por dicho tercero. Cualquier informaci\xf3n relacionada con la salud se proporciona para mejorar tu experiencia, pero no pretende constituir un consejo m\xe9dico ni diagnosticar, tratar, curar o prevenir ninguna afecci\xf3n m\xe9dica. Si tienes preguntas sobre tu salud o tratamiento, comun\xedcate con tu farmac\xe9utico u otro profesional m\xe9dico.</p>\\n\\n<h4>III. Tus Acciones</h4>\\n<p>Si tienes preguntas sobre tu salud o tratamiento, comun\xedcate con tu farmac\xe9utico u otro m\xe9dico profesional. (i) usar o explotar los Servicios para cualquier prop\xf3sito que sea ilegal, tortuoso, calumnioso, difamatorio, falso, enga\xf1oso, acosador, abusivo, obsceno, vulgar, pornogr\xe1fico, intrusivo en la privacidad de otra persona, perjudicial para nuestros intereses o los de nuestros usuarios, o inapropiado con respecto a raza, g\xe9nero, sexualidad, etnia u otra caracter\xedstica intr\xednseca; (ii) cargar, publicar, reproducir, distribuir, transmitir, transferir o de otro modo usar o explotar de cualquier manera informaci\xf3n, software u otro material protegido por cualquier propiedad intelectual, publicidad o derecho de privacidad (incluidas nuestras marcas comerciales e imagen comercial) sin obtener primero el permiso del titular de dichos derechos; (iii) recopilar o almacenar datos personales sobre otros usuarios; (iv) reproducir, distribuir, duplicar, copiar, vender, revender, descompilar, modificar, realizar ingenier\xeda inversa, desensamblar, asignar, crear trabajos derivados, suplantar o explotar de otro modo cualquier parte de los Servicios (incluido cualquier software que pongamos a disposici\xf3n) para cualquier prop\xf3sito a menos que lo aprobemos expresamente por escrito; (v) cargar, publicar, enviar por correo electr\xf3nico o transmitir de otro modo cualquier material publicitario o promocional o cualquier otra forma de solicitud o comunicaci\xf3n no autorizada; (vi) emprender o facilitar cualquier esfuerzo para interrumpir, modificar, limitar, interferir, explotar comercialmente o impactar negativamente la funcionalidad de cualquier Servicio, ni utilizar\xe1 ni explotar\xe1 los Servicios de ninguna manera que no sea la expresamente permitida por estos T\xe9rminos; (vii) eliminar, alterar, ocultar o hacer ininteligible cualquier aviso de propiedad; e (viii) implementar o utilizar cualquier m\xe9todo automatizado para recopilar contenido de nuestro sitio, como robots, rastreadores y mecanismos de raspado (Secciones (i) a (viii) colectivamente, \\"Uso prohibido\\"). Para proteger nuestros intereses y los de nuestros usuarios, podemos monitorear, modificar, cancelar y revelar a terceros (incluidas las fuerzas del orden) su uso de los Servicios (incluido el Contenido del usuario) en cualquier momento.</p>\\n<p>Es posible que puedas crear o enviar dise\xf1os, fotograf\xedas, rese\xf1as de productos, publicaciones escritas y otro contenido (\\"Contenido de Usuario\\"). T\xfa aceptas que: (i) no mostrar\xe1s ni proporcionar\xe1s ning\xfan Contenido de Usuario que contenga informaci\xf3n personal o la semejanza de cualquier individuo, viole la privacidad/publicidad de cualquier otro individuo o entidad, o cualquier cosa que tenga la obligaci\xf3n contractual de mantener privada o confidencial; (ii) no se har\xe1 pasar por ninguna persona u organizaci\xf3n (incluidos nosotros), ni tergiversar\xe1 una afiliaci\xf3n con otra persona u organizaci\xf3n; y (iii) no publicar\xe1s ni cargar\xe1s ning\xfan Contenido de Usuario que constituya un Uso Prohibido. Sin perjuicio de lo anterior, estos T\xe9rminos no limitan de ninguna manera sus derechos seg\xfan la Ley de Equidad de Revisi\xf3n del Consumidor (Consumer Review Fairness Act en ingl\xe9s) de 2016 (H.R. 5111).</p>\\n<p>Al mostrar, publicar o publicar de otro modo cualquier Contenido de Usuario en o a trav\xe9s de los Servicios, o al aceptar afirmativamente nuestra solicitud en l\xednea para usar tu Contenido de Usuario (electr\xf3nicamente o de otro modo), por la presente nos otorgas una licencia perpetua, no exclusiva y sublicenciable. (a trav\xe9s de m\xfaltiples niveles), licencia mundial, totalmente pagada y libre de regal\xedas para usar dicho Contenido de Usuario (incluido, entre otros, modificar, presentar p\xfablicamente, mostrar p\xfablicamente, reproducir, crear trabajos derivados y distribuir dicho Contenido de Usuario para cualquier prop\xf3sito, ya sea que contenga una imagen personal o de otro tipo) en todos y cada uno de los medios ahora conocidos o desarrollados en el futuro, sin el requisito de realizar pagos a ninguna parte o buscar el permiso de un tercero o hacer ninguna atribuci\xf3n de autor\xeda. T\xfa contin\xfaas conservando todos los derechos de propiedad sobre tu Contenido de Usuario y contin\xfaas teniendo derecho a utilizar tu Contenido de Usuario de la forma que elijas, sujeto a estos T\xe9rminos y la licencia descrita en este documento, aunque para los fines de esta Secci\xf3n, renuncias a todos \\"derechos morales\\" en el mismo. T\xfa declaras y garantizas que (i) eres propietario del Contenido de Usuario enviado, mostrado, publicado, proporcionado o publicado por ti en los Servicios, o que de otro modo tienes el derecho de otorgar la licencia establecida en este documento, y (ii) tu visualizaci\xf3n, publicaci\xf3n, prestaci\xf3n o publicaci\xf3n de cualquier Contenido de Usuario que t\xfa env\xedes, y nuestro uso del mismo de acuerdo con estos T\xe9rminos, no viola ni violar\xe1 la ley aplicable ni ninguna privacidad, publicidad, derechos de autor, marca registrada, patente, contrato o cualquier otro derecho de cualquier persona o entidad. Sin perjuicio de lo anterior, t\xfa comprendes y aceptas adem\xe1s que no tienes derechos de propiedad sobre ninguna cuenta que puedas tener con nosotros, ni sobre ning\xfan otro acceso a los Servicios o funciones de los mismos. Podemos cancelar y eliminar cualquier cuenta o Contenido de Usuario en cualquier momento sin previo aviso. No asumimos ninguna responsabilidad por la informaci\xf3n eliminada de nuestros Servicios y nos reservamos el derecho de restringir permanentemente el acceso a los Servicios o a una cuenta de usuario.</p>\\n<p>Si los Servicios requieren que crees una cuenta o proporciones informaci\xf3n personal, aceptas enviar informaci\xf3n precisa y completa y actualizarla seg\xfan corresponda. T\xfa eres el \xfanico responsable de las actividades y la seguridad de tu cuenta y debes notificarnos si sospechas de alg\xfan uso no autorizado. No somos responsables de ninguna p\xe9rdida en la que incurras como resultado de que otra persona use tu contrase\xf1a o cuenta, ya sea con o sin tu conocimiento, y no somos responsables de ninguna demora en el cierre de tu cuenta despu\xe9s de que nos hayas informado de una violaci\xf3n de seguridad.</p>\\n\\n<h4>IV. T\xe9rminos Espec\xedficos del Servicio</h4>\\n<p>Los Servicios que brindamos pueden estar sujetos a pol\xedticas adicionales, como una pol\xedtica de devoluci\xf3n, una pol\xedtica de tarjetas de regalo, T\xe9rminos y Condiciones de myWalgreens u otros t\xe9rminos. Puedes obtener m\xe1s informaci\xf3n sobre esos servicios y pol\xedticas espec\xedficos en https://www.walgreens.com/help.</p>\\n<p>Si realizas alguna compra, declaras que t\xfa y nosotros (incluidos nuestros proveedores de servicios) estamos autorizados a utilizar la informaci\xf3n que proporcionas (incluida la informaci\xf3n del m\xe9todo de pago) para realizar la transacci\xf3n. T\xda DECLARAS Y GARANTIZAS QUE TIENES EL DERECHO LEGAL DE UTILIZAR CUALQUIER TARJETA DE CR\xc9DITO UTILIZADA EN RELACI\xd3N CON CUALQUIER TRANSACCI\xd3N. Nuestra confirmaci\xf3n de un pedido significa que tu solicitud de pedido ha sido recibida pero no que tu pedido haya sido aceptado o enviado o que se haya confirmado el precio o la disponibilidad de un art\xedculo. Nos reservamos el derecho de cambiar el precio de un art\xedculo hasta el momento del env\xedo. El t\xedtulo y el riesgo de p\xe9rdida se transfieren a ti cuando entregamos el pedido al transportista. Sin perjuicio de cualquier disposici\xf3n en contrario, nos reservamos el derecho de cancelar o limitar cualquier pedido por cualquier motivo. Los precios, promociones, ofertas y disponibilidad de productos est\xe1n sujetos a cambios sin previo aviso.</p>\\n<p>Si participas en el programa myWalgreens, esa participaci\xf3n se rige por los T\xe9rminos y Condiciones de myWalgreens.</p>\\n<p>Si eliges cargar im\xe1genes y crear productos para comprar a trav\xe9s de nuestros servicios fotogr\xe1ficos, aceptas que eres el \xfanico responsable de dicho Contenido de Usuario y que nos notificar\xe1s sobre cualquier contenido que veas y que constituya un Uso Prohibido. Para facilitar el uso de los servicios fotogr\xe1ficos, podemos ofrecer una cantidad razonable de espacio de almacenamiento temporal a los usuarios activos, seg\xfan lo determinemos de vez en cuando a nuestro exclusivo criterio.</p>\\n<p>Si creas un pedido recurrente autom\xe1ticamente a trav\xe9s de nuestro programa Auto-Reorder & Save, se aplican los t\xe9rminos adicionales de este p\xe1rrafo. Tu pedido inicial se entregar\xe1 utilizando el m\xe9todo de env\xedo que selecciones y todos los pedidos autom\xe1ticos se entregar\xe1n mediante env\xedo est\xe1ndar gratuito. Tu pedido inicial costar\xe1 el monto que se muestra al finalizar la compra, y a todos los pedidos autom\xe1ticos se les cobrar\xe1 el precio de venta vigente en ese momento o el descuento de Auto-Reorder & Save, el que sea menor. Tus pedidos continuar\xe1n envi\xe1ndose hasta que canceles o cambies tu pedido autom\xe1tico. Se seguir\xe1 cobrando a tu m\xe9todo de pago hasta que lo canceles o lo cambies. El precio de tu pedido inicial no est\xe1 garantizado para pedidos autom\xe1ticos. Si el precio anunciado para cualquiera de tus art\xedculos cambia, este cambio de precio tambi\xe9n se aplicar\xe1 a tus art\xedculos programados para pedidos autom\xe1ticos. No se te notificar\xe1 sobre los cambios de precios antes de que se procesen y env\xeden tus art\xedculos de pedido autom\xe1tico. Las recompensas de myWalgreens Cash se pueden obtener con cualquier pedido, sujeto a los T\xe9rminos y Condiciones de myWalgreens, pero no se pueden canjear en ning\xfan pedido autom\xe1tico. Para ver y administrar tus pedidos autom\xe1ticos, inicia sesi\xf3n en Tu Cuenta y haz clic en \\"Administrador de Pedidos Autom\xe1ticos.\\" Puedes cancelar u omitir un pedido autom\xe1tico en cualquier momento antes de la fecha l\xedmite que se muestra en el Administrador de Pedidos Autom\xe1ticos. Para obtener informaci\xf3n adicional, vis\xedtanos en https://www.walgreens.com/autoreorder o visita https://www.walgreens.com/contactus o cont\xe1ctanos al 1-877-250-5823</p>\\n<p>Si eliges acceder a los servicios wifi en la tienda que podemos brindarte, aceptas que eres responsable de todas las actividades que ocurran en tu dispositivo.</p>\\n<p>Si descargas una de nuestras aplicaciones m\xf3viles, estos T\xe9rminos constituyen un acuerdo de licencia de usuario final y aceptas actuar de acuerdo con los acuerdos de licencia de usuario final y las pol\xedticas aplicables por tu proveedor de software de sistema operativo y proveedor de servicios inal\xe1mbricos (incluidos los enumerados dentro de sus respectivas tiendas de aplicaciones). T\xfa aceptas que eres el \xfanico responsable de los costos incurridos al acceder a una de nuestras aplicaciones m\xf3viles. Es posible que debas enviar y recibir, a tu costo, comunicaciones electr\xf3nicas relacionadas con los Servicios ofrecidos a trav\xe9s de nuestras aplicaciones m\xf3viles, incluidos, entre otros, mensajes administrativos, anuncios de servicios, informes de datos de diagn\xf3stico y actualizaciones. Si no tienes un plan de datos m\xf3viles inal\xe1mbricos ilimitados, puedes incurrir en cargos adicionales de tu proveedor de servicios inal\xe1mbricos en relaci\xf3n con el uso de estos Servicios. T\xfa eres el \xfanico responsable de obtener cualquier suscripci\xf3n adicional o servicio de conectividad o equipo necesario para acceder a estos Servicios, incluido, entre otros, el pago de todas las tarifas de terceros asociadas con los mismos, incluidas las tarifas por la informaci\xf3n enviada a estos Servicios o a trav\xe9s de ellos. Podemos, a nuestra discreci\xf3n, descargar autom\xe1ticamente actualizaciones de nuestras aplicaciones m\xf3viles a tu dispositivo de vez en cuando. T\xfa aceptas estas actualizaciones y pagar los costos asociados con su recepci\xf3n. Es posible que nuestras aplicaciones m\xf3viles no funcionen con todos los dispositivos o con todos los operadores de telefon\xeda m\xf3vil.</p>\\n<p>Si descargas y utilizas una de nuestras aplicaciones m\xf3viles disponibles a trav\xe9s de la plataforma Apple: T\xfa, el usuario final de estos Servicios, reconoces que este acuerdo se celebra entre Walgreens y sus subsidiarias y afiliadas, y t\xfa, y no con Apple, Inc., y Apple, Inc. no es responsable de los Servicios. Sin perjuicio de lo anterior, t\xfa reconoces que Apple, Inc. y sus subsidiarias son terceros beneficiarios de este acuerdo y que Apple, Inc. tiene el derecho (y se considera que ha aceptado el derecho) de hacer cumplir este acuerdo. T\xfa reconoces que Apple, Inc. no tiene obligaci\xf3n alguna de mantener o respaldar los Servicios. T\xfa reconoces que has revisado y aceptas los T\xe9rminos y Condiciones de la App Store (ubicados en l\xednea en https://www.apple.com/legal/itunes/us/terms.html#APPS), incluidas las Reglas de Uso establecidas en ellos. Este acuerdo incorpora por referencia el Acuerdo de Licencia de Usuario Final de la Aplicaci\xf3n con Licencia (el \\"LAEULA\\" por sus siglas en ingl\xe9s) publicado por Apple, Inc. (ubicado en l\xednea en https://www.apple.com/legal/macapps/dev/stdeula/). Para los fines de este Acuerdo, nuestros Servicios basados en aplicaciones m\xf3viles se consideran la \\"Aplicaci\xf3n con Licencia\\" seg\xfan se define en LAEULA y Walgreens se considera el \\"Proveedor de aplicaciones\\" seg\xfan se define en LAEULA. Si alguno de los T\xe9rminos del presente entra en conflicto con los t\xe9rminos de LAEULA, prevalecer\xe1n estos T\xe9rminos. En caso de que los Servicios no cumplan con cualquier garant\xeda aplicable establecida en este documento, t\xfa reconoces que, en la medida m\xe1xima permitida por la ley aplicable, Apple, Inc. no tendr\xe1 ninguna otra obligaci\xf3n de garant\xeda con respecto a los Servicios y cualquier otros reclamos, p\xe9rdidas, responsabilidades, da\xf1os, costos o gastos atribuibles a cualquier incumplimiento de cualquier garant\xeda. Adem\xe1s, reconoces y aceptas que en ning\xfan caso Apple, Inc. ser\xe1 responsable de ning\xfan reclamo relacionado con los Servicios (incluido, entre otros, el reclamo de un tercero de que los Servicios infringen los derechos de propiedad intelectual de ese tercero) o su uso o posesi\xf3n de los Servicios, incluidos, entre otros: (i) reclamaciones de responsabilidad del producto; (ii) cualquier reclamo de que los Servicios no cumplen con cualquier requisito legal o reglamentario aplicable; y (iii) reclamaciones que surjan en virtud de legislaci\xf3n de protecci\xf3n al consumidor o similar.</p>\\n\\n<h4>V. Privacidad</h4>\\n<p>Al proporcionar los Servicios, t\xfa puedes proporcionar, y nosotros podemos recopilar autom\xe1ticamente, informaci\xf3n sobre ti y tu uso de los Servicios, incluida, entre otras, tu ubicaci\xf3n en tiempo real, direcci\xf3n MAC y direcci\xf3n IP. Nuestra recopilaci\xf3n y uso de dicha informaci\xf3n se rige por nuestra Pol\xedtica de Seguridad y Privacidad en l\xednea disponible en https://www.walgreens.com/privacy y el Aviso de pr\xe1cticas de privacidad disponible en https://www.walgreens.com/noticeofprivacy</p>\\n\\n<h4>VI. Exenciones de Responsabilidad, Limitaci\xf3n de Responsabilidad e Indemnizaci\xf3n</h4>\\n<p>Proporcionamos los Servicios (incluidos, entre otros, todo el Contenido de Walgreens, el Contenido del Usuario y otro contenido) como un servicio para usted. ESTOS SERVICIOS SE PROPORCIONAN \\"TAL CUAL\\" Y \\"SEG\xdaN DISPONIBILIDAD\\" SIN GARANT\xcdA DE NING\xdaN TIPO, YA SEA EXPRESA, IMPL\xcdCITA O LEGAL, Y EN LA MEDIDA EN QUE LO PERMITA LA LEY APLICABLE, RENUNCIAMOS EXPRESAMENTE A TODAS Y CUALQUIER GARANT\xcdA. ESTE DESCARGO DE RESPONSABILIDAD INCLUYE, PERO NO SE LIMITA A, TODAS Y DECLARACIONES O GARANT\xcdAS DE COMERCIABILIDAD, IDONEIDAD PARA UN PROP\xd3SITO PARTICULAR, RENDIMIENTO, CONFIABILIDAD, SEGURIDAD, DISPONIBILIDAD, EXACTITUD, CALIDAD, IDONEIDAD, INTEGRIDAD, NO INFRACCI\xd3N O QUE LOS SERVICIOS SON LIBRE DE ERRORES O DEFECTOS. ANTES DE UTILIZAR CUALQUIER PRODUCTO, DEBES CONFIRMAR CUALQUIER INFORMACI\xd3N DE IMPORTANCIA PARA TI EN EL EMBALAJE DEL PRODUCTO. NO SOMOS RESPONSABLES Y POR LA PRESENTE RENUNCIAMOS A CUALQUIER RESPONSABILIDAD CON RESPECTO A TODO EL CONTENIDO DEL USUARIO, CUALQUIER USUARIO Y CUALQUIER TERCERO. T\xda ASUMES LA RESPONSABILIDAD POR LA EXACTITUD, IDONEIDAD Y LEGALIDAD DE CUALQUIER INFORMACI\xd3N QUE NOS PROPORCIONES. T\xda ACEPTAS QUE UTILIZAS ESTOS SERVICIOS BAJO T\xda PROPIO RIESGO.</p>\\n<p>ESTOS SERVICIOS EST\xc1N DISPONIBLES PARA LOS USUARIOS EN LOS EE. UU. Y NO OFRECEMOS NINGUNA GARANT\xcdA NI DECLARACI\xd3N DE QUE ALGUNO DE LOS SERVICIOS SEA APROPIADO PARA SU USO EN OTRAS UBICACIONES. NINGUNA PARTE DE LOS SERVICIOS DEBE INTERPRETARSE COMO UNA OFERTA O SOLICITUD POR O A ALGUIEN A QUIEN DICHA OFERTA O SOLICITUD NO SE PUEDA HACER LEGALMENTE.</p>\\n<p>COMO CONSIDERACI\xd3N PARCIAL POR TU ACCESO A NUESTROS SERVICIOS (INCLUYENDO EL CONTENIDO DE WALGREENS), T\xda ACEPTAS QUE NO SOMOS RESPONSABLES ANTE TI DE NINGUNA MANERA POR LAS DECISIONES QUE PUEDAS TOMAR O TUS ACCIONES O NO ACCIONES EN CONFIANZA EN ELLOS. T\xda TAMBI\xc9N ACEPTAS QUE NUESTRA RESPONSABILIDAD TOTAL QUE SURJA O SE RELACIONE CON TU USO Y ACCESO A LOS SERVICIOS, INDEPENDIENTEMENTE DE LA FORMA DE ACCI\xd3N O RECLAMACI\xd3N (POR EJEMPLO, CONTRATO, GARANT\xcdA, AGRAVIO, NEGLIGENCIA, RESPONSABILIDAD ESTRICTA, NEGLIGENCIA PROFESIONAL, FRAUDE, INFRACCI\xd3N U OTRAS BASES PARA RECLAMACIONES) SE LIMITA AL PRECIO DE COMPRA DE CUALQUIER ART\xcdCULO QUE NOS COMPRASTE EN LA TRANSACCI\xd3N CORRESPONDIENTE, SI LA HAY. EN NING\xdaN CASO SEREMOS RESPONSABLES DE NING\xdaN DA\xd1O DIRECTO, INDIRECTO, ESPECIAL, INCIDENTAL, CONSECUENTE O PUNITIVO (\\"DA\xd1OS\\"), NI SEREMOS RESPONSABLES DE NING\xdaN DA\xd1O DE NING\xdaN TIPO QUE RESULTE DE ERRORES, OMISIONES, INTERRUPCIONES, ELIMINACI\xd3N DE ARCHIVOS, ERRORES, DEFECTOS, RETRASOS EN LA OPERACI\xd3N O TRANSMISI\xd3N, O CUALQUIER FALLO DE RENDIMIENTO, YA SEA CAUSADO O NO POR EVENTOS FUERA DE NUESTRO CONTROL RAZONABLE, INCLUYENDO, PERO NO LIMITADO A, ACTOS FORTUITOS, FALLA EN LA L\xcdNEA DE COMUNICACIONES, ROBO, DESTRUCCI\xd3N O ACCESO NO AUTORIZADO A NUESTROS SITIOS, REGISTROS, PROGRAMAS, SERVICIOS O CONTENIDO, AUNQUE HAYAMOS SIDO INFORMADOS DE LA POSIBILIDAD DE TALES DA\xd1OS. SI NO EST\xc1S SATISFECHO CON ESTOS T\xc9RMINOS O NUESTROS SERVICIOS (INCLUYENDO EL CONTENIDO DE WALGREENS), TU \xdaNICO Y EXCLUSIVO RECURSO ES DEJAR DE UTILIZAR LOS SERVICIOS.</p>\\n<p>ALGUNAS JURISDICCIONES NO PERMITEN LA EXCLUSI\xd3N O LIMITACI\xd3N DE RESPONSABILIDAD POR DA\xd1OS CONSECUENTES INCIDENTALES U OTROS DA\xd1OS; COMO RESULTADO, LAS LIMITACIONES O EXCLUSIONES ANTERIORES PUEDEN NO SER APLICABLES A USTED, Y EL P\xc1RRAFO ANTERIOR NO SE APLICAR\xc1 A UN RESIDENTE DE NUEVA JERSEY EN LA MEDIDA EN QUE LOS DA\xd1OS A DICHO RESIDENTE DE NUEVA JERSEY SON EL RESULTADO DE NUESTRO ACTO NEGLIGENTE, FRAUDULENTO O IMPRUDENTE ( S) O MALA CONDUCTA INTENCIONAL.</p>\\n<p>T\xda ACEPTAS INDEMNIZAR, DEFENDER Y EXIMIR DE RESPONSABILIDAD A WALGREENS, INCLUYENDO SUS FUNCIONARIOS, DIRECTORES, EMPLEADOS, AFILIADOS, LICENCIANTES, PROVEEDORES, PROVEEDORES DE INFORMACI\xd3N Y AGENTES, DE Y CONTRA TODAS LAS P\xc9RDIDAS, GASTOS, DA\xd1OS, HONORARIOS, MULTAS Y COSTOS, INCLUYENDO SIN LIMITACI\xd3N , HONORARIOS RAZONABLES DE ABOGADOS, QUE RESULTEN DE O SE RELACIONEN CON TU USO DE LOS SERVICIOS O VIOLACIONES DE ESTOS T\xc9RMINOS.</p>\\n\\n<h4>VII. Resoluci\xf3n de Conflictos</h4>\\n<p>Si alguna vez surge una disputa entre nosotros, cont\xe1ctanos en walgreens.com/contactus. Si no podemos resolver el asunto de manera informal, t\xfa y nosotros aceptamos que todas y cada una de las disputas o reclamos que hayan surgido o puedan surgir entre t\xfa y nosotros se resolver\xe1n exclusivamente a trav\xe9s de un arbitraje final y vinculante, en lugar de en los tribunales, excepto que t\xfa puedas afirmar reclamos en el tribunal de reclamos menores, si tus reclamos califican (\\"Acuerdo de Arbitraje\\"). La Ley Federal de Arbitraje rige la interpretaci\xf3n y aplicaci\xf3n de este Acuerdo de Arbitraje, que ser\xe1 realizado por la Asociaci\xf3n Estadounidense de Arbitraje (\\"AAA\\" por sus siglas en ingl\xe9s) seg\xfan sus reglas y procedimientos, incluidos los Procedimientos Suplementarios de la AAA para Disputas Relacionadas con el Consumidor (seg\xfan corresponda), seg\xfan lo modificado por estos T\xe9rminos. Un formulario para iniciar un procedimiento de arbitraje est\xe1 disponible en el sitio web de la AAA. El arbitraje se llevar\xe1 a cabo en el condado en el que t\xfa resides. Si el valor de la compensaci\xf3n solicitada es de $10,000 o menos, t\xfa o nosotros podemos optar por que el arbitraje se realice por tel\xe9fono o se base \xfanicamente en presentaciones escritas, elecci\xf3n que ser\xe1 vinculante para ti y para nosotros, sujeta a la discreci\xf3n del \xe1rbitro de requerir una intervenci\xf3n adicional, audiencia en persona, si las circunstancias lo ameritan. T\xfa y/o nosotros podremos asistir a una audiencia en persona por tel\xe9fono, a menos que el \xe1rbitro exija lo contrario.</p>\\n<p>El \xe1rbitro decidir\xe1 el fondo de todos los reclamos de acuerdo con las leyes del Estado de Illinois, incluidos los principios reconocidos de equidad, y honrar\xe1 todos los reclamos de privilegio reconocidos por la ley. El \xe1rbitro no estar\xe1 obligado por fallos de arbitrajes anteriores que involucren a diferentes usuarios de Walgreens, pero s\xed estar\xe1s obligado por fallos de arbitrajes anteriores que involucren al mismo usuario de Walgreens en la medida requerida por la ley aplicable. El laudo del \xe1rbitro ser\xe1 definitivo y vinculante, y la sentencia sobre el laudo dictado por el \xe1rbitro podr\xe1 presentarse en cualquier tribunal que tenga jurisdicci\xf3n sobre el mismo.</p>\\n<p>T\xfa y nosotros aceptamos que cada uno de nosotros puede presentar reclamaciones contra el otro solo de forma individual y no como demandante o miembro de un grupo en cualquier supuesta acci\xf3n o procedimiento colectivo o representativo. A menos que t\xfa y nosotros acordemos lo contrario, el \xe1rbitro no podr\xe1 consolidar ni unir los reclamos de m\xe1s de una persona o parte y no podr\xe1 presidir ninguna forma de procedimiento consolidado, representativo o colectivo. El \xe1rbitro puede otorgar reparaci\xf3n (incluidas medidas monetarias, cautelares y declarativas) solo a favor de la parte individual que solicita la reparaci\xf3n y solo en la medida necesaria para proporcionar la reparaci\xf3n requerida por los reclamos individuales de esa parte. Cualquier compensaci\xf3n otorgada no afectar\xe1 a nuestros dem\xe1s usuarios.</p>\\n<p>Puedes optar por rechazar el Acuerdo de Arbitraje envi\xe1ndonos por correo un aviso de exclusi\xf3n firmado (\\"Aviso de exclusi\xf3n Voluntaria\\") dentro de los 30 d\xedas posteriores a la fecha en que accediste por primera vez a los Servicios o aceptaste cualquier versi\xf3n publicada posteriormente de estos T\xe9rminos. El Aviso de Exclusi\xf3n Voluntaria debe incluir una declaraci\xf3n de que usted no est\xe1 de acuerdo con este Acuerdo de Arbitraje, tu nombre, direcci\xf3n, n\xfamero de tel\xe9fono y cualquier direcci\xf3n de correo electr\xf3nico utilizada para iniciar sesi\xf3n en cualquier cuenta aplicable a la que se aplique la exclusi\xf3n voluntaria. Debes enviar el Aviso de Exclusi\xf3n Voluntaria por correo a Walgreens, a la atenci\xf3n de: Litigation and Regulatory Law Department, 104 Wilmot Road, MS 1431, Deerfield, IL 60015. Este procedimiento es la \xfanica forma en que puedes optar por no participar en el Acuerdo de Arbitraje. Si optas por no participar en el Acuerdo de Arbitraje, todas las dem\xe1s partes de estos T\xe9rminos, incluidas todas las dem\xe1s disposiciones de esta Secci\xf3n, seguir\xe1n aplic\xe1ndose. La exclusi\xf3n voluntaria de este Acuerdo de Arbitraje no tiene ning\xfan efecto sobre ning\xfan acuerdo de arbitraje anterior, otro o futuro que puedas tener con nosotros.</p>\\n<p>En la medida en que lo permita la ley aplicable, cualquier reclamo que surja en relaci\xf3n con el uso de estos Servicios o estos T\xe9rminos debe presentarse dentro de un (1) a\xf1o a partir de la fecha del evento que dio lugar a dicha acci\xf3n.</p>\\n\\n<h4>VIII. Ley de Derechos de Autor del Milenio Digital</h4>\\n<p>Si crees que alg\xfan Contenido de Walgreens infringe tus derechos de autor, visita https://www.walgreens.com/topic/help/digital_millenium_copyright_act.jsp para obtener instrucciones sobre c\xf3mo notificarnos.</p>\\n\\n<h4>IX. T\xe9rminos Adicionales</h4>\\n<p>Estos T\xe9rminos, incluidos todos los dem\xe1s t\xe9rminos y pol\xedticas a los que se hace referencia en este documento, constituyen el acuerdo completo entre t\xfa y nosotros con respecto al Servicio, y se interpretar\xe1n de acuerdo con las leyes del Estado de Illinois, sin respetar sus normas de conflicto de leyes. En caso de cualquier inconsistencia entre estos T\xe9rminos y las pol\xedticas a las que se hace referencia en ellos, prevalecer\xe1n estos T\xe9rminos. Nuestra incapacidad para ejercer o hacer cumplir cualquiera de los t\xe9rminos del presente no constituir\xe1 una renuncia, y si no actuamos con respecto a tu incumplimiento o el incumplimiento de cualquier otra persona en cualquier ocasi\xf3n, no renunciamos a nuestro derecho de actuar con respecto a incumplimientos futuros o similares. Si incumples alguna disposici\xf3n de estos T\xe9rminos, ya no podr\xe1s utilizar los Servicios. Si rescindimos estos T\xe9rminos o tu permiso para usar los Servicios por cualquier motivo, el acuerdo formado por tu aceptaci\xf3n de estos T\xe9rminos continuar\xe1 aplic\xe1ndose y ser\xe1 vinculante para ti con respecto a tu uso anterior de los Servicios y cualquier cosa relacionada con o que surjan de dicho uso. Si no est\xe1s satisfecho con estos T\xe9rminos o nuestros Servicios, tu \xfanico y exclusivo recurso es dejar de utilizar los Servicios. Estos T\xe9rminos, incluidos cualquiera o todos los derechos y obligaciones establecidos en el presente, pueden ser cedidos o transferidos libremente por nosotros, pero no por ti. Los encabezados de las secciones se incluyen \xfanicamente por conveniencia y no afectar\xe1n la interpretaci\xf3n de los T\xe9rminos. T\xfa aceptas que cualquier aviso electr\xf3nico que te enviemos deber\xe1 satisfacer cualquier requisito de que dichos avisos se realicen por escrito. Si se determina que alguna parte de estos T\xe9rminos es ilegal, nula o inaplicable por cualquier motivo, dicha parte se considerar\xe1 separable de estos T\xe9rminos y se eliminar\xe1 o limitar\xe1 en la medida m\xednima necesaria. El resto de estos T\xe9rminos, incluida cualquier parte revisada, permanecer\xe1 y estar\xe1 en pleno vigor y efecto.</p>\\n<p>Nuestro sistema automatizado de reabastecimiento de recetas mediante tonos tiene licencia de las siguientes Patentes de los Estados Unidos: 5,128,984; 5,561,707; 5,684,863; 5,815,551; 5,828,734; 5,898,762; 5,917,893; 5,974,120; entre otras.</p>\\n<p>Copyright 2021, Walgreen Co. Todos los derechos reservados.</p>"},"services":{"title":"Servicios Ofrecidos","cards":[{"title":"Preguntas sobre salud","icon":"assets/services/help_icon.svg","subTitle":"Obt\xe9n asistencia y respuestas a tus preguntas","highlightedText":"Tomar mejores decisiones de bienestar para tu salud puede ser confuso a veces. Pasa tiempo uno a uno con un Asesor de Salud de Walgreens y obtenga respuestas a algunas de las preguntas que tengas.","additionalText":"Desde consejos sobre medicamentos de venta libre y suplementos hasta nutrici\xf3n, pregunta a un asesor de salud de Walgreens que tenga experiencia cl\xednica para ayudarte a encontrar respuestas a tus preguntas.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud"},{"title":"Dispositivos de Monitoreo de la Salud","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Obt\xe9n ayuda para configurar dispositivos de monitoreo de salud","highlightedText":"Los dispositivos de monitoreo de la salud pueden mostrarte los cambios diarios en tu salud mediante el control de aspectos como la presi\xf3n arterial, la actividad, el sue\xf1o y m\xe1s.","additionalText":"Aprende a configurar y usar dispositivos de salud port\xe1tiles o en el hogar que pueden ayudarte a comprender mejor tu salud.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud"},{"title":"Vacuna contra la Influenza","icon":"assets/services/syringe_icon.svg","subTitle":"Obt\xe9n una Vacuna contra la Influenza hoy","highlightedText":"Las vacunas contra la influenza estacional pueden ayudarte a reducir el riesgo de contraer ciertas cepas del virus de la influenza.","additionalText":"La vacuna puede reducir las enfermedades gripales, las visitas al m\xe9dico y las ausencias al trabajo y a la escuela debido a la influenza, as\xed como prevenir las hospitalizaciones y muertes relacionadas con la influenza.<br> <br> Habla con un asesor de salud o farmac\xe9utico para vacunarte contra la influenza.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud"}],"appointment":{"title":"Programa una cita","phoneNumber":"Llama al: 877-645-4128"}},"scheduleAppointments":{"infoHeader":"El cuidado ahora est\xe1 m\xe1s cerca de lo que piensas","infoDescription":"En Walgreens Health Corner, ahora tienes un lugar c\xf3modo para realizar tus tareas pendientes de salud. Ac\xe9rcate con tus preguntas e inquietudes de salud, o incluso programa citas para ex\xe1menes de detecci\xf3n, vacunas o revisiones de salud. Walgreens Health Corner est\xe1 aqu\xed para ayudarte. Programa una cita hoy.","detailsHeader":"Estas son solo algunas de las formas en que Walgreens Health Corner puede ayudarte.","details":[{"title":"Preguntas de salud","icon":"assets/scheduleAppointments/help.svg","description":"<p>Obt\xe9n ayuda y respuestas a tus preguntas.</p><p>En ocasiones, tomar mejores decisiones de bienestar para tu salud, puede ser confuso. Habla con un Asesor de Salud y obt\xe9n respuestas a algunas de las preguntas que tienes.</p>"},{"title":"Dispositivos de Monitoreo de Salud","icon":"assets/scheduleAppointments/immunization.svg","description":"<p>Obt\xe9n ayuda para configurar dispositivos de monitoreo de salud.</p><p>Los dispositivos de monitoreo de la salud pueden mostrarte los cambios diarios en tu salud mediante el seguimiento de aspectos como tu presi\xf3n arterial, actividad, sue\xf1o y m\xe1s.</p>"},{"title":"Vacuna Contra la Influenza","icon":"assets/scheduleAppointments/band.svg","description":"<p>Obt\xe9n una vacuna contra la influenza.*</p><p>Las vacunas contra la influenza estacional pueden ayudarte a reducir el riesgo de contraer ciertas cepas del virus de la influenza. Habla con un Asesor de Salud o un farmac\xe9utico para vacunarte contra la gripe.</p><p></p><p>*Vacunas sujetas a disponibilidad. Pueden aplicarse restricciones relacionadas con el estado, la edad y la salud</p>"}]},"inactivityModal":{"title":"Su sesi\xf3n est\xe1 a punto de caducar","description":"Toque “Quedarse” para continuar explorando los servicios que Health Corner tiene para oferta.","closeBtnText":"Cerrar","timeoutMessageStart":"Esta sesi\xf3n expirar\xe1 en","timeoutMessageFinish":"segundos si no responde.","stayBtnText":"Quedarse","leaveBtnText":"Abandonar"},"virtualCare":{"title":"Atenci\xf3n virtual","leftHeader":"Experimente la atenci\xf3n virtual","leftParagraph":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.","middleHeader":"Prueba nuestra Atenci\xf3n Virtual","phoneImg":"assets/virtual-care/find-a-provider.png","phoneImgAlt":"Busque proveedores y la ubicaci\xf3n de Walgreens Health Corner m\xe1s cercana para satisfacer sus necesidades de salud. Programe citas con proveedores selectos directamente desde la aplicaci\xf3n.","rightHeader":"Escanee el c\xf3digo para experimentar Virtual Care de Walgreen.","newPhoneHeader":"iPhone y Android m\xe1s reciente","newPhoneParagraph":"Simplemente apunte su c\xe1mara al c\xf3digo QR a la derecha para iniciar autom\xe1ticamente la encuesta.","oldPhoneHeader":"Android m\xe1s antiguo","oldPhoneParagraph":"Descargue una aplicaci\xf3n de lector de c\xf3digos QR desde Play Store. Escanee el c\xf3digo con la aplicaci\xf3n de c\xf3digo QR.","speechBubble":"\xa1Escan\xe9ame!","qrCode":"assets/virtual-care/surveyQrCode.png","qrCodeAlt":"C\xf3digo QR para acceder a nuestro servicio de Atenci\xf3n Virtual"},"video":{"title":"Video","mediaUrl":"assets/video/kiosk_video.mp4","mediaPosterImg":"assets/video/videoPoster.png","pointerImg":"assets/video/pointer.svg","pointerAlt":"Learn More","learnMore":"Tap to learn more about Walgreens Health Corner"},"footer":{"leaveFeedback":"Deja un comentario","privacyPolicy":"Pol\xedtica de privacidad y t\xe9rminos","termsAndConditions":"Condiciones","nextLanguage":"English","endSession":"Finalizar Sesi\xf3n"},"endSessionPrompt":{"modalTitle":"\xbfYa terminaste?","confirmText":"S\xed","denyText":"No"}},"bsc":{"home":{"title":"Inicio","heading":"Bienvenido a tus cuidados de salud sin la m\xfasica de espera.","cards":[{"title":"Sobre Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Conoce a tus Asesores de Salud y m\xe1s informaci\xf3n sobre el horario de Walgreens Health Corner"},{"title":"Servicios que ofrecemos","link":"services","icon":"assets/home/store.svg","description":"Acceso conveniente a asistencia y ayuda personalizadas para tu salud, basadas en la elegibilidad de tu plan de salud."},{"title":"Dispositivos conectados","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitorea y rastrea tu salud con dispositivos inteligentes que miden tu progreso a trav\xe9s del tiempo."}],"descriptionBold":"Walgreens Health Corner","description":"es una sencilla, nueva forma de hacerte cargo de tus tareas de salud. Los miembros de selectos proveedores de seguros m\xe9dicos obtienen servicios especializados sin pagos duplicados ni citas."},"about":{"title":"Acerca de Walgreens Health Corner","heading":"Sobre Walgreens Health Corner","description":"Consulte nuestros horarios y conozca a nuestros amigables asesores de salud que pueden ayudarlo a responder preguntas y guiarlo para seleccionar pruebas y servicios disponibles aqu\xed o en la farmacia.","cards":[{"heading":"Informaci\xf3n y horarios","description":"Obtenga horarios actualizados para que pueda obtener respuestas actualizadas a sus preguntas de salud.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Informaci\xf3n y horarios de operaci\xf3n","heading":"Tienes preguntas. Tenemos respuestas.","description":"\xbfNo est\xe1s seguro(a) de c\xf3mo navegar por los medicamentos de venta libre o receta m\xe9dica? \xbfQuieres consejos sobre c\xf3mo mantenerte activo? \xbfNecesitas ayuda para usar un nuevo dispositivo de salud? Nuestros Aesores de salud est\xe1n aqu\xed para ayudarte a responder estas preguntas y m\xe1s.","hoursTitle":"Horario de Health Corner","advisorsDescription":"Nuestros asesores de salud son un equipo amigable y cl\xednicamente capacitado que est\xe1 aqu\xed para ayudarte a navegar tus necesidades de salud. Ellos te conocer\xe1n en cada visita e interacci\xf3n, brind\xe1ndote atenci\xf3n personalizada y continua. Desde ayuda para encontrar informaci\xf3n de salud hasta consejos sobre nutrici\xf3n y como mantenerte activo(a), est\xe1n aqu\xed para ayudarte.","learnMore":"Si deseas obtener m\xe1s informaci\xf3n, ingresa a <br>https://www.walgreens.com/findcare/partner/blueshieldca-health-corner<br> en tu tel\xe9fono m\xf3vil o dispositivo personal.","legalText":"Los servicios de Walgreens Health Corner no est\xe1n dise\xf1ados para usarse en casos de atenci\xf3n o como servicios m\xe9dicos de emergencia. La informaci\xf3n proporcionada no sustituye el consejo cl\xednico de tu m\xe9dico. Si necesitas atenci\xf3n m\xe9dica inmediata, comun\xedcate con tu m\xe9dico o ve a la sala de emergencias m\xe1s cercana. Consulta a tu m\xe9dico para el diagn\xf3stico y tratamiento de tu condici\xf3n m\xe9dica o enfermedad."},"connectedDevices":{"title":"Dispositivos Inteligentes de Monitoreo de la Salud","heading":"Monitorea tu salud con dispositivos inteligentes","description":"Simplifica la forma en que rastreas tu progreso o identificas cambios importantes en tu salud con dispositivos que sincronizan la informaci\xf3n a trav\xe9s de una aplicaci\xf3n en tu tel\xe9fono inteligente o tu tableta electr\xf3nica.","devices":[{"title":"Omron Serie 10 Monitor de presi\xf3n arterial","name":"Omron Serie 10 Monitor de presi\xf3n arterial","img":"assets/connectedDevices/devices/omron-bp-monitor-large.png","thumbnail":"assets/connectedDevices/devices/omron-bp-monitor.png","id":"omron-10-series-blood-pressure-monitor","body":"C\xf3modo y f\xe1cil de leer.","attributes":[{"title":"Tecnolog\xeda de precision avanzada","body":"Minimiza el posible impacto que pudieran tener tus movimientos y tu respiraci\xf3n en los resultados de la lectura de tu presi\xf3n arterial, ayudando a reducir errores e inconsistencias en la medici\xf3n.","icon":"assets/devices/device-health-dashboard.svg"},{"title":"Intervalos y usuarios personalizables","body":"Realiza 3 lecturas consecutivas en intervalos que puedes personalizar. Observa tu lectura anterior junto a la lectura actual para una comparaci\xf3n inmediata. Permite dos usuarios.","icon":"assets/devices/device-clock.svg"},{"title":"C\xf3modo y f\xe1cil de leer","body":"La pantalla LCD retroiluminada cuenta con una pantalla retroiluminada negra de alto contraste con n\xfameros extra grandes para obtener resultados f\xe1ciles de leer.","icon":"assets/devices/device-optical.svg"}]},{"title":"KardiaMobile Monitor personal ECG","id":"kardiamobile-personal-ekg-monitor","name":"KardiaMobile Monitor personal ECG","body":"Revisa la salud de tu coraz\xf3n desde casa","img":"assets/connectedDevices/devices/kardiamobile-ekg-monitor-large.png","thumbnail":"assets/connectedDevices/devices/kardiamobile-ekg-monitor.png","attributes":[{"title":"Detecci\xf3n en tiempo real","body":"Detecta los tres tipos m\xe1s comunes de arritmia: Fibrilaci\xf3n auricular, bradicardia y taquicardia y saber al instante si tu ritmo card\xedaco es normal te brindar\xe1 tranquilidad.","icon":"assets/devices/device-heart-blood-pressure.svg"},{"title":"F\xe1cil de usar","body":"Simplemente coloca tus dedos en los sensores—sin cables, parches, o geles.","icon":"assets/devices/device-bluetooth.svg"},{"title":"Almacena o comparte en segundos","body":"Almacena tus ECGs en tu tel\xe9fono o env\xedale un correo a tu doctor con solo apretar un bot\xf3n.","icon":"assets/devices/device-share.svg"}]},{"title":"OneTouch Verio Reflect Medidor de Glucosa","id":"onetouch-verio-reflect-glucose-meter","name":"OneTouch Verio Reflect Medidor de Glucosa","body":"Informaci\xf3n personalizada para ayudarte a manejar tu diabetes","img":"assets/connectedDevices/devices/onetouch-glucose-meter-large.png","thumbnail":"assets/connectedDevices/devices/onetouch-glucose-meter.png","disclaimer":"ATENCI\xd3N PACIENTES DE MEDICARE: Disponible solo para compra en l\xednea. Walgreens.com NO es un proveedor acreditado de Medicare. Si compra equipos o suministros m\xe9dicos en la secci\xf3n Soluciones para el cuidado de la salud en el hogar de nuestro sitio web y env\xeda un reclamo a Medicare por esos art\xedculos, Medicare no pagar\xe1. Usted es total y personalmente responsable del pago de cualquier equipo o suministros m\xe9dicos que compre en este sitio web).","attributes":[{"title":"Aprende a controlar mejor tu diabetes","body":"Informaci\xf3n personalizada dentro de la aplicaci\xf3n, gu\xeda y \xe1nimos para ayudar a los pacientesa controlar su diabetes.","icon":"assets/devices/device-blood-glucose.svg"},{"title":"Lee y act\xfaa en tiempo real","body":"El indicador de rango din\xe1mico ColorSure, muestra cuando los resultados son bajos, altos o dentro del rango para que puedas tomar medidas.","icon":"assets/devices/device-graph.svg"},{"title":"Tiras reactivas confiables","body":"Utiliza tiras reactivas OneTouch Verio con 9 a\xf1os de precisi\xf3n probada a niveles muy bajos y muy altos de glucosa en sangre.","icon":"assets/devices/device-blood.svg"}]},{"title":"iChoice Ox\xedmetro de pulso","id":"ichoice-pulse-oximeter","name":"iChoice Ox\xedmetro de pulso","body":"Relajaci\xf3n adecuada a tu ritmo card\xedaco","img":"assets/connectedDevices/devices/ichoice-pulse-oximeter-large.png","thumbnail":"assets/connectedDevices/devices/ichoice-pulse-oximeter.png","attributes":[{"title":"Lecturas en tiempo real","body":"Mide el nivel de Ox\xedgeno, Ritmo card\xedaco y el nivel de Calma/Estr\xe9s. El sensor de huellas transmite lecturas importantes en tiempo real a la aplicaci\xf3n gratuita de iChoice Relax.","icon":"assets/devices/device-heart-blood-pressure.svg"},{"title":"Mejora con t\xe9cnicas de entrenamiento","body":"Sigue un marcador de respiraci\xf3n liderado por el ritmo de tu coraz\xf3n para reducir la ansiedad y el estr\xe9s. Aprende a respirar a tu mejor frecuencia respiratoria de relajaci\xf3n personal.","icon":"assets/devices/device-trophy.svg"},{"title":"Duerme mejor","body":"Utiliza videos y sonidos relajantes en la aplicaci\xf3n para ayudarte a dormir.","icon":"assets/devices/device-night.svg"}]}]},"services":{"title":"Servicios Ofrecidos","heading":"Una nueva manera para cuidar de tu salud","description":"Conoce a nuestros amables Asesores de Salud que pueden ayudarte a responder preguntas y a elegir pruebas y servicios disponibles aqu\xed o en la farmacia. Adem\xe1s, los miembros de Blue Shield of California pueden acceder a servicios adicionales aqu\xed en Walgreens Health Corner","cards":[{"title":"Preguntas sobre salud","icon":"assets/services/help_icon.svg","subTitle":"Obt\xe9n asistencia y respuestas a tus preguntas","highlightedText":"Tomar mejores decisiones de bienestar para tu salud puede ser confuso a veces. Pasa tiempo uno a uno con un Asesor de Salud de Walgreens y obtenga respuestas a algunas de las preguntas que tengas.","additionalText":"Desde consejos sobre medicamentos de venta libre y suplementos hasta nutrici\xf3n, pregunta a un asesor de salud de Walgreens que tenga experiencia cl\xednica para ayudarte a encontrar respuestas a tus preguntas.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Blue Shield of California."},{"title":"Dispositivos de Monitoreo de la Salud","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Obt\xe9n ayuda para configurar dispositivos de monitoreo de salud","highlightedText":"Los dispositivos de monitoreo de la salud pueden mostrarte los cambios diarios en tu salud mediante el control de aspectos como la presi\xf3n arterial, la actividad, el sue\xf1o y m\xe1s.","additionalText":"Aprende a configurar y usar dispositivos de salud port\xe1tiles o en el hogar que pueden ayudarte a comprender mejor tu salud.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Blue Shield of California."},{"title":"Vacuna contra la Influenza","icon":"assets/services/syringe_icon.svg","subTitle":"Obt\xe9n una Vacuna contra la Influenza hoy","highlightedText":"Las vacunas contra la influenza estacional pueden ayudarte a reducir el riesgo de contraer ciertas cepas del virus de la influenza.","additionalText":"La vacuna puede reducir las enfermedades gripales, las visitas al m\xe9dico y las ausencias al trabajo y a la escuela debido a la influenza, as\xed como prevenir las hospitalizaciones y muertes relacionadas con la influenza.<br> <br> Habla con un asesor de salud o farmac\xe9utico para vacunarte contra la influenza.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Blue Shield of California."},{"title":"Monitoreo de la Presi\xf3n Arterial","icon":"assets/services/bp_icon.svg","availability":"Solo miembros BSC","subTitle":"Los miembros de Blue Shield of California obtienen un monitoreo de la presi\xf3n arterial","highlightedText":"Controlar tu presi\xf3n arterial es importante para reducir el riesgo de ataque card\xedaco y accidente cerebrovascular.","additionalText":"La presi\xf3n arterial alta a menudo no se presenta con ning\xfan s\xedntoma y a menudo se desarrolla lentamente con el tiempo; por lo tanto, es importante controlar tu presi\xf3n arterial regularmente.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Blue Shield of California."},{"title":"Evaluaci\xf3n del IMC","icon":"assets/services/bmi_icon.svg","availability":"Solo miembros BSC","subTitle":"Los miembros de Blue Shield of California obtienen una evaluaci\xf3n del IMC","highlightedText":"El \xedndice de masa corporal (IMC) se usa para estimar la grasa corporal y si una persona tiene un peso saludable.","additionalText":"Una mayor cantidad de grasa corporal puede estar relacionada con un mayor riesgo de algunas enfermedades. El IMC es un c\xe1lculo basado en la altura y el peso.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Blue Shield of California."},{"title":"Prueba de A1C","icon":"assets/services/drop_icon.svg","availability":"Solo miembros BSC","subTitle":"Los miembros de Blue Shield of California obtienen una prueba de A1C","highlightedText":"La prueba A1C - tambi\xe9n conocida como prueba de hemoglobina A1C o HbA1c - es un an\xe1lisis de sangre simple que mide los niveles promedio de az\xfacar en la sangre durante los \xfaltimos 2-3 meses.","additionalText":"Es una de las pruebas m\xe1s utilizadas para diagnosticar la prediabetes y la diabetes, y tambi\xe9n es la prueba principal para ayudarte a ti y a tu equipo de atenci\xf3n m\xe9dica a controlar tu diabetes.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Blue Shield of California."},{"title":"Coordinaci\xf3n de Cuidado de Mamograf\xeda","icon":"assets/services/selfcare_icon.svg","availability":"Solo miembros BSC","subTitle":"Los miembros de Blue Shield of California obtienen coordinaci\xf3n de cuidado de mamograf\xeda","highlightedText":"La detecci\xf3n de c\xe1ncer de mama es una prueba importante para la detecci\xf3n temprana del c\xe1ncer de mama antes de que haya signos o s\xedntomas de la enfermedad.","additionalText":"Aunque no pueden prevenir el c\xe1ncer de mama, las pruebas de detecci\xf3n (como las mamograf\xedas anuales) se realizan de forma rutinaria para detectar el c\xe1ncer de mama temprano, cuando es m\xe1s f\xe1cil de tratar.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Blue Shield of California."},{"title":"Detecci\xf3n de C\xe1ncer Colorrectal a Domicilio","icon":"assets/services/home_icon.svg","availability":"Solo miembros BSC","subTitle":"Los miembros de Blue Shield of California obtienen un kit de detecci\xf3n de c\xe1ncer colorrectal a domicilio","highlightedText":"Una prueba de detecci\xf3n se puede realizar en la comodidad de tu hogar y se usa para buscar anomal\xedas colorrectales cuando una persona no tiene s\xedntomas.","additionalText":"Debes comenzar a hacerte las pruebas de detecci\xf3n del c\xe1ncer colorrectal poco despu\xe9s de cumplir los 50 a\xf1os y luego continuar haci\xe9ndote las pruebas en intervalos regulares.","headerColor":"#ffffff","headerBackgroundColor":"#0071bc","headerLogo":"assets/services/bsc-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Blue Shield of California."}],"appointment":{"title":"Programa una cita","phoneNumber":"Llama al: 877-645-4128"}},"scheduleAppointments":{"infoHeader":"El cuidado ahora est\xe1 m\xe1s cerca de lo que piensas","infoDescription":"En Walgreens Health Corner, ahora tienes un lugar c\xf3modo para realizar tus tareas pendientes de salud. Ac\xe9rcate con tus preguntas e inquietudes de salud, o incluso programa citas para ex\xe1menes de detecci\xf3n, vacunas o revisiones de salud. Walgreens Health Corner est\xe1 aqu\xed para ayudarte. Programa una cita hoy.","detailsHeader":"Estas son solo algunas de las formas en que Walgreens Health Corner puede ayudarte.","details":[{"title":"Preguntas de salud","icon":"assets/scheduleAppointments/help.svg","description":"<p>Obt\xe9n ayuda y respuestas a tus preguntas.</p><p>En ocasiones, tomar mejores decisiones de bienestar para tu salud, puede ser confuso. Habla con un Asesor de Salud y obt\xe9n respuestas a algunas de las preguntas que tienes.</p>"},{"title":"Dispositivos de Monitoreo de Salud","icon":"assets/scheduleAppointments/immunization.svg","description":"<p>Obt\xe9n ayuda para configurar dispositivos de monitoreo de salud.</p><p>Los dispositivos de monitoreo de la salud pueden mostrarte los cambios diarios en tu salud mediante el seguimiento de aspectos como tu presi\xf3n arterial, actividad, sue\xf1o y m\xe1s.</p>"},{"title":"Vacuna Contra la Influenza","icon":"assets/scheduleAppointments/band.svg","description":"<p>Obt\xe9n una vacuna contra la influenza.*</p><p>Las vacunas contra la influenza estacional pueden ayudarte a reducir el riesgo de contraer ciertas cepas del virus de la influenza. Habla con un Asesor de Salud o un farmac\xe9utico para vacunarte contra la gripe.</p><p></p><p>*Vacunas sujetas a disponibilidad. Pueden aplicarse restricciones relacionadas con el estado, la edad y la salud</p>"}],"appointment":{"text":"Programa una cita","number":"Llama al: 877-645-4128"}}},"clover":{"home":{"title":"Inicio","heading":"Bienvenido a tus cuidados de salud sin la m\xfasica de espera.","cards":[{"title":"Sobre Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Conoce a tus Asesores de Salud y m\xe1s informaci\xf3n sobre el horario de Walgreens Health Corner."},{"title":"Servicios que ofrecemos","link":"services","icon":"assets/home/store.svg","description":"Acceso conveniente a asistencia y ayuda personalizadas para tu salud, basadas en la elegibilidad de tu plan de salud."},{"title":"Dispositivos conectados","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitorea y rastrea tu salud con dispositivos inteligentes que miden tu progreso a trav\xe9s del tiempo."}],"descriptionBold":"Walgreens Health Corner","description":"es una sencilla, nueva forma de hacerte cargo de tus tareas de salud. Los miembros de selectos proveedores de seguros m\xe9dicos obtienen servicios especializados sin pagos duplicados ni citas."},"feedback":{"title":"Deja tus Comentarios","heading":"Tu opini\xf3n es importante","description":"Para ayudarnos a mejorar futuras visitas a Health Corner, por favor, h\xe1ganos saber lo que piensa de su experiencia de hoy. Su respuesta solo se utilizar\xe1 para ayudarnos a nosotros y a su plan de salud a comprender c\xf3mo podemos mejorar su pr\xf3xima visita.","surveyHeading":"Completa la encuesta en su dispositivo","surveyQrCodeLink":"assets/feedback/surveyQrCodeNJ.png","surveyQrCodeLinkAlt":"c\xf3digo QR de la encuesta","phoneHeading":"iPhone & Nuevo Android","phoneDescription":"Simplemente apunte su c\xe1mara al c\xf3digo QR a la derecha para iniciar autom\xe1ticamente la encuesta.","oldPhoneHeading":"Android m\xe1s antiguo","oldPhoneDescription":"Descargue una aplicaci\xf3n de lector de c\xf3digos QR desde Play Store. Escanee el c\xf3digo con la aplicaci\xf3n de c\xf3digo QR."},"about":{"title":"Acerca de Walgreens Health Corner","heading":"Sobre Walgreens Health Corner","description":"Consulte nuestros horarios y conozca a nuestros amigables asesores de salud que pueden ayudarlo a responder preguntas y guiarlo para seleccionar pruebas y servicios disponibles aqu\xed o en la farmacia.","cards":[{"heading":"Informaci\xf3n y horarios","description":"Obtenga horarios actualizados para que pueda obtener respuestas actualizadas a sus preguntas de salud.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Informaci\xf3n y horarios de operaci\xf3n","heading":"Tienes preguntas. Tenemos respuestas.","description":"\xbfNo est\xe1s seguro(a) de c\xf3mo navegar por los medicamentos de venta libre o receta m\xe9dica? \xbfQuieres consejos sobre c\xf3mo mantenerte activo? \xbfNecesitas ayuda para usar un nuevo dispositivo de salud? Nuestros Aesores de salud est\xe1n aqu\xed para ayudarte a responder estas preguntas y m\xe1s.","hoursTitle":"Horario de Health Corner","advisorsDescription":"Nuestros asesores de salud son un equipo amigable y cl\xednicamente capacitado que est\xe1 aqu\xed para ayudarte a navegar tus necesidades de salud. Ellos te conocer\xe1n en cada visita e interacci\xf3n, brind\xe1ndote atenci\xf3n personalizada y continua. Desde ayuda para encontrar informaci\xf3n de salud hasta consejos sobre nutrici\xf3n y como mantenerte activo(a), est\xe1n aqu\xed para ayudarte.","learnMore":"Si deseas obtener m\xe1s informaci\xf3n, ingresa a <br>https://www.walgreenshealth.com/clover-health/home<br> en tu tel\xe9fono m\xf3vil o dispositivo personal.","legalText":"Los servicios de Walgreens Health Corner no est\xe1n dise\xf1ados para usarse en casos de atenci\xf3n o como servicios m\xe9dicos de emergencia. La informaci\xf3n proporcionada no sustituye el consejo cl\xednico de tu m\xe9dico. Si necesitas atenci\xf3n m\xe9dica inmediata, comun\xedcate con tu m\xe9dico o ve a la sala de emergencias m\xe1s cercana. Consulta a tu m\xe9dico para el diagn\xf3stico y tratamiento de tu condici\xf3n m\xe9dica o enfermedad."},"connectedDevices":{"title":"Dispositivos Inteligentes de Monitoreo de la Salud","heading":"Monitorea tu salud con dispositivos inteligentes","description":"Los dispositivos conectados utilizan tecnolog\xeda Bluetooth para monitorear, enviar alertas y sincronizar datos a trav\xe9s de una aplicaci\xf3n en tu tel\xe9fono inteligente o tableta.","devices":[{"title":"Withings Rastreador de actividad","id":"withings-activity-tracker","name":"Withings Rastreador de actividad","body":"Estilo cl\xe1sico. Rastreo avanzado.","img":"assets/connectedDevices/devices/activity-tracker-large.png","thumbnail":"assets/connectedDevices/devices/activity-tracker.png","attributes":[{"title":"Rastreo Constante","body":"Rastrea autom\xe1ticamente caminatas, trotes acelerados, nado y detecta f\xe1cilmente otras 30+ actividades. Tiene una modalidad para ejercicio y puede conectarse al GPS. Visualiza los datos recientes desde tu tel\xe9fono inteligente.","icon":"assets/devices/device-walking.svg"},{"title":"Durable","body":"Bater\xeda de hasta 18 meses de vida y resistencia al agua hasta de 50m.","icon":"assets/devices/device-calendar.svg"},{"title":"Medidor de descanso","body":"Muestra un Puntaje de descanso y estados ligeros y profundos del sue\xf1o, adem\xe1s de alarma silenciosa y Despertador inteligente.","icon":"assets/devices/device-sleep-tracking.svg"}]},{"title":"Withings Tapete de descanso","id":"withings-sleep-mat","name":"Withings Tapete de descanso","body":"Mejores noches para mejores d\xedas.","img":"assets/connectedDevices/devices/sleep-mat-large.png","thumbnail":"assets/connectedDevices/devices/sleep-mat.png","attributes":[{"title":"Nada que llevar","body":"Sencilla programaci\xf3n de una sola vez debajo del colch\xf3n, compatible con la mayor\xeda de los colchones. Despi\xe9rtate ante resultados inmediatos en la aplicaci\xf3n que puedes compartir f\xe1cilmente con tu doctor como un PDF que contenga los datos recabados por la aplicaci\xf3n.","icon":"assets/devices/checkbox.svg"},{"title":"Rastreador avanzado de descanso","body":"Obt\xe9n un an\xe1lisis profundo de tu noche con sus ciclos del sue\xf1o, ritmo cardiaco continuo y detecci\xf3n de ronquidos. Aprende sobre qu\xe9 tan reparador fue tu sue\xf1o con el Medidor de descanso.","icon":"assets/devices/sleep-tracking.svg"},{"title":"Automatizaci\xf3n del Hogar","body":"Controla las luces, la temperatura y otros dispositivos inteligentes disponibles en tu hogar solamente subiendo y bajando de tu cama.","icon":"assets/devices/home.svg"}]},{"title":"Withings B\xe1scula","id":"withings-scale","name":"Withings B\xe1scula","body":"Metas de salud. Hechas a tu medida.","img":"assets/connectedDevices/devices/withings-scale-large.png","thumbnail":"assets/connectedDevices/devices/withings-scale.png","attributes":[{"title":"Informaci\xf3n sobre tu peso al instante","body":"Monitorea tu progreso y mantente motivado durante cada valoraci\xf3n de peso con pantallas que muestran tu m\xe1s reciente peso e IMC.","icon":"assets/devices/graph.svg"},{"title":"Sincronizaci\xf3n Autom\xe1tica","body":"Los datos de cada valoraci\xf3n de peso aparencen en la aplicaci\xf3n de Health Mate autom\xe1ticamente al conectarse v\xeda Wifi.","icon":"assets/devices/bluetooth.svg"},{"title":"Amigable para usarse con multiples usuarios","body":"Reconoce hasta 8 usuarios con sincronizaci\xf3n independiente.","icon":"assets/devices/multi-user.svg"}]},{"title":"Withings Brazalete medidor de presi\xf3n arterial","id":"withings-blood-pressure-cuff","name":"Withings Brazalete medidor de presi\xf3n arterial","body":"F\xe1cil de usar. F\xe1cil de leer.","img":"assets/connectedDevices/devices/withings-blood-pressure-cuff-large.png","thumbnail":"assets/connectedDevices/devices/withings-blood-pressure-cuff.png","attributes":[{"title":"Accesibilidad y precisi\xf3n m\xe9dica","body":"Monitoreo cl\xednicamente validado de tu presi\xf3n arterial con resultados precisos en los que puedes confiar. Sube de nivel tus revisiones m\xe9dicas compartiendo tu diario de salud con los profesionales de la salud que te atienden.","icon":"assets/devices/graph.svg"},{"title":"F\xe1cil de leer","body":"Incluso antes de abrir la aplicaci\xf3n, obt\xe9n retroalimentaci\xf3n instant\xe1nea y codificada con colores en la pantalla LED que te muestra tus resultados en un s\xf3lo vistazo.","icon":"assets/devices/glasses.svg"},{"title":"F\xe1cil de usar","body":"Con s\xf3lo oprimir un bot\xf3n y sincronizaci\xf3n autom\xe1tica de Wi-Fi a la aplicaci\xf3n de Health Mate, nuestros dispositivos son la manera m\xe1s simple de medir y monitorear con precisi\xf3n la presi\xf3n arterial en tiempo real.","icon":"assets/devices/bluetooth.svg"}]}]},"services":{"title":"Servicios Ofrecidos","heading":"Una nueva manera para cuidar de tu salud","description":"Conoce a nuestros amables Asesores de Salud que pueden ayudarte a responder preguntas y a elegir pruebas y servicios disponibles aqu\xed o en la farmacia. Adem\xe1s, los miembros de Clover pueden acceder a servicios adicionales aqu\xed en Walgreens Health Corner.","cards":[{"title":"Preguntas sobre salud","icon":"assets/services/help_icon.svg","subTitle":"Obt\xe9n asistencia y respuestas a tus preguntas","highlightedText":"Tomar mejores decisiones de bienestar para tu salud puede ser confuso a veces. Pasa tiempo uno a uno con un Asesor de Salud de Walgreens y obtenga respuestas a algunas de las preguntas que tengas.","additionalText":"Desde consejos sobre medicamentos de venta libre y suplementos hasta nutrici\xf3n, pregunta a un asesor de salud de Walgreens que tenga experiencia cl\xednica para ayudarte a encontrar respuestas a tus preguntas.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Dispositivos de Monitoreo de la Salud","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Obt\xe9n ayuda para configurar dispositivos de monitoreo de salud","highlightedText":"Los dispositivos de monitoreo de la salud pueden mostrarte los cambios diarios en tu salud mediante el control de aspectos como la presi\xf3n arterial, la actividad, el sue\xf1o y m\xe1s.","additionalText":"Aprende a configurar y usar dispositivos de salud port\xe1tiles o en el hogar que pueden ayudarte a comprender mejor tu salud.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Vacuna contra la Influenza","icon":"assets/services/syringe_icon.svg","subTitle":"Obt\xe9n una Vacuna contra la Influenza hoy","highlightedText":"Las vacunas contra la influenza estacional pueden ayudarte a reducir el riesgo de contraer ciertas cepas del virus de la influenza.","additionalText":"La vacuna puede reducir las enfermedades gripales, las visitas al m\xe9dico y las ausencias al trabajo y a la escuela debido a la influenza, as\xed como prevenir las hospitalizaciones y muertes relacionadas con la influenza.. <br /><br /> Habla con un asesor de salud o farmac\xe9utico para vacunarte contra la influenza.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Medici\xf3n de riesgos para la salud","icon":"assets/services/test_results_icon.svg","availability":"S\xf3lo miembros de Clover","subTitle":"Los miembros de Clover Health son acreedores a una evaluaci\xf3n de riesgos para la salud","highlightedText":"Queremos ayudarte a estar tan saludable como sea posible con asistencia y cuidados para la salud que son seleccionados espec\xedficamente para ti.","additionalText":"Un Asesor de salud te guiar\xe1 a trav\xe9s de un cuestionario que eval\xfaa aspectos con respecto a tu estilo de vida y factores de riesgo tales como, nutrici\xf3n, ejercicio, estr\xe9s, sue\xf1o y salud mental.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Obt\xe9n una medici\xf3n de presi\xf3n arterial","icon":"assets/services/bp_icon.svg","availability":"S\xf3lo miembros de Clover","subTitle":"Los miembros de Clover Health son acreedores a una medici\xf3n de presi\xf3n arterial","highlightedText":"Monitorear tu presi\xf3n arterial es importante para reducir el riesgo de paro cardiaco y apoplej\xeda.","additionalText":"La presi\xf3n arterial alta no suele presentar s\xedntomas y frecuentemente se desarrolla lentamente; por lo tanto, es importante que midas tu presi\xf3n arterial regularmente.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Medici\xf3n de IMC","icon":"assets/services/bmi_icon.svg","availability":"S\xf3lo miembros de Clover","subTitle":"Los miembros de Clover Health son acreedores a una medici\xf3n de IMC","highlightedText":"El \xedndice de masa corporal (IMC) es usado para medir la grasa corporal y si una persona se encuentra en un peso saludable.","additionalText":"Los altos niveles de grasa corporal pueden estar relacionados a un mayor riesgo de sufrir algunas enfermedades. El IMC es un c\xe1lculo basado en la altura y el peso.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Prueba de A1C","icon":"assets/services/drop_icon.svg","availability":"S\xf3lo miembros de Clover","subTitle":"Los miembros de Clover Health son acreedores a una prueba A1C","highlightedText":"La prueba A1C—tambi\xe9n conocida como prueba de hemoglobina A1C o prueba de hemoglobina glicosilada HbA1c— es una sencilla prueba de sangre que mide el promedio de tus niveles de az\xfacar de los \xfaltimos 2 a tres meses.","additionalText":"Es una de las pruebas m\xe1s usadas para diagnosticar la prediabetes y la diabetes y es tambi\xe9n la principal prueba para ayudarte a ti y a tu equipo de salud a manejar tu diabetes.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Informaci\xf3n did\xe1ctica sobre medicinas","icon":"assets/services/medication_info_icon.svg","availability":"S\xf3lo miembros de Clover","subTitle":"Los miembros de Clover Health pueden obtener informaci\xf3n did\xe1ctica con respecto a sus medicinas","highlightedText":"Tomar las medicinas como son prescritas es importante para controlar condiciones cr\xf3nicas, tratar condiciones temporales y en general, para procurar una buena salud y bienestar a largo plazo.","additionalText":"Obt\xe9n informaci\xf3n did\xe1ctica general acerca de las prescripciones que tomas para tu condici\xf3n de salud.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Escaneo de C\xe1ncer colorectal en casa","icon":"assets/services/home_icon.svg","availability":"S\xf3lo miembros de Clover","subTitle":"Los miembros de Clover Health obtienen un kit de escaneo para detectar el C\xe1ncer colorrectal en casa","highlightedText":"Un examen de escaneo puede hacerse en la comodidad de tu hogar y es usado para buscar anomal\xedas colorrectales cuando una persona no presenta s\xedntomas.","additionalText":"YLos escaneos que detectan el c\xe1ncer colorrectal deben comenzar a hacerse tan pronto como se cumplen 50 a\xf1os, despu\xe9s de eso deber\xe1s realizar ex\xe1menes peri\xf3dicamente.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."},{"title":"Prueba de Nefropat\xeda Diab\xe9tica","icon":"assets/services/microscope_icon.svg","availability":"S\xf3lo miembros de Clover","subTitle":"Los Miembros de Clover Health pueden obtener una Prueba de Nefropat\xeda Diab\xe9tica","highlightedText":"Se puede realizar una prueba de detecci\xf3n en la comodidad de su hogar con una simple recolecci\xf3n de orina que puede detectar la presencia de prote\xednas.","additionalText":"Se recomienda la prueba de nefropat\xeda diab\xe9tica para adultos diagnosticados con diabetes. El comienzo y la duraci\xf3n de tus pruebas de detecci\xf3n pueden variar seg\xfan tu progreso y el tipo de diabetes que te hayan diagnosticado.","headerColor":"#ffffff","headerBackgroundColor":"#0c6d5e","headerLogo":"assets/services/clover-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Clover."}],"appointment":{"title":"Programa una cita","phoneNumber":"Llama al: 877-645-4128"}}},"buckeye":{"home":{"title":"Inicio","heading":"Bienvenido a tus cuidados de salud sin la m\xfasica de espera.","cards":[{"title":"Sobre Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Conoce a tus Asesores de Salud y m\xe1s informaci\xf3n sobre el horario de Walgreens Health Corner"},{"title":"Servicios que ofrecemos","link":"services","icon":"assets/home/store.svg","description":"Acceso conveniente a asistencia y ayuda personalizadas para tu salud, basadas en la elegibilidad de tu plan de salud."},{"title":"Dispositivos conectados","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitorea y rastrea tu salud con dispositivos inteligentes que miden tu progreso a trav\xe9s del tiempo."}],"descriptionBold":"Walgreens Health Corner","description":"es una sencilla, nueva forma de hacerte cargo de tus tareas de salud. Los miembros de selectos proveedores de seguros m\xe9dicos obtienen servicios especializados sin pagos duplicados ni citas."},"about":{"title":"Acerca de Walgreens Health Corner","heading":"Sobre Walgreens Health Corner","description":"Consulte nuestros horarios y conozca a nuestros amigables asesores de salud que pueden ayudarlo a responder preguntas y guiarlo para seleccionar pruebas y servicios disponibles aqu\xed o en la farmacia.","cards":[{"heading":"Informaci\xf3n y horarios","description":"Obtenga horarios actualizados para que pueda obtener respuestas actualizadas a sus preguntas de salud.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Informaci\xf3n y horarios de operaci\xf3n","heading":"Tienes preguntas. Tenemos respuestas.","description":"\xbfNo est\xe1s seguro(a) de c\xf3mo navegar por los medicamentos de venta libre o receta m\xe9dica? \xbfQuieres consejos sobre c\xf3mo mantenerte activo? \xbfNecesitas ayuda para usar un nuevo dispositivo de salud? Nuestros Aesores de salud est\xe1n aqu\xed para ayudarte a responder estas preguntas y m\xe1s.","hoursTitle":"Horario de Health Corner","advisorsDescription":"Nuestros asesores de salud son un equipo amigable y cl\xednicamente capacitado que est\xe1 aqu\xed para ayudarte a navegar tus necesidades de salud. Ellos te conocer\xe1n en cada visita e interacci\xf3n, brind\xe1ndote atenci\xf3n personalizada y continua. Desde ayuda para encontrar informaci\xf3n de salud hasta consejos sobre nutrici\xf3n y como mantenerte activo(a), est\xe1n aqu\xed para ayudarte.","learnMore":"Si deseas obtener m\xe1s informaci\xf3n, ingresa a <br>https://www.walgreenshealth.com/buckeyehealthplan/home<br> en tu tel\xe9fono m\xf3vil o dispositivo personal.","legalText":"Los servicios de Walgreens Health Corner no est\xe1n dise\xf1ados para usarse en casos de atenci\xf3n o como servicios m\xe9dicos de emergencia. La informaci\xf3n proporcionada no sustituye el consejo cl\xednico de tu m\xe9dico. Si necesitas atenci\xf3n m\xe9dica inmediata, comun\xedcate con tu m\xe9dico o ve a la sala de emergencias m\xe1s cercana. Consulta a tu m\xe9dico para el diagn\xf3stico y tratamiento de tu condici\xf3n m\xe9dica o enfermedad."},"connectedDevices":{"title":"Dispositivos Inteligentes de Monitoreo de la Salud","heading":"Monitorea tu salud con dispositivos inteligentes","description":"Simplifica la forma en que rastreas tu progreso o identificas cambios importantes en tu salud con dispositivos que sincronizan la informaci\xf3n a trav\xe9s de una aplicaci\xf3n en tu tel\xe9fono inteligente o tu tableta electr\xf3nica.","devices":[{"title":"Omron Serie 10 Monitor de presi\xf3n arterial","name":"Omron Serie 10 Monitor de presi\xf3n arterial","img":"assets/connectedDevices/devices/omron-bp-monitor-large.png","thumbnail":"assets/connectedDevices/devices/omron-bp-monitor.png","id":"omron-10-series-blood-pressure-monitor","body":"C\xf3modo y f\xe1cil de leer.","attributes":[{"title":"Tecnolog\xeda de precision avanzada","body":"Minimiza el posible impacto que pudieran tener tus movimientos y tu respiraci\xf3n en los resultados de la lectura de tu presi\xf3n arterial, ayudando a reducir errores e inconsistencias en la medici\xf3n.","icon":"assets/devices/device-health-dashboard.svg"},{"title":"Intervalos y usuarios personalizables","body":"Realiza 3 lecturas consecutivas en intervalos que puedes personalizar. Observa tu lectura anterior junto a la lectura actual para una comparaci\xf3n inmediata. Permite dos usuarios.","icon":"assets/devices/device-clock.svg"},{"title":"C\xf3modo y f\xe1cil de leer","body":"La pantalla LCD retroiluminada cuenta con una pantalla retroiluminada negra de alto contraste con n\xfameros extra grandes para obtener resultados f\xe1ciles de leer.","icon":"assets/devices/device-optical.svg"}]},{"title":"KardiaMobile Monitor personal ECG","id":"kardiamobile-personal-ekg-monitor","name":"KardiaMobile Monitor personal ECG","body":"Revisa la salud de tu coraz\xf3n desde casa","img":"assets/connectedDevices/devices/kardiamobile-ekg-monitor-large.png","thumbnail":"assets/connectedDevices/devices/kardiamobile-ekg-monitor.png","attributes":[{"title":"Detecci\xf3n en tiempo real","body":"Detecta los tres tipos m\xe1s comunes de arritmia: Fibrilaci\xf3n auricular, bradicardia y taquicardia y saber al instante si tu ritmo card\xedaco es normal te brindar\xe1 tranquilidad.","icon":"assets/devices/device-heart-blood-pressure.svg"},{"title":"F\xe1cil de usar","body":"Simplemente coloca tus dedos en los sensores—sin cables, parches, o geles.","icon":"assets/devices/device-bluetooth.svg"},{"title":"Almacena o comparte en segundos","body":"Almacena tus ECGs en tu tel\xe9fono o env\xedale un correo a tu doctor con solo apretar un bot\xf3n.","icon":"assets/devices/device-share.svg"}]},{"title":"OneTouch Verio Reflect Medidor de Glucosa","id":"onetouch-verio-reflect-glucose-meter","name":"OneTouch Verio Reflect Medidor de Glucosa","body":"Informaci\xf3n personalizada para ayudarte a manejar tu diabetes","img":"assets/connectedDevices/devices/onetouch-glucose-meter-large.png","thumbnail":"assets/connectedDevices/devices/onetouch-glucose-meter.png","disclaimer":"ATENCI\xd3N PACIENTES DE MEDICARE: Disponible solo para compra en l\xednea. Walgreens.com NO es un proveedor acreditado de Medicare. Si compra equipos o suministros m\xe9dicos en la secci\xf3n Soluciones para el cuidado de la salud en el hogar de nuestro sitio web y env\xeda un reclamo a Medicare por esos art\xedculos, Medicare no pagar\xe1. Usted es total y personalmente responsable del pago de cualquier equipo o suministros m\xe9dicos que compre en este sitio web).","attributes":[{"title":"Aprende a controlar mejor tu diabetes","body":"Informaci\xf3n personalizada dentro de la aplicaci\xf3n, gu\xeda y \xe1nimos para ayudar a los pacientesa controlar su diabetes.","icon":"assets/devices/device-blood-glucose.svg"},{"title":"Lee y act\xfaa en tiempo real","body":"El indicador de rango din\xe1mico ColorSure, muestra cuando los resultados son bajos, altos o dentro del rango para que puedas tomar medidas.","icon":"assets/devices/device-graph.svg"},{"title":"Tiras reactivas confiables","body":"Utiliza tiras reactivas OneTouch Verio con 9 a\xf1os de precisi\xf3n probada a niveles muy bajos y muy altos de glucosa en sangre.","icon":"assets/devices/device-blood.svg"}]},{"title":"iChoice Ox\xedmetro de pulso","id":"ichoice-pulse-oximeter","name":"iChoice Ox\xedmetro de pulso","body":"Relajaci\xf3n adecuada a tu ritmo card\xedaco","img":"assets/connectedDevices/devices/ichoice-pulse-oximeter-large.png","thumbnail":"assets/connectedDevices/devices/ichoice-pulse-oximeter.png","attributes":[{"title":"Lecturas en tiempo real","body":"Mide el nivel de Ox\xedgeno, Ritmo card\xedaco y el nivel de Calma/Estr\xe9s. El sensor de huellas transmite lecturas importantes en tiempo real a la aplicaci\xf3n gratuita de iChoice Relax.","icon":"assets/devices/device-heart-blood-pressure.svg"},{"title":"Mejora con t\xe9cnicas de entrenamiento","body":"Sigue un marcador de respiraci\xf3n liderado por el ritmo de tu coraz\xf3n para reducir la ansiedad y el estr\xe9s. Aprende a respirar a tu mejor frecuencia respiratoria de relajaci\xf3n personal.","icon":"assets/devices/device-trophy.svg"},{"title":"Duerme mejor","body":"Utiliza videos y sonidos relajantes en la aplicaci\xf3n para ayudarte a dormir.","icon":"assets/devices/device-night.svg"}]}]},"services":{"title":"Servicios Ofrecidos","heading":"Una nueva manera para cuidar de tu salud","description":"Conoce a nuestros amables Asesores de Salud que te ayudar\xe1n con tus preguntas y a elegir pruebas y servicios aqu\xed o en la farmacia. Adem\xe1s, los miembros del Plan de Salud de Buckeye pueden acceder a servicios adicionales aqu\xed en Walgreens Health Corner.","cards":[{"title":"Preguntas sobre salud","icon":"assets/services/help_icon.svg","subTitle":"Obt\xe9n asistencia y respuestas a tus preguntas","highlightedText":"Tomar mejores decisiones de bienestar para tu salud puede ser confuso a veces. Pasa tiempo uno a uno con un Asesor de Salud de Walgreens y obtenga respuestas a algunas de las preguntas que tengas.","additionalText":"Desde consejos sobre medicamentos de venta libre y suplementos hasta nutrici\xf3n, pregunta a un asesor de salud de Walgreens que tenga experiencia cl\xednica para ayudarte a encontrar respuestas a tus preguntas.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye."},{"title":"Dispositivos de Monitoreo de la Salud","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Obt\xe9n ayuda para configurar dispositivos de monitoreo de salud","highlightedText":"Los dispositivos de monitoreo de la salud pueden mostrarte los cambios diarios en tu salud mediante el control de aspectos como la presi\xf3n arterial, la actividad, el sue\xf1o y m\xe1s.","additionalText":"Aprende a configurar y usar dispositivos de salud port\xe1tiles o en el hogar que pueden ayudarte a comprender mejor tu salud.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye."},{"title":"Vacuna contra la Influenza","icon":"assets/services/syringe_icon.svg","subTitle":"Obt\xe9n una Vacuna contra la Influenza hoy","highlightedText":"Las vacunas contra la influenza estacional pueden ayudarte a reducir el riesgo de contraer ciertas cepas del virus de la influenza.","additionalText":"La vacuna puede reducir las enfermedades gripales, las visitas al m\xe9dico y las ausencias al trabajo y a la escuela debido a la influenza, as\xed como prevenir las hospitalizaciones y muertes relacionadas con la influenza.<br> <br> Habla con un asesor de salud o farmac\xe9utico para vacunarte contra la influenza.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye."},{"title":"Medici\xf3n de la salud","icon":"assets/services/test_results_icon.svg","availability":"Solo miembros del Plan de Salud de Buckeye","subTitle":"Los miembros del Plan de Salud de Buckeye son acreedores a una evaluaci\xf3n de riesgos para la salud","highlightedText":"Queremos ayudarte a estar tan saludable como sea posible con asistencia y cuidados para la salud que son seleccionados espec\xedficamente para ti.","additionalText":"Un Asesor de salud te guiar\xe1 a trav\xe9s de un cuestionario que eval\xfaa aspectos con respecto a tu estilo de vida y factores de riesgo tales como, nutrici\xf3n, ejercicio, estr\xe9s, sue\xf1o y salud mental.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Obt\xe9n una medici\xf3n de presi\xf3n arterial","icon":"assets/services/bp_icon.svg","availability":"Solo miembros del Plan de Salud de Buckeye","subTitle":"Los miembros del Plan de Salud de Buckeye son acreedores a una medici\xf3n de presi\xf3n arterial","highlightedText":"Monitorear tu presi\xf3n arterial es importante para reducir el riesgo de paro cardiaco y apoplej\xeda.","additionalText":"La presi\xf3n arterial alta no suele presentar s\xedntomas y frecuentemente se desarrolla lentamente; por lo tanto, es importante que midas tu presi\xf3n arterial regularmente.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Medici\xf3n de IMC","icon":"assets/services/bmi_icon.svg","availability":"Solo miembros del Plan de Salud de Buckeye","subTitle":"Los miembros del Plan de Salud de Buckeye son acreedores a una medici\xf3n de IMC","highlightedText":"El \xedndice de masa corporal (IMC) es usado para medir la grasa corporal y si una persona se encuentra en un peso saludable.","additionalText":"Los altos niveles de grasa corporal pueden estar relacionados a un mayor riesgo de sufrir algunas enfermedades. El IMC es un c\xe1lculo basado en la altura y el peso.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Prueba de A1C","icon":"assets/services/drop_icon.svg","availability":"Solo miembros del Plan de Salud de Buckeye","subTitle":"Los miembros del Plan de Salud de Buckeye son acreedores a una prueba A1C","highlightedText":"La prueba A1C—tambi\xe9n conocida como prueba de hemoglobina A1C o prueba de hemoglobina glicosilada HbA1c— es una sencilla prueba de sangre que mide el promedio de tus niveles de az\xfacar de los \xfaltimos 2 a tres meses.","additionalText":"Es una de las pruebas m\xe1s usadas para diagnosticar la prediabetes y la diabetes y es tambi\xe9n la principal prueba para ayudarte a ti y a tu equipo de salud a manejar tu diabetes.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Coordinaci\xf3n de cuidados para mamograf\xeda","icon":"assets/services/selfcare_icon.svg","availability":"Solo miembros del Plan de Salud de Buckeye","subTitle":"Los miembros del Plan de Salud de Buckeye obtienen coordinaci\xf3n de cuidados para mamograf\xeda","highlightedText":"Un escaneo para el c\xe1ncer de seno es un examen importante que permite la detecci\xf3n temprana del c\xe1ncer antes de que haya signos o s\xedntomas de la enfermedad.","additionalText":"A pesar de no poder prevenir el c\xe1ncer de seno, los ex\xe1menes de escaneo (como las mamograf\xedas anuales) se prescriben de manera rutinaria para detectar el c\xe1ncer de mama de forma temprana, cuando es m\xe1s f\xe1cil de tratar.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Escaneo de C\xe1ncer colorectal en casa","icon":"assets/services/home_icon.svg","availability":"Solo miembros del Plan de Salud de Buckeye","subTitle":"Los miembros del Plan de Salud de Buckeye obtienen un kit de escaneo para detectar el C\xe1ncer colorrectal en casa","highlightedText":"Un examen de escaneo puede hacerse en la comodidad de tu hogar y es usado para buscar anomal\xedas colorrectales cuando una persona no presenta s\xedntomas.","additionalText":"Los escaneos que detectan el c\xe1ncer colorrectal deben comenzar a hacerse tan pronto como se cumplen 50 a\xf1os, despu\xe9s de eso deber\xe1s realizar ex\xe1menes peri\xf3dicamente.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"},{"title":"Prueba de Nefropat\xeda Diab\xe9tica","icon":"assets/services/microscope_icon.svg","availability":"Solo miembros del Plan de Salud de Buckeye","subTitle":"Los miembros del Plan de Salud de Buckeye pueden obtener una Prueba de Nefropat\xeda Diab\xe9tica","highlightedText":"Se puede realizar una prueba de detecci\xf3n en la comodidad de su hogar con una simple recolecci\xf3n de orina que puede detectar la presencia de prote\xednas.","additionalText":"Se recomienda la prueba de nefropat\xeda diab\xe9tica para adultos diagnosticados con diabetes. El comienzo y la duraci\xf3n de tus pruebas de detecci\xf3n pueden variar seg\xfan tu progreso y el tipo de diabetes que te hayan diagnosticado.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Buckeye.","headerColor":"#ffffff","headerBackgroundColor":"#859c32","headerLogo":"assets/services/buckeye-logo.png"}],"appointment":{"title":"Programa una cita","phoneNumber":"Llama al: 877-645-4128"}}},"horizon":{"home":{"title":"Inicio","heading":"Bienvenido a tus cuidados de salud sin la m\xfasica de espera.","cards":[{"title":"Sobre Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Conoce a tus Asesores de Salud y m\xe1s informaci\xf3n sobre el horario de Walgreens Health Corner."},{"title":"Servicios que ofrecemos","link":"services","icon":"assets/home/store.svg","description":"Acceso conveniente a asistencia y ayuda personalizadas para tu salud, basadas en la elegibilidad de tu plan de salud."},{"title":"Dispositivos conectados","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitorea y rastrea tu salud con dispositivos inteligentes que miden tu progreso a trav\xe9s del tiempo."}],"descriptionBold":"Walgreens Health Corner","description":"es una sencilla, nueva forma de hacerte cargo de tus tareas de salud. Los miembros de selectos proveedores de seguros m\xe9dicos obtienen servicios especializados sin pagos duplicados ni citas."},"feedback":{"title":"Deja tus Comentarios","heading":"Tu opini\xf3n es importante","description":"Para ayudarnos a mejorar futuras visitas a Health Corner, por favor, h\xe1ganos saber lo que piensa de su experiencia de hoy. Su respuesta solo se utilizar\xe1 para ayudarnos a nosotros y a su plan de salud a comprender c\xf3mo podemos mejorar su pr\xf3xima visita.","surveyHeading":"Completa la encuesta en su dispositivo","surveyQrCodeLink":"assets/feedback/surveyQrCodeNJ.png","surveyQrCodeLinkAlt":"c\xf3digo QR de la encuesta","phoneHeading":"iPhone & Nuevo Android","phoneDescription":"Simplemente apunte su c\xe1mara al c\xf3digo QR a la derecha para iniciar autom\xe1ticamente la encuesta.","oldPhoneHeading":"Android m\xe1s antiguo","oldPhoneDescription":"Descargue una aplicaci\xf3n de lector de c\xf3digos QR desde Play Store. Escanee el c\xf3digo con la aplicaci\xf3n de c\xf3digo QR."},"about":{"title":"Acerca de Walgreens Health Corner","heading":"Sobre Walgreens Health Corner","description":"Consulte nuestros horarios y conozca a nuestros amigables asesores de salud que pueden ayudarlo a responder preguntas y guiarlo para seleccionar pruebas y servicios disponibles aqu\xed o en la farmacia.","cards":[{"heading":"Informaci\xf3n y horarios","description":"Obtenga horarios actualizados para que pueda obtener respuestas actualizadas a sus preguntas de salud.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Informaci\xf3n y horarios de operaci\xf3n","heading":"Tienes preguntas. Tenemos respuestas.","description":"\xbfNo est\xe1s seguro(a) de c\xf3mo navegar por los medicamentos de venta libre o receta m\xe9dica? \xbfQuieres consejos sobre c\xf3mo mantenerte activo? \xbfNecesitas ayuda para usar un nuevo dispositivo de salud? Nuestros Aesores de salud est\xe1n aqu\xed para ayudarte a responder estas preguntas y m\xe1s.","hoursTitle":"Horario de Health Corner","advisorsDescription":"Nuestros asesores de salud son un equipo amigable y cl\xednicamente capacitado que est\xe1 aqu\xed para ayudarte a navegar tus necesidades de salud. Ellos te conocer\xe1n en cada visita e interacci\xf3n, brind\xe1ndote atenci\xf3n personalizada y continua. Desde ayuda para encontrar informaci\xf3n de salud hasta consejos sobre nutrici\xf3n y como mantenerte activo(a), est\xe1n aqu\xed para ayudarte.","legalText":"Los servicios de Walgreens Health Corner no est\xe1n dise\xf1ados para usarse en casos de atenci\xf3n o como servicios m\xe9dicos de emergencia. La informaci\xf3n proporcionada no sustituye el consejo cl\xednico de tu m\xe9dico. Si necesitas atenci\xf3n m\xe9dica inmediata, comun\xedcate con tu m\xe9dico o ve a la sala de emergencias m\xe1s cercana. Consulta a tu m\xe9dico para el diagn\xf3stico y tratamiento de tu condici\xf3n m\xe9dica o enfermedad."},"connectedDevices":{"title":"Dispositivos Inteligentes de Monitoreo de la Salud","heading":"Monitorea tu salud con dispositivos inteligentes","description":"Los dispositivos conectados utilizan tecnolog\xeda Bluetooth para monitorear, enviar alertas y sincronizar datos a trav\xe9s de una aplicaci\xf3n en tu tel\xe9fono inteligente o tableta.","devices":[{"title":"Withings Rastreador de actividad","id":"withings-activity-tracker","name":"Withings Rastreador de actividad","body":"Estilo cl\xe1sico. Rastreo avanzado.","img":"assets/connectedDevices/devices/activity-tracker-large.png","thumbnail":"assets/connectedDevices/devices/activity-tracker.png","attributes":[{"title":"Rastreo Constante","body":"Rastrea autom\xe1ticamente caminatas, trotes acelerados, nado y detecta f\xe1cilmente otras 30+ actividades. Tiene una modalidad para ejercicio y puede conectarse al GPS. Visualiza los datos recientes desde tu tel\xe9fono inteligente.","icon":"assets/devices/device-walking.svg"},{"title":"Durable","body":"Bater\xeda de hasta 18 meses de vida y resistencia al agua hasta de 50m.","icon":"assets/devices/device-calendar.svg"},{"title":"Medidor de descanso","body":"Muestra un Puntaje de descanso y estados ligeros y profundos del sue\xf1o, adem\xe1s de alarma silenciosa y Despertador inteligente.","icon":"assets/devices/device-sleep-tracking.svg"}]},{"title":"Withings Tapete de descanso","id":"withings-sleep-mat","name":"Withings Tapete de descanso","body":"Mejores noches para mejores d\xedas.","img":"assets/connectedDevices/devices/sleep-mat-large.png","thumbnail":"assets/connectedDevices/devices/sleep-mat.png","attributes":[{"title":"Nada que llevar","body":"Sencilla programaci\xf3n de una sola vez debajo del colch\xf3n, compatible con la mayor\xeda de los colchones. Despi\xe9rtate ante resultados inmediatos en la aplicaci\xf3n que puedes compartir f\xe1cilmente con tu doctor como un PDF que contenga los datos recabados por la aplicaci\xf3n.","icon":"assets/devices/checkbox.svg"},{"title":"Rastreador avanzado de descanso","body":"Obt\xe9n un an\xe1lisis profundo de tu noche con sus ciclos del sue\xf1o, ritmo cardiaco continuo y detecci\xf3n de ronquidos. Aprende sobre qu\xe9 tan reparador fue tu sue\xf1o con el Medidor de descanso.","icon":"assets/devices/sleep-tracking.svg"},{"title":"Automatizaci\xf3n del Hogar","body":"Controla las luces, la temperatura y otros dispositivos inteligentes disponibles en tu hogar solamente subiendo y bajando de tu cama.","icon":"assets/devices/home.svg"}]},{"title":"Withings B\xe1scula","id":"withings-scale","name":"Withings B\xe1scula","body":"Metas de salud. Hechas a tu medida.","img":"assets/connectedDevices/devices/withings-scale-large.png","thumbnail":"assets/connectedDevices/devices/withings-scale.png","attributes":[{"title":"Informaci\xf3n sobre tu peso al instante","body":"Monitorea tu progreso y mantente motivado durante cada valoraci\xf3n de peso con pantallas que muestran tu m\xe1s reciente peso e IMC.","icon":"assets/devices/graph.svg"},{"title":"Sincronizaci\xf3n Autom\xe1tica","body":"Los datos de cada valoraci\xf3n de peso aparencen en la aplicaci\xf3n de Health Mate autom\xe1ticamente al conectarse v\xeda Wifi.","icon":"assets/devices/bluetooth.svg"},{"title":"Amigable para usarse con multiples usuarios","body":"Reconoce hasta 8 usuarios con sincronizaci\xf3n independiente.","icon":"assets/devices/multi-user.svg"}]},{"title":"Withings Brazalete medidor de presi\xf3n arterial","id":"withings-blood-pressure-cuff","name":"Withings Brazalete medidor de presi\xf3n arterial","body":"F\xe1cil de usar. F\xe1cil de leer.","img":"assets/connectedDevices/devices/withings-blood-pressure-cuff-large.png","thumbnail":"assets/connectedDevices/devices/withings-blood-pressure-cuff.png","attributes":[{"title":"Accesibilidad y precisi\xf3n m\xe9dica","body":"Monitoreo cl\xednicamente validado de tu presi\xf3n arterial con resultados precisos en los que puedes confiar. Sube de nivel tus revisiones m\xe9dicas compartiendo tu diario de salud con los profesionales de la salud que te atienden.","icon":"assets/devices/graph.svg"},{"title":"F\xe1cil de leer","body":"Incluso antes de abrir la aplicaci\xf3n, obt\xe9n retroalimentaci\xf3n instant\xe1nea y codificada con colores en la pantalla LED que te muestra tus resultados en un s\xf3lo vistazo.","icon":"assets/devices/glasses.svg"},{"title":"F\xe1cil de usar","body":"Con s\xf3lo oprimir un bot\xf3n y sincronizaci\xf3n autom\xe1tica de Wi-Fi a la aplicaci\xf3n de Health Mate, nuestros dispositivos son la manera m\xe1s simple de medir y monitorear con precisi\xf3n la presi\xf3n arterial en tiempo real.","icon":"assets/devices/bluetooth.svg"}]}]},"services":{"title":"Servicios Ofrecidos","heading":"Una nueva manera para cuidar de tu salud","description":"Conoce a nuestros amables Asesores de Salud que pueden ayudarte a responder preguntas y a elegir pruebas y servicios disponibles aqu\xed o en la farmacia. Adem\xe1s, los miembros de Horizon pueden acceder a servicios adicionales aqu\xed en Walgreens Health Corner.","cards":[{"title":"Preguntas sobre salud","icon":"assets/services/help_icon.svg","subTitle":"Obt\xe9n asistencia y respuestas a tus preguntas","highlightedText":"Tomar mejores decisiones de bienestar para tu salud puede ser confuso a veces. Pasa tiempo uno a uno con un Asesor de Salud de Walgreens y obtenga respuestas a algunas de las preguntas que tengas.","additionalText":"Desde consejos sobre medicamentos de venta libre y suplementos hasta nutrici\xf3n, pregunta a un asesor de salud de Walgreens que tenga experiencia cl\xednica para ayudarte a encontrar respuestas a tus preguntas.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Horizon."},{"title":"Dispositivos de Monitoreo de la Salud","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Obt\xe9n ayuda para configurar dispositivos de monitoreo de salud","highlightedText":"Los dispositivos de monitoreo de la salud pueden mostrarte los cambios diarios en tu salud mediante el control de aspectos como la presi\xf3n arterial, la actividad, el sue\xf1o y m\xe1s.","additionalText":"Aprende a configurar y usar dispositivos de salud port\xe1tiles o en el hogar que pueden ayudarte a comprender mejor tu salud.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Horizon."},{"title":"Vacuna contra la Influenza","icon":"assets/services/syringe_icon.svg","subTitle":"Obt\xe9n una Vacuna contra la Influenza hoy","highlightedText":"Las vacunas contra la influenza estacional pueden ayudarte a reducir el riesgo de contraer ciertas cepas del virus de la influenza.","additionalText":"La vacuna puede reducir las enfermedades gripales, las visitas al m\xe9dico y las ausencias al trabajo y a la escuela debido a la influenza, as\xed como prevenir las hospitalizaciones y muertes relacionadas con la influenza.. <br /><br /> Habla con un asesor de salud o farmac\xe9utico para vacunarte contra la influenza.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Horizon."},{"title":"Obt\xe9n una medici\xf3n de presi\xf3n arterial","icon":"assets/services/bp_icon.svg","availability":"S\xf3lo miembros de Horizon","subTitle":"Los miembros de Horizon Health son acreedores a una medici\xf3n de presi\xf3n arterial","highlightedText":"Monitorear tu presi\xf3n arterial es importante para reducir el riesgo de paro cardiaco y apoplej\xeda.","additionalText":"La presi\xf3n arterial alta no suele presentar s\xedntomas y frecuentemente se desarrolla lentamente; por lo tanto, es importante que midas tu presi\xf3n arterial regularmente.","headerColor":"#ffffff","headerBackgroundColor":"#1F3D7D","headerLogo":"assets/services/horizon-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Horizon."},{"title":"Prueba de A1C","icon":"assets/services/drop_icon.svg","availability":"S\xf3lo miembros de Horizon","subTitle":"Los miembros de Horizon Health son acreedores a una prueba A1C","highlightedText":"La prueba A1C—tambi\xe9n conocida como prueba de hemoglobina A1C o prueba de hemoglobina glicosilada HbA1c— es una sencilla prueba de sangre que mide el promedio de tus niveles de az\xfacar de los \xfaltimos 2 a tres meses.","additionalText":"Es una de las pruebas m\xe1s usadas para diagnosticar la prediabetes y la diabetes y es tambi\xe9n la principal prueba para ayudarte a ti y a tu equipo de salud a manejar tu diabetes.","headerColor":"#ffffff","headerBackgroundColor":"#1F3D7D","headerLogo":"assets/services/horizon-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Horizon."},{"title":"Escaneo de C\xe1ncer colorectal","icon":"assets/services/home_icon.svg","availability":"S\xf3lo miembros de Horizon","subTitle":"Los miembros de Horizon Health obtienen un kit de escaneo para detectar el C\xe1ncer colorrectal","highlightedText":"Un examen de escaneo puede hacerse en la comodidad de tu hogar y es usado para buscar anomal\xedas colorrectales cuando una persona no presenta s\xedntomas.","additionalText":"YLos escaneos que detectan el c\xe1ncer colorrectal deben comenzar a hacerse tan pronto como se cumplen 50 a\xf1os, despu\xe9s de eso deber\xe1s realizar ex\xe1menes peri\xf3dicamente.","headerColor":"#ffffff","headerBackgroundColor":"#1F3D7D","headerLogo":"assets/services/horizon-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Horizon."},{"title":"Cuidado de Adultos 66+","icon":"assets/services/person_with_heart_icon.svg","availability":"S\xf3lo miembros de Horizon","subTitle":"Ayudando a los miembros de Horizon mayores de 66 a\xf1os a obtener la atenci\xf3n que necesitan","highlightedText":"Obteniendo la atenci\xf3n que necesita en esta fase de la vida puede ayudar a mantener o mejorar su calidad de vida para que pueda hacer m\xe1s de lo que le importa","additionalText":"Nuestro equipo de Walgreens Health Corner trabajar\xe1 con usted para brindarle: \\n-Revisi\xf3n de Medicamentos\\n- Evaluaci\xf3n del dolor\\n- Evaluaci\xf3n de ca\xeddas\\n-Evaluaci\xf3n de la Actividad F\xedsica\\n","headerColor":"#ffffff","headerBackgroundColor":"#1F3D7D","headerLogo":"assets/services/horizon-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Horizon."}],"appointment":{"title":"Programa una cita","phoneNumber":"Llama al: 877-645-4128"}}},"braven":{"home":{"title":"Inicio","heading":"Bienvenido a tus cuidados de salud sin la m\xfasica de espera.","cards":[{"title":"Sobre Walgreens Health Corner","link":"about","icon":"assets/home/health-advisor.svg","description":"Conoce a tus Asesores de Salud y m\xe1s informaci\xf3n sobre el horario de Walgreens Health Corner."},{"title":"Servicios que ofrecemos","link":"services","icon":"assets/home/store.svg","description":"Acceso conveniente a asistencia y ayuda personalizadas para tu salud, basadas en la elegibilidad de tu plan de salud."},{"title":"Dispositivos conectados","link":"connectedDevices","icon":"assets/home/connected-devices.svg","description":"Monitorea y rastrea tu salud con dispositivos inteligentes que miden tu progreso a trav\xe9s del tiempo."}],"descriptionBold":"Walgreens Health Corner","description":"es una sencilla, nueva forma de hacerte cargo de tus tareas de salud. Los miembros de selectos proveedores de seguros m\xe9dicos obtienen servicios especializados sin pagos duplicados ni citas."},"feedback":{"title":"Deja tus Comentarios","heading":"Tu opini\xf3n es importante","description":"Para ayudarnos a mejorar futuras visitas a Health Corner, por favor, h\xe1ganos saber lo que piensa de su experiencia de hoy. Su respuesta solo se utilizar\xe1 para ayudarnos a nosotros y a su plan de salud a comprender c\xf3mo podemos mejorar su pr\xf3xima visita.","surveyHeading":"Completa la encuesta en su dispositivo","surveyQrCodeLink":"assets/feedback/surveyQrCodeNJ.png","surveyQrCodeLinkAlt":"c\xf3digo QR de la encuesta","phoneHeading":"iPhone & Nuevo Android","phoneDescription":"Simplemente apunte su c\xe1mara al c\xf3digo QR a la derecha para iniciar autom\xe1ticamente la encuesta.","oldPhoneHeading":"Android m\xe1s antiguo","oldPhoneDescription":"Descargue una aplicaci\xf3n de lector de c\xf3digos QR desde Play Store. Escanee el c\xf3digo con la aplicaci\xf3n de c\xf3digo QR."},"about":{"title":"Acerca de Walgreens Health Corner","heading":"Sobre Walgreens Health Corner","description":"Consulte nuestros horarios y conozca a nuestros amigables asesores de salud que pueden ayudarlo a responder preguntas y guiarlo para seleccionar pruebas y servicios disponibles aqu\xed o en la farmacia.","cards":[{"heading":"Informaci\xf3n y horarios","description":"Obtenga horarios actualizados para que pueda obtener respuestas actualizadas a sus preguntas de salud.","img":"assets/about/caregiver.svg","link":"informationAndHours"}]},"informationAndHours":{"title":"Informaci\xf3n y horarios de operaci\xf3n","heading":"Tienes preguntas. Tenemos respuestas.","description":"\xbfNo est\xe1s seguro(a) de c\xf3mo navegar por los medicamentos de venta libre o receta m\xe9dica? \xbfQuieres consejos sobre c\xf3mo mantenerte activo? \xbfNecesitas ayuda para usar un nuevo dispositivo de salud? Nuestros Aesores de salud est\xe1n aqu\xed para ayudarte a responder estas preguntas y m\xe1s.","hoursTitle":"Horario de Health Corner","advisorsDescription":"Nuestros asesores de salud son un equipo amigable y cl\xednicamente capacitado que est\xe1 aqu\xed para ayudarte a navegar tus necesidades de salud. Ellos te conocer\xe1n en cada visita e interacci\xf3n, brind\xe1ndote atenci\xf3n personalizada y continua. Desde ayuda para encontrar informaci\xf3n de salud hasta consejos sobre nutrici\xf3n y como mantenerte activo(a), est\xe1n aqu\xed para ayudarte.","legalText":"Los servicios de Walgreens Health Corner no est\xe1n dise\xf1ados para usarse en casos de atenci\xf3n o como servicios m\xe9dicos de emergencia. La informaci\xf3n proporcionada no sustituye el consejo cl\xednico de tu m\xe9dico. Si necesitas atenci\xf3n m\xe9dica inmediata, comun\xedcate con tu m\xe9dico o ve a la sala de emergencias m\xe1s cercana. Consulta a tu m\xe9dico para el diagn\xf3stico y tratamiento de tu condici\xf3n m\xe9dica o enfermedad."},"connectedDevices":{"title":"Dispositivos Inteligentes de Monitoreo de la Salud","heading":"Monitorea tu salud con dispositivos inteligentes","description":"Los dispositivos conectados utilizan tecnolog\xeda Bluetooth para monitorear, enviar alertas y sincronizar datos a trav\xe9s de una aplicaci\xf3n en tu tel\xe9fono inteligente o tableta.","devices":[{"title":"Withings Rastreador de actividad","id":"withings-activity-tracker","name":"Withings Rastreador de actividad","body":"Estilo cl\xe1sico. Rastreo avanzado.","img":"assets/connectedDevices/devices/activity-tracker-large.png","thumbnail":"assets/connectedDevices/devices/activity-tracker.png","attributes":[{"title":"Rastreo Constante","body":"Rastrea autom\xe1ticamente caminatas, trotes acelerados, nado y detecta f\xe1cilmente otras 30+ actividades. Tiene una modalidad para ejercicio y puede conectarse al GPS. Visualiza los datos recientes desde tu tel\xe9fono inteligente.","icon":"assets/devices/device-walking.svg"},{"title":"Durable","body":"Bater\xeda de hasta 18 meses de vida y resistencia al agua hasta de 50m.","icon":"assets/devices/device-calendar.svg"},{"title":"Medidor de descanso","body":"Muestra un Puntaje de descanso y estados ligeros y profundos del sue\xf1o, adem\xe1s de alarma silenciosa y Despertador inteligente.","icon":"assets/devices/device-sleep-tracking.svg"}]},{"title":"Withings Tapete de descanso","id":"withings-sleep-mat","name":"Withings Tapete de descanso","body":"Mejores noches para mejores d\xedas.","img":"assets/connectedDevices/devices/sleep-mat-large.png","thumbnail":"assets/connectedDevices/devices/sleep-mat.png","attributes":[{"title":"Nada que llevar","body":"Sencilla programaci\xf3n de una sola vez debajo del colch\xf3n, compatible con la mayor\xeda de los colchones. Despi\xe9rtate ante resultados inmediatos en la aplicaci\xf3n que puedes compartir f\xe1cilmente con tu doctor como un PDF que contenga los datos recabados por la aplicaci\xf3n.","icon":"assets/devices/checkbox.svg"},{"title":"Rastreador avanzado de descanso","body":"Obt\xe9n un an\xe1lisis profundo de tu noche con sus ciclos del sue\xf1o, ritmo cardiaco continuo y detecci\xf3n de ronquidos. Aprende sobre qu\xe9 tan reparador fue tu sue\xf1o con el Medidor de descanso.","icon":"assets/devices/sleep-tracking.svg"},{"title":"Automatizaci\xf3n del Hogar","body":"Controla las luces, la temperatura y otros dispositivos inteligentes disponibles en tu hogar solamente subiendo y bajando de tu cama.","icon":"assets/devices/home.svg"}]},{"title":"Withings B\xe1scula","id":"withings-scale","name":"Withings B\xe1scula","body":"Metas de salud. Hechas a tu medida.","img":"assets/connectedDevices/devices/withings-scale-large.png","thumbnail":"assets/connectedDevices/devices/withings-scale.png","attributes":[{"title":"Informaci\xf3n sobre tu peso al instante","body":"Monitorea tu progreso y mantente motivado durante cada valoraci\xf3n de peso con pantallas que muestran tu m\xe1s reciente peso e IMC.","icon":"assets/devices/graph.svg"},{"title":"Sincronizaci\xf3n Autom\xe1tica","body":"Los datos de cada valoraci\xf3n de peso aparencen en la aplicaci\xf3n de Health Mate autom\xe1ticamente al conectarse v\xeda Wifi.","icon":"assets/devices/bluetooth.svg"},{"title":"Amigable para usarse con multiples usuarios","body":"Reconoce hasta 8 usuarios con sincronizaci\xf3n independiente.","icon":"assets/devices/multi-user.svg"}]},{"title":"Withings Brazalete medidor de presi\xf3n arterial","id":"withings-blood-pressure-cuff","name":"Withings Brazalete medidor de presi\xf3n arterial","body":"F\xe1cil de usar. F\xe1cil de leer.","img":"assets/connectedDevices/devices/withings-blood-pressure-cuff-large.png","thumbnail":"assets/connectedDevices/devices/withings-blood-pressure-cuff.png","attributes":[{"title":"Accesibilidad y precisi\xf3n m\xe9dica","body":"Monitoreo cl\xednicamente validado de tu presi\xf3n arterial con resultados precisos en los que puedes confiar. Sube de nivel tus revisiones m\xe9dicas compartiendo tu diario de salud con los profesionales de la salud que te atienden.","icon":"assets/devices/graph.svg"},{"title":"F\xe1cil de leer","body":"Incluso antes de abrir la aplicaci\xf3n, obt\xe9n retroalimentaci\xf3n instant\xe1nea y codificada con colores en la pantalla LED que te muestra tus resultados en un s\xf3lo vistazo.","icon":"assets/devices/glasses.svg"},{"title":"F\xe1cil de usar","body":"Con s\xf3lo oprimir un bot\xf3n y sincronizaci\xf3n autom\xe1tica de Wi-Fi a la aplicaci\xf3n de Health Mate, nuestros dispositivos son la manera m\xe1s simple de medir y monitorear con precisi\xf3n la presi\xf3n arterial en tiempo real.","icon":"assets/devices/bluetooth.svg"}]}]},"services":{"title":"Servicios Ofrecidos","heading":"Una nueva manera para cuidar de tu salud","description":"Conoce a nuestros amables Asesores de Salud que pueden ayudarte a responder preguntas y a elegir pruebas y servicios disponibles aqu\xed o en la farmacia. Adem\xe1s, los miembros de Braven pueden acceder a servicios adicionales aqu\xed en Walgreens Health Corner.","cards":[{"title":"Preguntas sobre salud","icon":"assets/services/help_icon.svg","subTitle":"Obt\xe9n asistencia y respuestas a tus preguntas","highlightedText":"Tomar mejores decisiones de bienestar para tu salud puede ser confuso a veces. Pasa tiempo uno a uno con un Asesor de Salud de Walgreens y obtenga respuestas a algunas de las preguntas que tengas.","additionalText":"Desde consejos sobre medicamentos de venta libre y suplementos hasta nutrici\xf3n, pregunta a un asesor de salud de Walgreens que tenga experiencia cl\xednica para ayudarte a encontrar respuestas a tus preguntas.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Braven."},{"title":"Dispositivos de Monitoreo de la Salud","icon":"assets/services/glucose_meter_icon.svg","subTitle":"Obt\xe9n ayuda para configurar dispositivos de monitoreo de salud","highlightedText":"Los dispositivos de monitoreo de la salud pueden mostrarte los cambios diarios en tu salud mediante el control de aspectos como la presi\xf3n arterial, la actividad, el sue\xf1o y m\xe1s.","additionalText":"Aprende a configurar y usar dispositivos de salud port\xe1tiles o en el hogar que pueden ayudarte a comprender mejor tu salud.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Braven."},{"title":"Vacuna contra la Influenza","icon":"assets/services/syringe_icon.svg","subTitle":"Obt\xe9n una Vacuna contra la Influenza hoy","highlightedText":"Las vacunas contra la influenza estacional pueden ayudarte a reducir el riesgo de contraer ciertas cepas del virus de la influenza.","additionalText":"La vacuna puede reducir las enfermedades gripales, las visitas al m\xe9dico y las ausencias al trabajo y a la escuela debido a la influenza, as\xed como prevenir las hospitalizaciones y muertes relacionadas con la influenza.. <br /><br /> Habla con un asesor de salud o farmac\xe9utico para vacunarte contra la influenza.","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Braven."},{"title":"Obt\xe9n una medici\xf3n de presi\xf3n arterial","icon":"assets/services/bp_icon.svg","availability":"S\xf3lo miembros de Braven","subTitle":"Los miembros de Braven Health son acreedores a una medici\xf3n de presi\xf3n arterial","highlightedText":"Monitorear tu presi\xf3n arterial es importante para reducir el riesgo de paro cardiaco y apoplej\xeda.","additionalText":"La presi\xf3n arterial alta no suele presentar s\xedntomas y frecuentemente se desarrolla lentamente; por lo tanto, es importante que midas tu presi\xf3n arterial regularmente.","headerColor":"#284B9B","headerBackgroundColor":"#FFFFFF","headerLogo":"assets/services/braven-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Braven."},{"title":"Prueba de A1C","icon":"assets/services/drop_icon.svg","availability":"S\xf3lo miembros de Braven","subTitle":"Los miembros de Braven Health son acreedores a una prueba A1C","highlightedText":"La prueba A1C—tambi\xe9n conocida como prueba de hemoglobina A1C o prueba de hemoglobina glicosilada HbA1c— es una sencilla prueba de sangre que mide el promedio de tus niveles de az\xfacar de los \xfaltimos 2 a tres meses.","additionalText":"Es una de las pruebas m\xe1s usadas para diagnosticar la prediabetes y la diabetes y es tambi\xe9n la principal prueba para ayudarte a ti y a tu equipo de salud a manejar tu diabetes.","headerColor":"#284B9B","headerBackgroundColor":"#FFFFFF","headerLogo":"assets/services/braven-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Braven."},{"title":"Escaneo de C\xe1ncer colorectal","icon":"assets/services/home_icon.svg","availability":"S\xf3lo miembros de Braven","subTitle":"Los miembros de Braven Health obtienen un kit de escaneo para detectar el C\xe1ncer colorrectal","highlightedText":"Un examen de escaneo puede hacerse en la comodidad de tu hogar y es usado para buscar anomal\xedas colorrectales cuando una persona no presenta s\xedntomas.","additionalText":"YLos escaneos que detectan el c\xe1ncer colorrectal deben comenzar a hacerse tan pronto como se cumplen 50 a\xf1os, despu\xe9s de eso deber\xe1s realizar ex\xe1menes peri\xf3dicamente.","headerColor":"#284B9B","headerBackgroundColor":"#FFFFFF","headerLogo":"assets/services/braven-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para qu\xe9 servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salud de Braven."},{"title":"Cuidado de Adultos 66+","icon":"assets/services/person_with_heart_icon.svg","availability":"S\xf3lo miembros de Braven","subTitle":"Ayudando a los miembros de Braven mayores de 66 a\xf1os a obtener la atenci\xf3n que necesitan.","highlightedText":"Obteniendo la atenci\xf3n que necesita en esta fase de la vida puede ayudar a mantener o mejorar su calidad de vida para que pueda hacer m\xe1s de lo que le importa.","additionalText":"Nuestro equipo de Walgreens Health Corner trabajara con usted para brindarle \\b–Evaluaci\xf3n de ca\xeddas \\n– Evaluaci\xf3n de la Actividad F\xedsica","headerColor":"#284B9B","headerBackgroundColor":"#FFFFFF","headerLogo":"assets/services/braven-logo.png","legalDisclaimer":"*Consulta a un Asesor de Salud para determinar para que servicios eres elegible. Los costos y la elegibilidad var\xedan seg\xfan el Plan de Salude de Braven."}],"appointment":{"title":"Programa una cita","phoneNumber":"Llama al: 877-645-4128"}}}}}');


const $f4054af2a8c7c60b$export$ffa34252a456de62 = {
    fetchContentEntry (locale, payor, key) {
        const normalizedLocale = locale === "es-419" ? locale : "en";
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const normalizedPayor = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($02d11728b58142c5$exports)))[normalizedLocale]).includes(payor) ? payor : "default";
        return(// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        (0, (/*@__PURE__*/$parcel$interopDefault($02d11728b58142c5$exports)))[normalizedLocale][normalizedPayor][// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        key] ?? (0, (/*@__PURE__*/$parcel$interopDefault($02d11728b58142c5$exports)))[normalizedLocale].default[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        key]);
    }
};


function $8d0b0d663386d395$export$6fec604aa7293d0c(search) {
    const parameters = new URLSearchParams(search || window.location.search);
    const store = parameters.get("store");
    if (store === null) return "";
    return `?store=${store}`;
}
function $8d0b0d663386d395$export$17c2ed143a4045c(location) {
    const parameters = location.params;
    const payor = Array.isArray(parameters.payor) ? parameters.payor[0] : parameters.payor;
    const locale = Array.isArray(parameters.locale) ? parameters.locale[0] : parameters.locale;
    if (payor === undefined || locale === undefined) throw new Error("payor / and or locale are missing from the route");
    return {
        payor: payor,
        locale: locale
    };
}
function $8d0b0d663386d395$export$786f9a4bc80cc6b0(location) {
    return location.search || window.location.search;
}
function $8d0b0d663386d395$export$da6d2f7032b7150b(location) {
    const foundRoute = location.routes.find((route)=>route.component !== "web-kiosk")?.path;
    if (foundRoute === undefined || foundRoute === "") return undefined;
    return foundRoute;
}


class $3fb2d069a78cd8a3$export$262589ac480ce656 extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    getTitle() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.content?.title || "Walgreens Health Corner";
    }
    getStoreId() {
        if (!this.location) {
            // eslint-disable-next-line no-console
            console.error("Location is undefined.");
            return "";
        }
        const searchParameters = new URLSearchParams(this.location.search);
        if (!searchParameters.has("store")) return "";
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return searchParameters.get("store").replace("s", "");
    }
    getPayor() {
        if (!this.location) {
            // eslint-disable-next-line no-console
            console.error("Location is undefined.");
            return "";
        }
        if (this.location.params.payor === undefined) {
            // eslint-disable-next-line no-console
            console.error("Payor is undefined.");
            return "";
        }
        return this.location.params.payor.toString();
    }
    getLocale() {
        if (!this.location) {
            // eslint-disable-next-line no-console
            console.error("Location is undefined.");
            return "";
        }
        if (this.location.params.locale === undefined) {
            // eslint-disable-next-line no-console
            console.error("Locale is undefined.");
            return "";
        }
        return this.location.params.locale.toString();
    }
    createRelativeLink(route) {
        if (!this.location) return "";
        const parameters = (0, $8d0b0d663386d395$export$17c2ed143a4045c)(this.location);
        const search = (0, $8d0b0d663386d395$export$786f9a4bc80cc6b0)(this.location);
        const store = (0, $8d0b0d663386d395$export$6fec604aa7293d0c)(search);
        return `${parameters.payor}/${parameters.locale}/${route}${store}`;
    }
    setTitle(title) {
        window.document.title = title;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setTitle(this.getTitle());
    }
    onBeforeEnter() {
        this.updateContentFromUrl();
    }
    updateContentFromUrl() {
        if (!this.location) return;
        const parameters = (0, $8d0b0d663386d395$export$17c2ed143a4045c)(this.location);
        const contentParameters = {
            ...this.location.params,
            ...Object.fromEntries(new URLSearchParams(window.location.search).entries())
        };
        this.content = this.loadContentEntry(parameters.locale, parameters.payor, contentParameters.contentKey);
        this.requestUpdate();
    }
    loadContentEntry(locale, payor, contentKey) {
        return (0, $f4054af2a8c7c60b$export$ffa34252a456de62).fetchContentEntry(locale, payor, contentKey);
    }
    constructor(...args){
        super(...args);
        this.content = "not set";
        this.location = undefined;
    }
}
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $3fb2d069a78cd8a3$export$262589ac480ce656.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $3fb2d069a78cd8a3$export$262589ac480ce656.prototype, "location", void 0);


let $1408101c239588f2$export$b27cb2325c43daa6 = class WebKioskAboutElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    filterCards(cards) {
        if (!cards) return [];
        return cards;
    }
    renderCards(cards) {
        if (!cards) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return this.filterCards(cards).map((card)=>{
            const { heading: heading, description: description, img: img, link: link } = card;
            return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
        <a href=${this.createRelativeLink(link)}>
          <wh-card flat size="large">
            <section class="card-inner">
              <img src=${img} alt=${heading} />
              <h2>${heading}</h2>
              <p>${description}</p>
            </section>
          </wh-card>
        </a>
      `;
        });
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section class="page-body">
      <div class="body-inner">
        <web-kiosk-home-link
          link=${this.createRelativeLink("home")}
        ></web-kiosk-home-link>
        <div class="body-content">
          <section name="about-text">
            <h1>${this.content?.heading}</h1>

            <p>${this.content?.description}</p>
          </section>

          <section name="cards">
            ${this.renderCards(this.content?.cards)}
          </section>
        </div>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c1e8ff;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
    }

    .page-body {
      height: 100%;
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/about/bg/person.svg") left 3% bottom no-repeat,
        url("assets/about/bg/swirl.svg") center bottom 14% no-repeat,
        url("assets/shared/bg/city.svg") right bottom -7% no-repeat,
        var(--web-kiosk-bg, hotpink);
      `)};
      background-size: calc(100vmin - 485px), contain, 40%;
    }

    @media only screen and (width <= 1800px) {
      .page-body {
        /* stylelint-disable-next-line declaration-colon-space-after */
        background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/shared/bg/city.svg") right bottom -7% no-repeat,
        var(--web-kiosk-bg, hotpink);
      `)};
        background-size: 40%;
      }
    }

    a {
      text-decoration: none;
    }

    .body-inner {
      padding: 48px 56px;
    }

    .body-content {
      display: flex;
      gap: 210px;
    }

    section[name="about-text"] {
      width: 38%;
      flex: 1 0 38%;
      margin-left: 8px;
    }

    section[name="about-text"] h1 {
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
      margin: 52px 0 40px;
    }

    a,
    section[name="about-text"] :is(h1, p),
    wh-card h2 {
      color: var(--web-kiosk-text-color, hotpink);
    }

    section[name="cards"] {
      display: flex;
      flex: 1 1 0;
      gap: 32px;
      margin: 48px 24px 0 0;
    }

    wh-card {
      width: fit-content;
      text-align: center;
    }

    wh-card h2 {
      font-size: 32px;
      font-weight: 700;
      line-height: 38px;
      margin: 0 28px 10px;
    }

    wh-card p {
      font-size: 26px;
      font-weight: 400;
      line-height: 40px;
      margin: 0 0 12px;
    }

    section[name="about-text"] p {
      font-size: 32px;
      line-height: 52px;
    }

    .card-inner {
      min-height: 442px;
      min-width: 376px;
      padding: 32px 0 54px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $1408101c239588f2$export$b27cb2325c43daa6.prototype, "content", void 0);
$1408101c239588f2$export$b27cb2325c43daa6 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-about")
], $1408101c239588f2$export$b27cb2325c43daa6);






/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $af8e33ff014f07c6$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $5bb961e9df347661$export$45b790e32b2810ee);







var $93a0a45f296597f3$exports = {};



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c37c0eaf2b71ccde$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $c37c0eaf2b71ccde$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $c37c0eaf2b71ccde$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $db805c9ee37de70c$export$56cc687933817664 = (0, $c37c0eaf2b71ccde$export$99b43ad1ed32e735)(class extends (0, $c37c0eaf2b71ccde$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $c37c0eaf2b71ccde$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $5bb961e9df347661$export$9c068ae9cc5db4e8;
    }
});




function $60901fbb25bd758e$export$5f3bc63d31cbc29(value, target, plusMinus = 0) {
    const lower = target - plusMinus;
    const upper = target + plusMinus;
    return value >= lower && value <= upper;
}


// NOTE: This function allow us to get the exact position relative to a parent element. `offset` does not account for padding.
function $a0f0d6bbf0f64768$export$11575fec8593cad8(element, parent) {
    const elementRect = element.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    return {
        bottom: elementRect.bottom - parentRect.bottom,
        left: elementRect.left - parentRect.left,
        right: elementRect.right - parentRect.right,
        top: elementRect.top - parentRect.top
    };
}


function $54044ad5603f26a6$export$28f07b8f6c19ecb5(arrayToRotate, amount) {
    const { length: length } = arrayToRotate;
    const rotationAmount = amount % length;
    if (rotationAmount === 0) return arrayToRotate.slice();
    return arrayToRotate.map((item, index)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        arrayToRotate[(index + (length + rotationAmount)) % length]);
}


const $744afbcf778c9c67$var$animationConfig = {
    direction: "normal",
    duration: 233,
    easing: "ease-out",
    fill: "forwards"
};
function $744afbcf778c9c67$export$7f9953c70dacfd7f(direction = "direct", stagedOffset = 150) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const slidePadding = stagedOffset * 0.1;
    const stagedOffsetWithSlide = Math.floor(stagedOffset + slidePadding);
    return {
        active: {
            keyframes: [
                {
                    offset: 0,
                    opacity: 1,
                    transform: `translateX(${direction === "previous" ? `-${stagedOffset}px` : `${stagedOffset}px`}) scale(0.9)`,
                    zIndex: 3
                },
                {
                    offset: 1,
                    opacity: 1,
                    transform: "translateX(0px) scale(1)",
                    zIndex: 3
                }
            ],
            config: $744afbcf778c9c67$var$animationConfig
        },
        hidden: {
            keyframes: [
                {
                    offset: 0,
                    opacity: 0,
                    zIndex: 1
                },
                {
                    offset: 1,
                    opacity: 0,
                    zIndex: 1
                }
            ],
            config: {
                ...$744afbcf778c9c67$var$animationConfig,
                duration: 50
            }
        },
        pre: {
            keyframes: [
                {
                    offset: 0,
                    opacity: String(direction === "previous" ? "0.3" : "1"),
                    transform: `translateX(${direction === "previous" ? `-${stagedOffsetWithSlide}px` : "0px"}) scale(${direction === "previous" ? "0.8" : "1"})`,
                    zIndex: 2
                },
                {
                    offset: 1,
                    opacity: 1,
                    transform: `translateX(-${stagedOffset}px) scale(0.8)`,
                    zIndex: 2
                }
            ],
            config: $744afbcf778c9c67$var$animationConfig
        },
        post: {
            keyframes: [
                {
                    offset: 0,
                    opacity: 0.3,
                    transform: `translateX(${direction === "previous" ? "0px" : `${stagedOffsetWithSlide}px`}) scale(${direction === "previous" ? "1" : "0.8"})`,
                    zIndex: 2
                },
                {
                    offset: 1,
                    opacity: 1,
                    transform: `translateX(${stagedOffset}px) scale(0.8)`,
                    zIndex: 2
                }
            ],
            config: $744afbcf778c9c67$var$animationConfig
        }
    };
}


var $93a0a45f296597f3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $93a0a45f296597f3$export$30b6270887ec42cc = class WhCarouselElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.debounceWaitTime = 50;
        this.runScrollHandler = ({ target: target })=>{
            this.scrollHandler(target);
        };
        this.snapPoints = [];
        this.active = 0;
        this.variant = "scrolling";
        this.isInitialized = false;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.carousel.removeEventListener("scroll", this.runScrollHandler);
    }
    firstUpdated() {
        this.processSnapPoints();
        this.carousel.addEventListener("scroll", this.runScrollHandler, {
            passive: true
        });
        if (this.areSnapPointsSetInternally()) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.dispatchScrollCompleteEvent(this.snapPoints[0], true);
        this.isInitialized = true;
    }
    updated(changedProperties) {
        if (this.active === undefined) return;
        if (this.variant === "scrolling" && this.snapPoints.length === 0) return;
        if (this.variant === "scrolling") this.carousel.scrollTo({
            behavior: "smooth",
            left: this.snapPoints[this.active]?.position
        });
        if (this.variant === "stacked") this.rotateStackedCarousel(this.active, this.calculateDirection(changedProperties.get("active"), this.active));
    }
    dispatchScrollCompleteEvent(activeSnapPoint, firstUpdated = false) {
        this.snapPoints = this.snapPoints.map((point)=>({
                active: point.index === activeSnapPoint.index,
                element: point.element,
                index: point.index,
                last: point.last,
                position: point.position
            }));
        const eventData = {
            activeIndex: activeSnapPoint.index,
            activeSnapPoint: activeSnapPoint,
            firstUpdated: firstUpdated,
            snapPoints: this.snapPoints,
            type: "scrollcomplete"
        };
        this.dispatchEvent(new CustomEvent("scrollcomplete", {
            detail: eventData
        }));
    }
    processSnapPoints() {
        this.snapPoints = this.snapPointElements.map((point, index, points)=>({
                active: index === 0,
                element: point,
                index: index,
                last: index === points.length - 1,
                position: (0, $a0f0d6bbf0f64768$export$11575fec8593cad8)(point, this.carousel).left
            }));
    }
    rotateStackedCarousel(amount, direction) {
        const rotated = (0, $54044ad5603f26a6$export$28f07b8f6c19ecb5)(this.carouselElements, amount);
        const stagedOffset = this.carouselElements.length > 0 ? this.carouselElements[0]?.clientWidth ?? 0 : undefined;
        const { active: active, hidden: hidden, post: post, pre: pre } = (0, $744afbcf778c9c67$export$7f9953c70dacfd7f)(direction, stagedOffset);
        rotated.forEach((page, index)=>{
            switch(index){
                case 0:
                    page.animate(pre.keyframes, pre.config);
                    break;
                case 1:
                    page.animate(active.keyframes, active.config);
                    break;
                // eslint-disable-next-line @typescript-eslint/no-magic-numbers
                case 2:
                    page.animate(post.keyframes, post.config);
                    break;
                default:
                    page.animate(hidden.keyframes, hidden.config);
                    break;
            }
        });
    }
    scrollHandler(target) {
        if (this.debounceWaitTimeout !== undefined) clearTimeout(this.debounceWaitTimeout);
        this.debounceWaitTimeout = setTimeout(()=>{
            const currentPoint = this.snapPoints.find(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (point)=>point.position === target.scrollLeft);
            if (currentPoint) this.dispatchScrollCompleteEvent(currentPoint);
            else if ((0, $60901fbb25bd758e$export$5f3bc63d31cbc29)(this.carousel.scrollWidth - this.carousel.scrollLeft, this.carousel.clientWidth, // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            3)) {
                const lastPoint = this.snapPoints.find((point)=>point.last);
                if (lastPoint) this.dispatchScrollCompleteEvent(lastPoint);
            }
        }, this.debounceWaitTime);
    }
    calculateDirection(oldValue, newValue) {
        const oldNumber = Number(oldValue);
        const newNumber = Number(newValue);
        if (oldNumber > newNumber) return "previous";
        if (newNumber > oldNumber) return "next";
        return "direct";
    }
    areSnapPointsSetInternally() {
        return this.snapPoints.length > 0;
    }
    renderVariantScrolling() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <article
        class=${(0, $db805c9ee37de70c$export$56cc687933817664)({
            scrolling: true,
            snappy: this.isInitialized
        })}
      >
        <slot @slotchange=${this.processSnapPoints}></slot>
      </article>
    `;
    }
    renderVariantStacked() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <article class="stacked">
        <slot
          @slotchange=${()=>{
            this.rotateStackedCarousel(0, "direct");
        }}
        ></slot>
      </article>
    `;
    }
    render() {
        if (this.variant === "stacked") return this.renderVariantStacked();
        return this.renderVariantScrolling();
    }
};
/* Stryker disable next-line StringLiteral */ $93a0a45f296597f3$export$30b6270887ec42cc.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --wh-dimension-spacer-xxs: 8px;
    }

    article.scrolling {
      display: flex;
      flex-direction: row;
      gap: var(--wh-dimension-spacer-xxs);
      overflow: scroll;
      scroll-behavior: smooth;
      scrollbar-width: none;
    }

    .snappy {
      scroll-snap-stop: always;
      scroll-snap-type: x mandatory;
    }

    article.scrolling > ::slotted(section[wh-carousel-snap]) {
      scroll-snap-align: start;
    }

    article.stacked {
      display: flex;
      justify-content: center;
      position: relative;
    }

    article.stacked > ::slotted(section) {
      box-sizing: border-box;
      opacity: 0;
      position: absolute;
      transform-origin: center;
    }

    ::-webkit-scrollbar {
      height: 0;
      width: 0;
      background: transparent;
    }
  `;
$93a0a45f296597f3$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        attribute: "active"
    })
], $93a0a45f296597f3$export$30b6270887ec42cc.prototype, "active", void 0);
$93a0a45f296597f3$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        attribute: "variant"
    })
], $93a0a45f296597f3$export$30b6270887ec42cc.prototype, "variant", void 0);
$93a0a45f296597f3$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean
    })
], $93a0a45f296597f3$export$30b6270887ec42cc.prototype, "isInitialized", void 0);
$93a0a45f296597f3$var$__decorate([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("article")
], $93a0a45f296597f3$export$30b6270887ec42cc.prototype, "carousel", void 0);
$93a0a45f296597f3$var$__decorate([
    (0, $eca0be5f509d50f1$export$4682af2d9ee91415)({
        selector: "section"
    })
], $93a0a45f296597f3$export$30b6270887ec42cc.prototype, "carouselElements", void 0);
$93a0a45f296597f3$var$__decorate([
    (0, $eca0be5f509d50f1$export$4682af2d9ee91415)({
        selector: "[wh-carousel-snap]"
    })
], $93a0a45f296597f3$export$30b6270887ec42cc.prototype, "snapPointElements", void 0);
$93a0a45f296597f3$export$30b6270887ec42cc = $93a0a45f296597f3$var$__decorate([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("wh-carousel")
], $93a0a45f296597f3$export$30b6270887ec42cc);


var $a72106b704c0c085$exports = {};


var $4a79a76a1e44d5c5$exports = {};


// src/styles/component.styles.ts
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $721e1b33361a91ed$var$t = globalThis, $721e1b33361a91ed$export$b4d10f6001c083c2 = $721e1b33361a91ed$var$t.ShadowRoot && (void 0 === $721e1b33361a91ed$var$t.ShadyCSS || $721e1b33361a91ed$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $721e1b33361a91ed$var$s = Symbol(), $721e1b33361a91ed$var$o = new WeakMap;
class $721e1b33361a91ed$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $721e1b33361a91ed$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($721e1b33361a91ed$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $721e1b33361a91ed$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $721e1b33361a91ed$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $721e1b33361a91ed$export$8d80f9cac07cdb3 = (t)=>new $721e1b33361a91ed$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $721e1b33361a91ed$var$s), $721e1b33361a91ed$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $721e1b33361a91ed$export$505d1e8739bad805(o, t, $721e1b33361a91ed$var$s);
}, $721e1b33361a91ed$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($721e1b33361a91ed$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $721e1b33361a91ed$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $721e1b33361a91ed$export$ee69dfd951e24778 = $721e1b33361a91ed$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $721e1b33361a91ed$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $911d26c32f40a4b3$var$i, defineProperty: $911d26c32f40a4b3$var$e, getOwnPropertyDescriptor: $911d26c32f40a4b3$var$r, getOwnPropertyNames: $911d26c32f40a4b3$var$h, getOwnPropertySymbols: $911d26c32f40a4b3$var$o, getPrototypeOf: $911d26c32f40a4b3$var$n } = Object, $911d26c32f40a4b3$var$a = globalThis, $911d26c32f40a4b3$var$c = $911d26c32f40a4b3$var$a.trustedTypes, $911d26c32f40a4b3$var$l = $911d26c32f40a4b3$var$c ? $911d26c32f40a4b3$var$c.emptyScript : "", $911d26c32f40a4b3$var$p = $911d26c32f40a4b3$var$a.reactiveElementPolyfillSupport, $911d26c32f40a4b3$var$d = (t, s)=>t, $911d26c32f40a4b3$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $911d26c32f40a4b3$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $911d26c32f40a4b3$export$53a6892c50694894 = (t, s)=>!$911d26c32f40a4b3$var$i(t, s), $911d26c32f40a4b3$var$y = {
    attribute: !0,
    type: String,
    converter: $911d26c32f40a4b3$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $911d26c32f40a4b3$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $911d26c32f40a4b3$var$a.litPropertyMetadata ??= new WeakMap;
class $911d26c32f40a4b3$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $911d26c32f40a4b3$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $911d26c32f40a4b3$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $911d26c32f40a4b3$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $911d26c32f40a4b3$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($911d26c32f40a4b3$var$d("elementProperties"))) return;
        const t = $911d26c32f40a4b3$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($911d26c32f40a4b3$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($911d26c32f40a4b3$var$d("properties"))) {
            const t = this.properties, s = [
                ...$911d26c32f40a4b3$var$h(t),
                ...$911d26c32f40a4b3$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $721e1b33361a91ed$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $721e1b33361a91ed$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$Eg = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$ES ??= []).push(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$ES?.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $721e1b33361a91ed$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$ES?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$ES?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EO(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $911d26c32f40a4b3$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $911d26c32f40a4b3$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, r) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $911d26c32f40a4b3$export$53a6892c50694894)(e ? r : this[t], s)) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$Eg = this._$EP());
    }
    C(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$Eg;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.C(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$ES?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$ET();
        } catch (s) {
            throw t = !1, this._$ET(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$ES?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$ET() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$Eg;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EO(t, this[t])), this._$ET();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$911d26c32f40a4b3$export$c7c07a37856565d.elementStyles = [], $911d26c32f40a4b3$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $911d26c32f40a4b3$export$c7c07a37856565d[$911d26c32f40a4b3$var$d("elementProperties")] = new Map, $911d26c32f40a4b3$export$c7c07a37856565d[$911d26c32f40a4b3$var$d("finalized")] = new Map, $911d26c32f40a4b3$var$p?.({
    ReactiveElement: $911d26c32f40a4b3$export$c7c07a37856565d
}), ($911d26c32f40a4b3$var$a.reactiveElementVersions ??= []).push("2.0.1");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6d8f6951af537b31$var$t = globalThis, $6d8f6951af537b31$var$i = $6d8f6951af537b31$var$t.trustedTypes, $6d8f6951af537b31$var$s = $6d8f6951af537b31$var$i ? $6d8f6951af537b31$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $6d8f6951af537b31$var$e = "$lit$", $6d8f6951af537b31$var$h = `lit$${(Math.random() + "").slice(9)}$`, $6d8f6951af537b31$var$o = "?" + $6d8f6951af537b31$var$h, $6d8f6951af537b31$var$n = `<${$6d8f6951af537b31$var$o}>`, $6d8f6951af537b31$var$r = document, $6d8f6951af537b31$var$l = ()=>$6d8f6951af537b31$var$r.createComment(""), $6d8f6951af537b31$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $6d8f6951af537b31$var$a = Array.isArray, $6d8f6951af537b31$var$u = (t)=>$6d8f6951af537b31$var$a(t) || "function" == typeof t?.[Symbol.iterator], $6d8f6951af537b31$var$d = "[ 	\n\f\r]", $6d8f6951af537b31$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $6d8f6951af537b31$var$v = /-->/g, $6d8f6951af537b31$var$_ = />/g, $6d8f6951af537b31$var$m = RegExp(`>|${$6d8f6951af537b31$var$d}(?:([^\\s"'>=/]+)(${$6d8f6951af537b31$var$d}*=${$6d8f6951af537b31$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $6d8f6951af537b31$var$p = /'/g, $6d8f6951af537b31$var$g = /"/g, $6d8f6951af537b31$var$$ = /^(?:script|style|textarea|title)$/i, $6d8f6951af537b31$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $6d8f6951af537b31$export$c0bb0b647f701bb5 = $6d8f6951af537b31$var$y(1), $6d8f6951af537b31$export$7ed1367e7fa1ad68 = $6d8f6951af537b31$var$y(2), $6d8f6951af537b31$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $6d8f6951af537b31$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $6d8f6951af537b31$var$A = new WeakMap, $6d8f6951af537b31$var$E = $6d8f6951af537b31$var$r.createTreeWalker($6d8f6951af537b31$var$r, 129);
function $6d8f6951af537b31$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $6d8f6951af537b31$var$s ? $6d8f6951af537b31$var$s.createHTML(i) : i;
}
const $6d8f6951af537b31$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $6d8f6951af537b31$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $6d8f6951af537b31$var$f ? "!--" === u[1] ? c = $6d8f6951af537b31$var$v : void 0 !== u[1] ? c = $6d8f6951af537b31$var$_ : void 0 !== u[2] ? ($6d8f6951af537b31$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $6d8f6951af537b31$var$m) : void 0 !== u[3] && (c = $6d8f6951af537b31$var$m) : c === $6d8f6951af537b31$var$m ? ">" === u[0] ? (c = r ?? $6d8f6951af537b31$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $6d8f6951af537b31$var$m : '"' === u[3] ? $6d8f6951af537b31$var$g : $6d8f6951af537b31$var$p) : c === $6d8f6951af537b31$var$g || c === $6d8f6951af537b31$var$p ? c = $6d8f6951af537b31$var$m : c === $6d8f6951af537b31$var$v || c === $6d8f6951af537b31$var$_ ? c = $6d8f6951af537b31$var$f : (c = $6d8f6951af537b31$var$m, r = void 0);
        const x = c === $6d8f6951af537b31$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $6d8f6951af537b31$var$f ? s + $6d8f6951af537b31$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $6d8f6951af537b31$var$e + s.slice(d) + $6d8f6951af537b31$var$h + x) : s + $6d8f6951af537b31$var$h + (-2 === d ? i : x);
    }
    return [
        $6d8f6951af537b31$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $6d8f6951af537b31$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $6d8f6951af537b31$var$P(t, s);
        if (this.el = $6d8f6951af537b31$var$V.createElement(f, n), $6d8f6951af537b31$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $6d8f6951af537b31$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($6d8f6951af537b31$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($6d8f6951af537b31$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $6d8f6951af537b31$var$k : "?" === e[1] ? $6d8f6951af537b31$var$H : "@" === e[1] ? $6d8f6951af537b31$var$I : $6d8f6951af537b31$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($6d8f6951af537b31$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($6d8f6951af537b31$var$$.test(r.tagName)) {
                    const t = r.textContent.split($6d8f6951af537b31$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $6d8f6951af537b31$var$i ? $6d8f6951af537b31$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $6d8f6951af537b31$var$l()), $6d8f6951af537b31$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $6d8f6951af537b31$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $6d8f6951af537b31$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($6d8f6951af537b31$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $6d8f6951af537b31$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $6d8f6951af537b31$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $6d8f6951af537b31$var$N(t, i, s = t, e) {
    if (i === $6d8f6951af537b31$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $6d8f6951af537b31$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $6d8f6951af537b31$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $6d8f6951af537b31$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $6d8f6951af537b31$var$r).importNode(i, !0);
        $6d8f6951af537b31$var$E.currentNode = e;
        let h = $6d8f6951af537b31$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $6d8f6951af537b31$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $6d8f6951af537b31$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $6d8f6951af537b31$var$E.nextNode(), o++);
        }
        return $6d8f6951af537b31$var$E.currentNode = $6d8f6951af537b31$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $6d8f6951af537b31$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $6d8f6951af537b31$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $6d8f6951af537b31$var$N(this, t, i), $6d8f6951af537b31$var$c(t) ? t === $6d8f6951af537b31$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $6d8f6951af537b31$export$45b790e32b2810ee && this._$AR(), this._$AH = $6d8f6951af537b31$export$45b790e32b2810ee) : t !== this._$AH && t !== $6d8f6951af537b31$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $6d8f6951af537b31$var$u(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $6d8f6951af537b31$export$45b790e32b2810ee && $6d8f6951af537b31$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.$($6d8f6951af537b31$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $6d8f6951af537b31$var$V.createElement($6d8f6951af537b31$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $6d8f6951af537b31$var$S(e, this), s = t.u(this.options);
            t.p(i), this.$(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $6d8f6951af537b31$var$A.get(t.strings);
        return void 0 === i && $6d8f6951af537b31$var$A.set(t.strings, i = new $6d8f6951af537b31$var$V(t)), i;
    }
    T(t) {
        $6d8f6951af537b31$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $6d8f6951af537b31$var$M(this.k($6d8f6951af537b31$var$l()), this.k($6d8f6951af537b31$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $6d8f6951af537b31$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $6d8f6951af537b31$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $6d8f6951af537b31$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $6d8f6951af537b31$var$N(this, t, i, 0), o = !$6d8f6951af537b31$var$c(t) || t !== this._$AH && t !== $6d8f6951af537b31$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $6d8f6951af537b31$var$N(this, e[s + n], i, n), r === $6d8f6951af537b31$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$6d8f6951af537b31$var$c(r) || r !== this._$AH[n], r === $6d8f6951af537b31$export$45b790e32b2810ee ? t = $6d8f6951af537b31$export$45b790e32b2810ee : t !== $6d8f6951af537b31$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.O(t);
    }
    O(t) {
        t === $6d8f6951af537b31$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $6d8f6951af537b31$var$k extends $6d8f6951af537b31$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    O(t) {
        this.element[this.name] = t === $6d8f6951af537b31$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $6d8f6951af537b31$var$H extends $6d8f6951af537b31$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    O(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $6d8f6951af537b31$export$45b790e32b2810ee);
    }
}
class $6d8f6951af537b31$var$I extends $6d8f6951af537b31$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $6d8f6951af537b31$var$N(this, t, i, 0) ?? $6d8f6951af537b31$export$45b790e32b2810ee) === $6d8f6951af537b31$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $6d8f6951af537b31$export$45b790e32b2810ee && s !== $6d8f6951af537b31$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $6d8f6951af537b31$export$45b790e32b2810ee && (s === $6d8f6951af537b31$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $6d8f6951af537b31$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $6d8f6951af537b31$var$N(this, t);
    }
}
const $6d8f6951af537b31$export$8613d1ca9052b22e = {
    j: $6d8f6951af537b31$var$e,
    P: $6d8f6951af537b31$var$h,
    A: $6d8f6951af537b31$var$o,
    C: 1,
    M: $6d8f6951af537b31$var$P,
    L: $6d8f6951af537b31$var$S,
    R: $6d8f6951af537b31$var$u,
    V: $6d8f6951af537b31$var$N,
    D: $6d8f6951af537b31$var$M,
    I: $6d8f6951af537b31$var$R,
    H: $6d8f6951af537b31$var$H,
    N: $6d8f6951af537b31$var$I,
    U: $6d8f6951af537b31$var$k,
    B: $6d8f6951af537b31$var$L
}, $6d8f6951af537b31$var$Z = $6d8f6951af537b31$var$t.litHtmlPolyfillSupport;
$6d8f6951af537b31$var$Z?.($6d8f6951af537b31$var$V, $6d8f6951af537b31$var$M), ($6d8f6951af537b31$var$t.litHtmlVersions ??= []).push("3.0.2");
const $6d8f6951af537b31$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $6d8f6951af537b31$var$M(i.insertBefore($6d8f6951af537b31$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $f3fad224a49aecbc$export$3f2f9f5909897157 extends (0, $911d26c32f40a4b3$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $6d8f6951af537b31$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $6d8f6951af537b31$export$9c068ae9cc5db4e8;
    }
}
$f3fad224a49aecbc$export$3f2f9f5909897157._$litElement$ = !0, $f3fad224a49aecbc$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $f3fad224a49aecbc$export$3f2f9f5909897157
});
const $f3fad224a49aecbc$var$r = globalThis.litElementPolyfillSupport;
$f3fad224a49aecbc$var$r?.({
    LitElement: $f3fad224a49aecbc$export$3f2f9f5909897157
});
const $f3fad224a49aecbc$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.1");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cb754caa09b7574e$export$6acf61af03e62db = !1;




var $a15991058abab049$export$e1ac0a3ec62d1269 = (0, $721e1b33361a91ed$export$dbf350e5966cf602)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;



var $f227d2fcbc26f981$export$f0b0874d64866432 = (0, $721e1b33361a91ed$export$dbf350e5966cf602)`
  ${(0, $a15991058abab049$export$e1ac0a3ec62d1269)}

  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;


// src/utilities/base-path.ts
var $0bcb9082047a001c$var$basePath = "";
function $0bcb9082047a001c$export$784ad41d332938c6(path) {
    $0bcb9082047a001c$var$basePath = path;
}
function $0bcb9082047a001c$export$9099264ed9b1c55a(subpath = "") {
    if (!$0bcb9082047a001c$var$basePath) {
        const scripts = [
            ...document.getElementsByTagName("script")
        ];
        const configScript = scripts.find((script)=>script.hasAttribute("data-shoelace"));
        if (configScript) $0bcb9082047a001c$export$784ad41d332938c6(configScript.getAttribute("data-shoelace"));
        else {
            const fallbackScript = scripts.find((s)=>{
                return /shoelace(\.min)?\.js($|\?)/.test(s.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(s.src);
            });
            let path = "";
            if (fallbackScript) path = fallbackScript.getAttribute("src");
            $0bcb9082047a001c$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
        }
    }
    return $0bcb9082047a001c$var$basePath.replace(/\/$/, "") + (subpath ? `/${subpath.replace(/^\//, "")}` : ``);
}


// src/components/icon/library.default.ts
var $5ef4441932d7ec19$var$library = {
    name: "default",
    resolver: (name)=>(0, $0bcb9082047a001c$export$9099264ed9b1c55a)(`assets/icons/${name}.svg`)
};
var $5ef4441932d7ec19$export$761783e099ce3526 = $5ef4441932d7ec19$var$library;


// src/components/icon/library.system.ts
var $6fa0dfb900476e61$var$icons = {
    caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
    check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
    "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16" part="svg">
      <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"></path>
    </svg>
  `,
    eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
    "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
    eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
    "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
    indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
    "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
    "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
    radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
    "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
    "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
    "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
};
var $6fa0dfb900476e61$var$systemLibrary = {
    name: "system",
    resolver: (name)=>{
        if (name in $6fa0dfb900476e61$var$icons) return `data:image/svg+xml,${encodeURIComponent($6fa0dfb900476e61$var$icons[name])}`;
        return "";
    }
};
var $6fa0dfb900476e61$export$3139252f9828970f = $6fa0dfb900476e61$var$systemLibrary;


// src/components/icon/library.ts
var $39a534c23b7ef51e$var$registry = [
    (0, $5ef4441932d7ec19$export$761783e099ce3526),
    (0, $6fa0dfb900476e61$export$3139252f9828970f)
];
var $39a534c23b7ef51e$var$watchedIcons = [];
function $39a534c23b7ef51e$export$da63f424a7208010(icon) {
    $39a534c23b7ef51e$var$watchedIcons.push(icon);
}
function $39a534c23b7ef51e$export$9e46b25ecab82f0b(icon) {
    $39a534c23b7ef51e$var$watchedIcons = $39a534c23b7ef51e$var$watchedIcons.filter((el)=>el !== icon);
}
function $39a534c23b7ef51e$export$be026de5111f322b(name) {
    return $39a534c23b7ef51e$var$registry.find((lib)=>lib.name === name);
}
function $39a534c23b7ef51e$export$a482e04ad60c9b11(name, options) {
    $39a534c23b7ef51e$export$8faa256e94012669(name);
    $39a534c23b7ef51e$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator,
        spriteSheet: options.spriteSheet
    });
    $39a534c23b7ef51e$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $39a534c23b7ef51e$export$8faa256e94012669(name) {
    $39a534c23b7ef51e$var$registry = $39a534c23b7ef51e$var$registry.filter((lib)=>lib.name !== name);
}


var $eab5a1a480d90122$var$__defProp = Object.defineProperty;
var $eab5a1a480d90122$var$__defProps = Object.defineProperties;
var $eab5a1a480d90122$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $eab5a1a480d90122$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $eab5a1a480d90122$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $eab5a1a480d90122$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $eab5a1a480d90122$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $eab5a1a480d90122$var$__knownSymbol = (name, symbol)=>{
    if (symbol = Symbol[name]) return symbol;
    throw Error("Symbol." + name + " is not defined");
};
var $eab5a1a480d90122$var$__defNormalProp = (obj, key, value)=>key in obj ? $eab5a1a480d90122$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $eab5a1a480d90122$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($eab5a1a480d90122$var$__hasOwnProp.call(b, prop)) $eab5a1a480d90122$var$__defNormalProp(a, prop, b[prop]);
    if ($eab5a1a480d90122$var$__getOwnPropSymbols) {
        for (var prop of $eab5a1a480d90122$var$__getOwnPropSymbols(b))if ($eab5a1a480d90122$var$__propIsEnum.call(b, prop)) $eab5a1a480d90122$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $eab5a1a480d90122$export$f4da8f157c1253f7 = (a, b)=>$eab5a1a480d90122$var$__defProps(a, $eab5a1a480d90122$var$__getOwnPropDescs(b));
var $eab5a1a480d90122$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $eab5a1a480d90122$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $eab5a1a480d90122$var$__defProp(target, key, result);
    return result;
};
var $eab5a1a480d90122$var$__await = function(promise, isYieldStar) {
    this[0] = promise;
    this[1] = isYieldStar;
};
var $eab5a1a480d90122$export$5590fd18e5672c2 = (value)=>{
    var obj = value[$eab5a1a480d90122$var$__knownSymbol("asyncIterator")];
    var isAwait = false;
    var method;
    var it = {};
    if (obj == null) {
        obj = value[$eab5a1a480d90122$var$__knownSymbol("iterator")]();
        method = (k)=>it[k] = (x)=>obj[k](x);
    } else {
        obj = obj.call(value);
        method = (k)=>it[k] = (v)=>{
                if (isAwait) {
                    isAwait = false;
                    if (k === "throw") throw v;
                    return v;
                }
                isAwait = true;
                return {
                    done: false,
                    value: new $eab5a1a480d90122$var$__await(new Promise((resolve)=>{
                        var x = obj[k](v);
                        if (!(x instanceof Object)) throw TypeError("Object expected");
                        resolve(x);
                    }), 1)
                };
            };
    }
    return it[$eab5a1a480d90122$var$__knownSymbol("iterator")] = ()=>it, method("next"), "throw" in obj ? method("throw") : it.throw = (x)=>{
        throw x;
    }, "return" in obj && method("return"), it;
};


// src/internal/watch.ts
function $245c976188bf2656$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = (0, $eab5a1a480d90122$export$7de063a7aa429f6c)({
        waitUntilFirstUpdate: false
    }, options);
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $344420827729c852$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a435086cf00d3e55$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $911d26c32f40a4b3$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $911d26c32f40a4b3$export$53a6892c50694894)
}, $a435086cf00d3e55$export$8d623b1670eb40f4 = (t = $a435086cf00d3e55$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $a435086cf00d3e55$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $a435086cf00d3e55$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9eba64a7190237ae$export$ca000e230c0caa3e(r) {
    return (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9005a61f2b4ce6dd$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e92690beb2e349f4$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a381745756984e0e$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: u } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $e92690beb2e349f4$export$51987bb50e1f6752)(n, s, {
                get () {
                    if (r) {
                        let t = e.call(this);
                        return void 0 === t && (t = o(this), u.call(this, t)), t;
                    }
                    return o(this);
                }
            });
        }
        return (0, $e92690beb2e349f4$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $226b731ee8ffaa14$var$e;
function $226b731ee8ffaa14$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $e92690beb2e349f4$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($226b731ee8ffaa14$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d09844260361997d$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $e92690beb2e349f4$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $20bd66fffb528666$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $e92690beb2e349f4$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1c010fcf5f740ac6$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $e92690beb2e349f4$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




var $d6532421f6fe77d5$export$6f25236e887097b = class extends (0, $f3fad224a49aecbc$export$3f2f9f5909897157) {
    constructor(){
        super();
        Object.entries(this.constructor.dependencies).forEach(([name, component])=>{
            this.constructor.define(name, component);
        });
    }
    emit(name, options) {
        const event = new CustomEvent(name, (0, $eab5a1a480d90122$export$7de063a7aa429f6c)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
    /* eslint-enable */ static define(name, elementConstructor = this, options = {}) {
        const currentlyRegisteredConstructor = customElements.get(name);
        if (!currentlyRegisteredConstructor) {
            customElements.define(name, class extends elementConstructor {
            }, options);
            return;
        }
        let newVersion = " (unknown version)";
        let existingVersion = newVersion;
        if ("version" in elementConstructor && elementConstructor.version) newVersion = " v" + elementConstructor.version;
        if ("version" in currentlyRegisteredConstructor && currentlyRegisteredConstructor.version) existingVersion = " v" + currentlyRegisteredConstructor.version;
        if (newVersion && existingVersion && newVersion === existingVersion) return;
        console.warn(`Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`);
    }
};
/* eslint-disable */ // @ts-expect-error This is auto-injected at build time.
$d6532421f6fe77d5$export$6f25236e887097b.version = "2.11.2";
$d6532421f6fe77d5$export$6f25236e887097b.dependencies = {};
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $d6532421f6fe77d5$export$6f25236e887097b.prototype, "dir", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $d6532421f6fe77d5$export$6f25236e887097b.prototype, "lang", 2);





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { D: $b79faa653abc7290$var$t } = (0, $6d8f6951af537b31$export$8613d1ca9052b22e), $b79faa653abc7290$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $b79faa653abc7290$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $b79faa653abc7290$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $b79faa653abc7290$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $b79faa653abc7290$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $b79faa653abc7290$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $b79faa653abc7290$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $b79faa653abc7290$var$s = ()=>document.createComment(""), $b79faa653abc7290$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($b79faa653abc7290$var$s(), l), c = e.insertBefore($b79faa653abc7290$var$s(), l);
        n = new $b79faa653abc7290$var$t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $b79faa653abc7290$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $b79faa653abc7290$var$u = {}, $b79faa653abc7290$export$ea70d9dd5965b1c8 = (o, t = $b79faa653abc7290$var$u)=>o._$AH = t, $b79faa653abc7290$export$59e9bce518cde500 = (o)=>o._$AH, $b79faa653abc7290$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $b79faa653abc7290$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};





var $7bf02663e7e33382$var$CACHEABLE_ERROR = Symbol();
var $7bf02663e7e33382$var$RETRYABLE_ERROR = Symbol();
var $7bf02663e7e33382$var$parser;
var $7bf02663e7e33382$var$iconCache = /* @__PURE__ */ new Map();
var $7bf02663e7e33382$export$ef62a86bf282441 = class extends (0, $d6532421f6fe77d5$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.initialRender = false;
        this.svg = null;
        this.label = "";
        this.library = "default";
    }
    /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */ async resolveIcon(url, library) {
        var _a;
        let fileData;
        if (library == null ? void 0 : library.spriteSheet) return (0, $6d8f6951af537b31$export$c0bb0b647f701bb5)`<svg part="svg">
        <use part="use" href="${url}"></use>
      </svg>`;
        try {
            fileData = await fetch(url, {
                mode: "cors"
            });
            if (!fileData.ok) return fileData.status === 410 ? $7bf02663e7e33382$var$CACHEABLE_ERROR : $7bf02663e7e33382$var$RETRYABLE_ERROR;
        } catch (e) {
            return $7bf02663e7e33382$var$RETRYABLE_ERROR;
        }
        try {
            const div = document.createElement("div");
            div.innerHTML = await fileData.text();
            const svg = div.firstElementChild;
            if (((_a = svg == null ? void 0 : svg.tagName) == null ? void 0 : _a.toLowerCase()) !== "svg") return $7bf02663e7e33382$var$CACHEABLE_ERROR;
            if (!$7bf02663e7e33382$var$parser) $7bf02663e7e33382$var$parser = new DOMParser();
            const doc = $7bf02663e7e33382$var$parser.parseFromString(svg.outerHTML, "text/html");
            const svgEl = doc.body.querySelector("svg");
            if (!svgEl) return $7bf02663e7e33382$var$CACHEABLE_ERROR;
            svgEl.part.add("svg");
            return document.adoptNode(svgEl);
        } catch (e) {
            return $7bf02663e7e33382$var$CACHEABLE_ERROR;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $39a534c23b7ef51e$export$da63f424a7208010)(this);
    }
    firstUpdated() {
        this.initialRender = true;
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $39a534c23b7ef51e$export$9e46b25ecab82f0b)(this);
    }
    getIconSource() {
        const library = (0, $39a534c23b7ef51e$export$be026de5111f322b)(this.library);
        if (this.name && library) return {
            url: library.resolver(this.name),
            fromLibrary: true
        };
        return {
            url: this.src,
            fromLibrary: false
        };
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        var _a;
        const { url: url, fromLibrary: fromLibrary } = this.getIconSource();
        const library = fromLibrary ? (0, $39a534c23b7ef51e$export$be026de5111f322b)(this.library) : void 0;
        if (!url) {
            this.svg = null;
            return;
        }
        let iconResolver = $7bf02663e7e33382$var$iconCache.get(url);
        if (!iconResolver) {
            iconResolver = this.resolveIcon(url, library);
            $7bf02663e7e33382$var$iconCache.set(url, iconResolver);
        }
        if (!this.initialRender) return;
        const svg = await iconResolver;
        if (svg === $7bf02663e7e33382$var$RETRYABLE_ERROR) $7bf02663e7e33382$var$iconCache.delete(url);
        if (url !== this.getIconSource().url) return;
        if ((0, $b79faa653abc7290$export$6b6d145ec2a44ca9)(svg)) {
            this.svg = svg;
            return;
        }
        switch(svg){
            case $7bf02663e7e33382$var$RETRYABLE_ERROR:
            case $7bf02663e7e33382$var$CACHEABLE_ERROR:
                this.svg = null;
                this.emit("sl-error");
                break;
            default:
                this.svg = svg.cloneNode(true);
                (_a = library == null ? void 0 : library.mutator) == null || _a.call(library, this.svg);
                this.emit("sl-load");
        }
    }
    render() {
        return this.svg;
    }
};
$7bf02663e7e33382$export$ef62a86bf282441.styles = (0, $f227d2fcbc26f981$export$f0b0874d64866432);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $9eba64a7190237ae$export$ca000e230c0caa3e)()
], $7bf02663e7e33382$export$ef62a86bf282441.prototype, "svg", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        reflect: true
    })
], $7bf02663e7e33382$export$ef62a86bf282441.prototype, "name", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $7bf02663e7e33382$export$ef62a86bf282441.prototype, "src", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $7bf02663e7e33382$export$ef62a86bf282441.prototype, "label", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        reflect: true
    })
], $7bf02663e7e33382$export$ef62a86bf282441.prototype, "library", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $245c976188bf2656$export$3db5d71bdb2d5499)("label")
], $7bf02663e7e33382$export$ef62a86bf282441.prototype, "handleLabelChange", 1);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $245c976188bf2656$export$3db5d71bdb2d5499)([
        "name",
        "src",
        "library"
    ])
], $7bf02663e7e33382$export$ef62a86bf282441.prototype, "setIcon", 1);


// src/components/icon/icon.ts
var $70b43628b3a75252$export$21036209a317fcec = (0, $7bf02663e7e33382$export$ef62a86bf282441);
(0, $7bf02663e7e33382$export$ef62a86bf282441).define("sl-icon");























/* eslint-disable max-len */ const $7aca0318821b9def$export$c4bed357580b213 = {
    "bang-circle": `<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" class="bi" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16 30.4C23.9529 30.4 30.4 23.9529 30.4 16C30.4 8.04707 23.9529 1.59997 16 1.59997C8.0471 1.59997 1.6 8.04707 1.6 16C1.6 23.9529 8.0471 30.4 16 30.4Z"/>
<rect x="15" y="10" width="2" height="8" rx="1"/>
<circle cx="16" cy="21" r="1"/>
</svg>
`,
    "bang-triangle": `<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" class="bi" xmlns="http://www.w3.org/2000/svg">
<path fill="none"  stroke="currentColor" d="M0.765997 29.0838L0.766011 29.0838L15.9019 2.80631L15.2528 2.43239L15.9019 2.8063C15.9452 2.73123 16.0548 2.73123 16.098 2.8063L16.7479 2.43196L16.098 2.80631L31.234 29.0838C31.2755 29.1559 31.2248 29.25 31.1359 29.25H0.864068C0.775272 29.25 0.724451 29.1559 0.765997 29.0838Z" stroke-width="1.5"/>
<rect x="15" y="13" width="2" height="8" rx="1"/>
<circle cx="16" cy="24" r="1"/>
</svg>
`,
    "caret-left-circle": `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi" viewBox="0 0 24 24">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 0C5.3727 0 0 5.37269 0 12C0 18.6274 5.3727 24 12.0001 24C18.6275 24 24 18.6275 24 12C24 5.37265 18.6274 0 12.0001 0ZM12.0001 1.10318C18.0182 1.10318 22.8968 5.98192 22.8968 12C22.8968 18.0182 18.0182 22.8968 12.0001 22.8968C5.9819 22.8968 1.1032 18.0182 1.1032 12C1.1032 5.98195 5.982 1.10318 12.0001 1.10318ZM13.1727 7.68322L9.1278 11.6945C8.9574 11.8634 8.9574 12.1362 9.1278 12.3055L13.1727 16.3168C13.4187 16.5611 13.819 16.5611 14.0655 16.3168C14.3115 16.0725 14.3115 15.676 14.0655 15.4317L10.6053 11.9998L14.0655 8.56872C14.3115 8.32399 14.3115 7.92751 14.0655 7.68322C13.819 7.43893 13.4187 7.43893 13.1727 7.68322Z"/>
</svg>
`,
    "caret-right-circle": `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi" viewBox="0 0 24 24">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 0C18.6273 0 24 5.37269 24 12C24 18.6274 18.6273 24 11.9999 24C5.37251 24 0 18.6275 0 12C0 5.37265 5.37258 0 11.9999 0ZM11.9999 1.10318C5.98185 1.10318 1.10319 5.98192 1.10319 12C1.10319 18.0182 5.98179 22.8968 11.9999 22.8968C18.0181 22.8968 22.8968 18.0182 22.8968 12C22.8968 5.98195 18.018 1.10318 11.9999 1.10318ZM10.8273 7.68322L14.8722 11.6945C15.0426 11.8634 15.0426 12.1362 14.8722 12.3055L10.8273 16.3168C10.5813 16.5611 10.181 16.5611 9.93452 16.3168C9.68849 16.0725 9.68849 15.676 9.93452 15.4317L13.3947 11.9998L9.93452 8.56872C9.68849 8.32399 9.68849 7.92751 9.93452 7.68322C10.181 7.43893 10.5813 7.43893 10.8273 7.68322Z"/>
</svg>
`,
    "check-circle": `<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" class="bi" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM30.4 16C30.4 23.9529 23.9529 30.4 16 30.4C8.0471 30.4 1.6 23.9529 1.6 16C1.6 8.04707 8.0471 1.59997 16 1.59997C23.9529 1.59997 30.4 8.04707 30.4 16ZM22.4352 10.9497C22.8257 10.5592 23.4589 10.5592 23.8494 10.9497C24.2399 11.3403 24.2399 11.9734 23.8494 12.364L15.3641 20.8492C14.9736 21.2398 14.3404 21.2398 13.9499 20.8492L9.70718 16.6066C9.31668 16.2161 9.31668 15.5829 9.70718 15.1924C10.0978 14.8019 10.7309 14.8019 11.1215 15.1924L14.657 18.7279L22.4352 10.9497Z"/>
</svg>
`,
    checkmark: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0H4ZM10.0805 13.8534L17.3947 6.53927C17.8896 6.04433 18.7145 6.04433 19.2644 6.48428C19.7594 6.97922 19.7594 7.85911 19.2644 8.35405L11.0154 16.658C10.7405 16.933 10.4105 17.043 10.0805 17.043C9.75059 17.043 9.42063 16.933 9.14566 16.658L5.29613 12.8085C4.80119 12.3136 4.80119 11.4337 5.29613 10.9387C5.79107 10.4438 6.67096 10.4438 7.1659 10.9387L10.0805 13.8534Z" fill="currentColor"/>
</svg>
`,
    "chevron-down": `<svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.6373 10.6362C11.1573 11.1114 10.385 11.1211 9.89307 10.6653L9.8627 10.6362L0.878925 1.74379C0.707026 1.57364 0.707026 1.29777 0.878925 1.12761C1.04395 0.964267 1.30741 0.957733 1.48031 1.10801L1.50143 1.12761L10.4852 10.0201C10.6251 10.1585 10.8481 10.1645 10.9952 10.0381L11.0148 10.0201L19.9986 1.12761C20.1705 0.95746 20.4492 0.95746 20.6211 1.12761C20.7861 1.29096 20.7927 1.55174 20.6409 1.72288L20.6211 1.74379L11.6373 10.6362Z" fill="currentColor" stroke="currentColor" stroke-width="0.75"/>
</svg>
`,
    "circle-solid": `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#circle_solid_clippath)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 0C5.3727 0 0 5.37269 0 12C0 18.6274 5.3727 24 12.0001 24C18.6275 24 24 18.6275 24 12C24 5.37265 18.6274 0 12.0001 0Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="circle_solid_clippath">
<rect width="24" height="24" fill="transparent" transform="matrix(-1 0 0 1 24 0)"/>
</clipPath>
</defs>
</svg>
`,
    circle: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#circle_clippath)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 0C5.3727 0 0 5.37269 0 12C0 18.6274 5.3727 24 12.0001 24C18.6275 24 24 18.6275 24 12C24 5.37265 18.6274 0 12.0001 0ZM12.0001 1.10318C18.0182 1.10318 22.8968 5.98192 22.8968 12C22.8968 18.0182 18.0182 22.8968 12.0001 22.8968C5.9819 22.8968 1.1032 18.0182 1.1032 12C1.1032 5.98195 5.982 1.10318 12.0001 1.10318Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="circle_clippath">
<rect width="24" height="24" fill="transparent" transform="matrix(-1 0 0 1 24 0)"/>
</clipPath>
</defs>
</svg>
`,
    close: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7697 0.404904C23.4626 0.111777 22.9648 0.111777 22.6577 0.404904L12 10.5787L1.3423 0.404983L1.30456 0.371214C0.995707 0.112324 0.525089 0.123581 0.230302 0.404983C-0.0767674 0.69811 -0.0767674 1.17336 0.230302 1.46649L10.888 11.6402L0.230302 21.814L0.194928 21.85C-0.0762761 22.1448 -0.0644846 22.5941 0.230302 22.8755C0.537372 23.1686 1.03523 23.1686 1.3423 22.8755L12 12.7017L22.6577 22.8756L22.6954 22.9093C23.0043 23.1682 23.4749 23.157 23.7697 22.8756C24.0768 22.5824 24.0768 22.1072 23.7697 21.8141L13.112 11.6402L23.7697 1.46641L23.8051 1.43039C24.0763 1.13556 24.0645 0.686306 23.7697 0.404904Z" fill="currentColor">
    </path>
</svg>`,
    "clover-logo": `<svg role="img" width="20" height="24" aria-labelledby="brandLogoTitleID brandLogoDescID" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.1917 16.1841C18.8453 16.1841 18.538 16.2986 18.1153 16.5275C16.808 17.2901 15.0389 17.748 13.3089 17.748C9.34626 17.748 7.42438 15.3458 7.42438 11.1508C7.42438 7.56685 8.84712 6.19489 10.1171 5.81276C10.4617 5.69829 10.8471 5.66126 11.1934 5.66126C12.9625 5.66126 14.3462 6.88171 15.7316 9.4354C16.1544 10.1997 16.4633 10.3124 17.117 10.3124C18.5788 10.3124 20.4243 8.86305 20.4243 6.00299C20.4243 2.648 17.0015 0.436036 11.7333 0.436036C4.73001 0.434352 0 5.08722 0 12.2938C0 20.3774 4.84546 24 11.499 24C15.19 24 17.499 22.9328 18.9217 21.5978C19.9217 20.6838 20.5754 19.3876 20.5754 18.051C20.5754 16.4888 19.7299 16.1841 19.1917 16.1841Z" fill="white"></path>
</svg>`,
    "eye-hide": `<svg width="16" height="16" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.17212 3.14357C3.88246 2.9289 3.4732 2.95518 3.21301 3.22094C2.92679 3.51327 2.92934 3.98466 3.21869 4.27383L26.7448 27.7848L26.8279 27.8564C27.1175 28.0711 27.5268 28.0448 27.787 27.7791C28.0732 27.4867 28.0707 27.0153 27.7813 26.7262L4.25516 3.2152L4.17212 3.14357ZM0.138988 15.5248C1.29523 12.7505 2.961 10.3592 4.9797 8.48551L5.95795 9.45316C4.10562 11.1564 2.56532 13.3339 1.47826 15.8686L1.42249 15.9999L1.47759 16.1301C4.18209 22.4374 9.69289 26.5328 15.8347 26.6157L16.0248 26.617C18.1017 26.617 20.1079 26.1482 21.9605 25.2823L23.0005 26.311C20.908 27.3724 18.6172 27.9661 16.2317 27.9986L16.0248 28C9.09882 28 2.92022 23.3545 0.051222 16.2617C-0.0210863 16.0829 -0.0140388 15.8923 0.0547465 15.7286L0.0596659 15.7178L0.138988 15.5248ZM9.25786 16C9.25786 15.0297 9.45744 14.1066 9.81727 13.2706L10.8817 14.3236C10.7134 14.8517 10.6225 15.4151 10.6225 16C10.6225 19.0099 13.0302 21.4499 16.0001 21.4499C16.6231 21.4499 17.2214 21.3425 17.7779 21.145L18.8423 22.1978C17.9786 22.6053 17.0156 22.8328 16.0001 22.8328C12.2765 22.8328 9.25786 19.7737 9.25786 16ZM13.3382 9.72055L14.4191 10.7897C14.919 10.6341 15.4499 10.5504 16.0001 10.5504C18.9699 10.5504 21.3775 12.9902 21.3775 16C21.3775 16.5113 21.308 17.0062 21.1781 17.4755L22.2591 18.5447C22.5707 17.7582 22.7422 16.8994 22.7422 16C22.7422 12.2264 19.7236 9.16739 16.0001 9.16739C15.0547 9.16739 14.1548 9.36456 13.3382 9.72055ZM30.5213 16.0153C29.4517 18.5258 27.9527 20.6909 26.1547 22.3981L27.1322 23.3651C29.1481 21.4377 30.806 18.9825 31.9493 16.1406L31.9618 16.1071L31.9751 16.0642L31.9826 16.0342L31.9917 15.9869L31.9954 15.9591L31.9988 15.921L32 15.8826L31.9991 15.844L31.9961 15.8053L31.9908 15.7666L31.9834 15.728L31.9736 15.6895L31.9608 15.6491L31.9472 15.6133L31.8595 15.4032C28.9315 8.49625 22.8388 4 16.0248 4L15.8173 4.00139C13.4799 4.03274 11.231 4.593 9.16958 5.59713L10.2159 6.63209C12.0342 5.82084 13.9965 5.38298 16.0248 5.38298L16.2138 5.38425C22.3171 5.46613 27.7992 9.51017 30.5229 15.7567L30.577 15.8828L30.5213 16.0153Z"></path>
</svg>`,
    "eye-show": `<svg width="16" height="16" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0248 4C22.8388 4 28.9315 8.49625 31.8595 15.4032L31.9472 15.6133L31.9608 15.6491L31.9736 15.6895L31.9834 15.728L31.9908 15.7666L31.9961 15.8053L31.9991 15.844L32 15.8826L31.9988 15.921L31.9954 15.9591L31.9917 15.9869L31.9826 16.0342L31.9751 16.0642L31.9618 16.1071L31.9493 16.1406C29.0994 23.2245 23.0524 27.9057 16.2317 27.9986L16.0248 28C9.09882 28 2.92022 23.3545 0.051222 16.2617C-0.0210863 16.0829 -0.0140388 15.8923 0.0547465 15.7286L0.0596659 15.7178L0.138988 15.5248C3.01542 8.62287 9.04531 4.09222 15.8173 4.00139L16.0248 4ZM16.0248 5.38298C9.80739 5.38298 4.21082 9.49701 1.47826 15.8686L1.42249 15.9999L1.47759 16.1301C4.18209 22.4374 9.69289 26.5328 15.8347 26.6157L16.0248 26.617C22.2165 26.617 27.7793 22.4506 30.5213 16.0153L30.577 15.8828L30.5229 15.7567C27.7992 9.51017 22.3171 5.46613 16.2138 5.38425L16.0248 5.38298ZM9.25786 16C9.25786 12.2264 12.2765 9.16739 16.0001 9.16739C19.7236 9.16739 22.7422 12.2264 22.7422 16C22.7422 19.7736 19.7236 22.8328 16.0001 22.8328C12.2765 22.8328 9.25786 19.7737 9.25786 16ZM21.3775 16C21.3775 12.9902 18.9699 10.5504 16.0001 10.5504C13.0301 10.5504 10.6225 12.9902 10.6225 16C10.6225 19.0099 13.0302 21.4499 16.0001 21.4499C18.9699 21.4499 21.3775 19.0098 21.3775 16ZM18.0635 16C18.0635 17.155 17.1397 18.0913 16.0002 18.0913C14.8605 18.0913 13.9366 17.155 13.9366 16C13.9366 14.8452 14.8605 13.9089 16.0002 13.9089C17.1397 13.9089 18.0635 14.8452 18.0635 16Z"></path>
</svg>`,
    facebook: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
</svg>`,
    globe: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
    <path fill="currentColor" d="M 7.832031 1.832031 C 4.433594 1.832031 1.667969 4.601562 1.667969 8 C 1.667969 11.398438 4.433594 14.167969 7.832031 14.167969 C 11.234375 14.167969 14 11.398438 14 8 C 14 4.601562 11.234375 1.832031 7.832031 1.832031 Z M 7.589844 13.519531 C 7 13.519531 6.363281 12.425781 6.027344 10.667969 L 9.152344 10.667969 C 8.816406 12.425781 8.179688 13.519531 7.589844 13.519531 Z M 5.925781 10.035156 C 5.855469 9.507812 5.808594 8.929688 5.796875 8.316406 L 9.382812 8.316406 C 9.371094 8.929688 9.324219 9.507812 9.253906 10.035156 Z M 2.316406 8.316406 L 5.164062 8.316406 C 5.175781 8.894531 5.21875 9.476562 5.292969 10.035156 L 2.691406 10.035156 C 2.476562 9.5 2.347656 8.921875 2.316406 8.316406 Z M 7.589844 2.480469 C 8.171875 2.480469 8.796875 3.542969 9.136719 5.253906 L 6.042969 5.253906 C 6.382812 3.542969 7.007812 2.480469 7.589844 2.480469 Z M 9.242188 5.886719 C 9.320312 6.4375 9.371094 7.039062 9.382812 7.683594 L 5.796875 7.683594 C 5.8125 7.039062 5.859375 6.4375 5.9375 5.886719 Z M 5.164062 7.683594 L 2.316406 7.683594 C 2.351562 7.050781 2.488281 6.445312 2.71875 5.886719 L 5.304688 5.886719 C 5.222656 6.46875 5.175781 7.078125 5.164062 7.683594 Z M 10.015625 8.316406 L 13.351562 8.316406 C 13.316406 8.921875 13.1875 9.5 12.976562 10.035156 L 9.886719 10.035156 C 9.960938 9.476562 10.003906 8.894531 10.015625 8.316406 Z M 10.015625 7.683594 C 10.003906 7.078125 9.957031 6.46875 9.878906 5.886719 L 12.945312 5.886719 C 13.179688 6.445312 13.316406 7.050781 13.351562 7.683594 Z M 12.632812 5.253906 L 9.777344 5.253906 C 9.566406 4.140625 9.226562 3.167969 8.765625 2.550781 C 10.417969 2.832031 11.824219 3.847656 12.632812 5.253906 Z M 6.324219 2.679688 C 5.90625 3.300781 5.601562 4.21875 5.40625 5.253906 L 3.035156 5.253906 C 3.746094 4.015625 4.921875 3.078125 6.324219 2.679688 Z M 2.988281 10.667969 L 5.390625 10.667969 C 5.585938 11.738281 5.898438 12.683594 6.324219 13.320312 C 4.890625 12.914062 3.695312 11.945312 2.988281 10.667969 Z M 8.765625 13.449219 C 9.238281 12.816406 9.582031 11.8125 9.789062 10.667969 L 12.679688 10.667969 C 11.878906 12.113281 10.449219 13.160156 8.765625 13.449219 Z M 8.765625 13.449219 "/>
</svg>`,
    info: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
</svg>`,
    instagram: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"/>
</svg>`,
    lightbulb: `<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" class="bi" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M24.1361 18.1063C23.1266 19.1969 21.9231 20.9819 21.9231 23.292V24.157C21.9231 25.2431 21.2156 26.1689 20.2308 26.5128V27.9888C20.2308 30.2855 18.3328 32 16 32C13.6672 32 11.7692 30.2855 11.7692 27.9888V26.5128C10.7844 26.1689 10.0769 25.243 10.0769 24.157V23.5843C10.0769 21.5116 9.3681 19.647 8.08102 18.3342C6.09425 16.3077 5 13.6421 5 10.829C5.00008 4.85781 9.9346 0 16 0C22.0655 0 27 4.85781 27 10.829C27 13.5268 25.9828 16.1112 24.1361 18.1063ZM20.2308 24.157V23.292C20.2308 21.0414 21.1487 18.8601 22.8852 16.9842C24.4474 15.2966 25.3077 13.1107 25.3077 10.829C25.3077 5.77652 21.1323 1.66599 16 1.66599C10.8678 1.66599 6.69239 5.77652 6.69231 10.829C6.69231 13.2083 7.61792 15.4629 9.29872 17.1773C10.8919 18.8023 11.7692 21.0777 11.7692 23.5843V24.157C11.7692 24.6164 12.1488 24.99 12.6154 24.99H19.3846C19.8512 24.99 20.2308 24.6164 20.2308 24.157ZM16.0001 12.9829L18.7864 10.24C19.1169 9.91472 19.6525 9.91472 19.983 10.24C20.3134 10.5653 20.3134 11.0928 19.983 11.4181L16.8462 14.5061V20.825C16.8462 21.285 16.4673 21.658 16.0001 21.658C15.5328 21.658 15.1539 21.285 15.1539 20.825V14.5061L12.017 11.418C11.6866 11.0927 11.6866 10.5652 12.017 10.2399C12.3476 9.91472 12.8833 9.91472 13.2138 10.2399L16.0001 12.9829Z"/>
</svg>
`,
    privacy: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="16" viewBox="0 0 15 15" version="1.1">
    <path fill="currentColor" d="M 7.59375 1.253906 C 9.085938 1.253906 10.160156 2.445312 10.160156 3.988281 C 10.160156 5.152344 9.703125 5.839844 8.5625 6.464844 L 8.394531 6.554688 L 9.144531 6.832031 C 9.195312 6.851562 9.246094 6.871094 9.292969 6.886719 L 9.578125 7 L 9.847656 7.109375 C 9.933594 7.148438 10.019531 7.183594 10.101562 7.21875 L 10.335938 7.328125 C 11.664062 7.964844 12.171875 8.605469 12.171875 9.773438 L 12.179688 10.085938 C 12.183594 10.265625 12.1875 10.449219 12.1875 10.625 L 12.1875 11.035156 L 12.179688 11.308594 C 12.179688 11.390625 12.175781 11.472656 12.171875 11.542969 C 12.128906 12.285156 11.761719 12.570312 11 12.6875 C 10.625 12.746094 10.25 12.792969 9.835938 12.835938 L 9.40625 12.871094 C 9.328125 12.878906 9.253906 12.886719 9.175781 12.890625 C 9 12.902344 8.84375 12.773438 8.832031 12.601562 C 8.816406 12.425781 8.949219 12.273438 9.128906 12.261719 L 9.5625 12.226562 C 10.050781 12.183594 10.472656 12.128906 10.898438 12.0625 L 11.046875 12.039062 C 11.417969 11.964844 11.507812 11.855469 11.527344 11.507812 L 11.53125 11.402344 L 11.539062 11.160156 L 11.542969 10.882812 C 11.542969 10.714844 11.542969 10.542969 11.539062 10.363281 L 11.527344 9.78125 C 11.527344 8.890625 11.109375 8.386719 9.917969 7.832031 L 9.691406 7.734375 L 9.449219 7.628906 L 9.1875 7.527344 C 9.140625 7.507812 9.097656 7.492188 9.050781 7.472656 L 8.761719 7.363281 L 8.296875 7.195312 L 7.9375 7.054688 C 7.878906 7.035156 7.820312 7.011719 7.765625 6.988281 L 7.59375 6.917969 C 7.421875 6.992188 7.242188 7.0625 7.054688 7.132812 L 6.28125 7.417969 L 6.003906 7.527344 L 5.742188 7.628906 L 5.496094 7.734375 L 5.273438 7.832031 C 4.113281 8.367188 3.6875 8.859375 3.664062 9.703125 L 3.660156 9.78125 L 3.660156 11.328125 C 3.660156 11.550781 3.714844 11.683594 3.832031 11.785156 L 3.878906 11.824219 C 4.023438 11.925781 4.054688 12.125 3.949219 12.265625 C 3.84375 12.40625 3.640625 12.4375 3.496094 12.332031 C 3.199219 12.117188 3.042969 11.820312 3.019531 11.425781 L 3.015625 11.328125 L 3.015625 9.78125 C 3.015625 8.476562 3.648438 7.824219 5.339844 7.109375 L 5.609375 7 L 5.894531 6.886719 L 6.199219 6.773438 L 6.628906 6.617188 L 6.796875 6.554688 L 6.746094 6.527344 C 5.554688 5.90625 5.058594 5.234375 5.03125 4.09375 L 5.027344 3.988281 C 5.027344 2.445312 6.101562 1.253906 7.59375 1.253906 Z M 7.59375 1.886719 C 6.476562 1.886719 5.671875 2.777344 5.671875 3.988281 C 5.671875 5.015625 6.15625 5.582031 7.5 6.1875 L 7.59375 6.230469 L 7.691406 6.1875 C 8.996094 5.597656 9.488281 5.046875 9.515625 4.074219 L 9.515625 3.988281 C 9.515625 2.777344 8.710938 1.886719 7.59375 1.886719 Z M 5.265625 9.738281 C 5.0625 9.785156 4.878906 9.898438 4.78125 10.078125 C 4.714844 10.199219 4.679688 10.449219 4.667969 10.664062 L 4.636719 11.414062 L 4.632812 11.65625 L 4.632812 11.734375 C 4.632812 12.582031 4.816406 12.902344 5.414062 12.917969 L 5.730469 12.925781 L 6.414062 12.941406 L 6.726562 12.949219 L 7.148438 12.949219 L 7.324219 12.941406 C 7.792969 12.921875 8.011719 12.855469 8.128906 12.671875 C 8.21875 12.539062 8.246094 12.417969 8.261719 12.214844 C 8.285156 12 8.292969 11.78125 8.289062 11.527344 L 8.285156 11.265625 L 8.273438 10.980469 L 8.257812 10.667969 C 8.242188 10.367188 8.195312 10.167969 8.054688 10.015625 C 7.929688 9.882812 7.785156 9.808594 7.613281 9.777344 C 7.59375 8.824219 7.261719 8.285156 6.488281 8.289062 C 5.65625 8.289062 5.34375 8.785156 5.324219 9.730469 C 5.304688 9.730469 5.285156 9.734375 5.265625 9.738281 Z M 6.488281 8.917969 C 6.8125 8.917969 6.953125 9.132812 6.96875 9.75 L 6.523438 9.75 L 6.230469 9.742188 C 6.183594 9.742188 6.136719 9.742188 6.09375 9.738281 L 5.96875 9.734375 L 5.96875 9.730469 L 5.976562 9.570312 C 6.003906 9.070312 6.136719 8.921875 6.488281 8.917969 Z M 5.65625 10.351562 L 5.792969 10.359375 L 6.066406 10.371094 L 6.355469 10.378906 L 6.675781 10.382812 L 7.316406 10.382812 C 7.464844 10.382812 7.539062 10.402344 7.582031 10.445312 L 7.589844 10.488281 L 7.601562 10.554688 L 7.613281 10.648438 C 7.613281 10.667969 7.613281 10.683594 7.617188 10.703125 L 7.628906 11.003906 L 7.640625 11.273438 C 7.652344 11.621094 7.644531 11.898438 7.621094 12.160156 L 7.613281 12.246094 L 7.605469 12.273438 L 7.558594 12.28125 L 7.457031 12.292969 L 7.398438 12.300781 C 7.34375 12.304688 7.28125 12.308594 7.214844 12.308594 L 7 12.316406 C 6.960938 12.316406 6.921875 12.316406 6.878906 12.316406 L 6.523438 12.3125 L 5.542969 12.289062 L 5.402344 12.289062 L 5.359375 12.285156 C 5.304688 12.273438 5.289062 12.234375 5.28125 12.109375 L 5.277344 11.886719 L 5.277344 11.585938 L 5.289062 11.253906 L 5.308594 10.714844 L 5.316406 10.625 L 5.339844 10.414062 L 5.347656 10.382812 C 5.347656 10.378906 5.371094 10.363281 5.40625 10.355469 C 5.433594 10.351562 5.46875 10.347656 5.515625 10.347656 Z M 6.746094 11.199219 C 6.722656 11.058594 6.597656 10.953125 6.449219 10.953125 C 6.285156 10.953125 6.152344 11.082031 6.152344 11.242188 L 6.152344 11.457031 L 6.15625 11.5 C 6.175781 11.640625 6.300781 11.75 6.449219 11.75 C 6.613281 11.75 6.746094 11.617188 6.746094 11.457031 Z M 6.746094 11.199219 "/>
</svg>`,
    "question-circle": `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
</svg>`,
    "thumbs-up": `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" version="1.1">
    <path fill="currentColor" d="M 8.667969 1.882812 C 7.46875 4.726562 5.679688 6.730469 2.957031 8.328125 C 2.898438 8.363281 2.855469 8.414062 2.828125 8.476562 C 2.433594 9.476562 2.40625 10.933594 2.671875 12.597656 L 2.710938 12.828125 C 2.730469 12.945312 2.753906 13.0625 2.773438 13.183594 L 2.824219 13.421875 C 2.847656 13.542969 2.875 13.664062 2.902344 13.785156 C 2.933594 13.921875 3.058594 14.019531 3.199219 14.019531 C 3.277344 14.015625 3.355469 14.015625 3.4375 14.015625 L 3.941406 14.015625 C 4.027344 14.015625 4.117188 14.015625 4.207031 14.015625 L 4.480469 14.023438 L 4.769531 14.027344 L 5.066406 14.035156 L 5.378906 14.046875 L 5.699219 14.058594 L 6.0625 14.074219 L 6.421875 14.089844 L 7.027344 14.121094 L 9.363281 14.242188 L 9.976562 14.269531 L 10.34375 14.285156 L 10.644531 14.292969 L 11 14.300781 L 11.46875 14.300781 L 11.585938 14.296875 L 11.699219 14.292969 L 11.800781 14.289062 L 11.898438 14.28125 L 11.992188 14.273438 L 12.078125 14.265625 C 12.417969 14.222656 12.605469 14.132812 12.695312 13.96875 C 12.734375 13.898438 12.757812 13.824219 12.773438 13.75 L 12.78125 13.703125 C 12.8125 13.441406 12.707031 13.214844 12.492188 12.933594 L 12.449219 12.878906 L 12.457031 12.875 C 12.496094 12.859375 12.539062 12.839844 12.578125 12.824219 C 12.980469 12.628906 13.238281 12.316406 13.242188 11.867188 L 13.242188 11.824219 C 13.234375 11.492188 13.085938 11.3125 12.796875 11.175781 L 12.773438 11.167969 L 12.804688 11.15625 C 13.34375 10.945312 13.550781 10.660156 13.488281 10.113281 L 13.484375 10.070312 C 13.429688 9.742188 13.199219 9.5 12.851562 9.320312 L 12.835938 9.3125 L 12.863281 9.289062 C 13.210938 9.03125 13.394531 8.65625 13.332031 8.175781 C 13.285156 7.785156 12.957031 7.59375 12.457031 7.523438 C 12.410156 7.515625 12.363281 7.511719 12.3125 7.503906 L 12.210938 7.496094 C 12.191406 7.496094 12.175781 7.496094 12.15625 7.496094 L 12.042969 7.488281 L 11.925781 7.488281 C 11.882812 7.488281 11.84375 7.488281 11.800781 7.488281 L 11.664062 7.488281 C 11.640625 7.488281 11.617188 7.488281 11.59375 7.492188 L 11.445312 7.496094 L 11.285156 7.503906 L 11.117188 7.511719 L 10.476562 7.546875 L 10.335938 7.554688 L 10.078125 7.566406 L 9.960938 7.570312 L 9.664062 7.570312 L 9.578125 7.566406 L 9.503906 7.5625 L 9.433594 7.558594 L 9.375 7.550781 C 9.363281 7.546875 9.355469 7.546875 9.347656 7.546875 L 9.289062 7.535156 L 9.289062 7.507812 C 9.257812 6.9375 9.394531 6.117188 9.636719 5.347656 L 9.667969 5.246094 C 10.25 3.472656 9.996094 1.953125 9.019531 1.710938 C 8.875 1.671875 8.726562 1.746094 8.667969 1.882812 Z M 12.269531 11.617188 L 12.496094 11.699219 C 12.617188 11.746094 12.636719 11.765625 12.640625 11.828125 L 12.640625 11.863281 C 12.640625 12.046875 12.53125 12.179688 12.320312 12.28125 C 12.234375 12.324219 12.136719 12.355469 12.042969 12.375 L 11.933594 12.398438 C 11.929688 12.398438 11.925781 12.398438 11.921875 12.398438 C 11.742188 12.417969 11.621094 12.589844 11.664062 12.765625 C 11.683594 12.859375 11.730469 12.941406 11.808594 13.042969 L 11.984375 13.257812 L 12.011719 13.296875 C 12.125 13.441406 12.179688 13.542969 12.183594 13.613281 L 12.183594 13.628906 L 12.148438 13.640625 L 12.089844 13.652344 C 12.066406 13.65625 12.042969 13.660156 12.019531 13.664062 L 11.941406 13.671875 C 11.894531 13.675781 11.84375 13.679688 11.789062 13.683594 L 11.671875 13.691406 C 11.652344 13.691406 11.632812 13.691406 11.609375 13.691406 L 11.480469 13.695312 C 11.457031 13.699219 11.433594 13.699219 11.410156 13.699219 L 10.933594 13.699219 L 10.621094 13.691406 L 10.160156 13.679688 L 9.503906 13.648438 L 6.933594 13.515625 L 6.328125 13.484375 L 5.964844 13.46875 L 5.558594 13.453125 L 5.238281 13.441406 L 4.933594 13.433594 L 4.636719 13.425781 L 4.351562 13.417969 L 4.074219 13.414062 L 3.808594 13.414062 C 3.765625 13.414062 3.722656 13.414062 3.679688 13.414062 L 3.433594 13.414062 L 3.410156 13.300781 C 3.035156 11.484375 2.984375 9.863281 3.339844 8.828125 L 3.351562 8.792969 L 3.390625 8.769531 C 6.019531 7.195312 7.816406 5.230469 9.046875 2.523438 L 9.089844 2.421875 L 9.105469 2.4375 C 9.429688 2.808594 9.5 3.78125 9.125 4.980469 L 9.097656 5.058594 C 8.78125 6.03125 8.617188 7.089844 8.710938 7.785156 C 8.722656 7.875 8.773438 7.953125 8.851562 8 C 8.976562 8.078125 9.125 8.125 9.328125 8.152344 L 9.410156 8.160156 L 9.492188 8.164062 L 9.585938 8.171875 L 9.683594 8.171875 C 9.699219 8.171875 9.71875 8.171875 9.734375 8.171875 L 9.957031 8.171875 L 10.148438 8.164062 L 10.285156 8.160156 L 10.585938 8.144531 L 11.148438 8.109375 L 11.363281 8.101562 L 11.496094 8.09375 L 11.625 8.09375 L 11.800781 8.089844 L 11.910156 8.089844 L 12.011719 8.09375 L 12.109375 8.09375 L 12.195312 8.101562 L 12.277344 8.105469 L 12.351562 8.113281 L 12.421875 8.121094 L 12.484375 8.132812 L 12.539062 8.140625 C 12.667969 8.167969 12.734375 8.207031 12.738281 8.25 C 12.773438 8.53125 12.664062 8.71875 12.425781 8.863281 C 12.28125 8.953125 12.113281 9.003906 11.984375 9.03125 L 11.933594 9.039062 C 11.59375 9.085938 11.585938 9.574219 11.921875 9.632812 L 11.976562 9.644531 L 12.027344 9.652344 L 12.089844 9.667969 C 12.21875 9.703125 12.347656 9.746094 12.464844 9.796875 C 12.730469 9.914062 12.878906 10.054688 12.894531 10.179688 L 12.898438 10.238281 C 12.910156 10.398438 12.882812 10.460938 12.738281 10.53125 L 12.683594 10.554688 L 12.621094 10.582031 L 12.558594 10.605469 L 12.492188 10.628906 L 12.417969 10.65625 L 11.882812 10.832031 C 11.65625 10.902344 11.601562 11.195312 11.78125 11.34375 C 11.871094 11.421875 11.96875 11.484375 12.078125 11.535156 C 12.136719 11.566406 12.199219 11.589844 12.269531 11.617188 Z M 12.269531 11.617188 "/>
</svg`,
    twitter: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter" viewBox="0 0 16 16">
  <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
</svg>`,
    "walgreens-logo": `<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M33.4113 0.432224C31.9445 0.425797 30.5277 1.33843 29.604 2.71381C33.9418 5.63809 28.6241 20.176 20.791 20.176C19.8486 20.176 19.0559 19.8932 18.5191 19.3212C22.7633 15.3814 25.8279 10.0342 25.8279 6.8785C25.8279 5.26532 25.0602 4.24343 23.2689 4.24343C18.0635 4.24343 12.5772 13.0356 13.5946 19.3854C10.3116 20.5873 8.68257 19.0834 8.68257 16.0691C8.68257 9.77065 15.0738 3.23439 14.6993 1.27416C8.07714 3.36936 2.89048 -1.52801 0.5 6.44789C3.7206 4.64191 6.69154 7.52763 10.3615 5.41957C7.20958 9.16008 4.02643 14.4688 4.07012 18.9484C4.10133 21.8791 5.63673 23.9936 8.96967 23.9936C10.8608 23.9936 12.8269 23.3123 14.7118 22.2005C15.5232 23.2416 16.8277 23.9936 18.8187 23.9936C26.9513 23.9936 35.833 12.2322 35.833 3.83853C35.8392 1.60836 34.9779 0.438651 33.4113 0.432224ZM17.7639 16.6025C17.8326 12.0651 20.9471 7.30268 22.5199 7.30268C22.988 7.30268 23.0816 7.6176 23.0816 7.94538C23.0879 9.50071 20.8534 13.6461 17.7639 16.6025Z" fill="#E52600"/>
</svg>
`,
    "x-circle": `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="bi" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 0C18.6274 0 24 5.37262 24 12C24 18.6275 18.6275 24 11.9999 24C5.37264 24 0 18.6274 0 12C0 5.37272 5.3727 0 11.9999 0ZM15.5504 8.44954C15.3065 8.20565 14.9237 8.18533 14.6567 8.38858L14.5869 8.44956L11.9999 11.0365L9.38036 8.419C9.11276 8.184 8.70498 8.19421 8.44956 8.44963C8.20566 8.69352 8.18533 9.07631 8.38857 9.34336L8.44954 9.41313L11.0356 11.9999L8.44954 14.5871L8.41889 14.6198C8.18391 14.8874 8.19413 15.2952 8.44956 15.5506C8.69345 15.7945 9.07626 15.8148 9.3433 15.6116L9.41306 15.5506L11.999 12.9633L14.6196 15.5814C14.8872 15.8163 15.295 15.8061 15.5504 15.5507C15.7943 15.3068 15.8147 14.924 15.6114 14.657L15.5505 14.5872L12.9633 11.9999L15.5811 9.38034C15.8161 9.11272 15.8059 8.70495 15.5504 8.44954Z"/>
</svg>
`,
    youtube: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-youtube" viewBox="0 0 16 16">
  <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/>
</svg>`
};


const $1ec2e28778eb11c3$export$89ce1880c5e6b1b3 = {
    // the type requires a name here but it doesn't appear to be used
    name: "",
    resolver: (name)=>{
        if (!(name in (0, $7aca0318821b9def$export$c4bed357580b213))) {
            // eslint-disable-next-line no-console
            console.debug(`icon "${String(name)}" doesn't exist`);
            return "";
        }
        return `data:image/svg+xml,${encodeURIComponent(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $7aca0318821b9def$export$c4bed357580b213)[name])}`;
    },
    mutator: (svg)=>{
        svg.setAttribute("fill", "currentColor");
    }
};


var $4a79a76a1e44d5c5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(0, $39a534c23b7ef51e$export$a482e04ad60c9b11)("wh-icons", (0, $1ec2e28778eb11c3$export$89ce1880c5e6b1b3));
let $4a79a76a1e44d5c5$export$ace7c1b3d5182386 = class WhIconElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.name = "";
        this.label = "";
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<sl-icon
      library="wh-icons"
      name=${this.name}
      label=${this.label}
    ></sl-icon>`;
    }
};
$4a79a76a1e44d5c5$export$ace7c1b3d5182386.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      display: inline-flex;
    }
  `;
$4a79a76a1e44d5c5$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $4a79a76a1e44d5c5$export$ace7c1b3d5182386.prototype, "name", void 0);
$4a79a76a1e44d5c5$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $4a79a76a1e44d5c5$export$ace7c1b3d5182386.prototype, "label", void 0);
$4a79a76a1e44d5c5$export$ace7c1b3d5182386 = $4a79a76a1e44d5c5$var$__decorate([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("wh-icon")
], $4a79a76a1e44d5c5$export$ace7c1b3d5182386);


var $a72106b704c0c085$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a72106b704c0c085$export$774aca4b469aab4a = class WhPaginationElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /**
         * Used in the ARIA tags for screen readers. This should describe the unit being paged. Examples: Page, Item
         * @example
         * ```html
         * <wh-pagination affectedComponentAriaLabel="Page" ...>
         * ```
         *
         * @example
         * ```html
         * <wh-pagination affectedComponentAriaLabel="Item" ...>
         * ```
         */ // eslint-disable-next-line @typescript-eslint/no-inferrable-types, prettier/prettier
        this.affectedComponentAriaLabel = "Page";
        /**
         * The current item or page number. Example: The "x" in "x of y".
         * ```html
         * <wh-pagination current-page-number="1" ...>
         * ```
         */ // eslint-disable-next-line prettier/prettier
        this.currentPageNumber = 1;
        /**
         * Available variants for the component.
         * @example
         * ```html
         * <wh-pagination variant="number-of" ...>
         * ```
         */ this.variant = "number-of";
        this.loop = false;
    }
    ariaLabelCurrent() {
        return `Current ${this.affectedComponentAriaLabel}, ${this.affectedComponentAriaLabel} ${this.currentPageNumber}`;
    }
    ariaLabelGoto(page) {
        return `Go to ${this.affectedComponentAriaLabel} ${page}`;
    }
    changePageHandler(event, direction, gotoPage = 1) {
        event.preventDefault();
        event.stopPropagation();
        const newPagePosition = direction === "direct" ? gotoPage : this.newPagePosition(direction);
        const eventData = {
            direction: direction,
            newPagePosition: newPagePosition,
            totalPages: this.totalPages,
            previousPagePosition: this.currentPageNumber,
            type: "PaginationEvent"
        };
        this.dispatchEvent(new CustomEvent("paginate", {
            detail: eventData
        }));
    }
    nextButtonClickHandler(event) {
        this.changePageHandler(event, "next");
    }
    get nextPage() {
        if (this.loop && this.currentPageNumber === this.totalPages) return 1;
        return Math.min(this.currentPageNumber + 1, this.totalPages);
    }
    newPagePosition(direction) {
        if (direction === "next") return this.nextPage;
        return this.previousPage;
    }
    pageButtonClickHandler(event) {
        const goto = event.currentTarget.dataset.gotoPage;
        this.changePageHandler(event, "direct", Number(goto));
    }
    previousButtonClickHandler(event) {
        this.changePageHandler(event, "previous");
    }
    get previousPage() {
        if (this.loop && this.currentPageNumber === 1) return this.totalPages;
        return Math.max(this.currentPageNumber - 1, 1);
    }
    isPreviousButtonDisabled() {
        if (this.loop) return false;
        return Boolean(this.currentPageNumber === 1);
    }
    isNextButtonDisabled() {
        if (this.loop) return false;
        return Boolean(this.currentPageNumber === this.totalPages);
    }
    renderVariantDotted() {
        const dots = [];
        for(let index = 1; index <= this.totalPages; index += 1){
            const active = index === this.currentPageNumber;
            const icon = active ? "circle" : "circle-solid";
            const label = active ? this.ariaLabelCurrent() : this.ariaLabelGoto(index);
            dots.push((0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<button
          aria-label=${label}
          data-goto-page=${index}
          aria-current=${active}
          @click=${this.pageButtonClickHandler}
        >
          <wh-icon name=${icon} label=${label}></wh-icon>
        </button>`);
        }
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<span part="dots">${dots}</span>`;
    }
    renderVariantNumberOf() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <span part="prefix"><slot name="prefix">Part</slot></span>
      <span
        part="current-page"
        aria-label=${this.ariaLabelCurrent()}
        aria-current="true"
        >${this.currentPageNumber}</span
      >
      <span part="status-of"><slot name="separator">of</slot></span>
      <span part="number-of-pages">${this.totalPages}</span>
    `;
    }
    render() {
        const statusContent = this.variant === "number-of" ? this.renderVariantNumberOf() : this.renderVariantDotted();
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <nav
        part="nav"
        role="navigation"
        aria-label="${this.affectedComponentAriaLabel} Pagination"
      >
        <ul part="list">
          <li part="previous-button-container">
            <button
              class="image-button"
              data-testid="pagination-previous-button"
              aria-label=${this.ariaLabelGoto(this.previousPage)}
              @click=${this.previousButtonClickHandler}
              .disabled=${this.isPreviousButtonDisabled()}
            >
              <wh-icon
                name="caret-left-circle"
                .label=${this.ariaLabelGoto(this.previousPage)}
              ></wh-icon>
            </button>
          </li>
          <li part="status">${statusContent}</li>
          <li part="next-button-container">
            <button
              class="image-button"
              data-testid="pagination-next-button"
              aria-label=${this.ariaLabelGoto(this.nextPage)}
              @click=${this.nextButtonClickHandler}
              .disabled=${this.isNextButtonDisabled()}
            >
              <wh-icon
                name="caret-right-circle"
                .label=${this.ariaLabelGoto(this.nextPage)}
              ></wh-icon>
            </button>
          </li>
        </ul>
      </nav>
    `;
    }
};
/* Stryker disable next-line StringLiteral */ $a72106b704c0c085$export$774aca4b469aab4a.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --wh-dimension-spacer-xxxs: 4px;
      --wh-dimension-spacer-xxs: 8px;
      --wh-dimension-spacer-xs: 12px;
      --wh-theme-colors-primary: #323264ff;
      --wh-typography-standard-fontSize: 16px;
      --wh-typography-standard-fontFamily: "Source Sans Pro", helvetica, arial;

      display: inline-block;
      font-family: var(--wh-typography-standard-fontFamily, San-Serif);
      font-size: var(--wh-typography-standard-fontSize);
    }

    nav > ul {
      align-items: center;
      display: flex;
      gap: var(--wh-dimension-spacer-xxs);
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .image-button {
      align-items: center;
      appearance: none;
      background-color: transparent;
      border: 0;
      color: var(--wh-theme-colors-primary);
      cursor: pointer;
      display: flex;
      font-size: 2em;
      padding: 0;
    }

    .image-button:disabled {
      cursor: not-allowed;
      opacity: 0.3;
    }

    [part="status"] {
      color: var(--wh-theme-colors-primary);
    }

    [part="dots"] {
      display: flex;
      margin: auto var(--wh-dimension-spacer-xxxs);
    }

    [part="dots"] > button {
      align-items: center;
      appearance: none;
      background-color: transparent;
      border: 0;
      cursor: pointer;
      display: flex;
      justify-items: center;
      padding: var(--wh-dimension-spacer-xxs) var(--wh-dimension-spacer-xxxs);
    }

    [part="dots"] wh-icon {
      font-size: 0.8em;
    }
  `;
$a72106b704c0c085$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        attribute: "affected-component-aria-label"
    })
], $a72106b704c0c085$export$774aca4b469aab4a.prototype, "affectedComponentAriaLabel", void 0);
$a72106b704c0c085$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        attribute: "current-page-number",
        type: Number
    })
], $a72106b704c0c085$export$774aca4b469aab4a.prototype, "currentPageNumber", void 0);
$a72106b704c0c085$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        attribute: "total-pages",
        type: Number
    })
], $a72106b704c0c085$export$774aca4b469aab4a.prototype, "totalPages", void 0);
$a72106b704c0c085$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $a72106b704c0c085$export$774aca4b469aab4a.prototype, "variant", void 0);
$a72106b704c0c085$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $a72106b704c0c085$export$774aca4b469aab4a.prototype, "loop", void 0);
$a72106b704c0c085$var$__decorate([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("[part='next-button-container'] > button")
], $a72106b704c0c085$export$774aca4b469aab4a.prototype, "nextButton", void 0);
$a72106b704c0c085$var$__decorate([
    (0, $8660d4204a87fd9f$export$dcd0d083aa86c355)("[part='dots'] > button")
], $a72106b704c0c085$export$774aca4b469aab4a.prototype, "pageButtons", void 0);
$a72106b704c0c085$var$__decorate([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("[part='previous-button-container'] > button")
], $a72106b704c0c085$export$774aca4b469aab4a.prototype, "previousButton", void 0);
$a72106b704c0c085$export$774aca4b469aab4a = $a72106b704c0c085$var$__decorate([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("wh-pagination")
], $a72106b704c0c085$export$774aca4b469aab4a);



let $83332deb14018f4f$export$631acf559a857989 = class WebKioskHomeElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    changePage({ detail: detail }) {
        this.carouselCurrentPageNumber = detail.newPagePosition;
        this.carouselActiveNumber = detail.newPagePosition - 1;
    }
    updatePagination({ detail: { activeIndex: activeIndex } }) {
        this.carouselCurrentPageNumber = activeIndex + 1;
    }
    renderCard(card, index) {
        const snap = index % this.cardsPerPage === 0;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section ?wh-carousel-snap=${snap}>
      <a href=${this.createRelativeLink(card.link)}>
        <wh-card flat size="large">
          <section class="card-inner">
            <img src=${card.icon} alt=${card.title} />
            <h2>${card.title}</h2>
            <p>${card.description}</p>
          </section>
        </wh-card>
      </a>
    </section> `;
    }
    renderPagination(cardsCount) {
        if (cardsCount <= this.cardsPerPage) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        const totalPages = Math.ceil(cardsCount / this.cardsPerPage);
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<wh-pagination
      variant="number-of"
      current-page-number=${this.carouselCurrentPageNumber}
      total-pages=${totalPages}
      @paginate=${this.changePage}
    >
      <span slot="prefix">${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Page", {
            id: "home-carousel-prefix"
        })}</span>
      <span slot="separator"> / </span>
    </wh-pagination>`;
    }
    renderCards(cards) {
        return cards.map((card, index)=>this.renderCard(card, index));
    }
    renderCarousel(cards) {
        if (!cards || cards.length === 0) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        const cardsToRender = cards;
        const renderedCards = this.renderCards(cardsToRender);
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<wh-carousel
      active=${(0, $af8e33ff014f07c6$export$f68dd208b5df064d)(this.carouselActiveNumber)}
      @scrollcomplete=${this.updatePagination}
    >
      ${renderedCards}
    </wh-carousel> `;
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section class="page-body">
      <div class="body-inner">
        <section id="header">
          <h1>${this.content?.heading}</h1>
          <img
            src="assets/home/wg-stacked-logo.svg"
            alt=${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Walgreens Logo", {
            id: "walgreens-logo"
        })}
          />
        </section>
        <section id="cards">
          ${this.renderCarousel(this.content?.cards)}
        </section>
        <section id="info">
          <p>
            <strong>${this.content?.descriptionBold} </strong>${this.content?.description}
          </p>
          ${this.renderPagination(this.content?.cards.length ?? 0)}
        </section>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c1e8ff;
      --web-kiosk-text-color: #323264;
    }

    .page-body {
      height: 100%;
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/shared/bg/city.svg") right bottom -7% no-repeat,
        url("assets/home/bg/swirl.svg") 50% 50% no-repeat,
        var(--web-kiosk-bg, hotpink);
      `)};
      background-size: 40%, 100%;
    }

    .body-inner {
      padding: 82px 56px 0;
    }

    section[id="header"] {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    h1 {
      width: 52%;
      margin: 0;
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 72px;
      font-weight: 700;
      line-height: 82px;
    }

    section[id="header"] img {
      height: fit-content;
    }

    section[id="cards"] {
      margin-top: 32px;
    }

    wh-carousel section {
      flex: 1 1 0;
    }

    wh-carousel section:not(:last-of-type) {
      padding-right: 32px;
    }

    a,
    wh-card {
      text-align: center;
      text-decoration: none;
    }

    wh-card h2 {
      font-size: 32px;
      font-weight: 700;
      line-height: 38px;
      margin: 0 28px 10px;
      color: var(--web-kiosk-text-color, hotpink);
    }

    wh-card p {
      font-size: 26px;
      font-weight: 400;
      line-height: 40px;
      margin: 0 0 42px;
    }

    .card-inner {
      min-height: 490px;
      min-width: 373px;
    }

    section[id="info"] {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--web-kiosk-text-color, hotpink);
    }

    section[id="info"] p {
      width: 70%;
      font-size: 28px;
      line-height: 48px;
      font-weight: 400;
    }

    wh-pagination {
      font-size: 32px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.cardsPerPage = 4;
        this.content = undefined;
        this.carouselCurrentPageNumber = 1;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $83332deb14018f4f$export$631acf559a857989.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-pagination")
], $83332deb14018f4f$export$631acf559a857989.prototype, "paginationElement", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-carousel")
], $83332deb14018f4f$export$631acf559a857989.prototype, "carousel", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $83332deb14018f4f$export$631acf559a857989.prototype, "carouselCurrentPageNumber", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $83332deb14018f4f$export$631acf559a857989.prototype, "carouselActiveNumber", void 0);
$83332deb14018f4f$export$631acf559a857989 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-home")
], $83332deb14018f4f$export$631acf559a857989);










let $77d0586404637f31$export$be75d1f280ea4d13 = class WebKioskFeedbackElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <section class="page-body">
      <div class="body-inner">
        <web-kiosk-home-link
          link=${this.createRelativeLink("home")}
        ></web-kiosk-home-link>

        <section class="body-content">
          <section class="feedback-text">
            <h1>${this.content?.heading}</h1>

            <p>${this.content?.description}</p>
          </section>
        </section>

        <article class="qr-code">
          <h2>${this.content?.surveyHeading}</h2>
          <section class="survey">
            <img
              src=${this.content?.surveyQrCodeLink}
              alt=${this.content?.surveyQrCodeLinkAlt}
            />
            <section class="phone">
              <h3 class="iphone">${this.content?.phoneHeading}</h3>
              <p class="iphone-p">${this.content?.phoneDescription}</p>
              <h3>${this.content?.oldPhoneHeading}</h3>
              <p>${this.content?.oldPhoneDescription}</p>
            </section>
          </section>
        </article>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c1e8ff;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
    }

    .page-body {
      height: 100%;
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/feedback/peopleTable.svg") top right 10% no-repeat,
        url("assets/feedback/plantRight.svg") bottom right 58% no-repeat,
        url("assets/feedback/window.svg") top 10% right 5% no-repeat,
        url("assets/feedback/feedbackPageVector.svg") bottom right 40% no-repeat,
        var(--web-kiosk-bg, hotpink);
      `)};
      background-size: 45%, 8%, 15%, 35%;
    }

    .body-inner {
      padding: 48px 56px;
    }

    .body-content {
      display: flex;
      gap: 210px;
    }

    .feedback-text,
    .qr-code {
      width: 38%;
      flex: 0 38%;
      margin-left: 8px;
    }

    .feedback-text h1 {
      font-size: 72px;
      font-weight: 700;
      line-height: 82px;
      margin: 48px 0 40px;
    }

    a,
    .feedback-text :is(h1),
    h2 h3 h4 {
      color: var(--web-kiosk-text-color, hotpink);
    }

    .feedback-text p {
      font-size: 26px;
      font-weight: 400px;
      line-height: 40px;
      margin-bottom: 88px;
      padding-right: 12px;
    }

    .qr-code h2 {
      margin-bottom: 24px;
      font-size: 28px;
      font-weight: 700px;
      line-height: 48px;
    }

    .survey {
      display: flex;
      align-items: flex-start;
    }

    .phone {
      margin: 0 24px;
    }

    .phone h3 {
      font-size: 22px;
      font-weight: 700px;
      line-height: 32px;
      margin-bottom: 0;
    }

    .phone p {
      margin-top: 0;
      font-size: 20px;
      font-weight: 400px;
      line-height: 28px;
    }

    .iphone-p {
      margin-bottom: 16px;
    }

    .iphone {
      margin-top: 0;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $77d0586404637f31$export$be75d1f280ea4d13.prototype, "content", void 0);
$77d0586404637f31$export$be75d1f280ea4d13 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-feedback")
], $77d0586404637f31$export$be75d1f280ea4d13);






var $65d452b19e489b9b$exports = {};





var $4bdb087a209cba1b$export$6a9ed4d91972acb3 = (0, $721e1b33361a91ed$export$dbf350e5966cf602)`
  ${(0, $a15991058abab049$export$e1ac0a3ec62d1269)}

  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.01em, 2.75em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.01em, 2.75em;
    }
  }
`;


// src/utilities/localize.ts
const $5a356428e3af430b$var$connectedElements = new Set();
const $5a356428e3af430b$var$documentElementObserver = new MutationObserver($5a356428e3af430b$export$722fbec263ad908a);
const $5a356428e3af430b$var$translations = new Map();
let $5a356428e3af430b$var$documentDirection = document.documentElement.dir || "ltr";
let $5a356428e3af430b$var$documentLanguage = document.documentElement.lang || navigator.language;
let $5a356428e3af430b$var$fallback;
$5a356428e3af430b$var$documentElementObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [
        "dir",
        "lang"
    ]
});
function $5a356428e3af430b$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($5a356428e3af430b$var$translations.has(code)) $5a356428e3af430b$var$translations.set(code, Object.assign(Object.assign({}, $5a356428e3af430b$var$translations.get(code)), t));
        else $5a356428e3af430b$var$translations.set(code, t);
        if (!$5a356428e3af430b$var$fallback) $5a356428e3af430b$var$fallback = t;
    });
    $5a356428e3af430b$export$722fbec263ad908a();
}
function $5a356428e3af430b$export$722fbec263ad908a() {
    $5a356428e3af430b$var$documentDirection = document.documentElement.dir || "ltr";
    $5a356428e3af430b$var$documentLanguage = document.documentElement.lang || navigator.language;
    [
        ...$5a356428e3af430b$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === "function") el.requestUpdate();
    });
}
class $5a356428e3af430b$export$b1a2fed5bb41b893 {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $5a356428e3af430b$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $5a356428e3af430b$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $5a356428e3af430b$var$documentDirection}`.toLowerCase();
    }
    lang() {
        return `${this.host.lang || $5a356428e3af430b$var$documentLanguage}`.toLowerCase();
    }
    getTranslationData(lang) {
        var _a, _b;
        const locale = new Intl.Locale(lang.replace(/_/g, "-"));
        const language = locale === null || locale === void 0 ? void 0 : locale.language.toLowerCase();
        const region = (_b = (_a = locale === null || locale === void 0 ? void 0 : locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
        const primary = $5a356428e3af430b$var$translations.get(`${language}-${region}`);
        const secondary = $5a356428e3af430b$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $5a356428e3af430b$var$fallback && $5a356428e3af430b$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($5a356428e3af430b$var$fallback && $5a356428e3af430b$var$fallback[key]) term = $5a356428e3af430b$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === "function") return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? "" : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
}


var $bad2bd6ac4a0d8f9$export$b1a2fed5bb41b893 = class extends (0, $5a356428e3af430b$export$b1a2fed5bb41b893) {
};




var $93e00229d38c0ccc$export$4e45ce56e46d2b00 = class extends (0, $d6532421f6fe77d5$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $bad2bd6ac4a0d8f9$export$b1a2fed5bb41b893)(this);
    }
    render() {
        return (0, $6d8f6951af537b31$export$c0bb0b647f701bb5)`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
    }
};
$93e00229d38c0ccc$export$4e45ce56e46d2b00.styles = (0, $4bdb087a209cba1b$export$6a9ed4d91972acb3);



// src/internal/form.ts
var $fc3320018fa77694$export$61a522b559454891 = /* @__PURE__ */ new WeakMap();
var $fc3320018fa77694$var$reportValidityOverloads = /* @__PURE__ */ new WeakMap();
var $fc3320018fa77694$var$userInteractedControls = /* @__PURE__ */ new WeakSet();
var $fc3320018fa77694$var$interactions = /* @__PURE__ */ new WeakMap();
var $fc3320018fa77694$export$43da334182d34ab4 = class {
    constructor(host, options){
        this.handleFormData = (event)=>{
            const disabled = this.options.disabled(this.host);
            const name = this.options.name(this.host);
            const value = this.options.value(this.host);
            const isButton = this.host.tagName.toLowerCase() === "sl-button";
            if (!disabled && !isButton && typeof name === "string" && name.length > 0 && typeof value !== "undefined") {
                if (Array.isArray(value)) value.forEach((val)=>{
                    event.formData.append(name, val.toString());
                });
                else event.formData.append(name, value.toString());
            }
        };
        this.handleFormSubmit = (event)=>{
            var _a;
            const disabled = this.options.disabled(this.host);
            const reportValidity = this.options.reportValidity;
            if (this.form && !this.form.noValidate) (_a = $fc3320018fa77694$export$61a522b559454891.get(this.form)) == null || _a.forEach((control)=>{
                this.setUserInteracted(control, true);
            });
            if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        this.handleFormReset = ()=>{
            this.options.setValue(this.host, this.options.defaultValue(this.host));
            this.setUserInteracted(this.host, false);
            $fc3320018fa77694$var$interactions.set(this.host, []);
        };
        this.handleInteraction = (event)=>{
            const emittedEvents = $fc3320018fa77694$var$interactions.get(this.host);
            if (!emittedEvents.includes(event.type)) emittedEvents.push(event.type);
            if (emittedEvents.length === this.options.assumeInteractionOn.length) this.setUserInteracted(this.host, true);
        };
        this.reportFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.reportValidity === "function") {
                    if (!element.reportValidity()) return false;
                }
            }
            return true;
        };
        (this.host = host).addController(this);
        this.options = (0, $eab5a1a480d90122$export$7de063a7aa429f6c)({
            form: (input)=>{
                if (input.hasAttribute("form") && input.getAttribute("form") !== "") {
                    const root = input.getRootNode();
                    const formId = input.getAttribute("form");
                    if (formId) return root.getElementById(formId);
                }
                return input.closest("form");
            },
            name: (input)=>input.name,
            value: (input)=>input.value,
            defaultValue: (input)=>input.defaultValue,
            disabled: (input)=>{
                var _a;
                return (_a = input.disabled) != null ? _a : false;
            },
            reportValidity: (input)=>typeof input.reportValidity === "function" ? input.reportValidity() : true,
            setValue: (input, value)=>input.value = value,
            assumeInteractionOn: [
                "sl-input"
            ]
        }, options);
    }
    hostConnected() {
        const form = this.options.form(this.host);
        if (form) this.attachForm(form);
        $fc3320018fa77694$var$interactions.set(this.host, []);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.addEventListener(event, this.handleInteraction);
        });
    }
    hostDisconnected() {
        this.detachForm();
        $fc3320018fa77694$var$interactions.delete(this.host);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.removeEventListener(event, this.handleInteraction);
        });
    }
    hostUpdated() {
        const form = this.options.form(this.host);
        if (!form) this.detachForm();
        if (form && this.form !== form) {
            this.detachForm();
            this.attachForm(form);
        }
        if (this.host.hasUpdated) this.setValidity(this.host.validity.valid);
    }
    attachForm(form) {
        if (form) {
            this.form = form;
            if ($fc3320018fa77694$export$61a522b559454891.has(this.form)) $fc3320018fa77694$export$61a522b559454891.get(this.form).add(this.host);
            else $fc3320018fa77694$export$61a522b559454891.set(this.form, /* @__PURE__ */ new Set([
                this.host
            ]));
            this.form.addEventListener("formdata", this.handleFormData);
            this.form.addEventListener("submit", this.handleFormSubmit);
            this.form.addEventListener("reset", this.handleFormReset);
            if (!$fc3320018fa77694$var$reportValidityOverloads.has(this.form)) {
                $fc3320018fa77694$var$reportValidityOverloads.set(this.form, this.form.reportValidity);
                this.form.reportValidity = ()=>this.reportFormValidity();
            }
        } else this.form = void 0;
    }
    detachForm() {
        var _a;
        if (this.form) {
            (_a = $fc3320018fa77694$export$61a522b559454891.get(this.form)) == null || _a.delete(this.host);
            this.form.removeEventListener("formdata", this.handleFormData);
            this.form.removeEventListener("submit", this.handleFormSubmit);
            this.form.removeEventListener("reset", this.handleFormReset);
            if ($fc3320018fa77694$var$reportValidityOverloads.has(this.form)) {
                this.form.reportValidity = $fc3320018fa77694$var$reportValidityOverloads.get(this.form);
                $fc3320018fa77694$var$reportValidityOverloads.delete(this.form);
            }
        }
        this.form = void 0;
    }
    setUserInteracted(el, hasInteracted) {
        if (hasInteracted) $fc3320018fa77694$var$userInteractedControls.add(el);
        else $fc3320018fa77694$var$userInteractedControls.delete(el);
        el.requestUpdate();
    }
    doAction(type, submitter) {
        if (this.form) {
            const button = document.createElement("button");
            button.type = type;
            button.style.position = "absolute";
            button.style.width = "0";
            button.style.height = "0";
            button.style.clipPath = "inset(50%)";
            button.style.overflow = "hidden";
            button.style.whiteSpace = "nowrap";
            if (submitter) {
                button.name = submitter.name;
                button.value = submitter.value;
                [
                    "formaction",
                    "formenctype",
                    "formmethod",
                    "formnovalidate",
                    "formtarget"
                ].forEach((attr)=>{
                    if (submitter.hasAttribute(attr)) button.setAttribute(attr, submitter.getAttribute(attr));
                });
            }
            this.form.append(button);
            button.click();
            button.remove();
        }
    }
    /** Returns the associated `<form>` element, if one exists. */ getForm() {
        var _a;
        return (_a = this.form) != null ? _a : null;
    }
    /** Resets the form, restoring all the control to their default value */ reset(submitter) {
        this.doAction("reset", submitter);
    }
    /** Submits the form, triggering validation and form data injection. */ submit(submitter) {
        this.doAction("submit", submitter);
    }
    /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */ setValidity(isValid) {
        const host = this.host;
        const hasInteracted = Boolean($fc3320018fa77694$var$userInteractedControls.has(host));
        const required = Boolean(host.required);
        host.toggleAttribute("data-required", required);
        host.toggleAttribute("data-optional", !required);
        host.toggleAttribute("data-invalid", !isValid);
        host.toggleAttribute("data-valid", isValid);
        host.toggleAttribute("data-user-invalid", !isValid && hasInteracted);
        host.toggleAttribute("data-user-valid", isValid && hasInteracted);
    }
    /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */ updateValidity() {
        const host = this.host;
        this.setValidity(host.validity.valid);
    }
    /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */ emitInvalidEvent(originalInvalidEvent) {
        const slInvalidEvent = new CustomEvent("sl-invalid", {
            bubbles: false,
            composed: false,
            cancelable: true,
            detail: {}
        });
        if (!originalInvalidEvent) slInvalidEvent.preventDefault();
        if (!this.host.dispatchEvent(slInvalidEvent)) originalInvalidEvent == null || originalInvalidEvent.preventDefault();
    }
};
var $fc3320018fa77694$export$6c5960ddf0f5ff89 = Object.freeze({
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: true,
    valueMissing: false
});
var $fc3320018fa77694$export$bd584164a4d1886c = Object.freeze((0, $eab5a1a480d90122$export$f4da8f157c1253f7)((0, $eab5a1a480d90122$export$7de063a7aa429f6c)({}, $fc3320018fa77694$export$6c5960ddf0f5ff89), {
    valid: false,
    valueMissing: true
}));
var $fc3320018fa77694$export$d17679f2bc5863d4 = Object.freeze((0, $eab5a1a480d90122$export$f4da8f157c1253f7)((0, $eab5a1a480d90122$export$7de063a7aa429f6c)({}, $fc3320018fa77694$export$6c5960ddf0f5ff89), {
    valid: false,
    customError: true
}));




var $33dcc4b9d93b44c3$export$172eea9c07ee1ffd = (0, $721e1b33361a91ed$export$dbf350e5966cf602)`
  ${(0, $a15991058abab049$export$e1ac0a3ec62d1269)}

  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition:
      var(--sl-transition-x-fast) background-color,
      var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border,
      var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-color-neutral-300);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-color-neutral-300);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    height: auto;
    min-height: var(--sl-input-height-small);
    font-size: var(--sl-button-font-size-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    height: auto;
    min-height: var(--sl-input-height-medium);
    font-size: var(--sl-button-font-size-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    height: auto;
    min-height: var(--sl-input-height-large);
    font-size: var(--sl-button-font-size-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host(.sl-button-group__button--first:not(.sl-button-group__button--last)) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host(.sl-button-group__button--inner) .button {
    border-radius: 0;
  }

  :host(.sl-button-group__button--last:not(.sl-button-group__button--first)) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host(.sl-button-group__button:not(.sl-button-group__button--first)) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      .sl-button-group__button:not(
          .sl-button-group__button--first,
          .sl-button-group__button--radio,
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host(.sl-button-group__button--hover) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host(.sl-button-group__button--focus),
  :host(.sl-button-group__button[checked]) {
    z-index: 2;
  }
`;


// src/internal/slot.ts
var $50a13d85bbf8d38d$export$34f6a5ffaa663541 = class {
    constructor(host, ...slotNames){
        this.slotNames = [];
        this.handleSlotChange = (event)=>{
            const slot = event.target;
            if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
        };
        (this.host = host).addController(this);
        this.slotNames = slotNames;
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") return true;
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                const tagName = el.tagName.toLowerCase();
                if (tagName === "sl-visually-hidden") return false;
                if (!el.hasAttribute("slot")) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    test(slotName) {
        return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    }
};
function $50a13d85bbf8d38d$export$132e79e4118a78e0(slot) {
    if (!slot) return "";
    const nodes = slot.assignedNodes({
        flatten: true
    });
    let text = "";
    [
        ...nodes
    ].forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return text;
}








/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cbbb35c4e6711c6b$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $cbbb35c4e6711c6b$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $cbbb35c4e6711c6b$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $756492cca5018fee$export$56cc687933817664 = (0, $cbbb35c4e6711c6b$export$99b43ad1ed32e735)(class extends (0, $cbbb35c4e6711c6b$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $cbbb35c4e6711c6b$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== s.strings && (this.st = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.st?.has(t) && this.it.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.it)t in i || (r.remove(t), this.it.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.it.has(t) || this.st?.has(t) || (s ? (r.add(t), this.it.add(t)) : (r.remove(t), this.it.delete(t)));
        }
        return 0, $6d8f6951af537b31$export$9c068ae9cc5db4e8;
    }
});





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $34c33baf83c15327$var$e = Symbol.for(""), $34c33baf83c15327$var$o = (t)=>{
    if (t?.r === $34c33baf83c15327$var$e) return t?._$litStatic$;
}, $34c33baf83c15327$export$4b395f4b8c9b548e = (t)=>({
        _$litStatic$: t,
        r: $34c33baf83c15327$var$e
    }), $34c33baf83c15327$export$c8ec6e1ec9fefcb0 = (t, ...r)=>({
        _$litStatic$: r.reduce((r, e, o)=>r + ((t)=>{
                if (void 0 !== t._$litStatic$) return t._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`);
            })(e) + t[o + 1], t[0]),
        r: $34c33baf83c15327$var$e
    }), $34c33baf83c15327$var$a = new Map, $34c33baf83c15327$export$878791788f808fc0 = (t)=>(r, ...e)=>{
        const i = e.length;
        let s, l;
        const n = [], u = [];
        let c, $ = 0, f = !1;
        for(; $ < i;){
            for(c = r[$]; $ < i && void 0 !== (l = e[$], s = $34c33baf83c15327$var$o(l));)c += s + r[++$], f = !0;
            $ !== i && u.push(l), n.push(c), $++;
        }
        if ($ === i && n.push(r[i]), f) {
            const t = n.join("$$lit$$");
            void 0 === (r = $34c33baf83c15327$var$a.get(t)) && (n.raw = n, $34c33baf83c15327$var$a.set(t, r = n)), e = u;
        }
        return t(r, ...e);
    }, $34c33baf83c15327$export$c0bb0b647f701bb5 = $34c33baf83c15327$export$878791788f808fc0((0, $6d8f6951af537b31$export$c0bb0b647f701bb5)), $34c33baf83c15327$export$7ed1367e7fa1ad68 = $34c33baf83c15327$export$878791788f808fc0((0, $6d8f6951af537b31$export$7ed1367e7fa1ad68));





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $83cd63fc68f4807b$export$f68dd208b5df064d = (o)=>o ?? (0, $6d8f6951af537b31$export$45b790e32b2810ee);





var $fbc5ca4259f5cd1f$export$e56d306ebf763f31 = class extends (0, $d6532421f6fe77d5$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $fc3320018fa77694$export$43da334182d34ab4)(this, {
            form: (input)=>{
                if (input.hasAttribute("form")) {
                    const doc = input.getRootNode();
                    const formId = input.getAttribute("form");
                    return doc.getElementById(formId);
                }
                return input.closest("form");
            },
            assumeInteractionOn: [
                "click"
            ]
        });
        this.hasSlotController = new (0, $50a13d85bbf8d38d$export$34f6a5ffaa663541)(this, "[default]", "prefix", "suffix");
        this.localize = new (0, $bad2bd6ac4a0d8f9$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.invalid = false;
        this.title = "";
        this.variant = "default";
        this.size = "medium";
        this.caret = false;
        this.disabled = false;
        this.loading = false;
        this.outline = false;
        this.pill = false;
        this.circle = false;
        this.type = "button";
        this.name = "";
        this.value = "";
        this.href = "";
        this.rel = "noreferrer noopener";
    }
    /** Gets the validity state object */ get validity() {
        if (this.isButton()) return this.button.validity;
        return 0, $fc3320018fa77694$export$6c5960ddf0f5ff89;
    }
    /** Gets the validation message */ get validationMessage() {
        if (this.isButton()) return this.button.validationMessage;
        return "";
    }
    firstUpdated() {
        if (this.isButton()) this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick() {
        if (this.type === "submit") this.formControlController.submit(this);
        if (this.type === "reset") this.formControlController.reset(this);
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    isButton() {
        return this.href ? false : true;
    }
    isLink() {
        return this.href ? true : false;
    }
    handleDisabledChange() {
        if (this.isButton()) this.formControlController.setValidity(this.disabled);
    }
    /** Simulates a click on the button. */ click() {
        this.button.click();
    }
    /** Sets focus on the button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the button. */ blur() {
        this.button.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        if (this.isButton()) return this.button.checkValidity();
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        if (this.isButton()) return this.button.reportValidity();
        return true;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        if (this.isButton()) {
            this.button.setCustomValidity(message);
            this.formControlController.updateValidity();
        }
    }
    render() {
        const isLink = this.isLink();
        const tag = isLink ? (0, $34c33baf83c15327$export$c8ec6e1ec9fefcb0)`a` : (0, $34c33baf83c15327$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $34c33baf83c15327$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $756492cca5018fee$export$56cc687933817664)({
            button: true,
            "button--default": this.variant === "default",
            "button--primary": this.variant === "primary",
            "button--success": this.variant === "success",
            "button--neutral": this.variant === "neutral",
            "button--warning": this.variant === "warning",
            "button--danger": this.variant === "danger",
            "button--text": this.variant === "text",
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--caret": this.caret,
            "button--circle": this.circle,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--loading": this.loading,
            "button--standard": !this.outline,
            "button--outline": this.outline,
            "button--pill": this.pill,
            "button--rtl": this.localize.dir() === "rtl",
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
        ?disabled=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? void 0 : this.name)}
        value=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? void 0 : this.value)}
        href=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? this.href : void 0)}
        target=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? this.rel : void 0)}
        role=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? (0, $34c33baf83c15327$export$c0bb0b647f701bb5)` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? (0, $34c33baf83c15327$export$c0bb0b647f701bb5)`<sl-spinner part="spinner"></sl-spinner>` : ""}
      </${tag}>
    `;
    }
};
$fbc5ca4259f5cd1f$export$e56d306ebf763f31.styles = (0, $33dcc4b9d93b44c3$export$172eea9c07ee1ffd);
$fbc5ca4259f5cd1f$export$e56d306ebf763f31.dependencies = {
    "sl-icon": (0, $7bf02663e7e33382$export$ef62a86bf282441),
    "sl-spinner": (0, $93e00229d38c0ccc$export$4e45ce56e46d2b00)
};
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a381745756984e0e$export$2fa187e846a241c4)(".button")
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "button", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $9eba64a7190237ae$export$ca000e230c0caa3e)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "hasFocus", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $9eba64a7190237ae$export$ca000e230c0caa3e)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "invalid", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "title", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        reflect: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "variant", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        reflect: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "size", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "caret", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "disabled", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "loading", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "outline", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "pill", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "circle", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "type", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "name", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "value", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "href", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "target", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "rel", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "download", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "form", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        attribute: "formaction"
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "formAction", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        attribute: "formenctype"
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "formEnctype", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        attribute: "formmethod"
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "formMethod", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        attribute: "formnovalidate",
        type: Boolean
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "formNoValidate", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        attribute: "formtarget"
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "formTarget", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $245c976188bf2656$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $fbc5ca4259f5cd1f$export$e56d306ebf763f31.prototype, "handleDisabledChange", 1);


// src/components/button/button.ts
var $89e62541f495535f$export$11c362adf4e83e40 = (0, $fbc5ca4259f5cd1f$export$e56d306ebf763f31);
(0, $fbc5ca4259f5cd1f$export$e56d306ebf763f31).define("sl-button");









// src/translations/en.ts

var $5e9f30d5449fba17$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    carousel: "Carousel",
    clearEntry: "Clear entry",
    close: "Close",
    copied: "Copied",
    copy: "Copy",
    currentValue: "Current value",
    error: "Error",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    slideNum: (slide)=>`Slide ${slide}`,
    toggleColorFormat: "Toggle color format"
};
(0, $5a356428e3af430b$export$2332cb3ce32cc839)($5e9f30d5449fba17$var$translation);
var $5e9f30d5449fba17$export$802b895dc4aecf21 = $5e9f30d5449fba17$var$translation;














var $65d452b19e489b9b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $65d452b19e489b9b$export$87f57225dee186c5 = [
    "primary",
    "negative",
    "secondary",
    "tertiary-inverted",
    "tertiary",
    "text",
    "text-flat",
    "text-inverted"
];
let $65d452b19e489b9b$export$ea7030c9d7bd9a16 = class WhButtonElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.variant = "primary";
        this.size = "medium";
        this.disabled = false;
        this.href = "";
        this.fullwidth = false;
    }
    get supportedVariant() {
        if (!$65d452b19e489b9b$export$87f57225dee186c5.includes(this.variant)) {
            // eslint-disable-next-line no-console
            console.warn(`${this.variant} is not a supported option. Use  one of ${$65d452b19e489b9b$export$87f57225dee186c5.join(",")} instead`);
            return "primary";
        }
        const map = {
            text: "text",
            "text-inverted": "text",
            "text-flat": "text",
            tertiary: "neutral",
            negative: "danger",
            "tertiary-inverted": "primary",
            secondary: "primary",
            primary: "primary"
        };
        return map[this.variant];
    }
    isOutlined() {
        return [
            "tertiary",
            "tertiary-inverted",
            "negative"
        ].includes(this.variant);
    }
    isPill() {
        return ![
            "text",
            "text-inverted",
            "text-flat"
        ].includes(this.variant);
    }
    render() {
        const { variant: variant, fullwidth: fullwidth, disabled: disabled, supportedVariant: supportedVariant, size: size, href: href } = this;
        const classes = {
            [variant]: true,
            fullwidth: fullwidth
        };
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <sl-button
      exportparts="base"
      class=${(0, $db805c9ee37de70c$export$56cc687933817664)(classes)}
      .disabled=${disabled}
      ?pill=${this.isPill()}
      .variant=${supportedVariant}
      size=${size}
      .href=${href}
      .outline=${this.isOutlined()}
    >
      <slot name="prefix" slot="prefix"></slot>
      <slot></slot>
      <slot name="suffix" slot="suffix"></slot>
    </sl-button>`;
    }
};
$65d452b19e489b9b$export$ea7030c9d7bd9a16.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --wh-dimension-radius-m: 8px;
      --wh-dimension-text-btn-border-radius: 10px;
    }

    sl-button::part(base) {
      align-items: center;
    }

    .primary::part(base),
    .text-inverted::part(base) {
      background-color: var(--wh-theme-colors-primary, gray);
      color: var(--wh-theme-colors-on-primary, white);
      border: none;
    }

    .primary::part(base):hover {
      background-color: var(--wh-theme-colors-primary-weak, gray);
    }

    .secondary::part(base) {
      background-color: var(--wh-theme-colors-secondary, lightblue);
      border: none;
      color: var(--wh-theme-colors-primary-strong, blue);
    }

    .secondary::part(base):hover {
      background-color: var(--wh-theme-colors-secondary-weak, lightblue);
      border: none;
      color: var(--wh-theme-colors-primary-strong, blue);
    }

    .tertiary::part(base) {
      background-color: transparent;
      border: 1px solid var(--wh-theme-colors-tertiary, blue);
      color: var(--wh-theme-colors-tertiary, blue);
    }

    .tertiary::part(base):hover {
      border-color: var(--wh-theme-colors-primary-strong, blue);
      color: var(--wh-theme-colors-primary-strong, blue);
    }

    .tertiary-inverted::part(base) {
      background-color: transparent;
      border-color: var(--wh-palette-colors-gray0, gray);
      border: 1px solid var(--wh-theme-colors-tertiary, blue);
      color: var(--wh-palette-colors-white, white);
    }

    .tertiary-inverted::part(base):hover {
      background-color: transparent;
      border-color: var(--wh-palette-colors-gray0, gray);
      color: var(--wh-palette-colors-white, white);
    }

    .primary::part(base)[disabled] {
      color: var(--wh-theme-colors-disabled, gray);
    }

    :is(.text, .text-flat)::part(base) {
      color: var(--wh-theme-colors-primary, darkblue);
    }

    :is(.text, .text-inverted, .text-flat)::part(base) {
      height: auto;
      line-height: 1.5;
      padding: 4px 12px;
    }

    :is(.text, .text-inverted, .text-flat)::part(label) {
      padding-inline-start: 0;
      padding-inline-end: 0;
    }

    .text::part(base):hover,
    .text-inverted::part(base):hover {
      border-radius: var(--wh-dimension-text-btn-border-radius);
    }

    .text::part(base):hover {
      background-color: var(--wh-theme-colors-background, #e5e5e5);
    }

    .text-inverted::part(base):hover {
      background-color: var(--wh-theme-colors-on-surface, hotpink);
    }

    .text::part(base):active {
      background-color: var(--wh-theme-colors-on-background, #d6d6da);
    }

    sl-button.fullwidth {
      width: 100%;
    }

    slot[name="prefix"]::slotted(*) {
      padding-inline-end: 12px;
    }

    slot[name="suffix"]::slotted(*) {
      padding-inline-start: 12px;
    }
  `;
$65d452b19e489b9b$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $65d452b19e489b9b$export$ea7030c9d7bd9a16.prototype, "variant", void 0);
$65d452b19e489b9b$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $65d452b19e489b9b$export$ea7030c9d7bd9a16.prototype, "size", void 0);
$65d452b19e489b9b$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $65d452b19e489b9b$export$ea7030c9d7bd9a16.prototype, "disabled", void 0);
$65d452b19e489b9b$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $65d452b19e489b9b$export$ea7030c9d7bd9a16.prototype, "href", void 0);
$65d452b19e489b9b$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $65d452b19e489b9b$export$ea7030c9d7bd9a16.prototype, "fullwidth", void 0);
$65d452b19e489b9b$export$ea7030c9d7bd9a16 = $65d452b19e489b9b$var$__decorate([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("wh-button")
], $65d452b19e489b9b$export$ea7030c9d7bd9a16);







var $27665b5b015060bf$exports = {};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $27665b5b015060bf$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$27665b5b015060bf$var$debounce.debounce = $27665b5b015060bf$var$debounce;
$27665b5b015060bf$exports = $27665b5b015060bf$var$debounce;


let $d5952239b7b7120e$export$eef6e6b67e56fdf = class WebKioskBackButtonElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("scroll", this.debounceToggleVisibility());
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("scroll", this.debounceToggleVisibility());
    }
    debounceToggleVisibility() {
        return (0, $27665b5b015060bf$exports.debounce)(()=>{
            this.toggleButtonVisibility(this);
        }, this.debounceTime);
    }
    toggleButtonVisibility(context) {
        const show = window.scrollY >= context.showAfterPx;
        this.backButton?.classList.toggle("visible", show);
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<button id="go-back" @click=${this.scrollToTop}>
      <wh-icon name="caret-right-circle"></wh-icon>
      <br />
      ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Back to top")}
    </button>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-text-color: #323264;
    }

    button {
      display: none;
      font-size: 16px;
      color: var(--web-kiosk-text-color, hotpink);
      background: none;
      border: none;
      cursor: pointer;
    }

    .visible {
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    wh-icon {
      font-size: 28px;
      transform: rotate(-90deg);
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.debounceTime = 100;
        this.showAfterPx = 250;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $d5952239b7b7120e$export$eef6e6b67e56fdf.prototype, "debounceTime", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $d5952239b7b7120e$export$eef6e6b67e56fdf.prototype, "showAfterPx", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("button")
], $d5952239b7b7120e$export$eef6e6b67e56fdf.prototype, "backButton", void 0);
$d5952239b7b7120e$export$eef6e6b67e56fdf = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-back-button")
], $d5952239b7b7120e$export$eef6e6b67e56fdf);








let $27cbeb9548b9b5fb$export$97b505aa098f3a2b = class WebKioskPrivacyHeaderElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("scroll", this.debounceToggleFixedHeader());
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("scroll", this.debounceToggleFixedHeader());
    }
    debounceToggleFixedHeader() {
        return (0, $27665b5b015060bf$exports.debounce)(()=>{
            this.toggleFixedHeader(this);
        }, this.debounceTime);
    }
    toggleFixedHeader(context) {
        if (!context.header) return;
        const fixed = window.scrollY >= context.header.clientHeight;
        this.navigation?.classList.toggle("fixed", fixed);
    }
    renderCards(cards) {
        if (!cards) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return cards.map((card)=>(0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<div>
        <img src=${card.img} alt=${card.title} />
        <h2>${card.title}</h2>
        <p>${card.description}</p>
      </div>`);
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section id="header">
      <div id="navigation">
        <a
          href="."
          @click=${(event)=>{
            event.preventDefault();
            window.history.back();
        }}
        >
          <wh-icon name="chevron-down"></wh-icon>
          ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Back")}
        </a>
        <h1>${this.content?.headerHeading}</h1>
      </div>
      <div id="header-content">
        <div id="content">
          <section id="texts">
            <h1>${this.content?.headerHeading}</h1>
            <p>${this.content?.headerDescription}</p>
          </section>
          <section id="cards">
            ${this.renderCards(this.content?.headerCards)}
          </section>
        </div>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c1e8ff;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
    }

    #header {
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/privacy/bg/swirl.svg") right 40px no-repeat,
        var(--web-kiosk-bg, hotpink);
      `)};
    }

    #header-content {
      padding: 52px 58px;
    }

    #navigation {
      display: flex;
      padding: 52px 58px 0;
      color: var(--web-kiosk-link-color, hotpink);
      font-size: 32px;
    }

    h1 {
      margin: 0 0 8px;
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
    }

    #navigation h1 {
      display: none;
    }

    #navigation.fixed {
      position: fixed;
      width: 100%;
      padding: 36px 59px;
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/privacy/bg/swirl.svg") right 100px top 24px no-repeat,
        var(--web-kiosk-bg, hotpink);
      `)};
      transition: all 0.2s ease;
    }

    #navigation.fixed h1 {
      display: block;
      margin-left: 64px;
    }

    #navigation wh-icon {
      font-size: 50px;
      transform: rotate(90deg);
    }

    #navigation a {
      width: 20%;
      display: flex;
      align-items: center;
      color: var(--web-kiosk-link-color, hotpink);
      text-decoration: none;
      font-weight: bold;
    }

    #content {
      display: flex;
      justify-content: space-between;
    }

    #texts {
      width: 42%;
      padding-top: 36px;
    }

    #texts p {
      font-size: 26px;
      font-weight: 400;
      line-height: 40px;
    }

    #cards {
      display: flex;
      gap: 42px;
      width: 50%;
      padding-top: 36px;
      justify-content: space-between;
    }

    #cards div {
      text-align: center;
    }

    #cards h2 {
      margin: 16px 0 0;
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 26px;
      font-weight: 700;
      line-height: 32px;
    }

    #cards p {
      margin: 8px 0;
      font-size: 22px;
      font-weight: 400;
      line-height: 32px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
        this.debounceTime = 10;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $27cbeb9548b9b5fb$export$97b505aa098f3a2b.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $27cbeb9548b9b5fb$export$97b505aa098f3a2b.prototype, "debounceTime", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("#header")
], $27cbeb9548b9b5fb$export$97b505aa098f3a2b.prototype, "header", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("#navigation")
], $27cbeb9548b9b5fb$export$97b505aa098f3a2b.prototype, "navigation", void 0);
$27cbeb9548b9b5fb$export$97b505aa098f3a2b = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-privacy-header")
], $27cbeb9548b9b5fb$export$97b505aa098f3a2b);







/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $3db3538a645e2fa6$export$3bebd1f0e3943985 extends (0, $c37c0eaf2b71ccde$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.et = (0, $5bb961e9df347661$export$45b790e32b2810ee), i.type !== (0, $c37c0eaf2b71ccde$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $5bb961e9df347661$export$45b790e32b2810ee) || null == r) return this.ft = void 0, this.et = r;
        if (r === (0, $5bb961e9df347661$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.et) return this.ft;
        this.et = r;
        const s = [
            r
        ];
        return s.raw = s, this.ft = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$3db3538a645e2fa6$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $3db3538a645e2fa6$export$3bebd1f0e3943985.resultType = 1;
const $3db3538a645e2fa6$export$b6e69390c23686fb = (0, $c37c0eaf2b71ccde$export$99b43ad1ed32e735)($3db3538a645e2fa6$export$3bebd1f0e3943985);





var $83a6dd9b60a2cf67$exports = {};




var $262ccfd8db0d3b35$export$b895ad4e52a7056d = (0, $721e1b33361a91ed$export$dbf350e5966cf602)`
  ${(0, $a15991058abab049$export$e1ac0a3ec62d1269)}

  :host {
    --color: var(--sl-panel-border-color);
    --width: var(--sl-panel-border-width);
    --spacing: var(--sl-spacing-medium);
  }

  :host(:not([vertical])) {
    display: block;
    border-top: solid var(--width) var(--color);
    margin: var(--spacing) 0;
  }

  :host([vertical]) {
    display: inline-block;
    height: 100%;
    border-left: solid var(--width) var(--color);
    margin: 0 var(--spacing);
  }
`;






var $3953074c38e96fd9$export$b433b4df8768f10b = class extends (0, $d6532421f6fe77d5$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.vertical = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute("role", "separator");
    }
    handleVerticalChange() {
        this.setAttribute("aria-orientation", this.vertical ? "vertical" : "horizontal");
    }
};
$3953074c38e96fd9$export$b433b4df8768f10b.styles = (0, $262ccfd8db0d3b35$export$b895ad4e52a7056d);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $3953074c38e96fd9$export$b433b4df8768f10b.prototype, "vertical", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $245c976188bf2656$export$3db5d71bdb2d5499)("vertical")
], $3953074c38e96fd9$export$b433b4df8768f10b.prototype, "handleVerticalChange", 1);


// src/components/divider/divider.ts
var $949c28412e6cebaf$export$2233c5fdcde64809 = (0, $3953074c38e96fd9$export$b433b4df8768f10b);
(0, $3953074c38e96fd9$export$b433b4df8768f10b).define("sl-divider");










var $83a6dd9b60a2cf67$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $83a6dd9b60a2cf67$export$a4741d2bdf49c71b = class WhSeparatorElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.orientation = "horizontal";
    }
    isVertical() {
        return this.orientation === "vertical";
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<sl-divider
      ?vertical=${this.isVertical()}
      class=${this.orientation}
    >
    </sl-divider>`;
    }
};
/* Stryker disable next-line StringLiteral */ $83a6dd9b60a2cf67$export$a4741d2bdf49c71b.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      display: block;
      height: 1rem;
    }
  `;
$83a6dd9b60a2cf67$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $83a6dd9b60a2cf67$export$a4741d2bdf49c71b.prototype, "orientation", void 0);
$83a6dd9b60a2cf67$export$a4741d2bdf49c71b = $83a6dd9b60a2cf67$var$__decorate([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("wh-separator")
], $83a6dd9b60a2cf67$export$a4741d2bdf49c71b);


let $fe09f573cc0e0183$export$ef81e9bccad06f1f = class WebKioskPrivacyContentElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    setPrivacyActive() {
        this.privacySidebar.classList.add("active");
        this.termsSidebar.classList.remove("active");
    }
    setTermsActive() {
        this.termsSidebar.classList.add("active");
        this.privacySidebar.classList.remove("active");
    }
    firstUpdated() {
        const intersectionObserver = new IntersectionObserver(this.scrollCallback, {
            rootMargin: "5px",
            threshold: 0.05
        });
        intersectionObserver.observe(this.privacyHeader);
        intersectionObserver.observe(this.termsHeader);
    }
    scrollToPrivacy() {
        this.privacyHeader.scrollIntoView({
            behavior: "smooth"
        });
    }
    scrollToTerms() {
        this.termsHeader.scrollIntoView({
            behavior: "smooth"
        });
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<div class="privacy-text-container">
      <div class="privacy-sidebar">
        <button @click=${this.scrollToPrivacy} class="sidebar-item">
          <img
            src=${this.content?.contentPrivacyIcon}
            alt=${this.content?.contentPrivacyIconAlt}
            class="sidebar-icon"
          />
          <div id=${this.PRIVACY_SIDEBAR_ID}>${this.content?.contentPrivacySidebarText}</div>
        </button>
        <wh-separator class="sidebar-separator"></wh-separator>
        <button @click=${this.scrollToTerms} class="sidebar-item">
          <img
          src=${this.content?.contentTermsIcon}
            alt=${this.content?.contentTermsIconAlt}
            class="sidebar-icon"
          />
          <div id=${this.TERMS_SIDEBAR_ID}>${this.content?.contentTermsSidebarText}</div>
        </button>
      </div>

        <div class="privacy-text">
          <div id=${this.PRIVACY_HEADER_ID} class="section-header">
            ${(0, $3db3538a645e2fa6$export$b6e69390c23686fb)(this.content?.contentPrivacyBody)}
          </div>
          <div id=${this.TERMS_HEADER_ID} class="section-header">
          ${(0, $3db3538a645e2fa6$export$b6e69390c23686fb)(this.content?.contentTermsBody)}
          </div>
        </div>
        <web-kiosk-back-button></web-kiosk-back-button>
      </div>
    </div>`;
    }
    static{
        /* Stryker disable next-line StringLiteral */ this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-font: "Source Sans Pro", helvetica, arial;
      --web-kiosk-font-size-large: 28px;
      --web-kiosk-font-size: 24px;
      --web-kiosk-text-color: #323264;
      --web-kiosk-background-color: #f5f5f0;
    }

    h3 {
      color: var(--web-kiosk-text-color, blue);
      font-size: 48px;
      margin-bottom: 64px;
    }

    h4 {
      color: var(--web-kiosk-text-color, blue);
      font-size: 32px;
      margin-bottom: 64px;
    }

    strong {
      color: var(--web-kiosk-text-color, blue);
      margin-bottom: 64px;
    }

    p {
      margin-bottom: 64px;
    }

    .active {
      font-weight: 700;
    }

    .privacy-sidebar {
      position: sticky;
      top: 224px;
      align-self: flex-start;
      flex: 1 1 1;
      padding: 16px;
    }

    .sidebar-item {
      display: flex;
      align-items: center;
      text-decoration: none;
      cursor: pointer;
      width: 100%;
      height: 100%;
      font-family: var(--web-kiosk-font);
      font-size: var(--web-kiosk-font-size-large);
      color: var(--web-kiosk-text-color, blue);
      text-align: left;
      background-color: transparent;
      border: none;
    }

    .sidebar-separator {
      padding-top: 64px;
      padding-bottom: 64px;
    }

    .sidebar-icon {
      padding-right: 20px;
      padding-left: 20px;
    }

    .privacy-text-container {
      display: grid;
      grid-template-columns: 3fr 8fr 1fr;
      padding: 64px 56px;
      background-color: var(--web-kiosk-background-color, grey);
    }

    .section-header {
      scroll-margin-top: 160px;
    }

    .privacy-text {
      height: 100%;
      font-family: arial, sans-serif;
      font-size: var(--web-kiosk-font-size, 24px);
    }

    web-kiosk-back-button {
      position: fixed;
      bottom: 120px;
      right: 64px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
        this.active = "";
        this.PRIVACY_HEADER_ID = "privacy-header";
        this.PRIVACY_SIDEBAR_ID = "privacy-sidebar-item";
        this.TERMS_HEADER_ID = "terms-header";
        this.TERMS_SIDEBAR_ID = "terms-sidebar-item";
        this.scrollCallback = (entries)=>{
            entries.forEach((entry)=>{
                const { id: id } = entry.target;
                if (entry.isIntersecting) {
                    if (id === this.PRIVACY_HEADER_ID) this.setPrivacyActive();
                    if (id === this.TERMS_HEADER_ID) this.setTermsActive();
                }
            });
        };
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $fe09f573cc0e0183$export$ef81e9bccad06f1f.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $fe09f573cc0e0183$export$ef81e9bccad06f1f.prototype, "active", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("#privacy-header")
], $fe09f573cc0e0183$export$ef81e9bccad06f1f.prototype, "privacyHeader", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("#terms-header")
], $fe09f573cc0e0183$export$ef81e9bccad06f1f.prototype, "termsHeader", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("#privacy-sidebar-item")
], $fe09f573cc0e0183$export$ef81e9bccad06f1f.prototype, "privacySidebar", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("#terms-sidebar-item")
], $fe09f573cc0e0183$export$ef81e9bccad06f1f.prototype, "termsSidebar", void 0);
$fe09f573cc0e0183$export$ef81e9bccad06f1f = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-privacy-content")
], $fe09f573cc0e0183$export$ef81e9bccad06f1f);



let $d4e92e5afc14e919$export$418bc80bdc416b15 = class WebKioskPrivacyElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section id="privacy">
        <web-kiosk-privacy-header
          .content=${this.content}
        ></web-kiosk-privacy-header>
      </section>
      <web-kiosk-privacy-content
        .content=${this.content}
      ></web-kiosk-privacy-content>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    #privacy {
      z-index: 0;
    }
  `;
    }
};
$d4e92e5afc14e919$export$418bc80bdc416b15 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-privacy")
], $d4e92e5afc14e919$export$418bc80bdc416b15);







let $d3497f0a471f709c$export$8bc5801a6200675a = class WebKioskVideoElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    connectedCallback() {
        super.connectedCallback();
        this.dispatchEvent(new CustomEvent("web-kiosk-video-open", {
            bubbles: true
        }));
    }
    fireCloseEvent() {
        this.dispatchEvent(new CustomEvent("web-kiosk-video-close", {
            bubbles: true
        }));
    }
    render() {
        if (!this.content) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<video
        loop
        muted
        autoplay
        preload="auto"
        src=${this.content.mediaUrl}
        poster=${this.content.mediaPosterImg}
        @click=${this.fireCloseEvent}
      ></video>
      <div id="learn-more">
        <span id="pointer">
          <img src=${this.content.pointerImg} alt=${this.content.pointerAlt} />
        </span>
        <span id="message"> ${this.content.learnMore} </span>
      </div>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    #learn-more {
      display: flex;
      position: absolute;
      align-items: center;
      right: 0;
      top: 66px;
      padding: 20px 73px 20px 24px;
      background: #fff;
      border: 4px solid #e52600;
      border-right: none;
      border-radius: 88px 0 0 88px;
      box-shadow: 0 8px 30px #0a14142b;
      animation: shake 1.2s infinite;
      -webkit-animation: shake 1.2s infinite;
    }

    #pointer {
      animation: pulse 1.2s infinite;
      -webkit-animation: pulse 1.2s infinite;
    }

    #message {
      width: 352px;
      margin-left: 8px;
      color: #264385;
      font-size: 32px;
      font-weight: 700;
      line-height: 38px;
      animation: shake 1.2s infinite;
      -webkit-animation: shake 1.2s infinite;
    }

    @keyframes pulse {
      0% {
        transform: scale(0.7);
      }

      50% {
        transform: scale(1);
      }

      100% {
        transform: scale(0.7);
      }
    }

    @-webkit-keyframes pulse {
      0% {
        transform: scale(0.7);
      }

      50% {
        transform: scale(1);
      }

      100% {
        transform: scale(0.7);
      }
    }

    @keyframes shake {
      0% {
        transform: translateX(0);
      }

      50% {
        transform: translateX(0.3px);
      }

      100% {
        transform: translateX(0);
      }
    }

    @-webkit-keyframes shake {
      0% {
        transform: translateX(0);
      }

      50% {
        transform: translateX(0.3px);
      }

      100% {
        transform: translateX(0);
      }
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $d3497f0a471f709c$export$8bc5801a6200675a.prototype, "content", void 0);
$d3497f0a471f709c$export$8bc5801a6200675a = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-video")
], $d3497f0a471f709c$export$8bc5801a6200675a);


/* eslint-disable @typescript-eslint/consistent-type-assertions */ 








/* eslint-disable sonarjs/no-duplicate-string */ /* eslint-disable lit/prefer-static-styles */ 





var $a4f385b00ed576c6$exports = {};




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4635a96a86119723$var$i = "important", $4635a96a86119723$var$n = " !" + $4635a96a86119723$var$i, $4635a96a86119723$export$1e5b4ce2fa884e6a = (0, $c37c0eaf2b71ccde$export$99b43ad1ed32e735)(class extends (0, $c37c0eaf2b71ccde$export$befdefbdce210f91) {
    constructor(t){
        var e;
        if (super(t), t.type !== (0, $c37c0eaf2b71ccde$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || (null === (e = t.strings) || void 0 === e ? void 0 : e.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ht) {
            this.ht = new Set;
            for(const t in r)this.ht.add(t);
            return this.render(r);
        }
        this.ht.forEach((t)=>{
            null == r[t] && (this.ht.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = "");
        });
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ht.add(t);
                const r = "string" == typeof e && e.endsWith($4635a96a86119723$var$n);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $4635a96a86119723$var$i : "") : s[t] = e;
            }
        }
        return 0, $5bb961e9df347661$export$9c068ae9cc5db4e8;
    }
});




// src/internal/tabbable.ts
function $f2fae79804a569f4$var$isTakingUpSpace(elem) {
    return Boolean(elem.offsetParent || elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
}
function $f2fae79804a569f4$var$isTabbable(el) {
    const tag = el.tagName.toLowerCase();
    if (el.getAttribute("tabindex") === "-1") return false;
    if (el.hasAttribute("disabled")) return false;
    if (tag === "input" && el.getAttribute("type") === "radio" && !el.hasAttribute("checked")) return false;
    if (!$f2fae79804a569f4$var$isTakingUpSpace(el)) return false;
    if (window.getComputedStyle(el).visibility === "hidden") return false;
    if ((tag === "audio" || tag === "video") && el.hasAttribute("controls")) return true;
    if (el.hasAttribute("tabindex")) return true;
    if (el.hasAttribute("contenteditable") && el.getAttribute("contenteditable") !== "false") return true;
    return [
        "button",
        "input",
        "select",
        "textarea",
        "a",
        "audio",
        "video",
        "summary"
    ].includes(tag);
}
function $f2fae79804a569f4$export$16b821ece3e89e24(root) {
    var _a, _b;
    const tabbableElements = $f2fae79804a569f4$export$59a770a0e59b0dd2(root);
    const start = (_a = tabbableElements[0]) != null ? _a : null;
    const end = (_b = tabbableElements[tabbableElements.length - 1]) != null ? _b : null;
    return {
        start: start,
        end: end
    };
}
function $f2fae79804a569f4$export$59a770a0e59b0dd2(root) {
    const tabbableElements = [];
    function walk(el) {
        if (el instanceof Element) {
            if (el.hasAttribute("inert")) return;
            if (!tabbableElements.includes(el) && $f2fae79804a569f4$var$isTabbable(el)) tabbableElements.push(el);
            const slotChildrenOutsideRootElement = (slotElement)=>{
                var _a;
                return ((_a = slotElement.getRootNode({
                    composed: true
                })) == null ? void 0 : _a.host) !== root;
            };
            if (el instanceof HTMLSlotElement && slotChildrenOutsideRootElement(el)) el.assignedElements({
                flatten: true
            }).forEach((assignedEl)=>{
                walk(assignedEl);
            });
            if (el.shadowRoot !== null && el.shadowRoot.mode === "open") walk(el.shadowRoot);
        }
        [
            ...el.children
        ].forEach((e)=>walk(e));
    }
    walk(root);
    return tabbableElements.sort((a, b)=>{
        const aTabindex = Number(a.getAttribute("tabindex")) || 0;
        const bTabindex = Number(b.getAttribute("tabindex")) || 0;
        return bTabindex - aTabindex;
    });
}



// src/internal/active-elements.ts
function* $3cd8c57fc2ffa742$var$activeElements(activeElement = document.activeElement) {
    if (activeElement === null || activeElement === void 0) return;
    yield activeElement;
    if ("shadowRoot" in activeElement && activeElement.shadowRoot && activeElement.shadowRoot.mode !== "closed") yield* (0, $eab5a1a480d90122$export$5590fd18e5672c2)($3cd8c57fc2ffa742$var$activeElements(activeElement.shadowRoot.activeElement));
}
function $3cd8c57fc2ffa742$var$getDeepestActiveElement() {
    return [
        ...$3cd8c57fc2ffa742$var$activeElements()
    ].pop();
}
// src/internal/modal.ts
var $3cd8c57fc2ffa742$var$activeModals = [];
var $3cd8c57fc2ffa742$export$2b77a92f1a5ad772 = class {
    constructor(element){
        this.tabDirection = "forward";
        this.handleFocusIn = ()=>{
            this.checkFocus();
        };
        this.handleKeyDown = (event)=>{
            var _a, _b;
            if (event.key !== "Tab" || this.isExternalActivated) return;
            if (event.shiftKey) this.tabDirection = "backward";
            else this.tabDirection = "forward";
            event.preventDefault();
            const tabbableElements = (0, $f2fae79804a569f4$export$59a770a0e59b0dd2)(this.element);
            const currentActiveElement = $3cd8c57fc2ffa742$var$getDeepestActiveElement();
            let currentFocusIndex = tabbableElements.findIndex((el)=>el === currentActiveElement);
            if (currentFocusIndex === -1) {
                this.currentFocus = tabbableElements[0];
                (_a = this.currentFocus) == null || _a.focus({
                    preventScroll: true
                });
                return;
            }
            const addition = this.tabDirection === "forward" ? 1 : -1;
            if (currentFocusIndex + addition >= tabbableElements.length) currentFocusIndex = 0;
            else if (currentFocusIndex + addition < 0) currentFocusIndex = tabbableElements.length - 1;
            else currentFocusIndex += addition;
            this.currentFocus = tabbableElements[currentFocusIndex];
            (_b = this.currentFocus) == null || _b.focus({
                preventScroll: true
            });
            setTimeout(()=>this.checkFocus());
        };
        this.handleKeyUp = ()=>{
            this.tabDirection = "forward";
        };
        this.element = element;
    }
    /** Activates focus trapping. */ activate() {
        $3cd8c57fc2ffa742$var$activeModals.push(this.element);
        document.addEventListener("focusin", this.handleFocusIn);
        document.addEventListener("keydown", this.handleKeyDown);
        document.addEventListener("keyup", this.handleKeyUp);
    }
    /** Deactivates focus trapping. */ deactivate() {
        $3cd8c57fc2ffa742$var$activeModals = $3cd8c57fc2ffa742$var$activeModals.filter((modal)=>modal !== this.element);
        this.currentFocus = null;
        document.removeEventListener("focusin", this.handleFocusIn);
        document.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("keyup", this.handleKeyUp);
    }
    /** Determines if this modal element is currently active or not. */ isActive() {
        return $3cd8c57fc2ffa742$var$activeModals[$3cd8c57fc2ffa742$var$activeModals.length - 1] === this.element;
    }
    /** Activates external modal behavior and temporarily disables focus trapping. */ activateExternal() {
        this.isExternalActivated = true;
    }
    /** Deactivates external modal behavior and re-enables focus trapping. */ deactivateExternal() {
        this.isExternalActivated = false;
    }
    checkFocus() {
        if (this.isActive() && !this.isExternalActivated) {
            const tabbableElements = (0, $f2fae79804a569f4$export$59a770a0e59b0dd2)(this.element);
            if (!this.element.matches(":focus-within")) {
                const start = tabbableElements[0];
                const end = tabbableElements[tabbableElements.length - 1];
                const target = this.tabDirection === "forward" ? start : end;
                if (typeof (target == null ? void 0 : target.focus) === "function") {
                    this.currentFocus = target;
                    target.focus({
                        preventScroll: true
                    });
                }
            }
        }
    }
};


// src/internal/offset.ts
function $e6c45abf44c82847$var$getOffset(element, parent) {
    return {
        top: Math.round(element.getBoundingClientRect().top - parent.getBoundingClientRect().top),
        left: Math.round(element.getBoundingClientRect().left - parent.getBoundingClientRect().left)
    };
}
// src/internal/scroll.ts
var $e6c45abf44c82847$var$locks = /* @__PURE__ */ new Set();
function $e6c45abf44c82847$var$getScrollbarWidth() {
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}
function $e6c45abf44c82847$export$5f4bd35c67f2403d(lockingEl) {
    $e6c45abf44c82847$var$locks.add(lockingEl);
    if (!document.body.classList.contains("sl-scroll-lock")) {
        const scrollbarWidth = $e6c45abf44c82847$var$getScrollbarWidth();
        document.body.classList.add("sl-scroll-lock");
        document.body.style.setProperty("--sl-scroll-lock-size", `${scrollbarWidth}px`);
    }
}
function $e6c45abf44c82847$export$7475b4759872c980(lockingEl) {
    $e6c45abf44c82847$var$locks.delete(lockingEl);
    if ($e6c45abf44c82847$var$locks.size === 0) {
        document.body.classList.remove("sl-scroll-lock");
        document.body.style.removeProperty("--sl-scroll-lock-size");
    }
}
function $e6c45abf44c82847$export$53a0910f038337bd(element, container, direction = "vertical", behavior = "smooth") {
    const offset = $e6c45abf44c82847$var$getOffset(element, container);
    const offsetTop = offset.top + container.scrollTop;
    const offsetLeft = offset.left + container.scrollLeft;
    const minX = container.scrollLeft;
    const maxX = container.scrollLeft + container.offsetWidth;
    const minY = container.scrollTop;
    const maxY = container.scrollTop + container.offsetHeight;
    if (direction === "horizontal" || direction === "both") {
        if (offsetLeft < minX) container.scrollTo({
            left: offsetLeft,
            behavior: behavior
        });
        else if (offsetLeft + element.clientWidth > maxX) container.scrollTo({
            left: offsetLeft - container.offsetWidth + element.clientWidth,
            behavior: behavior
        });
    }
    if (direction === "vertical" || direction === "both") {
        if (offsetTop < minY) container.scrollTo({
            top: offsetTop,
            behavior: behavior
        });
        else if (offsetTop + element.clientHeight > maxY) container.scrollTo({
            top: offsetTop - container.offsetHeight + element.clientHeight,
            behavior: behavior
        });
    }
}




var $3196099a7c45aac3$export$b752f4490c3ab6b1 = (0, $721e1b33361a91ed$export$dbf350e5966cf602)`
  ${(0, $a15991058abab049$export$e1ac0a3ec62d1269)}

  :host {
    --width: 31rem;
    --header-spacing: var(--sl-spacing-large);
    --body-spacing: var(--sl-spacing-large);
    --footer-spacing: var(--sl-spacing-large);

    display: contents;
  }

  .dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--sl-z-index-dialog);
  }

  .dialog__panel {
    display: flex;
    flex-direction: column;
    z-index: 2;
    width: var(--width);
    max-width: calc(100% - var(--sl-spacing-2x-large));
    max-height: calc(100% - var(--sl-spacing-2x-large));
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    box-shadow: var(--sl-shadow-x-large);
  }

  .dialog__panel:focus {
    outline: none;
  }

  /* Ensure there's enough vertical padding for phones that don't update vh when chrome appears (e.g. iPhone) */
  @media screen and (max-width: 420px) {
    .dialog__panel {
      max-height: 80vh;
    }
  }

  .dialog--open .dialog__panel {
    display: flex;
    opacity: 1;
  }

  .dialog__header {
    flex: 0 0 auto;
    display: flex;
  }

  .dialog__title {
    flex: 1 1 auto;
    font: inherit;
    font-size: var(--sl-font-size-large);
    line-height: var(--sl-line-height-dense);
    padding: var(--header-spacing);
    margin: 0;
  }

  .dialog__header-actions {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    gap: var(--sl-spacing-2x-small);
    padding: 0 var(--header-spacing);
  }

  .dialog__header-actions sl-icon-button,
  .dialog__header-actions ::slotted(sl-icon-button) {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
  }

  .dialog__body {
    flex: 1 1 auto;
    display: block;
    padding: var(--body-spacing);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: right;
    padding: var(--footer-spacing);
  }

  .dialog__footer ::slotted(sl-button:not(:first-of-type)) {
    margin-inline-start: var(--sl-spacing-x-small);
  }

  .dialog:not(.dialog--has-footer) .dialog__footer {
    display: none;
  }

  .dialog__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sl-overlay-background-color);
  }

  @media (forced-colors: active) {
    .dialog__panel {
      border: solid 1px var(--sl-color-neutral-0);
    }
  }
`;




var $76cd014fc4d2c614$export$e7174f10cedebf49 = (0, $721e1b33361a91ed$export$dbf350e5966cf602)`
  ${(0, $a15991058abab049$export$e1ac0a3ec62d1269)}

  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;









var $f31e9cc7b6b8813a$export$302c9d29315a4659 = class extends (0, $d6532421f6fe77d5$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasFocus = false;
        this.label = "";
        this.disabled = false;
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /** Simulates a click on the icon button. */ click() {
        this.button.click();
    }
    /** Sets focus on the icon button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the icon button. */ blur() {
        this.button.blur();
    }
    render() {
        const isLink = this.href ? true : false;
        const tag = isLink ? (0, $34c33baf83c15327$export$c8ec6e1ec9fefcb0)`a` : (0, $34c33baf83c15327$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $34c33baf83c15327$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $756492cca5018fee$export$56cc687933817664)({
            "icon-button": true,
            "icon-button--disabled": !isLink && this.disabled,
            "icon-button--focused": this.hasFocus
        })}
        ?disabled=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        href=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? this.href : void 0)}
        target=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink && this.target ? "noreferrer noopener" : void 0)}
        role=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(this.name)}
          library=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(this.library)}
          src=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${tag}>
    `;
    }
};
$f31e9cc7b6b8813a$export$302c9d29315a4659.styles = (0, $76cd014fc4d2c614$export$e7174f10cedebf49);
$f31e9cc7b6b8813a$export$302c9d29315a4659.dependencies = {
    "sl-icon": (0, $7bf02663e7e33382$export$ef62a86bf282441)
};
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a381745756984e0e$export$2fa187e846a241c4)(".icon-button")
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "button", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $9eba64a7190237ae$export$ca000e230c0caa3e)()
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "hasFocus", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "name", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "library", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "src", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "href", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "target", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "download", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)()
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "label", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $f31e9cc7b6b8813a$export$302c9d29315a4659.prototype, "disabled", 2);



// src/utilities/animation-registry.ts
var $fc99906a6f57ba04$var$defaultAnimationRegistry = /* @__PURE__ */ new Map();
var $fc99906a6f57ba04$var$customAnimationRegistry = /* @__PURE__ */ new WeakMap();
function $fc99906a6f57ba04$var$ensureAnimation(animation) {
    return animation != null ? animation : {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}
function $fc99906a6f57ba04$var$getLogicalAnimation(animation, dir) {
    if (dir.toLowerCase() === "rtl") return {
        keyframes: animation.rtlKeyframes || animation.keyframes,
        options: animation.options
    };
    return animation;
}
function $fc99906a6f57ba04$export$6e92ecdbe15fda0b(animationName, animation) {
    $fc99906a6f57ba04$var$defaultAnimationRegistry.set(animationName, $fc99906a6f57ba04$var$ensureAnimation(animation));
}
function $fc99906a6f57ba04$export$ea45326d94a48a31(el, animationName, animation) {
    $fc99906a6f57ba04$var$customAnimationRegistry.set(el, (0, $eab5a1a480d90122$export$f4da8f157c1253f7)((0, $eab5a1a480d90122$export$7de063a7aa429f6c)({}, $fc99906a6f57ba04$var$customAnimationRegistry.get(el)), {
        [animationName]: $fc99906a6f57ba04$var$ensureAnimation(animation)
    }));
}
function $fc99906a6f57ba04$export$b1aed5dec0c2d368(el, animationName, options) {
    const customAnimation = $fc99906a6f57ba04$var$customAnimationRegistry.get(el);
    if (customAnimation == null ? void 0 : customAnimation[animationName]) return $fc99906a6f57ba04$var$getLogicalAnimation(customAnimation[animationName], options.dir);
    const defaultAnimation = $fc99906a6f57ba04$var$defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) return $fc99906a6f57ba04$var$getLogicalAnimation(defaultAnimation, options.dir);
    return {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}


// src/internal/event.ts
function $3aa6a5f5fe95fc09$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}



// src/internal/animate.ts
function $fa8c98e335aa559f$export$3b755839a54e1bb0(el, keyframes, options) {
    return new Promise((resolve)=>{
        if ((options == null ? void 0 : options.duration) === Infinity) throw new Error("Promise-based animations must be finite.");
        const animation = el.animate(keyframes, (0, $eab5a1a480d90122$export$f4da8f157c1253f7)((0, $eab5a1a480d90122$export$7de063a7aa429f6c)({}, options), {
            duration: $fa8c98e335aa559f$export$ff7706047246b98b() ? 0 : options.duration
        }));
        animation.addEventListener("cancel", resolve, {
            once: true
        });
        animation.addEventListener("finish", resolve, {
            once: true
        });
    });
}
function $fa8c98e335aa559f$export$ecae829bb3747ea6(delay) {
    delay = delay.toString().toLowerCase();
    if (delay.indexOf("ms") > -1) return parseFloat(delay);
    if (delay.indexOf("s") > -1) return parseFloat(delay) * 1e3;
    return parseFloat(delay);
}
function $fa8c98e335aa559f$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}
function $fa8c98e335aa559f$export$ad12f740028ccbea(el) {
    return Promise.all(el.getAnimations().map((animation)=>{
        return new Promise((resolve)=>{
            const handleAnimationEvent = requestAnimationFrame(resolve);
            animation.addEventListener("cancel", ()=>handleAnimationEvent, {
                once: true
            });
            animation.addEventListener("finish", ()=>handleAnimationEvent, {
                once: true
            });
            animation.cancel();
        });
    }));
}
function $fa8c98e335aa559f$export$783a9b5bf095072a(keyframes, calculatedHeight) {
    return keyframes.map((keyframe)=>(0, $eab5a1a480d90122$export$f4da8f157c1253f7)((0, $eab5a1a480d90122$export$7de063a7aa429f6c)({}, keyframe), {
            height: keyframe.height === "auto" ? `${calculatedHeight}px` : keyframe.height
        }));
}











var $d142709e5fed5baa$export$2a86abe166e5892d = class extends (0, $d6532421f6fe77d5$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $50a13d85bbf8d38d$export$34f6a5ffaa663541)(this, "footer");
        this.localize = new (0, $bad2bd6ac4a0d8f9$export$b1a2fed5bb41b893)(this);
        this.modal = new (0, $3cd8c57fc2ffa742$export$2b77a92f1a5ad772)(this);
        this.open = false;
        this.label = "";
        this.noHeader = false;
        this.handleDocumentKeyDown = (event)=>{
            if (event.key === "Escape" && this.modal.isActive() && this.open) {
                event.stopPropagation();
                this.requestClose("keyboard");
            }
        };
    }
    firstUpdated() {
        this.dialog.hidden = !this.open;
        if (this.open) {
            this.addOpenListeners();
            this.modal.activate();
            (0, $e6c45abf44c82847$export$5f4bd35c67f2403d)(this);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.modal.deactivate();
        (0, $e6c45abf44c82847$export$7475b4759872c980)(this);
    }
    requestClose(source) {
        const slRequestClose = this.emit("sl-request-close", {
            cancelable: true,
            detail: {
                source: source
            }
        });
        if (slRequestClose.defaultPrevented) {
            const animation = (0, $fc99906a6f57ba04$export$b1aed5dec0c2d368)(this, "dialog.denyClose", {
                dir: this.localize.dir()
            });
            (0, $fa8c98e335aa559f$export$3b755839a54e1bb0)(this.panel, animation.keyframes, animation.options);
            return;
        }
        this.hide();
    }
    addOpenListeners() {
        document.addEventListener("keydown", this.handleDocumentKeyDown);
    }
    removeOpenListeners() {
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }
    async handleOpenChange() {
        if (this.open) {
            this.emit("sl-show");
            this.addOpenListeners();
            this.originalTrigger = document.activeElement;
            this.modal.activate();
            (0, $e6c45abf44c82847$export$5f4bd35c67f2403d)(this);
            const autoFocusTarget = this.querySelector("[autofocus]");
            if (autoFocusTarget) autoFocusTarget.removeAttribute("autofocus");
            await Promise.all([
                (0, $fa8c98e335aa559f$export$ad12f740028ccbea)(this.dialog),
                (0, $fa8c98e335aa559f$export$ad12f740028ccbea)(this.overlay)
            ]);
            this.dialog.hidden = false;
            requestAnimationFrame(()=>{
                const slInitialFocus = this.emit("sl-initial-focus", {
                    cancelable: true
                });
                if (!slInitialFocus.defaultPrevented) {
                    if (autoFocusTarget) autoFocusTarget.focus({
                        preventScroll: true
                    });
                    else this.panel.focus({
                        preventScroll: true
                    });
                }
                if (autoFocusTarget) autoFocusTarget.setAttribute("autofocus", "");
            });
            const panelAnimation = (0, $fc99906a6f57ba04$export$b1aed5dec0c2d368)(this, "dialog.show", {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $fc99906a6f57ba04$export$b1aed5dec0c2d368)(this, "dialog.overlay.show", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $fa8c98e335aa559f$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options),
                (0, $fa8c98e335aa559f$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
            ]);
            this.emit("sl-after-show");
        } else {
            this.emit("sl-hide");
            this.removeOpenListeners();
            this.modal.deactivate();
            await Promise.all([
                (0, $fa8c98e335aa559f$export$ad12f740028ccbea)(this.dialog),
                (0, $fa8c98e335aa559f$export$ad12f740028ccbea)(this.overlay)
            ]);
            const panelAnimation = (0, $fc99906a6f57ba04$export$b1aed5dec0c2d368)(this, "dialog.hide", {
                dir: this.localize.dir()
            });
            const overlayAnimation = (0, $fc99906a6f57ba04$export$b1aed5dec0c2d368)(this, "dialog.overlay.hide", {
                dir: this.localize.dir()
            });
            await Promise.all([
                (0, $fa8c98e335aa559f$export$3b755839a54e1bb0)(this.overlay, overlayAnimation.keyframes, overlayAnimation.options).then(()=>{
                    this.overlay.hidden = true;
                }),
                (0, $fa8c98e335aa559f$export$3b755839a54e1bb0)(this.panel, panelAnimation.keyframes, panelAnimation.options).then(()=>{
                    this.panel.hidden = true;
                })
            ]);
            this.dialog.hidden = true;
            this.overlay.hidden = false;
            this.panel.hidden = false;
            (0, $e6c45abf44c82847$export$7475b4759872c980)(this);
            const trigger = this.originalTrigger;
            if (typeof (trigger == null ? void 0 : trigger.focus) === "function") setTimeout(()=>trigger.focus());
            this.emit("sl-after-hide");
        }
    }
    /** Shows the dialog. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $3aa6a5f5fe95fc09$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the dialog */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $3aa6a5f5fe95fc09$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        return (0, $6d8f6951af537b31$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $756492cca5018fee$export$56cc687933817664)({
            dialog: true,
            "dialog--open": this.open,
            "dialog--has-footer": this.hasSlotController.test("footer")
        })}
      >
        <div part="overlay" class="dialog__overlay" @click=${()=>this.requestClose("overlay")} tabindex="-1"></div>

        <div
          part="panel"
          class="dialog__panel"
          role="dialog"
          aria-modal="true"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(this.noHeader ? this.label : void 0)}
          aria-labelledby=${(0, $83cd63fc68f4807b$export$f68dd208b5df064d)(!this.noHeader ? "title" : void 0)}
          tabindex="-1"
        >
          ${!this.noHeader ? (0, $6d8f6951af537b31$export$c0bb0b647f701bb5)`
                <header part="header" class="dialog__header">
                  <h2 part="title" class="dialog__title" id="title">
                    <slot name="label"> ${this.label.length > 0 ? this.label : String.fromCharCode(65279)} </slot>
                  </h2>
                  <div part="header-actions" class="dialog__header-actions">
                    <slot name="header-actions"></slot>
                    <sl-icon-button
                      part="close-button"
                      exportparts="base:close-button__base"
                      class="dialog__close"
                      name="x-lg"
                      label=${this.localize.term("close")}
                      library="system"
                      @click="${()=>this.requestClose("close-button")}"
                    ></sl-icon-button>
                  </div>
                </header>
              ` : ""}
          ${""}
          <slot part="body" class="dialog__body" tabindex="-1"></slot>

          <footer part="footer" class="dialog__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
    }
};
$d142709e5fed5baa$export$2a86abe166e5892d.styles = (0, $3196099a7c45aac3$export$b752f4490c3ab6b1);
$d142709e5fed5baa$export$2a86abe166e5892d.dependencies = {
    "sl-icon-button": (0, $f31e9cc7b6b8813a$export$302c9d29315a4659)
};
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a381745756984e0e$export$2fa187e846a241c4)(".dialog")
], $d142709e5fed5baa$export$2a86abe166e5892d.prototype, "dialog", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a381745756984e0e$export$2fa187e846a241c4)(".dialog__panel")
], $d142709e5fed5baa$export$2a86abe166e5892d.prototype, "panel", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a381745756984e0e$export$2fa187e846a241c4)(".dialog__overlay")
], $d142709e5fed5baa$export$2a86abe166e5892d.prototype, "overlay", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d142709e5fed5baa$export$2a86abe166e5892d.prototype, "open", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        reflect: true
    })
], $d142709e5fed5baa$export$2a86abe166e5892d.prototype, "label", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $a435086cf00d3e55$export$d541bacb2bda4494)({
        attribute: "no-header",
        type: Boolean,
        reflect: true
    })
], $d142709e5fed5baa$export$2a86abe166e5892d.prototype, "noHeader", 2);
(0, $eab5a1a480d90122$export$85c93885f16e8446)([
    (0, $245c976188bf2656$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $d142709e5fed5baa$export$2a86abe166e5892d.prototype, "handleOpenChange", 1);
(0, $fc99906a6f57ba04$export$6e92ecdbe15fda0b)("dialog.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.8
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $fc99906a6f57ba04$export$6e92ecdbe15fda0b)("dialog.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.8
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $fc99906a6f57ba04$export$6e92ecdbe15fda0b)("dialog.denyClose", {
    keyframes: [
        {
            scale: 1
        },
        {
            scale: 1.02
        },
        {
            scale: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $fc99906a6f57ba04$export$6e92ecdbe15fda0b)("dialog.overlay.show", {
    keyframes: [
        {
            opacity: 0
        },
        {
            opacity: 1
        }
    ],
    options: {
        duration: 250
    }
});
(0, $fc99906a6f57ba04$export$6e92ecdbe15fda0b)("dialog.overlay.hide", {
    keyframes: [
        {
            opacity: 1
        },
        {
            opacity: 0
        }
    ],
    options: {
        duration: 250
    }
});


// src/components/dialog/dialog.ts
var $992e01a2270ddf46$export$585117cab3e12d3 = (0, $d142709e5fed5baa$export$2a86abe166e5892d);
(0, $d142709e5fed5baa$export$2a86abe166e5892d).define("sl-dialog");





























var $a4f385b00ed576c6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a4f385b00ed576c6$export$f04f8f11d46d73cf = class WhModalElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.label = "";
        this.open = false;
        this.fitContent = false;
        this.flat = false;
        this.noHeader = false;
    }
    hideModal() {
        this.open = false;
    }
    showModal() {
        this.open = true;
    }
    getDialogStyles() {
        const styles = {};
        if (this.fitContent) styles["--width"] = "fit-content";
        return styles;
    }
    renderHeader() {
        const buttonVariant = this.flat ? "text-flat" : "text";
        return this.noHeader ? (0, $5bb961e9df347661$export$45b790e32b2810ee) : (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <slot name="modal-header" slot="label">
          ${this.label}
          <wh-button
            variant=${buttonVariant}
            @click=${this.hideModal}
            class="wh-modal-close"
          >
            <slot name="close-button-content">
              <wh-icon slot="prefix" name="x-circle" label="Close"></wh-icon>
              Close
            </slot>
          </wh-button></slot
        >`;
    }
    /* We have to style this dynamically to style the proper part for background color. */ render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <sl-dialog
        style=${(0, $4635a96a86119723$export$1e5b4ce2fa884e6a)(this.getDialogStyles())}
        ?open=${this.open}
        ?noHeader=${this.noHeader}
        exportparts="title, header, overlay"
        @sl-hide=${this.hideModal}
      >
        ${this.renderHeader()}
        <slot></slot>
      </sl-dialog>
    `;
    }
};
$a4f385b00ed576c6$export$f04f8f11d46d73cf.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      display: block;

      --wh-dimension-spacer-xs: 16px;
      --wh-modal-background-color: var(--wh-palette-colors-white, white);
    }

    sl-dialog::part(close-button) {
      display: none;
    }

    sl-dialog::part(close-button__base) {
      display: none;
      color: var(--wh-theme-colors-primary, hotpink);
    }

    sl-dialog::part(panel) {
      border-radius: 16px;
      background-color: var(--wh-modal-background-color, hotpink);
    }

    sl-dialog::part(body) {
      padding: 0;
    }

    sl-dialog::part(header) {
      font-family: var(
        --wh-typography-font-family,
        "Source Sans Pro",
        helvetica,
        arial
      );
      font-weight: bold;
      font-size: 27px;
      color: black;
    }

    sl-dialog::part(title) {
      display: flex;
      justify-content: flex-start;
      flex-grow: 1;
      position: relative;
    }

    :host([noHeader]) sl-dialog::part(title) {
      padding: 0;
    }

    sl-dialog::slotted(label) {
      display: flex;
      justify-content: space-between;
    }

    slot[name="modal-header"] {
      width: 100%;
    }

    .wh-modal-close {
      position: absolute;
      top: var(--wh-dimension-spacer-xs);
      right: 0;
      padding-right: var(--body-spacing);
    }
  `;
$a4f385b00ed576c6$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $a4f385b00ed576c6$export$f04f8f11d46d73cf.prototype, "label", void 0);
$a4f385b00ed576c6$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a4f385b00ed576c6$export$f04f8f11d46d73cf.prototype, "open", void 0);
$a4f385b00ed576c6$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a4f385b00ed576c6$export$f04f8f11d46d73cf.prototype, "fitContent", void 0);
$a4f385b00ed576c6$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a4f385b00ed576c6$export$f04f8f11d46d73cf.prototype, "flat", void 0);
$a4f385b00ed576c6$var$__decorate([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a4f385b00ed576c6$export$f04f8f11d46d73cf.prototype, "noHeader", void 0);
$a4f385b00ed576c6$export$f04f8f11d46d73cf = $a4f385b00ed576c6$var$__decorate([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("wh-modal")
], $a4f385b00ed576c6$export$f04f8f11d46d73cf);


let $e4c12e2ba16394f7$export$fe576bc577bd9afd = class WebKioskServicesModalElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    show() {
        this.modal?.showModal();
    }
    hide() {
        this.modal?.hideModal();
    }
    renderModalHeader(card) {
        if (!card) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        if (!card.headerColor) return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<label id="close" slot="close-button-content">
        <img
          src="assets/shared/close.svg"
          alt=${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Close", {
            id: "services-modal-close"
        })}
        />
        ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Close", {
            id: "services-modal-close"
        })}
      </label>`;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <span id="custom-header" slot="modal-header">
        <img src=${card.headerLogo} alt=${card.title} />
        <button @click=${this.hide}>
          <wh-icon name="close"></wh-icon> ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Close", {
            id: "services-modal-close"
        })}
        </button>
      </span>
      <style>
        wh-modal::part(header) {
          border-top-left-radius: inherit;
          border-top-right-radius: inherit;
          color: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(card.headerColor)};
          background-color: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(card.headerBackgroundColor)};
        }

        wh-modal::part(title) {
          padding: 0;
        }

        #custom-header {
          display: flex;
          width: 100%;
          justify-content: space-between;
          height: 104px;
          padding: 0 25px;
          align-items: center;
        }

        #custom-header img {
          margin-left: var(--web-kiosk-dimension-spacer-m, 32px);
        }

        #custom-header button {
          display: flex;
          align-items: center;
          color: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(card.headerColor)};
          font-family: var(--web-kiosk-font, "Source Sans Pro");
          font-size: 33px;
          font-weight: 700;
          line-height: 40px;
          background: none;
          border: none;
          cursor: pointer;
        }

        #custom-header button wh-icon {
          font-size: 1em;
          margin-right: var(--web-kiosk-dimension-spacer-xs, 16px);
        }
      </style>`;
    }
    renderAppointmentInfo(appointment) {
        if (!appointment) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section id="appointment">
      <dl>
        <dt>
          <strong>${appointment.title}</strong>
        </dt>
        <dd>${appointment.phoneNumber}</dd>
      </dl>
    </section>`;
    }
    render() {
        const { card: card, appointment: appointment } = this;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <wh-modal id="service-modal" flat fitContent>
      ${this.renderModalHeader(card)}
      <div id="modal-inner">
        <section id="icon">
          <img src=${card?.icon} alt=${card?.title} />
        </section>
        <section id="texts">
          <h3>${card?.title}</h3>
          <h4>${card?.subTitle}</h4>
          <p><strong>${card?.highlightedText}</strong></p>
          <p>${(0, $3db3538a645e2fa6$export$b6e69390c23686fb)(card?.additionalText)}</p>
          <p class="legal">${card?.legalDisclaimer}</p>
        </section>
        ${this.renderAppointmentInfo(appointment)}
      </div>
    </wh-modal>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-text-color: #323264;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-dimension-spacer-xxs: 8px;
      --web-kiosk-dimension-spacer-xs: 16px;
      --web-kiosk-dimension-spacer-s: 24px;
      --web-kiosk-dimension-spacer-m: 32px;
      --web-kiosk-font: "Source Sans Pro", helvetica, arial;
    }

    wh-modal {
      --wh-modal-background-color: #f5f5f0;
    }

    #close {
      display: block;
      color: var(--web-kiosk-link-color, hotpink);
      background: none;
      padding: var(--web-kiosk-dimension-spacer-s, 24px)
        var(--web-kiosk-dimension-spacer-xs, 16px);
      border: none;
      /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
      font-family: "Source Sans Pro";
      font-size: 33px;
      font-weight: 700;
      line-height: 40px;
    }

    #close:hover {
      cursor: pointer;
    }

    #close img {
      margin-right: var(--web-kiosk-dimension-spacer-xxs, 8px);
    }

    #modal-inner {
      display: flex;
      min-height: 595px;
      max-width: 1305px;
      padding-top: 7vw;
      padding-left: 8vw;
      padding-bottom: 36px;
    }

    wh-modal::part(overlay) {
      background-color: #00000080;
    }

    #icon {
      width: 8%;
      flex: 1 0 8%;
    }

    #icon img {
      width: 110px;
    }

    #texts {
      width: 58%;
      flex: 1 0 58%;
    }

    #texts h3 {
      margin: 0 0 var(--web-kiosk-dimension-spacer-xs, 16px)
        var(--web-kiosk-dimension-spacer-xs, 16px);
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 48px;
      line-height: 62px;
    }

    #texts h4 {
      margin: 0 0 var(--web-kiosk-dimension-spacer-s, 24px)
        var(--web-kiosk-dimension-spacer-xs, 16px);
      font-size: var(--web-kiosk-dimension-spacer-m, 32px);
      font-weight: 600;
      line-height: 42px;
    }

    #texts strong {
      font-weight: 600;
    }

    #texts p {
      margin-left: var(--web-kiosk-dimension-spacer-xs, 16px);
      font-size: 28px;
      line-height: 48px;
      font-weight: 400;
    }

    #texts p.legal {
      font-size: 20px;
      line-height: 28px;
    }

    #appointment {
      display: flex;
      flex: 1 0 34%;
      width: 34%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: url("assets/services/bg/blob.svg") no-repeat;
      background-size: contain;
      background-position: 100%;
    }

    #appointment dl {
      display: flex;
      padding-left: 3vw;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    #appointment dt {
      margin-bottom: var(--web-kiosk-dimension-spacer-s, 24px);
      font-size: var(--web-kiosk-dimension-spacer-s, 24px);
      line-height: 30px;
    }

    #appointment dd {
      margin-bottom: 56px;
      margin-left: 0;
      font-size: 28px;
      line-height: 48px;
    }

    #qr-code {
      height: 128px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.card = undefined;
        this.appointment = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $e4c12e2ba16394f7$export$fe576bc577bd9afd.prototype, "card", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $e4c12e2ba16394f7$export$fe576bc577bd9afd.prototype, "appointment", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-modal")
], $e4c12e2ba16394f7$export$fe576bc577bd9afd.prototype, "modal", void 0);
$e4c12e2ba16394f7$export$fe576bc577bd9afd = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-services-modal")
], $e4c12e2ba16394f7$export$fe576bc577bd9afd);



function $5a790392714b0661$export$a1cc004b7fc7fb3e(elements, pageSize) {
    if (!elements) return [];
    return Array.from({
        length: Math.ceil(elements.length / pageSize)
    }, (skip, index)=>elements.slice(index * pageSize, index * pageSize + pageSize));
}



let $debfb08e53488f8f$export$2cbd13e54b8dd57f = class WebKioskServicesElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    showInfo(card) {
        this.selectedCard = card;
        this.modal?.show();
    }
    changePage({ detail: detail }) {
        this.carouselCurrentPageNumber = detail.newPagePosition;
        this.carouselActiveNumber = detail.newPagePosition - 1;
    }
    updatePagination({ detail: { activeIndex: activeIndex } }) {
        this.carouselCurrentPageNumber = activeIndex + 1;
    }
    renderCard(card) {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<div class="card-container">
      <wh-card
        flat
        size="large"
        @click=${()=>{
            this.showInfo(card);
        }}
      >
        <section class="card-inner">
          <img src=${card.icon} class="card-icon" alt=${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Details")} />
          <div class="card-texts">
            <h3>${card.title}</h3>
            <p>${card.availability}</p>
          </div>

          <img
            src="assets/services/arrow_icon.svg"
            class="arrow-icon"
            alt=${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Details")}
          />
        </section>
      </wh-card>
    </div>`;
    }
    renderPageCards(cards) {
        return cards.map((card)=>this.renderCard(card));
    }
    renderSlides(cards) {
        const pages = (0, $5a790392714b0661$export$a1cc004b7fc7fb3e)(cards, this.cardsPerPage);
        return pages.map((page)=>(0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section wh-carousel-snap class="carousel-slide">
          ${this.renderPageCards(page)}
        </section>`);
    }
    renderCarousel(cards) {
        if (!cards || cards.length === 0) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<wh-carousel
      active=${(0, $af8e33ff014f07c6$export$f68dd208b5df064d)(this.carouselActiveNumber)}
      @scrollcomplete=${this.updatePagination}
    >
      ${this.renderSlides(cards)}
    </wh-carousel>`;
    }
    renderPagination(cardsCount) {
        if (cardsCount <= this.cardsPerPage) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        const totalPages = Math.ceil(cardsCount / this.cardsPerPage);
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<div id="pagination-container">
      <wh-pagination
        variant="number-of"
        current-page-number=${this.carouselCurrentPageNumber}
        total-pages=${totalPages}
        @paginate=${this.changePage}
      >
        <span slot="prefix"
          >${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Page", {
            id: "home-carousel-prefix"
        })}</span
        >
        <span slot="separator"> / </span>
      </wh-pagination>
    </div>`;
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section class="page-body">
      <div class="body-inner">
        <web-kiosk-home-link
          link=${this.createRelativeLink("home")}
        ></web-kiosk-home-link>

        <div class="body-content">
          <section id="about-text">
            <h1>${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Walgreens Health Corner Services")}</h1>
            <h2>${this.content?.heading}</h2>
            <p>${this.content?.description}</p>
          </section>
          <section id="cards">
            ${this.renderCarousel(this.content?.cards)}
            ${this.renderPagination(this.content?.cards.length ?? 0)}
          </section>
        </div>
        <web-kiosk-services-modal
          .card=${this.selectedCard}
          .appointment=${this.content?.appointment}
        ></web-kiosk-services-modal>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c1e8ff;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
      --web-kiosk-dimension-spacer-xxs: 8px;
      --web-kiosk-dimension-spacer-xs: 16px;
      --web-kiosk-dimension-spacer-m: 32px;
      --web-kiosk-dimension-spacer-l: 64px;
      --web-kiosk-services-availability-msg-color: #606565;
    }

    .page-body {
      height: 100%;
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: url("assets/services/bg/staff.svg") left bottom -12% no-repeat,
        url("assets/services/bg/swirl.svg") no-repeat,
        var(--web-kiosk-bg, hotpink);
      background-size: calc(100vmin - 445px), cover;
    }

    .body-inner {
      padding: 48px 56px;
    }

    .body-content {
      display: flex;
    }

    #about-text {
      max-width: 33%;
      flex: 1 0 33%;
    }

    #about-text h1 {
      font-size: var(--web-kiosk-dimension-spacer-l, 64px);
      font-weight: 700;
      line-height: 72px;
      margin: var(--web-kiosk-dimension-spacer-m, 32px) 0;
    }

    a,
    #about-text :is(h1, h2) {
      color: var(--web-kiosk-text-color, hotpink);
    }

    #about-text h2 {
      margin: 42px 0 4px;
      font-size: var(--web-kiosk-dimension-spacer-m, 32px);
      font-weight: 700;
      line-height: 38px;
    }

    .card-texts p {
      margin: 0;
      color: var(--web-kiosk-services-availability-msg-color, hotpink);
      font-size: 24px;
      font-weight: 600;
      line-height: 34px;
    }

    #about-text p {
      margin: 0;
      color: var(--web-kiosk-text-color, hotpink);
      font-size: var(--web-kiosk-dimension-spacer-m, 32px);
      font-weight: 400;
      line-height: 52px;
    }

    #cards {
      width: 67%;
      display: flex;
      flex-wrap: wrap;
    }

    wh-carousel {
      width: 100%;
      margin: 18px 12px 0;
    }

    wh-carousel .carousel-slide {
      flex: 0 0 99%;
      min-height: 730px;
    }

    #pagination-container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-right: var(--web-kiosk-dimension-spacer-m, 32px);
    }

    .card-container {
      display: inline-block;
      width: calc(50% - var(--web-kiosk-dimension-spacer-m, 32px));
      margin: var(--web-kiosk-dimension-spacer-xs, 16px);
    }

    wh-card:hover {
      cursor: pointer;
    }

    .card-inner {
      display: flex;
      width: auto;
      height: 120px;
      padding: var(--web-kiosk-dimension-spacer-xs, 16px);
      align-items: center;
    }

    .card-inner img {
      height: fit-content;
    }

    .card-inner h3 {
      margin: 0 0 var(--web-kiosk-dimension-spacer-xxs, 8px);
      color: var(--web-kiosk-text-color, hotpink);
      font-size: var(--web-kiosk-dimension-spacer-m, 32px);
      font-weight: 700;
      line-height: 38px;
    }

    .card-icon {
      padding-right: var(--web-kiosk-dimension-spacer-m, 32px);
    }

    .arrow-icon {
      margin-left: auto;
    }

    wh-pagination {
      font-size: var(--web-kiosk-dimension-spacer-m, 32px);
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.cardsPerPage = 6;
        this.content = undefined;
        this.selectedCard = undefined;
        this.carouselCurrentPageNumber = 1;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $debfb08e53488f8f$export$2cbd13e54b8dd57f.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $debfb08e53488f8f$export$2cbd13e54b8dd57f.prototype, "selectedCard", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("web-kiosk-services-modal")
], $debfb08e53488f8f$export$2cbd13e54b8dd57f.prototype, "modal", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-pagination")
], $debfb08e53488f8f$export$2cbd13e54b8dd57f.prototype, "paginationElement", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-carousel")
], $debfb08e53488f8f$export$2cbd13e54b8dd57f.prototype, "carousel", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $debfb08e53488f8f$export$2cbd13e54b8dd57f.prototype, "carouselCurrentPageNumber", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $debfb08e53488f8f$export$2cbd13e54b8dd57f.prototype, "carouselActiveNumber", void 0);
$debfb08e53488f8f$export$2cbd13e54b8dd57f = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-services")
], $debfb08e53488f8f$export$2cbd13e54b8dd57f);










var $6d26841802dd4a1d$exports = {};
$6d26841802dd4a1d$exports = JSON.parse('{"625":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"1254":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"2162":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"2560":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"2623":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"2884":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"2968":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"3197":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"3279":{"payors":["buckeye"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"3281":{"payors":["buckeye"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"3296":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"3379":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"3731":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"4050":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"4109":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"4517":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"4544":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"4659":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"4776":{"payors":["buckeye"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"5005":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"5300":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5333":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"5343":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"5365":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5456":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5463":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"5506":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5525":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5591":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5639":{"payors":["buckeye"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"5700":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5702":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5744":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5773":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5774":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5797":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"5798":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6061":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6127":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6147":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6161":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"6162":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"6249":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6255":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6382":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"6388":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6413":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6445":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6502":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6640":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6658":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6748":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"6903":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"6976":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"7191":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"7230":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"7244":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"7263":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"7311":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"7343":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"7654":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"7744":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"7950":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"7976":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"9080":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"9136":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"9346":{"payors":["buckeye"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"9560":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"9588":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"9817":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"9842":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"10366":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"10703":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"10767":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"10768":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"10910":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"11313":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"11473":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"11614":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"11706":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"11785":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"11990":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"12023":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"12406":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"12442":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"12460":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"12529":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"12792":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"12913":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"13812":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"13833":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"13834":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"15078":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"15330":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"15397":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"15593":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"15594":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"15930":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"16034":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"17797":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"18175":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"18253":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"18277":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"19184":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"19361":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"19517":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"19708":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"19827":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"19860":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"19903":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"9am - 5:30pm","tuesdayHours":"9am - 5:30pm","wednesdayHours":"9am - 5:30pm","thursdayHours":"9am - 5:30pm","fridayHours":"9am - 5:30pm","saturdayHours":"Closed"}},"19957":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"10am - 5pm","mondayHours":"9am - 6pm","tuesdayHours":"9am - 6pm","wednesdayHours":"9am - 6pm","thursdayHours":"9am - 6pm","fridayHours":"9am - 6pm","saturdayHours":"9am - 5pm"}},"59124":{"payors":["bsc"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}},"111111":{"payors":["braven","clover","horizon"],"hours":{"sundayHours":"Closed","mondayHours":"11am - 7:30pm","tuesdayHours":"11am - 7:30pm","wednesdayHours":"11am - 7:30pm","thursdayHours":"11am - 7:30pm","fridayHours":"11am - 7:30pm","saturdayHours":"Closed"}}}');


// eslint-disable-next-line @typescript-eslint/no-use-before-define
const $1af786e4380ab2c4$var$stores = (0, (/*@__PURE__*/$parcel$interopDefault($6d26841802dd4a1d$exports)));
function $1af786e4380ab2c4$export$3645925136c08b04(storeId) {
    const store = $1af786e4380ab2c4$var$stores[storeId];
    if (store === undefined) return [];
    const { payors: payors } = store;
    return payors;
}
function $1af786e4380ab2c4$export$7b1b81b8152f1344(storeId) {
    const store = $1af786e4380ab2c4$var$stores[storeId];
    if (store === undefined) return undefined;
    const { hours: hours } = store;
    return hours;
}




const $a9518f53fa8e6f69$export$f1bbfd513eb3d59e = [
    "default"
];
const $a9518f53fa8e6f69$export$5289a90f58917e7e = (query)=>{
    const storeIdRegExp = /s(?<storeId>\d+)/iu;
    return storeIdRegExp.exec(query)?.groups?.storeId;
};
function $a9518f53fa8e6f69$export$882ceb117ed70fd7(storeId) {
    if (storeId === "") return $a9518f53fa8e6f69$export$f1bbfd513eb3d59e;
    try {
        const result = (0, $1af786e4380ab2c4$export$3645925136c08b04)(storeId);
        if (result.length > 0) return result;
    } catch  {
        return $a9518f53fa8e6f69$export$f1bbfd513eb3d59e;
    }
    return $a9518f53fa8e6f69$export$f1bbfd513eb3d59e;
}


let $ea7dfe44ebbcf57b$export$b3a984396facac74 = class WebKioskInformationAndHoursElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    firstUpdated() {
        const store = (0, $8d0b0d663386d395$export$6fec604aa7293d0c)(window.location.search);
        const storeId = (0, $a9518f53fa8e6f69$export$5289a90f58917e7e)(store);
        this.storeHours = (0, $1af786e4380ab2c4$export$7b1b81b8152f1344)(storeId ?? "");
    }
    renderStoreHours(storeHours) {
        if (!storeHours) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <div id="hours-details">
        <dl>
          <dd
            aria-label=${`${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Monday", {
            id: "monday"
        })} ${storeHours.mondayHours}`}
          >
            <span> ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Monday", {
            id: "monday"
        })}</span
            >${storeHours.mondayHours}
          </dd>
          <dd
            aria-label=${`${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Tuesday", {
            id: "tuesday"
        })} ${storeHours.tuesdayHours}`}
          >
            <span> ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Tuesday", {
            id: "tuesday"
        })}</span
            >${storeHours.tuesdayHours}
          </dd>
          <dd
            aria-label=${`${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Wednesday", {
            id: "wednesday"
        })} ${storeHours.wednesdayHours}`}
          >
            <span> ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Wednesday", {
            id: "wednesday"
        })}</span
            >${storeHours.wednesdayHours}
          </dd>
          <dd
            aria-label=${`${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Thursday", {
            id: "thursday"
        })} ${storeHours.thursdayHours}`}
          >
            <span> ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Thursday", {
            id: "thursday"
        })}</span
            >${storeHours.thursdayHours}
          </dd>
        </dl>
        <dl>
          <dd
            aria-label=${`${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Friday", {
            id: "friday"
        })} ${storeHours.fridayHours}`}
          >
            <span> ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Friday", {
            id: "friday"
        })}</span
            >${storeHours.fridayHours}
          </dd>
          <dd
            aria-label=${`${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Saturday", {
            id: "saturday"
        })} ${storeHours.saturdayHours}`}
          >
            <span> ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Saturday", {
            id: "saturday"
        })}</span
            >${storeHours.saturdayHours}
          </dd>
          <dd
            aria-label=${`${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Sunday", {
            id: "sunday"
        })} ${storeHours.sundayHours}`}
          >
            <span> ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Sunday", {
            id: "sunday"
        })}</span
            >${storeHours.sundayHours}
          </dd>
        </dl>
      </div>
    `;
    }
    renderLearnMore() {
        const learnMoreContent = this.content?.learnMore;
        if (learnMoreContent === undefined) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<p class="learn-more">
      ${(0, $3db3538a645e2fa6$export$b6e69390c23686fb)(this.content?.learnMore)}
    </p>`;
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section id="info-and-hours">
      <div id="navigation">
        <a href=${this.createRelativeLink("about")}>
          <wh-icon name="chevron-down"></wh-icon>
          ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Back", {
            id: "info-and-hours-back"
        })}
        </a>
      </div>
      <div id="left-panel">
        <h1 tabindex="-1">${this.content?.heading}</h1>
        <p>${this.content?.description}</p>
        <h2>${this.content?.hoursTitle}</h2>
        ${this.renderStoreHours(this.storeHours)}
      </div>
      <div id="right-panel">
        <div>
          <div>
            <p>${this.content?.advisorsDescription}</p>
            ${this.renderLearnMore()}
            <p class="small narrow-text">${this.content?.legalText}</p>
          </div>
        </div>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg-blue: #c1e8ff;
      --web-kiosk-bg-grey: #f5f5f0;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
      --web-kiosk-hours-border-color: #3232643d;
      --web-kiosk-panel-padding: 64px;
    }

    h1 {
      margin: 0 0 8px;
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
      margin-right: 80px;
    }

    h2 {
      margin: 0;
      padding: 0;
      color: var(--web-kiosk-text-color, blue);
      font-size: 32px;
      font-weight: 700;
      line-height: 38px;
      padding-bottom: 16px;
    }

    p {
      font-size: 26px;
      padding-bottom: 40px;
      line-height: 40px;
      font-weight: 400;
    }

    p.small {
      font-size: 22px;
      line-height: 32px;
    }

    p.legal {
      font-size: 20px;
      line-height: 28px;
    }

    .narrow-text {
      max-width: 67%;
      width: fit-content;
    }

    .learn-more {
      max-width: 67%;
      width: fit-content;
      line-height: 34px;
      font-weight: 700;
    }

    .no-height-break {
      height: 0;
    }

    strong {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 56px;
    }

    #info-and-hours {
      height: 100%;
      background: url("assets/about/caregiver.svg") right -5% bottom no-repeat,
        url("assets/informationAndHours/swirl.svg") 100% 0 no-repeat,
        url("assets/shared/bg/city-skyline.svg") left 3% bottom -7% no-repeat,
        linear-gradient(
          90deg,
          var(--web-kiosk-bg-grey, #f5f5f0) 50%,
          var(--web-kiosk-bg-blue, #c1e8ff) 50%
        );
      background-size: 23%, 50%, 33%, cover;
    }

    #navigation {
      display: flex;
      padding: 52px 58px 48px 56px;
      color: var(--web-kiosk-link-color, hotpink);
      font-size: 32px;
    }

    #navigation a {
      width: 20%;
      display: flex;
      align-items: center;
      color: var(--web-kiosk-link-color, hotpink);
      text-decoration: none;
      font-weight: bold;
    }

    #navigation wh-icon {
      font-size: 50px;
      transform: rotate(90deg);
    }

    #left-panel {
      float: left;
      width: 50%;
      box-sizing: border-box;
      padding: 0 var(--web-kiosk-panel-padding, 64px);
    }

    #right-panel {
      float: right;
      width: 50%;
      box-sizing: border-box;
      padding: 0 var(--web-kiosk-panel-padding, 64px);
    }

    #hours-details {
      display: grid;
      grid-gap: 10%;
      gap: 10%;
      grid-template-columns: repeat(auto-fit, minmax(300px, 2fr));
      line-height: 56px;
      padding-bottom: 24px;
    }

    #hours-details dd {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid var(--web-kiosk-hours-border-color, #3232643d);
      margin: 0;
      padding: 4px 0;
      font-size: 24px;
      color: #0a1414;
    }

    #hours-details dd:first-of-type {
      border-top: none;
    }

    #hours-details span {
      font-size: 24px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
        this.storeHours = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $ea7dfe44ebbcf57b$export$b3a984396facac74.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $ea7dfe44ebbcf57b$export$b3a984396facac74.prototype, "storeHours", void 0);
$ea7dfe44ebbcf57b$export$b3a984396facac74 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-information-and-hours")
], $ea7dfe44ebbcf57b$export$b3a984396facac74);












let $9c866f5fa69297c1$export$bbf8c065b2c63a63 = class WebKioskDeviceAttributeElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section id="device-attribute">
      <slot name="icon"></slot>
      <div id="text-content">
        <h1>${this.heading}</h1>
        <p>${this.body}</p>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg-blue: #c1e8ff;
      --web-kiosk-bg-grey: #f5f5f0;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
      --web-kiosk-device-attribute-body-color: black;
      --web-kiosk-panel-padding-m: 64px;
      --web-kiosk-panel-padding-sm: 56px;
    }

    #device-attribute {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: row;
      padding: 32px 24px;
    }

    #text-content {
      display: block;
      padding-left: 32px;
    }

    h1 {
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 26px;
      font-weight: 700;
      line-height: 32px;
      margin: 0;
    }

    p {
      color: var(--web-kiosk-device-attribute-body-color, hotpink);
      font-size: 22px;
      line-height: 32px;
      font-weight: 400;
      margin: 0;
      padding-top: 8px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.heading = "";
        this.body = "";
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $9c866f5fa69297c1$export$bbf8c065b2c63a63.prototype, "heading", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: String
    })
], $9c866f5fa69297c1$export$bbf8c065b2c63a63.prototype, "body", void 0);
$9c866f5fa69297c1$export$bbf8c065b2c63a63 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-device-attribute")
], $9c866f5fa69297c1$export$bbf8c065b2c63a63);



let $27202b203e9d885f$export$418ad91d76129284 = class WebKioskConnectedDeviceElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    firstUpdated() {
        // eslint-disable-next-line total-functions/no-partial-url-constructor
        const url = new URL(window.location.toString()).searchParams;
        this.device = url.get("device");
        this.updateTitle();
    }
    updateTitle() {
        const deviceContent = this.content?.devices.find((deviceObject)=>deviceObject.id === this.device);
        if (deviceContent) this.setTitle(deviceContent.title);
    }
    renderAttributes(attributes) {
        return attributes.map((attribute)=>{
            const { title: title, body: attributeBody, icon: icon } = attribute;
            return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
        <web-kiosk-device-attribute
          slot="attributes"
          heading=${title}
          body=${attributeBody}
        >
          <img src=${icon} alt=${title} slot="icon"
        /></web-kiosk-device-attribute>
      `;
        });
    }
    renderDisclaimer(disclaimer) {
        if (!disclaimer) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<p class="disclaimer">${disclaimer}</p>`;
    }
    render() {
        if (!this.content) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        const deviceContent = this.content.devices.find((deviceObject)=>deviceObject.id === this.device);
        if (!deviceContent) return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<p>Device ${this.device} not found.</p>`;
        const { name: name, body: body, img: img, attributes: attributes, disclaimer: disclaimer } = deviceContent;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section id="device">
      <div id="navigation">
        <a href=${this.createRelativeLink("connectedDevices")}>
          <wh-icon name="chevron-down"></wh-icon>
          ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Back to Device List", {
            id: "device-back"
        })}
        </a>
      </div>
      <div id="left-panel">
        <h1>${name}</h1>
        <p class="subtitle">${body}</p>
        <img src=${img} alt=${name} class="device-image" />
      </div>
      <div id="right-panel">
        <section id="attributes">${this.renderAttributes(attributes)}</section>
        ${this.renderDisclaimer(disclaimer)}
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg-blue: #c1e8ff;
      --web-kiosk-bg-grey: #f5f5f0;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
      --web-kiosk-disclaimer-color: black;
      --web-kiosk-panel-padding-m: 64px;
      --web-kiosk-panel-padding-sm: 56px;
    }

    #navigation {
      display: flex;
      padding: 52px 58px 48px 56px;
      color: var(--web-kiosk-link-color, hotpink);
      font-size: 32px;
    }

    #navigation a {
      width: 20%;
      display: flex;
      align-items: center;
      color: var(--web-kiosk-link-color, hotpink);
      text-decoration: none;
      font-weight: bold;
    }

    #navigation wh-icon {
      font-size: 50px;
      transform: rotate(90deg);
    }

    /* stylelint-disable indentation */
    #device {
      height: 100%;
      background: url("assets/about/bg/ribbon-health-advisors.svg") right 0 top
          0 no-repeat,
        linear-gradient(
          90deg,
          var(--web-kiosk-bg-blue, #c1e8ff) 42%,
          var(--web-kiosk-bg-grey, #f5f5f0) 0
        );
      background-size: 58%, 100%;
    }
    /* stylelint-enable indentation */

    #left-panel {
      float: left;
      width: 42%;
      box-sizing: border-box;
      padding: 0 var(--web-kiosk-panel-padding-m, 64px) 0
        var(--web-kiosk-panel-padding-sm, 56px);
    }

    #right-panel {
      float: right;
      width: 58%;
      box-sizing: border-box;
      padding: 0 90px;
      margin-top: 28px;
    }

    #attributes {
      padding: 0 51px;
    }

    h1 {
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 48px;
      font-weight: 700;
      line-height: 62px;
    }

    p {
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 26px;
      padding-bottom: 40px;
      line-height: 40px;
      font-weight: 400;
    }

    p.subtitle {
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 32px;
      line-height: 52px;
      font-weight: 400;
    }

    p.disclaimer {
      color: var(--web-kiosk-disclaimer-color, hotpink);
      font-size: 20px;
      line-height: 28px;
      font-weight: 400;
    }

    .device-image {
      max-width: 100%;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
        this.device = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $27202b203e9d885f$export$418ad91d76129284.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $27202b203e9d885f$export$418ad91d76129284.prototype, "device", void 0);
$27202b203e9d885f$export$418ad91d76129284 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-connected-device")
], $27202b203e9d885f$export$418ad91d76129284);










let $856d2c9247909dfb$export$9bcfee81fcc3e0f4 = class WebKioskConnectedDevicesElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    createDeviceUrl(device) {
        if (!this.location) return "";
        const payor = this.getPayor();
        const locale = this.getLocale();
        const search = (0, $8d0b0d663386d395$export$786f9a4bc80cc6b0)(this.location).replace("?", "");
        const searchParameters = search === "" ? search : `&${search}`;
        return `/${payor}/${locale}/connectedDevice?device=${device.id}${searchParameters}`;
    }
    renderCards(devices) {
        if (!devices || devices.length === 0) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return devices.map((device)=>{
            const deviceLink = this.createDeviceUrl(device);
            return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <a class="device-link" href=${deviceLink}>
        <div class="device-card">
          <div class="img-container">
            <img src=${device.thumbnail} alt=${device.name} />
          </div>
          <div class="text-container">
            <h2>${device.name}</h2>
          </div>
        </div>
      </a>`;
        });
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section class="page-body">
      <div class="body-inner">
        <web-kiosk-home-link
          link=${this.createRelativeLink("home")}
        ></web-kiosk-home-link>

        <div class="body-content">
          <section id="description">
            <h1>${this.content?.heading}</h1>

            <p>${this.content?.description}</p>
          </section>
          <section id="cards">
            ${this.renderCards(this.content?.devices)}
          </section>
        </div>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c1e8ff;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
      --web-kiosk-device-card-bg: #f5f5f0;
      --web-kiosk-device-card-img-bg: #fff;
      --web-kiosk-dimension-spacer-xxxs: 8px;
      --web-kiosk-dimension-spacer-m: 32px;
    }

    .page-body {
      height: 100%;
      background: url("assets/connectedDevices/swirl.svg") 50% 80% no-repeat,
        var(--web-kiosk-bg, hotpink);
      background-size: contain;
    }

    .body-inner {
      padding: 48px 56px;
    }

    .home-link {
      color: var(--web-kiosk-link-color, hotpink);
    }

    .home-link img {
      margin-right: var(--web-kiosk-dimension-spacer-xxxs, 8px);
    }

    a.home-link {
      display: inline-flex;
      align-items: center;
      text-decoration: none;
      font-size: 33px;
      font-weight: 700;
      line-height: 40px;
      color: var(--web-kiosk-link-color, hotpink);
    }

    a.device-link {
      text-decoration: none;
      display: flex;
      flex: 0 0 423px;
      flex-direction: column;
      gap: 10px;
      align-items: center;
      background: var(--web-kiosk-device-card-bg, hotpink);
      border-radius: 2rem;
      border: none;
      overflow: hidden;
      text-align: center;
      padding-bottom: 68px;
    }

    #description {
      display: flex;
      gap: 80px;
    }

    #description h1 {
      flex: 1 0 39%;
      margin: 52px 0 40px;
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
      color: var(--web-kiosk-text-color, hotpink);
    }

    #description p {
      margin: 48px 0 40px;
      font-size: var(--web-kiosk-dimension-spacer-m, 32px);
      font-weight: 400;
      line-height: 52px;
      color: var(--web-kiosk-text-color, hotpink);
    }

    #cards {
      display: flex;
      gap: var(--web-kiosk-dimension-spacer-m, 32px);
      margin-top: var(--web-kiosk-dimension-spacer-xxxs, 8px);
    }

    .img-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: -220px;
      width: 519px;
      height: 538px;
      background: var(--web-kiosk-device-card-img-bg, hotpink);
      border-radius: 50%;
    }

    .img-container img {
      margin-top: 180px;
      max-width: 100%;
    }

    .text-container {
      margin: 0;
      padding: 22px 50px var(--web-kiosk-dimension-spacer-xxxs, 8px);
    }

    .text-container h2 {
      margin: 0;
      padding: 0;
      color: var(--web-kiosk-text-color, hotpink);
      font-size: var(--web-kiosk-dimension-spacer-m, 32px);
      font-weight: 700;
      line-height: 38px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $856d2c9247909dfb$export$9bcfee81fcc3e0f4.prototype, "content", void 0);
$856d2c9247909dfb$export$9bcfee81fcc3e0f4 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-connected-devices")
], $856d2c9247909dfb$export$9bcfee81fcc3e0f4);








let $2bab7eb413c7710c$export$67bd68243b16d315 = class WebKioskScheduleAppointmentsElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    renderHelpDetails(details) {
        if (!details || details.length === 0) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return details.map((detail)=>(0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<li>
          <div class="detail-icon">
            <img src=${detail.icon} alt=${detail.title} />
          </div>
          <div class="detail-text">
            <h3>${detail.title}</h3>
            <div class="detail-description">
              ${(0, $3db3538a645e2fa6$export$b6e69390c23686fb)(detail.description)}
            </div>
          </div>
        </li>`);
    }
    renderAppointmentInfo(info) {
        if (!info) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<div id="appointment">
      <dt><strong>${info.text}</strong></dt>
      <dd>${info.number}</dd>
    </div>`;
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<div class="page-body">
      <section id="info">
        <web-kiosk-home-link
          link=${this.createRelativeLink("home")}
        ></web-kiosk-home-link>
        <h1>${this.content?.infoHeader}</h1>
        <p>${this.content?.infoDescription}</p>
      </section>
      <section id="details">
        <div class="details-inner">
          <h2>${this.content?.detailsHeader}</h2>
          <ul id="help-details">
            ${this.renderHelpDetails(this.content?.details)}
          </ul>
          <dl id="extra-info">
            ${this.renderAppointmentInfo(this.content?.appointment)}
          </dl>
        </div>
      </section>
    </div>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c2e8ff;
      --web-kiosk-text-color: #323264;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-details-bg-color: #f5f5f0;
      --web-kiosk-details-description-color: #0a1414;
      --web-kiosk-details-description-heading-border-color: #32326429;
      --web-kiosk-dimension-spacer-xxs: 8px;
      --web-kiosk-dimension-spacer-m: 32px;
      --web-kiosk-dimension-spacer-l: 64px;
    }

    .page-body {
      display: flex;
      height: 100%;
      background: url("assets/scheduleAppointments/bg/info.svg") 0 100%
          no-repeat,
        url("assets/scheduleAppointments/bg/details.svg") 100% 0 no-repeat,
        linear-gradient(
          90deg,
          var(--web-kiosk-bg, hotpink) 35%,
          var(--web-kiosk-details-bg-color, hotpink) 0 100%
        );
      background-size: 35%, 58%, 100%;
    }

    web-kiosk-home-link {
      padding: 48px 56px;
    }

    #info {
      width: 35%;
    }

    #info h1 {
      margin: 0;
      padding: 4px var(--web-kiosk-dimension-spacer-m, 32px) 4px
        var(--web-kiosk-dimension-spacer-l, 64px);
      font-size: var(--web-kiosk-dimension-spacer-l, 64px);
      font-weight: 700;
      line-height: 72px;
      color: var(--web-kiosk-text-color, hotpink);
    }

    .detail-description p {
      margin: 0;
    }

    .detail-description p:empty {
      margin-top: 0.9em;
    }

    #info p {
      margin: 0;
      padding: 36px 48px 345px var(--web-kiosk-dimension-spacer-l, 64px);
      line-height: 1.71;
      font-size: 1.75rem;
      font-weight: 400;
      color: var(--web-kiosk-text-color, hotpink);
    }

    #details {
      width: 65%;
    }

    #details h2 {
      margin: 0;
      margin-bottom: 40px;
      padding-bottom: 40px;
      border-bottom: 1px solid
        var(--web-kiosk-details-description-heading-border-color, hotpink);
      font-size: 2rem;
      line-height: 1.16;
      font-weight: 600;
      color: var(--web-kiosk-text-color, hotpink);
    }

    .details-inner {
      padding: 188px 145px 0 120px;
    }

    #help-details {
      padding-left: 50px;
      margin-bottom: 0;
    }

    #help-details li {
      display: flex;
      gap: var(--web-kiosk-dimension-spacer-m, 32px);
    }

    #help-details li:not(:last-of-type) {
      margin-bottom: var(--web-kiosk-dimension-spacer-m, 32px);
    }

    .detail-text h3 {
      margin: 0 0 0.31em;
      font-size: 1.625rem;
      font-weight: 700;
      line-height: 1.35;
      color: var(--web-kiosk-text-color, hotpink);
    }

    .detail-description {
      font-size: 1.375rem;
      line-height: 1.45;
      color: var(--web-kiosk-details-description-color, hotpink);
    }

    #extra-info {
      display: flex;
      justify-content: flex-end;
      min-height: 89px;
      align-items: center;
    }

    :is(#appointment) {
      display: flex;
      align-items: center;
    }

    :is(#appointment) dt {
      font-size: 1.5rem;
      line-height: 1.25;
      margin-right: 0.33em;
    }

    :is(#appointment) dt strong {
      font-weight: 600;
    }

    :is(#appointment) dd {
      margin: 0;
      font-size: 1.5rem;
      line-height: 1.25;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $2bab7eb413c7710c$export$67bd68243b16d315.prototype, "content", void 0);
$2bab7eb413c7710c$export$67bd68243b16d315 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-schedule-appointments")
], $2bab7eb413c7710c$export$67bd68243b16d315);


















let $f746f2f1c27fb371$export$3b2aab762efb0ac0 = class WebKioskCardSecondaryElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <article>
        <section>
          <slot name="left"></slot>
        </section>
        <section>
          <slot name="right"></slot>
        </section>
      </article>
    `;
    }
    static{
        /* Stryker disable next-line StringLiteral */ this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-card-secondary-background: #d6efff;
      --web-kiosk-card-secondary-border-radius: 8px;
      --wh-color-surface-primary: #f5f5f0;
      --wh-dimension-radius-m: 8px;
      --wh-dimension-separator-s: 1px;
      --wh-dimension-spacer-xs: 16px;
      --wh-dimension-spacer-s: 24px;
      --wh-dimension-spacer-m: 32px;
      --wh-typography-body-fontFamily: "Source Sans Pro", helvetica, arial;
      --wh-typography-body-fontSize: 24px;
      --wh-typography-h2-fontFamily: "Source Sans Pro", helvetica, arial;
      --wh-typography-h2-fontSize: 32px;
    }

    article {
      align-items: center;
      background-color: var(--web-kiosk-card-secondary-background, hotpink);
      border-radius: var(--wh-dimension-radius-m);
      display: flex;
      flex-direction: row;
      margin: auto var(--wh-dimension-spacer-xs);
      min-height: 160px;
      padding: 0 var(--wh-dimension-spacer-m) 0
        calc(var(--wh-dimension-spacer-xs) + var(--wh-dimension-spacer-s));
      position: relative;
      justify-content: space-between;
    }

    article::before {
      background-color: var(--wh-color-surface-primary, hotpink);
      border-radius: var(--web-kiosk-card-secondary-border-radius);
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: calc(var(--web-kiosk-card-secondary-border-radius) * 2);
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $f746f2f1c27fb371$export$3b2aab762efb0ac0.prototype, "content", void 0);
$f746f2f1c27fb371$export$3b2aab762efb0ac0 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-card-secondary")
], $f746f2f1c27fb371$export$3b2aab762efb0ac0);




let $7f8fa13f72bf4272$export$7e5633f565a24447 = class WebKioskNewSession extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    changePage({ detail: detail }) {
        this.carouselCurrentPageNumber = detail.newPagePosition;
        this.carouselActiveNumber = detail.newPagePosition - 1;
    }
    connectedCallback() {
        this.filterCards();
        super.connectedCallback();
    }
    filterCards() {
        const store = (0, $8d0b0d663386d395$export$6fec604aa7293d0c)(window.location.search);
        const storeId = (0, $a9518f53fa8e6f69$export$5289a90f58917e7e)(store);
        const payors = (0, $a9518f53fa8e6f69$export$882ceb117ed70fd7)(storeId ?? "");
        if (this.content) this.content.cards = this.content.cards.filter((card)=>payors.includes(card.key));
    }
    goToPage(page, payor = "default") {
        if (!this.location) return;
        const locale = this.getLocale();
        const { search: search } = window.location;
        (0, $37559147baa8b97c$export$55185c17a0fcbe46).go(`${payor}/${locale}/${page}${search}`);
    }
    updatePagination({ detail: { activeIndex: activeIndex } }) {
        this.carouselCurrentPageNumber = activeIndex + 1;
    }
    renderCard(card, index) {
        const snap = index % this.cardsPerPage === 0;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section ?wh-carousel-snap=${snap}>
      <button
        @click=${()=>{
            this.goToPage("home", card.key);
        }}
      >
        <wh-card flat size="large">
          <section class="card-inner">
            <img src=${card.image} alt=${card.label} />
            <h2>${card.label}</h2>
          </section>
        </wh-card>
      </button>
    </section> `;
    }
    renderPagination(cardsCount) {
        if (cardsCount <= this.cardsPerPage) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        const totalPages = Math.ceil(cardsCount / this.cardsPerPage);
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<wh-pagination
      variant="number-of"
      current-page-number=${this.carouselCurrentPageNumber}
      total-pages=${totalPages}
      @paginate=${this.changePage}
    >
      <span slot="prefix">${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Page", {
            id: "home-carousel-prefix"
        })}</span>
      <span slot="separator"> / </span>
    </wh-pagination>`;
    }
    renderCards(cards) {
        return cards.map((card, index)=>this.renderCard(card, index));
    }
    renderCarousel(cards) {
        if (!cards || cards.length === 0) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        const renderedCards = this.renderCards(cards);
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<wh-carousel
      active=${(0, $af8e33ff014f07c6$export$f68dd208b5df064d)(this.carouselActiveNumber)}
      @scrollcomplete=${this.updatePagination}
    >
      ${renderedCards}
    </wh-carousel> `;
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section class="page-body">
      <div class="body-inner">
        <section id="header">
          <h1>${this.content?.heading}</h1>
          <img
            src="assets/home/wg-stacked-logo.svg"
            alt=${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("Walgreens Logo", {
            id: "walgreens-logo"
        })}
          />
        </section>
        <section id="cards">
          ${this.renderCarousel(this.content?.cards)}
        </section>
        <section id="info">
          <p>
            <strong>${this.content?.descriptionBold}</strong>${this.content?.description}
          </p>
          ${this.renderPagination(this.content?.cards.length ?? 0)}
        </section>
        <web-kiosk-card-secondary>
          <div slot="left">
            <h3>${this.content?.instructionTitle}</h3>
            <p>${this.content?.instructionMessage}</p>
          </div>
          <div slot="right">
            <wh-button
              variant="primary"
              size="large"
              @click=${()=>{
            this.goToPage("home");
        }}
              >${this.content?.defaultStoreButtonText}</wh-button
            >
          </div>
        </web-kiosk-card-secondary>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c1e8ff;
      --web-kiosk-text-color: #323264;
    }

    .page-body {
      height: 100%;
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/shared/bg/city.svg") right bottom -7% no-repeat,
        url("assets/home/bg/swirl.svg") 50% 50% no-repeat,
        var(--web-kiosk-bg, hotpink);
      `)};
      background-size: 40%, 100%;
    }

    .body-inner {
      padding: 82px 56px 0;
    }

    section[id="header"] {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    h1 {
      width: 52%;
      margin: 0;
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 72px;
      font-weight: 700;
      line-height: 82px;
    }

    section[id="cards"] {
      margin-top: 32px;
    }

    wh-card {
      cursor: pointer;
      text-align: center;
      text-decoration: none;
    }

    wh-card section {
      min-height: 500px;
    }

    wh-card img {
      margin: 64px 64px 32px;
      max-width: 300px;
    }

    wh-card h2 {
      font-size: 32px;
      font-weight: 700;
      line-height: 38px;
      margin-bottom: 64px;
      color: var(--web-kiosk-text-color, hotpink);
    }

    wh-card p {
      font-size: 26px;
      font-weight: 400;
      line-height: 40px;
      margin: 0 0 42px;
    }

    web-kiosk-card-secondary h3,
    web-kiosk-card-secondary p {
      font-family: var(--wh-typography-body-fontFamily);
      font-size: var(--wh-typography-body-fontSize);
    }

    web-kiosk-card-secondary section {
      line-height: calc(var(--wh-typography-body-fontSize) * 0.8);
    }

    web-kiosk-card-secondary [slot="left"] {
      max-width: 1000px;
    }

    wh-carousel section {
      flex: 1 1 0;
    }

    wh-carousel section:not(:last-of-type) {
      padding-right: 32px;
    }

    section[id="header"] img {
      height: fit-content;
    }

    button {
      all: unset;
      display: contents;
    }

    .card-inner {
      min-height: 200px;
      min-width: 373px;
    }

    section[id="info"] {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--web-kiosk-text-color, hotpink);
    }

    section[id="info"] p {
      width: 70%;
      font-size: 28px;
      line-height: 48px;
      font-weight: 400;
    }

    wh-pagination {
      font-size: 32px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.cardsPerPage = 4;
        this.content = undefined;
        this.location = undefined;
        this.carouselCurrentPageNumber = 1;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $7f8fa13f72bf4272$export$7e5633f565a24447.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $7f8fa13f72bf4272$export$7e5633f565a24447.prototype, "location", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-pagination")
], $7f8fa13f72bf4272$export$7e5633f565a24447.prototype, "paginationElement", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-carousel")
], $7f8fa13f72bf4272$export$7e5633f565a24447.prototype, "carousel", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $7f8fa13f72bf4272$export$7e5633f565a24447.prototype, "carouselCurrentPageNumber", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $7f8fa13f72bf4272$export$7e5633f565a24447.prototype, "carouselActiveNumber", void 0);
$7f8fa13f72bf4272$export$7e5633f565a24447 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-new-session")
], $7f8fa13f72bf4272$export$7e5633f565a24447);








let $0602c325870d4524$export$b632a14cb9f5b11e = class WebKioskVirtualCareElement extends (0, $3fb2d069a78cd8a3$export$262589ac480ce656) {
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<section id="virtual-care-page-container">
      <div id="left-panel">
        <div id="navigation">
          <web-kiosk-home-link
            link=${this.createRelativeLink("home")}
          ></web-kiosk-home-link>
        </div>
        <h1 id="left-header">${this.content?.leftHeader}</h1>
        <p id="left-paragraph">${this.content?.leftParagraph}</p>
      </div>

      <div id="middle-panel">
        <div>
          <h2 id="middle-header">${this.content?.middleHeader}</h2>
          <img
            src=${(0, $af8e33ff014f07c6$export$f68dd208b5df064d)(this.content?.phoneImg)}
            alt=${(0, $af8e33ff014f07c6$export$f68dd208b5df064d)(this.content?.phoneImgAlt)}
          />
        </div>
      </div>

      <div id="right-panel">
        <h3 id="right-header">${this.content?.rightHeader}</h3>
        <section class="phone">
          <h5 class="phone-h">${this.content?.newPhoneHeader}</h5>
          <p class="phone-p">${this.content?.newPhoneParagraph}</p>
          <h5 class="phone-h">${this.content?.oldPhoneHeader}</h5>
          <p class="phone-p" id="old-phone-p">
            ${this.content?.oldPhoneParagraph}
          </p>
        </section>
        <dd class="qr-code-container">
          <div class="speech-bubble">${this.content?.speechBubble}</div>
          <div class="speech-triangle"></div>
          <img
            id="qr-code"
            src=${(0, $af8e33ff014f07c6$export$f68dd208b5df064d)(this.content?.qrCode)}
            alt=${(0, $af8e33ff014f07c6$export$f68dd208b5df064d)(this.content?.qrCodeAlt)}
          />
        </dd>
      </div>
    </section>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-bg: #c1e8ff;
      --web-kiosk-secondary-bg: #323264;
      --web-kiosk-bg-grey: #f5f5f0;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-heading-text-color: #323264;
      --web-kiosk-paragraph-text-color: #414646;
      --web-kiosk-paragraph-secondary-text-color: #f9f9f6;
      --web-kiosk-panel-padding: 64px;
    }

    #virtual-care-page-container {
      display: flex;
      align-items: stretch;
      height: 100%;
      background-color: hotpink;
    }

    #navigation {
      display: flex;
      padding: 48px 0;
      color: var(--web-kiosk-link-color, hotpink);
      font-size: 32px;
    }

    #navigation a {
      width: 20%;
      display: flex;
      align-items: center;
      color: var(--web-kiosk-link-color, hotpink);
      text-decoration: none;
      font-weight: bold;
    }

    #navigation wh-icon {
      font-size: 50px;
      transform: rotate(90deg);
    }

    #left-panel {
      height: 100%;
      background-color: var(--web-kiosk-bg-grey, hotpink);
      width: 33%;
      box-sizing: border-box;
      padding: 0 52px;
    }

    #left-header {
      margin: 0 0 8px;
      color: var(--web-kiosk-heading-text-color, hotpink);
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
    }

    #left-paragraph {
      font-style: normal;
      font-weight: 400;
      font-size: 26px;
      line-height: 40px;
      color: var(--web-kiosk-paragraph-text-color, hotpink);
      margin-top: 100px;
    }

    #middle-panel {
      width: 42%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      background: url("assets/mobile-app/bg/ribbon.svg") center right no-repeat;
      background-color: var(--web-kiosk-bg, hotpink);
      background-size: contain;
    }

    #middle-header {
      display: flex;
      justify-content: center;
      font-size: 48px;
      font-weight: 700;
      line-height: 62px;
      color: var(--web-kiosk-heading-text-color, hotpink);
    }

    #right-panel {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      text-align: center;
      padding: 124px 64px 96px;
      background-color: var(--web-kiosk-secondary-bg, hotpink);
      background-size: contain;
    }

    #right-header {
      font-weight: 600;
      font-size: 32px;
      line-height: 32px;
      text-align: left;
      color: var(--web-kiosk-paragraph-secondary-text-color, hotpink);
    }

    .phone-h {
      font-style: normal;
      font-weight: 600;
      font-size: 22px;
      line-height: 32px;
      margin-bottom: 0;
      text-align: left;
      color: var(--web-kiosk-paragraph-secondary-text-color, hotpink);
    }

    .phone-p {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
      margin-top: 0;
      text-align: left;
      color: var(--web-kiosk-paragraph-secondary-text-color, hotpink);
    }

    #old-phone-p {
      margin-bottom: 48px;
    }

    .speech-bubble {
      background-color: var(--web-kiosk-bg, hotpink);
      width: 236px;
      height: 56px;
      border-radius: 42px;
      font-style: normal;
      font-weight: 700;
      font-size: 28px;
      color: var(--web-kiosk-heading-text-color, hotpink);
      line-height: 57px;
      text-align: center;
      vertical-align: center;
    }

    .speech-triangle {
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 6px solid transparent;
      border-top: 17px solid var(--web-kiosk-bg, hotpink);
    }

    .qr-code-container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    #qr-code {
      width: 232px;
      height: 232px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $0602c325870d4524$export$b632a14cb9f5b11e.prototype, "content", void 0);
$0602c325870d4524$export$b632a14cb9f5b11e = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-virtual-care")
], $0602c325870d4524$export$b632a14cb9f5b11e);


const $9d36f78e5f182c6e$export$da3bc2f57520e3c3 = [
    {
        path: "home",
        component: "web-kiosk-home",
        key: "home"
    },
    {
        path: "new-session",
        component: "web-kiosk-new-session",
        key: "newSession"
    },
    {
        path: "about",
        component: "web-kiosk-about",
        key: "about"
    },
    {
        path: "services",
        component: "web-kiosk-services",
        key: "services"
    },
    {
        path: "video",
        component: "web-kiosk-video",
        key: "video"
    },
    {
        path: "feedback",
        component: "web-kiosk-feedback",
        key: "feedback"
    },
    {
        path: "privacy",
        component: "web-kiosk-privacy",
        key: "privacy"
    },
    {
        path: "informationAndHours",
        component: "web-kiosk-information-and-hours",
        key: "informationAndHours"
    },
    {
        path: "connectedDevices",
        component: "web-kiosk-connected-devices",
        key: "connectedDevices"
    },
    {
        path: "connectedDevice",
        component: "web-kiosk-connected-device",
        key: "connectedDevices"
    },
    {
        path: "scheduleAppointments",
        component: "web-kiosk-schedule-appointments",
        key: "scheduleAppointments"
    },
    {
        path: "virtual-care",
        component: "web-kiosk-virtual-care",
        key: "virtualCare"
    }
];








/* eslint-disable lit-a11y/click-events-have-key-events */ /* eslint-disable lit-a11y/anchor-is-valid */ 



var $72f3d87a2065e391$exports = {};

$parcel$export($72f3d87a2065e391$exports, "templates", () => $72f3d87a2065e391$export$a8fc3402335b0b04);
// Do not modify this file by hand!
// Re-generate this file by running lit-localize
/* eslint-disable no-irregular-whitespace */ /* eslint-disable @typescript-eslint/no-explicit-any */ const $72f3d87a2065e391$export$a8fc3402335b0b04 = {
    "device-back": `Regresa a la Lista de Dispositivos`,
    "friday": `Viernes`,
    "home-carousel-prefix": `Página`,
    "home-link": `Inicio`,
    "info-and-hours-back": `Atrás`,
    "monday": `Lunes`,
    "s344c7633610bf8b0": `Volver arriba`,
    "s355b21b89ce5d9c5": `Detalles`,
    "s9eff639fb8a1be0a": `segundos`,
    "saturday": `Sábado`,
    "sc16e00a7a8b2fde2": `Atrás`,
    "sdb7d426d5522303c": `Servicios Walgreens Health Corner`,
    "services-modal-close": `Cerrar`,
    "sunday": `Domingo`,
    "thursday": `Jueves`,
    "tuesday": `Martes`,
    "walgreens-logo": `Logotipo de Walgreens`,
    "wednesday": `Miércoles`
};


const $95ba2c1facf5db64$var$ES_TYPED = $72f3d87a2065e391$exports;
const $95ba2c1facf5db64$var$sourceLocale = "en";
const $95ba2c1facf5db64$var$targetLocales = [
    "es-419"
];
const $95ba2c1facf5db64$var$localizedTemplates = new Map([
    [
        "es-419",
        $95ba2c1facf5db64$var$ES_TYPED
    ]
]);
const { getLocale: $95ba2c1facf5db64$export$180605366c04f0cd, setLocale: $95ba2c1facf5db64$export$c8aadf3621e41efb } = (0, $6f72fc66e4601be7$export$2f3903bcf09d572a)({
    sourceLocale: $95ba2c1facf5db64$var$sourceLocale,
    targetLocales: $95ba2c1facf5db64$var$targetLocales,
    loadLocale: async (locale)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        await Promise.resolve($95ba2c1facf5db64$var$localizedTemplates.get(locale))
});



var $d7f4ba93cc6162f4$exports = {};




const $a41ad12150656222$export$4ea5976125a01ffa = (0, $2123215298adf759$export$dbf350e5966cf602)`
  a {
    font-family: var(
      --wh-typography-font-family,
      "Source Sans Pro",
      helvetica,
      arial
    );
    padding-left: 1px;
    padding-right: 1px;
    font-style: normal;
    font-weight: 500;
    font-size: var(--wh-font-size-medium, 16px);
    line-height: var(--wh-dimension-spacer-s, 24px);
    text-align: center;
    text-decoration-line: underline;

    /* Accent/Interactive */
    color: var(--wh-theme-colors-primary, #284b9b);
  }
`;


var $d7f4ba93cc6162f4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d7f4ba93cc6162f4$export$fe0871f1a2250b4c = class WhFooterElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`<footer>
      <slot name="inside-footer-content"></slot>
      <slot name="outside-footer-content">
        <div class="links-legal">
          <a
            href="https://www.walgreens.com/topic/help/general/noticeprivacypractices.jsp"
            >Notice of Privacy Practices</a
          >
          <a
            href="https://www.walgreens.com/topic/help/generalhelp/termsofuse.jsp"
            >Terms of Use</a
          >
          <a
            href="https://www.walgreens.com/topic/help/generalhelp/privacyandsecurity.jsp"
            >Online Privacy & Security</a
          >
        </div>
        <div class="copyright">
          &copy; Copyright 2022 Walgreen Co. 200 Wilmot Rd., Deerfield, Il. All
          rights reserved.
        </div>
      </slot>
    </footer>`;
    }
};
/* Stryker disable next-line StringLiteral */ $d7f4ba93cc6162f4$export$fe0871f1a2250b4c.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    /* stylelint-disable-next-line max-line-length */
    /* stylelint-disable-next-line selector-descendant-combinator-no-non-space,selector-type-no-unknown,comment-empty-line-before */
    ${0, $a41ad12150656222$export$4ea5976125a01ffa}
    footer {
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
    }

    [name="inside-footer-content"]::slotted(*) {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 20px;
      background: var(--wh-theme-colors-background, #c2e8ff);
      padding: 40px 0;
    }

    [name="outside-footer-content"] {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 20px;
    }

    .copyright {
      font-weight: 400;
    }

    .links-legal {
      padding: 1.125em 1.25em;
    }

    .links-legal a {
      margin: 0 10px;
    }

    @media only screen and (width <= 1145px) {
      [name="outside-footer-content"] {
        flex-flow: column wrap;
        align-items: center;
        justify-content: center;
      }
    }

    /*For Mobile Phone*/
    @media only screen and (width <= 620px) {
      .copyright {
        text-align: center;
      }

      .links {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
      }

      .links-legal {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
      }
    }
  `;
$d7f4ba93cc6162f4$export$fe0871f1a2250b4c = $d7f4ba93cc6162f4$var$__decorate([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("wh-footer")
], $d7f4ba93cc6162f4$export$fe0871f1a2250b4c);




const $b97bdca8bdd83073$var$nextUpLocale = new Map([
    [
        "en",
        "es-419"
    ],
    [
        "es-419",
        "en"
    ]
]);
let $b97bdca8bdd83073$export$6ce5b30846ee00b8 = class WebKioskFooterElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    switchLocale() {
        const locale = (0, $95ba2c1facf5db64$export$180605366c04f0cd)();
        const nextLocale = $b97bdca8bdd83073$var$nextUpLocale.get(locale);
        if (nextLocale !== undefined && nextLocale !== "") this.dispatchEvent(new CustomEvent("web-kiosk-change-locale", {
            detail: nextLocale,
            bubbles: true
        }));
    }
    navigate(path) {
        this.dispatchEvent(new CustomEvent("web-kiosk-navigate", {
            detail: path,
            bubbles: true
        }));
    }
    endSession() {
        // will change to payor-select-screen
        this.navigate("home");
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    renderLanguageButton() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <a
      @click=${()=>{
            this.switchLocale();
        }}
    >
      <wh-icon name="globe"></wh-icon>
      ${this.content?.nextLanguage}
    </a>`;
    }
    renderEndSessionButton() {
        const showEndButton = this.showEndSessionButton;
        return showEndButton ? (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <wh-button
          id="end-session-button"
          variant="primary"
          size="large"
          @click=${()=>{
            this.dispatchEvent(new CustomEvent("open-end-session-prompt", {
                bubbles: true,
                composed: true
            }));
        }}
        >
          ${this.content?.endSession}
        </wh-button>` : (0, $5bb961e9df347661$export$45b790e32b2810ee);
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <wh-footer>
      <section slot="inside-footer-content"></section>
      <section role="contentinfo" slot="outside-footer-content">
        <span class="navigation">
          <span class="left">
            <a
              @click=${()=>{
            this.navigate("feedback");
        }}
            >
              <wh-icon name="thumbs-up"></wh-icon>
              ${this.content?.leaveFeedback}
            </a>
            <a
              @click=${()=>{
            this.navigate("privacy");
        }}
            >
              <wh-icon name="privacy"></wh-icon>
              ${this.content?.privacyPolicy} &
              ${this.content?.termsAndConditions}
            </a>
          </span>
          <span class="right">
            ${this.renderLanguageButton()} ${this.renderEndSessionButton()}
          </span>
        </span>
      </section>
    </wh-footer>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-footer-bg: #f5f5f0;
      --web-kiosk-footer-border-color: #3232643d;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-brand-primary: #e52600;
    }

    section[slot="inside-footer-content"] {
      display: none;
    }

    section[slot="outside-footer-content"] {
      width: calc(100% - 64px * 2);
      padding: 18px 64px 16px;
      background-color: var(--web-kiosk-footer-bg, hotpink);
      border-top: 2px solid var(--web-kiosk-footer-border-color, hotpink);
    }

    .navigation {
      display: flex;
    }

    .left {
      display: flex;
      flex: 1 0;
    }

    .right {
      display: flex;
      align-items: center;
    }

    a {
      display: inline-flex;
      font-size: 28px;
      font-weight: 400;
      line-height: 48px;
      text-decoration: none;
      color: var(--web-kiosk-link-color, hotpink);
      cursor: pointer;
    }

    .left a {
      margin-right: 64px;
    }

    .right wh-button {
      margin-left: 64px;
    }

    .switch-language-link {
      margin-right: 64px;
    }

    wh-icon {
      font-size: 48px;
      margin-right: 8px;
    }

    #end-session-button::part(base) {
      background-color: var(--web-kiosk-brand-primary, hotpink);
      font-size: 24px;
      padding-left: 32px;
      padding-right: 32px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
        this.showEndSessionButton = false;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $b97bdca8bdd83073$export$6ce5b30846ee00b8.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean
    })
], $b97bdca8bdd83073$export$6ce5b30846ee00b8.prototype, "showEndSessionButton", void 0);
$b97bdca8bdd83073$export$6ce5b30846ee00b8 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-footer")
], $b97bdca8bdd83073$export$6ce5b30846ee00b8);



class $dd8a1eaafcdccc43$export$2e2bcd8739ae039 extends EventTarget {
    constructor(){
        super();
        this.eventsOnDocument = [
            {
                name: "keydown",
                passive: false
            },
            {
                name: "mousedown",
                passive: true
            },
            {
                name: "popstate",
                passive: false
            },
            {
                name: "scroll",
                passive: true
            },
            {
                name: "touchmove",
                passive: true
            },
            {
                name: "touchstart",
                passive: true
            }
        ];
        this.registerEventListeners();
    }
    announceActivity() {
        this.dispatchEvent(new CustomEvent("user-activity", {
            bubbles: true,
            composed: true
        }));
    }
    registerEventListeners() {
        this.eventsOnDocument.forEach((trackedEvent)=>{
            document.addEventListener(trackedEvent.name, this.announceActivity.bind(this), {
                passive: trackedEvent.passive
            });
        });
    }
}









let $6759673ec84a5300$export$e69e05a97d3ae6f0 = class WebKioskCountdownBoxElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)` <div class="counter-box">
      <p class="counter-box-body">
        <span class="counter-number">${this.countdownNumber}</span>
        <br />
        ${(0, $76ac3e1a759bb142$export$d8bbfaecd0f57bdf)("seconds", {
            desc: "seconds label"
        })}
      </p>
    </div>`;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --wh-kiosk-counter-box-background-color: #fff;
    }

    .counter-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 auto 48px;
      border-radius: 10px;
      background-color: var(--wh-kiosk-counter-box-background-color, hotpink);
      border: 3px solid var(--wh-palette-colors-brand-red, hotpink);
      width: 186px;
    }

    .counter-box-body {
      color: var(--wh-palette-colors-gray5, hotpink);
      font-size: 26px;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
    }

    .counter-number {
      color: var(--wh-palette-colors-navy, hotpink);
      font-size: 88px;
      font-weight: 600;
      line-height: 88px;
      text-align: center;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.countdownNumber = 60;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $6759673ec84a5300$export$e69e05a97d3ae6f0.prototype, "countdownNumber", void 0);
$6759673ec84a5300$export$e69e05a97d3ae6f0 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-countdown-box")
], $6759673ec84a5300$export$e69e05a97d3ae6f0);




let $088871e7ee213307$export$28b7ef197deb4dd1 = class WebKioskTimeoutModalElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    render() {
        if (!this.content) return 0, $5bb961e9df347661$export$45b790e32b2810ee;
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <wh-modal flat fitContent .open=${this.open}>
        <label id="close" slot="close-button-content">
          <img src="assets/shared/close.svg" alt=${this.content.closeBtnText} />
          ${this.content.closeBtnText}
        </label>
        <div class="modal-body">
          <web-kiosk-countdown-box
            .countdownNumber=${this.timeoutNumber}
          ></web-kiosk-countdown-box>
          <h3 id="modal-title">${this.content.title}</h3>
          <h4 id="modal-description">${this.content.description}</h4>
          <p>
            ${`${this.content.timeoutMessageStart} ${this.timeoutNumber} ${this.content.timeoutMessageFinish}`}
          </p>
          <div class="buttons">
            <wh-button
              variant="primary"
              pill
              size="medium"
              id="stay-button"
              fullwidth="true"
              >${this.content.stayBtnText}
            </wh-button>
            <wh-button
              variant="secondary"
              id="leave-button"
              fullwidth="true"
              @click=${()=>{
            this.dispatchEvent(new CustomEvent("leave", {
                bubbles: true,
                composed: true
            }));
        }}
              >${this.content.leaveBtnText}
            </wh-button>
          </div>
        </div>
      </wh-modal>
    `;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-p-color: #0a1414;
      --web-kiosk-text-color: #323264;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-button-text-color: #fff;
      --wh-modal-background-color: #f5f5f0;
      --web-kiosk-dimension-spacer-xxs: 8px;
      --web-kiosk-dimension-spacer-xs: 16px;
      --web-kiosk-dimension-spacer-m: 32px;
      --web-kiosk-dimension-spacer-xl: 64px;
      --web-kiosk-font-size-s: 24px;
      --web-kiosk-font-size-m: 32px;
      --web-kiosk-font-size-l: 48px;
    }

    .modal-body {
      overflow-y: auto;
      border-bottom-right-radius: var(--web-kiosk-dimension-spacer-xs, 16px);
      border-bottom-left-radius: var(--web-kiosk-dimension-spacer-xs, 16px);
      padding: 156px 40px;
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/timeout-modal/waving.svg") no-repeat right bottom,
        url("assets/timeout-modal/ribbon.svg") bottom no-repeat,
        var(--wh-modal-background-color, hotpink);
      `)};
      background-size: 20%, contain;
    }

    #close {
      display: flex;
      align-items: center;
      color: var(--web-kiosk-link-color, hotpink);
      background: none;
      border: none;
      /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
      font-family: "Source Sans Pro";
      font-size: var(--web-kiosk-font-size-m, 32px);
      font-weight: 700;
      line-height: 40px;
      margin-left: auto;
    }

    #close:hover {
      cursor: pointer;
    }

    #close img {
      margin-right: var(--web-kiosk-dimension-spacer-xs, 8px);
      height: 24px;
      width: 24px;
    }

    p {
      color: var(--web-kiosk-p-color, hotpink);
      font-size: var(--web-kiosk-font-size-m, 32px);
      font-weight: 400;
      line-height: 52px;
    }

    #modal-description {
      color: var(--web-kiosk-p-color, hotpink);
      margin-top: var(--web-kiosk-dimension-spacer-xs, 16px);
      margin-bottom: var(--web-kiosk-dimension-spacer-xs, 16px);
      font-size: var(--web-kiosk-font-size-m, 32px);
      line-height: 38px;
    }

    wh-modal {
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-items: center;

      --wh-modal-background-color: #f5f5f0;
      --wh-modal-border-radius: 30px;
    }

    #modal-title {
      color: var(--web-kiosk-text-color, hotpink);
      font-size: var(--web-kiosk-font-size-l, 48px);
      line-height: 62px;
    }

    wh-button {
      margin-right: 44px;
      border-radius: 50px;
      font-weight: 600;
      font-size: var(--web-kiosk-font-size-s, 24px);
      line-height: 20px;
      border: 2px solid var(--web-kiosk-text-color, hotpink);
      width: 300px;
    }

    #stay-button {
      color: var(--web-kiosk-button-text-color, hotpink);
      background-color: var(--web-kiosk-text-color, hotpink);
    }

    #leave-button {
      color: var(--web-kiosk-text-color, hotpink);

      --wh-theme-colors-secondary: lightgray;
      --wh-theme-colors-secondary-weak: lightgray;
    }

    .buttons {
      display: flex;
      justify-content: center;
      margin-top: 24px;
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.contentEntryKey = "inactivityModal";
        this.content = undefined;
        this.timeoutNumber = 30;
        this.open = false;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)()
], $088871e7ee213307$export$28b7ef197deb4dd1.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Number
    })
], $088871e7ee213307$export$28b7ef197deb4dd1.prototype, "timeoutNumber", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $47e412eef43c2fd3$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $088871e7ee213307$export$28b7ef197deb4dd1.prototype, "open", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-modal")
], $088871e7ee213307$export$28b7ef197deb4dd1.prototype, "modal", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("web-kiosk-countdown-box")
], $088871e7ee213307$export$28b7ef197deb4dd1.prototype, "countdownBox", void 0);
$088871e7ee213307$export$28b7ef197deb4dd1 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-timeout-modal")
], $088871e7ee213307$export$28b7ef197deb4dd1);








let $66f07486d6d7bb99$export$59063d89733cfe3a = class WebKioskEndSessionPromptElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    openPrompt() {
        this.modal?.showModal();
    }
    closePrompt() {
        this.modal?.hideModal();
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <wh-modal flat fitContent .noHeader=${true}>
        <div class="modal-body">
          <h3 id="modal-title">${this.content?.modalTitle}</h3>
          <div class="buttons">
            <wh-button
              variant="secondary"
              id="leave-button"
              .fullwidth=${true}
              @click=${()=>{
            this.dispatchEvent(new CustomEvent("end-session", {
                bubbles: true,
                composed: true
            }));
        }}
            >
              ${this.content?.confirmText}
            </wh-button>
            <wh-button
              variant="primary"
              pill
              size="medium"
              id="stay-button"
              fullwidth="true"
              @click=${()=>{
            this.dispatchEvent(new CustomEvent("resume-session", {
                bubbles: true,
                composed: true
            }));
        }}
            >
              ${this.content?.denyText}
            </wh-button>
          </div>
        </div>
      </wh-modal>
    `;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    :host {
      --web-kiosk-p-color: #0a1414;
      --web-kiosk-text-color: #323264;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-button-text-color: #fff;
      --wh-modal-background-color: #f5f5f0;
      --web-kiosk-dimension-spacer-xxs: 8px;
      --web-kiosk-dimension-spacer-xs: 16px;
      --web-kiosk-dimension-spacer-m: 32px;
      --web-kiosk-dimension-spacer-xl: 64px;
      --web-kiosk-font-size-s: 24px;
      --web-kiosk-font-size-m: 32px;
      --web-kiosk-font-size-l: 48px;
    }

    .modal-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow-y: auto;
      border-bottom-right-radius: var(--web-kiosk-dimension-spacer-xs, 16px);
      border-bottom-left-radius: var(--web-kiosk-dimension-spacer-xs, 16px);
      padding: 0 64px 64px;
      /* stylelint-disable-next-line declaration-colon-space-after */
      background: ${(0, $2123215298adf759$export$8d80f9cac07cdb3)(`
        url("assets/timeout-modal/ribbon.svg") bottom no-repeat,
        var(--wh-modal-background-color, hotpink);
      `)};
      background-size: contain;
    }

    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 48px;
    }

    #modal-title {
      color: var(--web-kiosk-text-color, hotpink);
      font-size: var(--web-kiosk-font-size-l, 48px);
      margin-top: 24px;
      margin-bottom: 24px;
    }

    wh-button {
      border-radius: 50px;
      font-weight: 600;
      font-size: var(--web-kiosk-font-size-s, 24px);
      line-height: 20px;
      border: 2px solid var(--web-kiosk-text-color, hotpink);
      width: 160px;
    }

    #stay-button {
      color: var(--web-kiosk-button-text-color, hotpink);
      background-color: var(--web-kiosk-text-color, hotpink);
    }

    #leave-button {
      color: var(--web-kiosk-text-color, hotpink);

      --wh-theme-colors-secondary: var(--wh-modal-background-color, hotpink);
      --wh-theme-colors-secondary-weak: var(
        --wh-modal-background-color,
        hotpink
      );
    }
  `;
    }
    constructor(...args){
        super(...args);
        this.content = undefined;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $66f07486d6d7bb99$export$59063d89733cfe3a.prototype, "content", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("wh-modal")
], $66f07486d6d7bb99$export$59063d89733cfe3a.prototype, "modal", void 0);
$66f07486d6d7bb99$export$59063d89733cfe3a = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk-end-session-prompt")
], $66f07486d6d7bb99$export$59063d89733cfe3a);


class $5d65dfd3ac3e094a$export$dab5f1feffade6cc {
    constructor(host, seconds = 60){
        this.remainingSeconds = 35;
        this.timeout = 1000;
        this.timerID = 0;
        (this.host = host).addController(this);
        this.remainingSeconds = seconds;
    }
    countdown() {
        this.remainingSeconds -= 1;
        if (this.remainingSeconds === 0) window.dispatchEvent(new CustomEvent("activity-has-timed-out"));
    }
    hostConnected() {
        // Start a timer when the host is connected
        this.timerID = setInterval(()=>{
            this.countdown();
            // Update the host with new value
            this.host.requestUpdate();
        }, this.timeout);
    }
    hostDisconnected() {
        // Clear the timer when the host is disconnected
        clearInterval(this.timerID);
        this.timerID = undefined;
    }
}




const $323ac4cc8e19a49a$var$prefix = undefined ?? "";
let $323ac4cc8e19a49a$export$15c46ab8922f1b15 = class WebKioskElement extends (0, $2919ec35aa0c9943$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.footerContent = undefined;
        this.timeoutContent = undefined;
        this.endSessionPromptContent = undefined;
        this.payor = "default";
        this.locale = "en";
        this.allowedInactiveTime = 160;
        this.clock = new (0, $5d65dfd3ac3e094a$export$dab5f1feffade6cc)(this, this.allowedInactiveTime);
        this.activityMonitor = new (0, $dd8a1eaafcdccc43$export$2e2bcd8739ae039)();
        this.activityMonitor.addEventListener("user-activity", ()=>{
            this.clock.remainingSeconds = this.allowedInactiveTime;
        });
    }
    connectedCallback() {
        super.connectedCallback();
    }
    firstUpdated() {
        window.addEventListener("activity-has-timed-out", ()=>{
            this.openVideo();
        });
    }
    updated() {
        if (this.location) {
            const parameters = (0, $8d0b0d663386d395$export$17c2ed143a4045c)(this.location);
            this.payor = parameters.payor;
            this.locale = parameters.locale;
            this.footerContent = this.getContentForElement("footer");
            this.timeoutContent = this.getContentForElement("inactivityModal");
            this.endSessionPromptContent = this.getContentForElement("endSessionPrompt");
        }
    }
    getContentForElement(key) {
        return (0, $f4054af2a8c7c60b$export$ffa34252a456de62).fetchContentEntry(this.locale, this.payor, key);
    }
    toggleFooter(hide) {
        this.footer?.classList.toggle("hidden", hide);
    }
    showEndSessionButton() {
        if (!this.location || this.location.route === null) return false;
        const noShowRoutes = [
            "new-session",
            "video"
        ];
        const currentRoute = (0, $8d0b0d663386d395$export$da6d2f7032b7150b)(this.location);
        if (currentRoute === undefined) return false;
        return !noShowRoutes.includes(currentRoute);
    }
    openVideo() {
        if (!this.location) return;
        const parameters = (0, $8d0b0d663386d395$export$17c2ed143a4045c)(this.location);
        const search = (0, $8d0b0d663386d395$export$786f9a4bc80cc6b0)(this.location);
        const store = (0, $8d0b0d663386d395$export$6fec604aa7293d0c)(search);
        const currentRoute = (0, $8d0b0d663386d395$export$da6d2f7032b7150b)(this.location);
        if (currentRoute !== "video") {
            const path = `${parameters.payor}/${parameters.locale}/video${store}`;
            this.setLocation(path);
        }
    }
    closeVideo() {
        this.toggleFooter(false);
        if (this.location === undefined) throw new Error("Search was undefined. Closing the video and rerouting to the home page will not work without a valid search param");
        const search = (0, $8d0b0d663386d395$export$786f9a4bc80cc6b0)(this.location);
        const enHomeRoute = `${$323ac4cc8e19a49a$var$prefix}/default/en/new-session${search}`;
        this.setLocation(enHomeRoute);
    }
    setLocation(location) {
        (0, $37559147baa8b97c$export$55185c17a0fcbe46).go(location);
    }
    isModalOpen() {
        return this.clock.remainingSeconds > 0 && this.clock.remainingSeconds <= 20;
    }
    closeTimeOutModel() {
        this.clock.remainingSeconds = 0;
    }
    endSession() {
        this.openVideo();
        this.closeTimeOutModel();
    }
    openEndSessionPrompt() {
        this.endSessionPrompt?.openPrompt();
    }
    closeEndSessionPrompt() {
        this.endSessionPrompt?.closePrompt();
    }
    endSessionThroughPrompt() {
        this.openVideo();
        this.closeEndSessionPrompt();
    }
    async changeLocale(locale) {
        if (!this.location) return;
        const parameters = (0, $8d0b0d663386d395$export$17c2ed143a4045c)(this.location);
        const route = (0, $8d0b0d663386d395$export$da6d2f7032b7150b)(this.location);
        if (route === undefined) throw new Error("Route was undefined. Changing locale will not work without a valid route");
        const search = (0, $8d0b0d663386d395$export$786f9a4bc80cc6b0)(this.location);
        const url = `${$323ac4cc8e19a49a$var$prefix}/${parameters.payor}/${locale}/${route}${search}`;
        this.setLocation(url);
        await (0, $95ba2c1facf5db64$export$c8aadf3621e41efb)(locale);
    }
    navigate(path) {
        if (!this.location) return;
        const parameters = (0, $8d0b0d663386d395$export$17c2ed143a4045c)(this.location);
        const search = (0, $8d0b0d663386d395$export$786f9a4bc80cc6b0)(this.location);
        const store = (0, $8d0b0d663386d395$export$6fec604aa7293d0c)(search);
        const url = `${$323ac4cc8e19a49a$var$prefix}/${parameters.payor}/${parameters.locale}/${path}${store}`;
        this.setLocation(url);
    }
    render() {
        return (0, $5bb961e9df347661$export$c0bb0b647f701bb5)`
      <section>
        <main
          @web-kiosk-video-open=${()=>{
            this.toggleFooter(true);
        }}
          @web-kiosk-video-close=${()=>{
            this.closeVideo();
        }}
        >
          <slot></slot>
          <web-kiosk-timeout-modal
            .content=${this.timeoutContent}
            .open=${this.isModalOpen()}
            .timeoutNumber=${this.clock.remainingSeconds}
            .payor=${this.payor}
            .locale=${this.locale}
            @leave=${()=>{
            this.endSession();
        }}
          ></web-kiosk-timeout-modal>
        </main>
        <web-kiosk-end-session-prompt
          .content=${this.endSessionPromptContent}
          @end-session=${()=>{
            this.endSessionThroughPrompt();
        }}
          @resume-session=${()=>{
            this.closeEndSessionPrompt();
        }}
        ></web-kiosk-end-session-prompt>
        <web-kiosk-footer
          .content=${this.footerContent}
          @web-kiosk-change-locale=${async (event)=>{
            await this.changeLocale(event.detail);
        }}
          @web-kiosk-navigate=${(event)=>{
            this.navigate(event.detail);
        }}
          @open-end-session-prompt=${()=>{
            this.openEndSessionPrompt();
        }}
          .showEndSessionButton=${this.showEndSessionButton()}
        ></web-kiosk-footer>
      </section>
    `;
    }
    static{
        this.styles = (0, $2123215298adf759$export$dbf350e5966cf602)`
    section {
      display: flex;
      flex-flow: column;
      height: 100%;
    }

    main {
      flex: 1 1 auto;
    }

    web-kiosk-footer {
      position: sticky;
      bottom: 0;
    }

    .hidden {
      display: none;
    }
  `;
    }
};
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $323ac4cc8e19a49a$export$15c46ab8922f1b15.prototype, "footerContent", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $323ac4cc8e19a49a$export$15c46ab8922f1b15.prototype, "timeoutContent", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $508a6eefcf14fe64$export$ca000e230c0caa3e)()
], $323ac4cc8e19a49a$export$15c46ab8922f1b15.prototype, "endSessionPromptContent", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("web-kiosk-footer")
], $323ac4cc8e19a49a$export$15c46ab8922f1b15.prototype, "footer", void 0);
(0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $95c2f37d0a859407$export$2fa187e846a241c4)("web-kiosk-end-session-prompt")
], $323ac4cc8e19a49a$export$15c46ab8922f1b15.prototype, "endSessionPrompt", void 0);
$323ac4cc8e19a49a$export$15c46ab8922f1b15 = (0, $9d41c80c94e7185d$export$29e00dfd3077644b)([
    (0, $d6bc8835316fae7d$export$85ef745e96563a4b)(),
    (0, $e24e784c98936ac9$export$da64fc29f17f9d0e)("web-kiosk")
], $323ac4cc8e19a49a$export$15c46ab8922f1b15);


const $3a505d45e64739b0$export$49039328c942e39a = [
    {
        path: "",
        redirect: `/default/en/new-session${window.location.search}`
    },
    {
        path: "/:payor/:locale",
        component: "web-kiosk",
        children: (0, $9d36f78e5f182c6e$export$da3bc2f57520e3c3).map(({ path: path, component: component, key: key })=>({
                path: path,
                component: component,
                action (ctx) {
                    ctx.params.contentKey = key;
                }
            }))
    }
];


(0, $e5b0870a079870e6$export$91ec06c66ef21811)(document.body, (0, $3a505d45e64739b0$export$49039328c942e39a));


//# sourceMappingURL=index.fa575e5d.js.map
